(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.cssParser = void 0;

var ast = _interopRequireWildcard(require("../../extensions/amp-animation/0.1/parsers/css-expr-ast"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @fileoverview @suppress {checkTypes, suspiciousCode, uselessCode} */

/* parser generated by jison 0.4.18 */

/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parser = function () {
  var o = function o(k, v, _o, l) {
    for (_o = _o || {}, l = k.length; l--; _o[k[l]] = v) {
      ;
    }

    return _o;
  },
      $V0 = [1, 7],
      $V1 = [1, 8],
      $V2 = [1, 9],
      $V3 = [1, 14],
      $V4 = [1, 15],
      $V5 = [1, 32],
      $V6 = [1, 33],
      $V7 = [1, 34],
      $V8 = [1, 35],
      $V9 = [1, 36],
      $Va = [1, 37],
      $Vb = [1, 38],
      $Vc = [1, 39],
      $Vd = [1, 40],
      $Ve = [1, 41],
      $Vf = [1, 42],
      $Vg = [1, 43],
      $Vh = [1, 44],
      $Vi = [1, 45],
      $Vj = [1, 46],
      $Vk = [1, 47],
      $Vl = [1, 48],
      $Vm = [1, 49],
      $Vn = [1, 73],
      $Vo = [1, 50],
      $Vp = [1, 53],
      $Vq = [1, 54],
      $Vr = [1, 55],
      $Vs = [1, 56],
      $Vt = [1, 57],
      $Vu = [1, 66],
      $Vv = [1, 67],
      $Vw = [1, 68],
      $Vx = [1, 69],
      $Vy = [1, 58],
      $Vz = [1, 59],
      $VA = [1, 60],
      $VB = [1, 61],
      $VC = [1, 62],
      $VD = [1, 63],
      $VE = [1, 64],
      $VF = [1, 65],
      $VG = [1, 51],
      $VH = [1, 52],
      $VI = [1, 70],
      $VJ = [1, 71],
      $VK = [1, 72],
      $VL = [5, 9, 10, 11, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 52, 53, 57, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 76, 77, 78, 79, 80, 82, 85, 86, 87],
      $VM = [5, 9, 10, 11, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 52, 53, 55, 57, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 76, 77, 78, 79, 80, 82, 85, 86, 87, 89, 90, 91],
      $VN = [1, 80],
      $VO = [1, 124],
      $VP = [1, 123],
      $VQ = [1, 125],
      $VR = [1, 126],
      $VS = [53, 55, 57, 89, 90, 91],
      $VT = [1, 129],
      $VU = [53, 55],
      $VV = [1, 156],
      $VW = [53, 55, 90, 91];

  var parser = {
    trace: function trace() {},
    yy: {},
    symbols_: {
      "error": 2,
      "result": 3,
      "value": 4,
      "EOF": 5,
      "literal_or_function": 6,
      "literal": 7,
      "function": 8,
      "STRING": 9,
      "NUMBER": 10,
      "PERCENTAGE": 11,
      "length": 12,
      "angle": 13,
      "time": 14,
      "url": 15,
      "HEXCOLOR": 16,
      "IDENT": 17,
      "LENGTH_PX": 18,
      "LENGTH_EM": 19,
      "LENGTH_REM": 20,
      "LENGTH_VH": 21,
      "LENGTH_VW": 22,
      "LENGTH_VMIN": 23,
      "LENGTH_VMAX": 24,
      "LENGTH_CM": 25,
      "LENGTH_MM": 26,
      "LENGTH_Q": 27,
      "LENGTH_IN": 28,
      "LENGTH_PC": 29,
      "LENGTH_PT": 30,
      "ANGLE_DEG": 31,
      "ANGLE_RAD": 32,
      "ANGLE_GRAD": 33,
      "TIME_MS": 34,
      "TIME_S": 35,
      "var_function": 36,
      "calc_function": 37,
      "translate_function": 38,
      "rect_function": 39,
      "num_function": 40,
      "rand_function": 41,
      "index_function": 42,
      "length_function": 43,
      "inset_function": 44,
      "circle_function": 45,
      "ellipse_function": 46,
      "polygon_function": 47,
      "min_function": 48,
      "max_function": 49,
      "clamp_function": 50,
      "any_function": 51,
      "FUNCTION_START": 52,
      ")": 53,
      "args": 54,
      ",": 55,
      "border_radius": 56,
      "/": 57,
      "tuples": 58,
      "URL_START": 59,
      "TRANSLATE_START": 60,
      "TRANSLATE_X_START": 61,
      "TRANSLATE_Y_START": 62,
      "TRANSLATE_Z_START": 63,
      "TRANSLATE_3D_START": 64,
      "INSET_START": 65,
      "ROUND": 66,
      "CIRCLE_START": 67,
      "AT": 68,
      "ELLIPSE_START": 69,
      "POLYGON_START": 70,
      "WIDTH_START": 71,
      "HEIGHT_START": 72,
      "X_START": 73,
      "Y_START": 74,
      "CLOSEST_START": 75,
      "NUM_START": 76,
      "RAND_START": 77,
      "INDEX_START": 78,
      "LENGTH_START": 79,
      "VAR_START": 80,
      "VAR_NAME": 81,
      "CALC_START": 82,
      "calc_expr": 83,
      "calc_expr_list": 84,
      "MIN_START": 85,
      "MAX_START": 86,
      "CLAMP_START": 87,
      "(": 88,
      "*": 89,
      "+": 90,
      "-": 91,
      "$accept": 0,
      "$end": 1
    },
    terminals_: {
      2: "error",
      5: "EOF",
      9: "STRING",
      10: "NUMBER",
      11: "PERCENTAGE",
      16: "HEXCOLOR",
      17: "IDENT",
      18: "LENGTH_PX",
      19: "LENGTH_EM",
      20: "LENGTH_REM",
      21: "LENGTH_VH",
      22: "LENGTH_VW",
      23: "LENGTH_VMIN",
      24: "LENGTH_VMAX",
      25: "LENGTH_CM",
      26: "LENGTH_MM",
      27: "LENGTH_Q",
      28: "LENGTH_IN",
      29: "LENGTH_PC",
      30: "LENGTH_PT",
      31: "ANGLE_DEG",
      32: "ANGLE_RAD",
      33: "ANGLE_GRAD",
      34: "TIME_MS",
      35: "TIME_S",
      52: "FUNCTION_START",
      53: ")",
      55: ",",
      57: "/",
      59: "URL_START",
      60: "TRANSLATE_START",
      61: "TRANSLATE_X_START",
      62: "TRANSLATE_Y_START",
      63: "TRANSLATE_Z_START",
      64: "TRANSLATE_3D_START",
      65: "INSET_START",
      66: "ROUND",
      67: "CIRCLE_START",
      68: "AT",
      69: "ELLIPSE_START",
      70: "POLYGON_START",
      71: "WIDTH_START",
      72: "HEIGHT_START",
      73: "X_START",
      74: "Y_START",
      75: "CLOSEST_START",
      76: "NUM_START",
      77: "RAND_START",
      78: "INDEX_START",
      79: "LENGTH_START",
      80: "VAR_START",
      81: "VAR_NAME",
      82: "CALC_START",
      85: "MIN_START",
      86: "MAX_START",
      87: "CLAMP_START",
      88: "(",
      89: "*",
      90: "+",
      91: "-"
    },
    productions_: [0, [3, 2], [3, 1], [4, 1], [4, 2], [6, 1], [6, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [12, 1], [12, 1], [12, 1], [12, 1], [12, 1], [12, 1], [12, 1], [12, 1], [12, 1], [12, 1], [12, 1], [12, 1], [12, 1], [13, 1], [13, 1], [13, 1], [14, 1], [14, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [8, 1], [51, 2], [51, 3], [54, 1], [54, 3], [56, 1], [56, 3], [58, 2], [58, 4], [15, 3], [38, 3], [38, 3], [38, 3], [38, 3], [38, 3], [44, 5], [44, 3], [45, 2], [45, 4], [45, 5], [45, 3], [46, 2], [46, 4], [46, 5], [46, 3], [47, 3], [39, 2], [39, 2], [39, 2], [39, 2], [39, 3], [39, 3], [39, 3], [39, 3], [39, 5], [39, 5], [39, 5], [39, 5], [40, 3], [41, 2], [41, 5], [42, 2], [43, 2], [36, 3], [36, 5], [37, 3], [84, 1], [84, 3], [48, 3], [49, 3], [50, 3], [83, 1], [83, 3], [83, 3], [83, 3], [83, 3], [83, 3]],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate
    /* action[1] */
    , $$
    /* vstack */
    , _$
    /* lstack */
    ) {
      /* this == yyval */
      var $0 = $$.length - 1;

      switch (yystate) {
        case 1:
          return $$[$0 - 1];
          break;

        case 2:
          return null;
          break;

        case 3:
        case 5:
        case 6:
        case 10:
        case 11:
        case 12:
        case 13:
        case 34:
        case 35:
        case 36:
        case 37:
        case 38:
        case 39:
        case 40:
        case 41:
        case 42:
        case 43:
        case 44:
        case 45:
        case 46:
        case 47:
        case 48:
        case 49:
        case 100:
          this.$ = $$[$0];
          break;

        case 4:
          this.$ = ast.CssConcatNode.concat($$[$0 - 1], $$[$0]);
          break;

        case 7:
        case 14:
        case 15:
          this.$ = new ast.CssPassthroughNode($$[$0]);
          break;

        case 8:
          this.$ = new ast.CssNumberNode(parseFloat($$[$0]));
          break;

        case 9:
          this.$ = new ast.CssPercentNode(parseFloat($$[$0]));
          break;

        case 16:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'px');
          break;

        case 17:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'em');
          break;

        case 18:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'rem');
          break;

        case 19:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'vh');
          break;

        case 20:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'vw');
          break;

        case 21:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'vmin');
          break;

        case 22:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'vmax');
          break;

        case 23:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'cm');
          break;

        case 24:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'mm');
          break;

        case 25:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'q');
          break;

        case 26:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'in');
          break;

        case 27:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'pc');
          break;

        case 28:
          this.$ = new ast.CssLengthNode(parseFloat($$[$0]), 'pt');
          break;

        case 29:
          this.$ = new ast.CssAngleNode(parseFloat($$[$0]), 'deg');
          break;

        case 30:
          this.$ = new ast.CssAngleNode(parseFloat($$[$0]), 'rad');
          break;

        case 31:
          this.$ = new ast.CssAngleNode(parseFloat($$[$0]), 'grad');
          break;

        case 32:
          this.$ = new ast.CssTimeNode(parseFloat($$[$0]), 'ms');
          break;

        case 33:
          this.$ = new ast.CssTimeNode(parseFloat($$[$0]), 's');
          break;

        case 50:
          this.$ = new ast.CssFuncNode($$[$0 - 1].slice(0, -1), []);
          break;

        case 51:
          this.$ = new ast.CssFuncNode($$[$0 - 2].slice(0, -1), $$[$0 - 1]);
          break;

        case 52:
        case 95:
          this.$ = [$$[$0]];
          break;

        case 53:
          var args = $$[$0 - 2];
          args.push($$[$0]);
          this.$ = args;
          break;

        case 54:
          this.$ = ast.createBorderRadiusNode($$[$0]);
          break;

        case 55:
          this.$ = ast.createBorderRadiusNode($$[$0 - 2], $$[$0]);
          break;

        case 56:
          this.$ = [ast.CssConcatNode.concat($$[$0 - 1], $$[$0])];
          break;

        case 57:
          var tuples = $$[$0 - 3];
          tuples.push(ast.CssConcatNode.concat($$[$0 - 1], $$[$0]));
          this.$ = tuples;
          break;

        case 58:
          this.$ = new ast.CssUrlNode($$[$0 - 1].slice(1, -1));
          break;

        case 59:
          this.$ = new ast.CssTranslateNode('', $$[$0 - 1]);
          break;

        case 60:
          this.$ = new ast.CssTranslateNode('x', $$[$0 - 1]);
          break;

        case 61:
          this.$ = new ast.CssTranslateNode('y', $$[$0 - 1]);
          break;

        case 62:
          this.$ = new ast.CssTranslateNode('z', $$[$0 - 1]);
          break;

        case 63:
          this.$ = new ast.CssTranslateNode('3d', $$[$0 - 1]);
          break;

        case 64:
          this.$ = ast.createInsetNode($$[$0 - 3], $$[$0 - 1]);
          break;

        case 65:
          this.$ = ast.createInsetNode($$[$0 - 1]);
          break;

        case 66:
          this.$ = ast.createCircleNode();
          break;

        case 67:
          this.$ = ast.createCircleNode(null, $$[$0 - 1]);
          break;

        case 68:
          this.$ = ast.createCircleNode($$[$0 - 3], $$[$0 - 1]);
          break;

        case 69:
          this.$ = ast.createCircleNode($$[$0 - 1]);
          break;

        case 70:
          this.$ = ast.createEllipseNode();
          break;

        case 71:
          this.$ = ast.createEllipseNode(null, $$[$0 - 1]);
          break;

        case 72:
          this.$ = ast.createEllipseNode($$[$0 - 3], $$[$0 - 1]);
          break;

        case 73:
          this.$ = ast.createEllipseNode($$[$0 - 1]);
          break;

        case 74:
          this.$ = ast.createPolygonNode($$[$0 - 1]);
          break;

        case 75:
          this.$ = new ast.CssRectNode('w');
          break;

        case 76:
          this.$ = new ast.CssRectNode('h');
          break;

        case 77:
          this.$ = new ast.CssRectNode('x');
          break;

        case 78:
          this.$ = new ast.CssRectNode('y');
          break;

        case 79:
          this.$ = new ast.CssRectNode('w', $$[$0 - 1].slice(1, -1));
          break;

        case 80:
          this.$ = new ast.CssRectNode('h', $$[$0 - 1].slice(1, -1));
          break;

        case 81:
          this.$ = new ast.CssRectNode('x', $$[$0 - 1].slice(1, -1));
          break;

        case 82:
          this.$ = new ast.CssRectNode('y', $$[$0 - 1].slice(1, -1));
          break;

        case 83:
          this.$ = new ast.CssRectNode('w', $$[$0 - 2].slice(1, -1), 'closest');
          break;

        case 84:
          this.$ = new ast.CssRectNode('h', $$[$0 - 2].slice(1, -1), 'closest');
          break;

        case 85:
          this.$ = new ast.CssRectNode('x', $$[$0 - 2].slice(1, -1), 'closest');
          break;

        case 86:
          this.$ = new ast.CssRectNode('y', $$[$0 - 2].slice(1, -1), 'closest');
          break;

        case 87:
          this.$ = new ast.CssNumConvertNode($$[$0 - 1]);
          break;

        case 88:
          this.$ = new ast.CssRandNode();
          break;

        case 89:
          this.$ = new ast.CssRandNode($$[$0 - 3], $$[$0 - 1]);
          break;

        case 90:
          this.$ = new ast.CssIndexNode();
          break;

        case 91:
          this.$ = new ast.CssLengthFuncNode();
          break;

        case 92:
          this.$ = new ast.CssVarNode($$[$0 - 1]);
          break;

        case 93:
          this.$ = new ast.CssVarNode($$[$0 - 3], $$[$0 - 1]);
          break;

        case 94:
          this.$ = new ast.CssCalcNode($$[$0 - 1]);
          break;

        case 96:
          var calc_expr_list = $$[$0 - 2];
          calc_expr_list.push($$[$0]);
          this.$ = calc_expr_list;
          break;

        case 97:
          this.$ = new ast.CssMinMaxNode('min', $$[$0 - 1]);
          break;

        case 98:
          this.$ = new ast.CssMinMaxNode('max', $$[$0 - 1]);
          break;

        case 99:
          this.$ = new ast.CssMinMaxNode('clamp', $$[$0 - 1]);
          break;

        case 101:
          this.$ = $$[$0 - 1];
          break;

        case 102:
          this.$ = new ast.CssCalcProductNode($$[$0 - 2], $$[$0], '*');
          break;

        case 103:
          this.$ = new ast.CssCalcProductNode($$[$0 - 2], $$[$0], '/');
          break;

        case 104:
          this.$ = new ast.CssCalcSumNode($$[$0 - 2], $$[$0], '+');
          break;

        case 105:
          this.$ = new ast.CssCalcSumNode($$[$0 - 2], $$[$0], '-');
          break;
      }
    },
    table: [{
      3: 1,
      4: 2,
      5: [1, 3],
      6: 4,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      1: [3]
    }, {
      5: [1, 74],
      6: 75,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      1: [2, 2]
    }, o($VL, [2, 3]), o($VM, [2, 5]), o($VM, [2, 6]), o($VM, [2, 7]), o($VM, [2, 8]), o($VM, [2, 9]), o($VM, [2, 10]), o($VM, [2, 11]), o($VM, [2, 12]), o($VM, [2, 13]), o($VM, [2, 14]), o($VM, [2, 15]), o($VM, [2, 34]), o($VM, [2, 35]), o($VM, [2, 36]), o($VM, [2, 37]), o($VM, [2, 38]), o($VM, [2, 39]), o($VM, [2, 40]), o($VM, [2, 41]), o($VM, [2, 42]), o($VM, [2, 43]), o($VM, [2, 44]), o($VM, [2, 45]), o($VM, [2, 46]), o($VM, [2, 47]), o($VM, [2, 48]), o($VM, [2, 49]), o($VM, [2, 16]), o($VM, [2, 17]), o($VM, [2, 18]), o($VM, [2, 19]), o($VM, [2, 20]), o($VM, [2, 21]), o($VM, [2, 22]), o($VM, [2, 23]), o($VM, [2, 24]), o($VM, [2, 25]), o($VM, [2, 26]), o($VM, [2, 27]), o($VM, [2, 28]), o($VM, [2, 29]), o($VM, [2, 30]), o($VM, [2, 31]), o($VM, [2, 32]), o($VM, [2, 33]), {
      9: [1, 76]
    }, {
      81: [1, 77]
    }, {
      6: 79,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      83: 78,
      85: $VI,
      86: $VJ,
      87: $VK,
      88: $VN
    }, {
      6: 82,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      54: 81,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      6: 82,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      54: 83,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      6: 82,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      54: 84,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      6: 82,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      54: 85,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      6: 82,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      54: 86,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      9: [1, 88],
      53: [1, 87],
      75: [1, 89]
    }, {
      9: [1, 91],
      53: [1, 90],
      75: [1, 92]
    }, {
      9: [1, 94],
      53: [1, 93],
      75: [1, 95]
    }, {
      9: [1, 97],
      53: [1, 96],
      75: [1, 98]
    }, {
      6: 99,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      6: 101,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [1, 100],
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      53: [1, 102]
    }, {
      53: [1, 103]
    }, {
      4: 104,
      6: 4,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      6: 107,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [1, 105],
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      68: [1, 106],
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      4: 110,
      6: 4,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [1, 108],
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      68: [1, 109],
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      6: 112,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      58: 111,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      6: 79,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      83: 114,
      84: 113,
      85: $VI,
      86: $VJ,
      87: $VK,
      88: $VN
    }, {
      6: 79,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      83: 114,
      84: 115,
      85: $VI,
      86: $VJ,
      87: $VK,
      88: $VN
    }, {
      6: 79,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      83: 114,
      84: 116,
      85: $VI,
      86: $VJ,
      87: $VK,
      88: $VN
    }, {
      6: 82,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [1, 117],
      54: 118,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      1: [2, 1]
    }, o($VL, [2, 4]), {
      53: [1, 119]
    }, {
      53: [1, 120],
      55: [1, 121]
    }, {
      53: [1, 122],
      57: $VO,
      89: $VP,
      90: $VQ,
      91: $VR
    }, o($VS, [2, 100]), {
      6: 79,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      83: 127,
      85: $VI,
      86: $VJ,
      87: $VK,
      88: $VN
    }, {
      53: [1, 128],
      55: $VT
    }, o($VU, [2, 52]), {
      53: [1, 130],
      55: $VT
    }, {
      53: [1, 131],
      55: $VT
    }, {
      53: [1, 132],
      55: $VT
    }, {
      53: [1, 133],
      55: $VT
    }, o($VM, [2, 75]), {
      53: [1, 134]
    }, {
      9: [1, 135]
    }, o($VM, [2, 76]), {
      53: [1, 136]
    }, {
      9: [1, 137]
    }, o($VM, [2, 77]), {
      53: [1, 138]
    }, {
      9: [1, 139]
    }, o($VM, [2, 78]), {
      53: [1, 140]
    }, {
      9: [1, 141]
    }, {
      53: [1, 142]
    }, o($VM, [2, 88]), {
      55: [1, 143]
    }, o($VM, [2, 90]), o($VM, [2, 91]), {
      6: 75,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [1, 145],
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      66: [1, 144],
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, o($VM, [2, 66]), {
      4: 146,
      6: 4,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      53: [1, 148],
      68: [1, 147]
    }, o($VM, [2, 70]), {
      4: 149,
      6: 4,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      6: 75,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [1, 151],
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      68: [1, 150],
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      53: [1, 152],
      55: [1, 153]
    }, {
      6: 154,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      53: [1, 155],
      55: $VV
    }, o($VU, [2, 95], {
      57: $VO,
      89: $VP,
      90: $VQ,
      91: $VR
    }), {
      53: [1, 157],
      55: $VV
    }, {
      53: [1, 158],
      55: $VV
    }, o($VM, [2, 50]), {
      53: [1, 159],
      55: $VT
    }, o($VM, [2, 58]), o($VM, [2, 92]), {
      6: 160,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, o($VM, [2, 94]), {
      6: 79,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      83: 161,
      85: $VI,
      86: $VJ,
      87: $VK,
      88: $VN
    }, {
      6: 79,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      83: 162,
      85: $VI,
      86: $VJ,
      87: $VK,
      88: $VN
    }, {
      6: 79,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      83: 163,
      85: $VI,
      86: $VJ,
      87: $VK,
      88: $VN
    }, {
      6: 79,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      83: 164,
      85: $VI,
      86: $VJ,
      87: $VK,
      88: $VN
    }, {
      53: [1, 165],
      57: $VO,
      89: $VP,
      90: $VQ,
      91: $VR
    }, o($VM, [2, 59]), {
      6: 166,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, o($VM, [2, 60]), o($VM, [2, 61]), o($VM, [2, 62]), o($VM, [2, 63]), o($VM, [2, 79]), {
      53: [1, 167]
    }, o($VM, [2, 80]), {
      53: [1, 168]
    }, o($VM, [2, 81]), {
      53: [1, 169]
    }, o($VM, [2, 82]), {
      53: [1, 170]
    }, o($VM, [2, 87]), {
      6: 171,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      4: 173,
      6: 4,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      56: 172,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, o($VM, [2, 65]), {
      6: 75,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [1, 174],
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      4: 175,
      6: 4,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, o($VM, [2, 69]), {
      6: 75,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [1, 176],
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      4: 177,
      6: 4,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, o($VM, [2, 73]), o($VM, [2, 74]), {
      6: 178,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, o($VU, [2, 56]), o($VM, [2, 97]), {
      6: 79,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      83: 179,
      85: $VI,
      86: $VJ,
      87: $VK,
      88: $VN
    }, o($VM, [2, 98]), o($VM, [2, 99]), o($VM, [2, 51]), {
      53: [1, 180]
    }, o($VS, [2, 102]), o($VS, [2, 103]), o($VW, [2, 104], {
      57: $VO,
      89: $VP
    }), o($VW, [2, 105], {
      57: $VO,
      89: $VP
    }), o($VS, [2, 101]), o($VU, [2, 53]), {
      53: [1, 181]
    }, {
      53: [1, 182]
    }, {
      53: [1, 183]
    }, {
      53: [1, 184]
    }, {
      53: [1, 185]
    }, {
      53: [1, 186]
    }, {
      6: 75,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [2, 54],
      57: [1, 187],
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, o($VM, [2, 67]), {
      6: 75,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [1, 188],
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, o($VM, [2, 71]), {
      6: 75,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [1, 189],
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, {
      6: 190,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, o($VU, [2, 96], {
      57: $VO,
      89: $VP,
      90: $VQ,
      91: $VR
    }), o($VM, [2, 93]), o($VM, [2, 83]), o($VM, [2, 84]), o($VM, [2, 85]), o($VM, [2, 86]), o($VM, [2, 89]), o($VM, [2, 64]), {
      4: 191,
      6: 4,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }, o($VM, [2, 68]), o($VM, [2, 72]), o($VU, [2, 57]), {
      6: 75,
      7: 5,
      8: 6,
      9: $V0,
      10: $V1,
      11: $V2,
      12: 10,
      13: 11,
      14: 12,
      15: 13,
      16: $V3,
      17: $V4,
      18: $V5,
      19: $V6,
      20: $V7,
      21: $V8,
      22: $V9,
      23: $Va,
      24: $Vb,
      25: $Vc,
      26: $Vd,
      27: $Ve,
      28: $Vf,
      29: $Vg,
      30: $Vh,
      31: $Vi,
      32: $Vj,
      33: $Vk,
      34: $Vl,
      35: $Vm,
      36: 16,
      37: 17,
      38: 18,
      39: 19,
      40: 20,
      41: 21,
      42: 22,
      43: 23,
      44: 24,
      45: 25,
      46: 26,
      47: 27,
      48: 28,
      49: 29,
      50: 30,
      51: 31,
      52: $Vn,
      53: [2, 55],
      59: $Vo,
      60: $Vp,
      61: $Vq,
      62: $Vr,
      63: $Vs,
      64: $Vt,
      65: $Vu,
      67: $Vv,
      69: $Vw,
      70: $Vx,
      71: $Vy,
      72: $Vz,
      73: $VA,
      74: $VB,
      76: $VC,
      77: $VD,
      78: $VE,
      79: $VF,
      80: $VG,
      82: $VH,
      85: $VI,
      86: $VJ,
      87: $VK
    }],
    defaultActions: {
      3: [2, 2],
      74: [2, 1]
    },
    parseError: function parseError(str, hash) {
      if (hash.recoverable) {
        this.trace(str);
      } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
      }
    },
    parse: function parse(input) {
      var self = this,
          stack = [0],
          tstack = [],
          vstack = [null],
          lstack = [],
          table = this.table,
          yytext = '',
          yylineno = 0,
          yyleng = 0,
          recovering = 0,
          TERROR = 2,
          EOF = 1;
      var args = lstack.slice.call(arguments, 1);
      var lexer = Object.create(this.lexer);
      var sharedState = {
        yy: {}
      };

      for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
          sharedState.yy[k] = this.yy[k];
        }
      }

      lexer.setInput(input, sharedState.yy);
      sharedState.yy.lexer = lexer;
      sharedState.yy.parser = this;

      if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
      }

      var yyloc = lexer.yylloc;
      lstack.push(yyloc);
      var ranges = lexer.options && lexer.options.ranges;

      if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
      } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
      }

      function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
      }

      var lex = function lex() {
        var token;
        token = lexer.lex() || EOF;

        if (typeof token !== 'number') {
          token = self.symbols_[token] || token;
        }

        return token;
      };

      var symbol,
          preErrorSymbol,
          state,
          action,
          a,
          r,
          yyval = {},
          p,
          len,
          newState,
          expected;

      while (true) {
        state = stack[stack.length - 1];

        if (this.defaultActions[state]) {
          action = this.defaultActions[state];
        } else {
          if (symbol === null || typeof symbol == 'undefined') {
            symbol = lex();
          }

          action = table[state] && table[state][symbol];
        }

        if (typeof action === 'undefined' || !action.length || !action[0]) {
          var errStr = '';
          expected = [];

          for (p in table[state]) {
            if (this.terminals_[p] && p > TERROR) {
              expected.push('\'' + this.terminals_[p] + '\'');
            }
          }

          if (lexer.showPosition) {
            errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
          } else {
            errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
          }

          this.parseError(errStr, {
            text: lexer.match,
            token: this.terminals_[symbol] || symbol,
            line: lexer.yylineno,
            loc: yyloc,
            expected: expected
          });
        }

        if (action[0] instanceof Array && action.length > 1) {
          throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }

        switch (action[0]) {
          case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;

            if (!preErrorSymbol) {
              yyleng = lexer.yyleng;
              yytext = lexer.yytext;
              yylineno = lexer.yylineno;
              yyloc = lexer.yylloc;

              if (recovering > 0) {
                recovering--;
              }
            } else {
              symbol = preErrorSymbol;
              preErrorSymbol = null;
            }

            break;

          case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
              first_line: lstack[lstack.length - (len || 1)].first_line,
              last_line: lstack[lstack.length - 1].last_line,
              first_column: lstack[lstack.length - (len || 1)].first_column,
              last_column: lstack[lstack.length - 1].last_column
            };

            if (ranges) {
              yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
            }

            r = this.performAction.apply(yyval, [yytext, yyleng, yylineno, sharedState.yy, action[1], vstack, lstack].concat(args));

            if (typeof r !== 'undefined') {
              return r;
            }

            if (len) {
              stack = stack.slice(0, -1 * len * 2);
              vstack = vstack.slice(0, -1 * len);
              lstack = lstack.slice(0, -1 * len);
            }

            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;

          case 3:
            return true;
        }
      }

      return true;
    }
  };

  /* generated by jison-lex 0.3.4 */
  var lexer = function () {
    var lexer = {
      EOF: 1,
      parseError: function parseError(str, hash) {
        if (this.yy.parser) {
          this.yy.parser.parseError(str, hash);
        } else {
          throw new Error(str);
        }
      },
      // resets the lexer, sets new input
      setInput: function setInput(input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
          first_line: 1,
          first_column: 0,
          last_line: 1,
          last_column: 0
        };

        if (this.options.ranges) {
          this.yylloc.range = [0, 0];
        }

        this.offset = 0;
        return this;
      },
      // consumes and returns one char from the input
      input: function input() {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);

        if (lines) {
          this.yylineno++;
          this.yylloc.last_line++;
        } else {
          this.yylloc.last_column++;
        }

        if (this.options.ranges) {
          this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
      },
      // unshifts one char (or a string) into the input
      unput: function unput(ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);
        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
          this.yylineno -= lines.length - 1;
        }

        var r = this.yylloc.range;
        this.yylloc = {
          first_line: this.yylloc.first_line,
          last_line: this.yylineno + 1,
          first_column: this.yylloc.first_column,
          last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
        };

        if (this.options.ranges) {
          this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }

        this.yyleng = this.yytext.length;
        return this;
      },
      // When called from action, caches matched text and appends it on next action
      more: function more() {
        this._more = true;
        return this;
      },
      // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
      reject: function reject() {
        if (this.options.backtrack_lexer) {
          this._backtrack = true;
        } else {
          return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        }

        return this;
      },
      // retain first n characters of the match
      less: function less(n) {
        this.unput(this.match.slice(n));
      },
      // displays already matched input, i.e. for error messages
      pastInput: function pastInput() {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
      },
      // displays upcoming input, i.e. for error messages
      upcomingInput: function upcomingInput() {
        var next = this.match;

        if (next.length < 20) {
          next += this._input.substr(0, 20 - next.length);
        }

        return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
      },
      // displays the character position where the lexing error occurred, i.e. for error messages
      showPosition: function showPosition() {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
      },
      // test the lexed token: return FALSE when not a match, otherwise return token
      test_match: function test_match(match, indexed_rule) {
        var token, lines, backup;

        if (this.options.backtrack_lexer) {
          // save context
          backup = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          };

          if (this.options.ranges) {
            backup.yylloc.range = this.yylloc.range.slice(0);
          }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);

        if (lines) {
          this.yylineno += lines.length;
        }

        this.yylloc = {
          first_line: this.yylloc.last_line,
          last_line: this.yylineno + 1,
          first_column: this.yylloc.last_column,
          last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;

        if (this.options.ranges) {
          this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }

        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);

        if (this.done && this._input) {
          this.done = false;
        }

        if (token) {
          return token;
        } else if (this._backtrack) {
          // recover context
          for (var k in backup) {
            this[k] = backup[k];
          }

          return false;
        }

        return false;
      },
      // return next match in input
      next: function next() {
        if (this.done) {
          return this.EOF;
        }

        if (!this._input) {
          this.done = true;
        }

        var token, match, tempMatch, index;

        if (!this._more) {
          this.yytext = '';
          this.match = '';
        }

        var rules = this._currentRules();

        for (var i = 0; i < rules.length; i++) {
          tempMatch = this._input.match(this.rules[rules[i]]);

          if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
            match = tempMatch;
            index = i;

            if (this.options.backtrack_lexer) {
              token = this.test_match(tempMatch, rules[i]);

              if (token !== false) {
                return token;
              } else if (this._backtrack) {
                match = false;
                continue;
              } else {
                // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                return false;
              }
            } else if (!this.options.flex) {
              break;
            }
          }
        }

        if (match) {
          token = this.test_match(match, rules[index]);

          if (token !== false) {
            return token;
          }

          // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
          return false;
        }

        if (this._input === "") {
          return this.EOF;
        } else {
          return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        }
      },
      // return next match that has a token
      lex: function lex() {
        var r = this.next();

        if (r) {
          return r;
        } else {
          return this.lex();
        }
      },
      // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
      begin: function begin(condition) {
        this.conditionStack.push(condition);
      },
      // pop the previously active lexer condition state off the condition stack
      popState: function popState() {
        var n = this.conditionStack.length - 1;

        if (n > 0) {
          return this.conditionStack.pop();
        } else {
          return this.conditionStack[0];
        }
      },
      // produce the lexer rule set which is active for the currently active lexer condition state
      _currentRules: function _currentRules() {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
          return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
          return this.conditions["INITIAL"].rules;
        }
      },
      // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
      topState: function topState(n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);

        if (n >= 0) {
          return this.conditionStack[n];
        } else {
          return "INITIAL";
        }
      },
      // alias for begin(condition)
      pushState: function pushState(condition) {
        this.begin(condition);
      },
      // return the number of states currently on the stack
      stateStackSize: function stateStackSize() {
        return this.conditionStack.length;
      },
      options: {},
      performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
        var YYSTATE = YY_START;

        switch ($avoiding_name_collisions) {
          case 0:
            /* skip whitespace */
            break;

          case 1:
            return 18;
            break;

          case 2:
            return 19;
            break;

          case 3:
            return 20;
            break;

          case 4:
            return 21;
            break;

          case 5:
            return 22;
            break;

          case 6:
            return 23;
            break;

          case 7:
            return 24;
            break;

          case 8:
            return 25;
            break;

          case 9:
            return 26;
            break;

          case 10:
            return 27;
            break;

          case 11:
            return 28;
            break;

          case 12:
            return 29;
            break;

          case 13:
            return 30;
            break;

          case 14:
            return 31;
            break;

          case 15:
            return 32;
            break;

          case 16:
            return 33;
            break;

          case 17:
            return 34;
            break;

          case 18:
            return 35;
            break;

          case 19:
            return 11;
            break;

          case 20:
            return 10;
            break;

          case 21:
            return 16;
            break;

          case 22:
            return 68;
            break;

          case 23:
            return 66;
            break;

          case 24:
            return 59;
            break;

          case 25:
            return 82;
            break;

          case 26:
            return 85;
            break;

          case 27:
            return 86;
            break;

          case 28:
            return 87;
            break;

          case 29:
            return 80;
            break;

          case 30:
            return 60;
            break;

          case 31:
            return 61;
            break;

          case 32:
            return 62;
            break;

          case 33:
            return 63;
            break;

          case 34:
            return 64;
            break;

          case 35:
            return 77;
            break;

          case 36:
            return 78;
            break;

          case 37:
            return 79;
            break;

          case 38:
            return 71;
            break;

          case 39:
            return 72;
            break;

          case 40:
            return 75;
            break;

          case 41:
            return 76;
            break;

          case 42:
            return 65;
            break;

          case 43:
            return 67;
            break;

          case 44:
            return 69;
            break;

          case 45:
            return 70;
            break;

          case 46:
            return 73;
            break;

          case 47:
            return 74;
            break;

          case 48:
            return 52;
            break;

          case 49:
            return 17;
            break;

          case 50:
            return 81;
            break;

          case 51:
            return 9;
            break;

          case 52:
            return 90;
            break;

          case 53:
            return 91;
            break;

          case 54:
            return 89;
            break;

          case 55:
            return 57;
            break;

          case 56:
            return 88;
            break;

          case 57:
            return 53;
            break;

          case 58:
            return 55;
            break;

          case 59:
            return 'INVALID';
            break;

          case 60:
            return 5;
            break;
        }
      },
      rules: [/^(?:\s+)/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Pp])([Xx]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Ee])([Mm]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Rr])([Ee])([Mm]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Vv])([Hh]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Vv])([Ww]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Vv])([Mm])([Ii])([Nn]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Vv])([Mm])([Aa])([Xx]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Cc])([Mm]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Mm])([Mm]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Qq]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Ii])([Nn]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Pp])([Cc]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Pp])([Tt]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Dd])([Ee])([Gg]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Rr])([Aa])([Dd]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Gg])([Rr])([Aa])([Dd]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Mm])([Ss]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)([Ss]))/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)%)/, /^(?:([+-]?[0-9]+(\.[0-9]+)?([eE][+\-]?[0-9]+)?|[+-]?\.[0-9]+([eE][+\-]?[0-9]+)?)\b)/, /^(?:#([a-fA-F0-9]+))/, /^(?:([Aa])([Tt]))/, /^(?:([Rr])([Oo])([Uu])([Nn])([Dd]))/, /^(?:([Uu])([Rr])([Ll])\()/, /^(?:([Cc])([Aa])([Ll])([Cc])\()/, /^(?:([Mm])([Ii])([Nn])\()/, /^(?:([Mm])([Aa])([Xx])\()/, /^(?:([Cc])([Ll])([Aa])([Mm])([Pp])\()/, /^(?:([Vv])([Aa])([Rr])\()/, /^(?:([Tt])([Rr])([Aa])([Nn])([Ss])([Ll])([Aa])([Tt])([Ee])\()/, /^(?:([Tt])([Rr])([Aa])([Nn])([Ss])([Ll])([Aa])([Tt])([Ee])([Xx])\()/, /^(?:([Tt])([Rr])([Aa])([Nn])([Ss])([Ll])([Aa])([Tt])([Ee])([Yy])\()/, /^(?:([Tt])([Rr])([Aa])([Nn])([Ss])([Ll])([Aa])([Tt])([Ee])([Zz])\()/, /^(?:([Tt])([Rr])([Aa])([Nn])([Ss])([Ll])([Aa])([Tt])([Ee])3([Dd])\()/, /^(?:([Rr])([Aa])([Nn])([Dd])\()/, /^(?:([Ii])([Nn])([Dd])([Ee])([Xx])\()/, /^(?:([Ll])([Ee])([Nn])([Gg])([Tt])([Hh])\()/, /^(?:([Ww])([Ii])([Dd])([Tt])([Hh])\()/, /^(?:([Hh])([Ee])([Ii])([Gg])([Hh])([Tt])\()/, /^(?:([Cc])([Ll])([Oo])([Ss])([Ee])([Ss])([Tt])\()/, /^(?:([Nn])([Uu])([Mm])\()/, /^(?:([Ii])([Nn])([Ss])([Ee])([Tt])\()/, /^(?:([Cc])([Ii])([Rr])([Cc])([Ll])([Ee])\()/, /^(?:([Ee])([Ll])([Ll])([Ii])([Pp])([Ss])([Ee])\()/, /^(?:([Pp])([Oo])([Ll])([Yy])([Gg])([Oo])([Nn])\()/, /^(?:([Xx])\()/, /^(?:([Yy])\()/, /^(?:(-?[a-zA-Z_][\-a-zA-Z0-9_]*)\()/, /^(?:(-?[a-zA-Z_][\-a-zA-Z0-9_]*))/, /^(?:--(-?[a-zA-Z_][\-a-zA-Z0-9_]*))/, /^(?:('[^\']*'|"[^\"]*"))/, /^(?:\+)/, /^(?:-)/, /^(?:\*)/, /^(?:\/)/, /^(?:\()/, /^(?:\))/, /^(?:,)/, /^(?:.)/, /^(?:$)/],
      conditions: {
        "INITIAL": {
          "rules": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60],
          "inclusive": true
        }
      }
    };
    return lexer;
  }();

  parser.lexer = lexer;

  function Parser() {
    this.yy = {};
  }

  Parser.prototype = parser;
  parser.Parser = Parser;
  return new Parser();
}();

var cssParser = parser;
exports.cssParser = cssParser;

},{"../../extensions/amp-animation/0.1/parsers/css-expr-ast":4}],2:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpAnimation = void 0;

var _resolvedPromise10 = require("./../../../src/resolved-promise");

var _actionConstants = require("../../../src/action-constants");

var _webAnimations = require("./web-animations");

var _pass = require("../../../src/pass");

var _services = require("../../../src/services");

var _webAnimationTypes = require("./web-animation-types");

var _webAnimationService = require("./web-animation-service");

var _math = require("../../../src/utils/math");

var _log = require("../../../src/log");

var _json = require("../../../src/json");

var _eventHelper = require("../../../src/event-helper");

var _iframeHelper = require("../../../src/iframe-helper");

var _service = require("../../../src/service");

var _installPolyfill = require("./install-polyfill");

var _types = require("../../../src/types");

var _style = require("../../../src/style");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TAG = 'amp-animation';

var AmpAnimation = /*#__PURE__*/function (_AMP$BaseElement) {
  _inherits(AmpAnimation, _AMP$BaseElement);

  var _super = _createSuper(AmpAnimation);

  /** @param {!AmpElement} element */
  function AmpAnimation(element) {
    var _this;

    _classCallCheck(this, AmpAnimation);

    _this = _super.call(this, element);

    /** @private {boolean} */
    _this.triggerOnVisibility_ = false;

    /** @private {boolean} */
    _this.isIntersecting_ = false;

    /** @private {boolean} */
    _this.visible_ = false;

    /** @private {boolean} */
    _this.pausedByAction_ = false;

    /** @private {boolean} */
    _this.triggered_ = false;

    /** @private {!Array<!UnlistenDef>} */
    _this.cleanups_ = [];

    /** @private {?../../../src/friendly-iframe-embed.FriendlyIframeEmbed} */
    _this.embed_ = null;

    /** @private {?JsonObject} */
    _this.configJson_ = null;

    /** @private {?./runners/animation-runner.AnimationRunner} */
    _this.runner_ = null;

    /** @private {?Promise} */
    _this.runnerPromise_ = null;

    /** @private {?Pass} */
    _this.restartPass_ = null;
    return _this;
  }

  /** @override */
  _createClass(AmpAnimation, [{
    key: "buildCallback",
    value: function buildCallback() {
      var _this2 = this;

      var ampdoc = this.getAmpDoc();
      // Trigger.
      var trigger = this.element.getAttribute('trigger');

      if (trigger) {
        this.triggerOnVisibility_ = (0, _log.userAssert)(trigger == 'visibility', 'Only allowed value for "trigger" is "visibility": %s', this.element);
      }

      this.configJson_ = (0, _json.getChildJsonConfig)(this.element);

      if (this.triggerOnVisibility_) {
        // Make the element minimally displayed to make sure that `layoutCallback`
        // is called.
        this.mutateElement(function () {
          (0, _style.setStyles)(_this2.element, {
            visibility: 'hidden',
            top: '0px',
            left: '0px',
            width: '1px',
            height: '1px',
            position: 'fixed'
          });
          (0, _style.toggle)(_this2.element, true);
          (0, _style.setInitialDisplay)(_this2.element, 'block');
        });
      }

      // Restart with debounce.
      this.restartPass_ = new _pass.Pass(this.win, function () {
        if (!_this2.pausedByAction_) {
          _this2.startOrResume_();
        }
      },
      /* delay */
      50);
      // Visibility.
      this.cleanups_.push(ampdoc.onVisibilityChanged(function () {
        _this2.setVisible_(_this2.isIntersecting_ && ampdoc.isVisible());
      }));
      var io = new ampdoc.win.IntersectionObserver(function (records) {
        _this2.isIntersecting_ = records[records.length - 1].isIntersecting;

        _this2.setVisible_(_this2.isIntersecting_ && ampdoc.isVisible());
      });
      io.observe((0, _log.dev)().assertElement(this.element.parentElement));
      this.cleanups_.push(function () {
        return io.disconnect();
      });
      // Resize.
      this.cleanups_.push((0, _eventHelper.listen)(this.win, 'resize', function () {
        return _this2.onResize_();
      }));
      // TODO(#22733): remove when ampdoc-fie is launched.
      var frameElement = (0, _service.getParentWindowFrameElement)(this.element, ampdoc.win);
      var embed = frameElement ? (0, _iframeHelper.getFriendlyIframeEmbedOptional)(frameElement) : null;
      this.embed_ = embed;
      // Actions.
      this.registerDefaultAction(this.startAction_.bind(this), 'start', _actionConstants.ActionTrust.LOW);
      this.registerAction('restart', this.restartAction_.bind(this), _actionConstants.ActionTrust.LOW);
      this.registerAction('pause', this.pauseAction_.bind(this), _actionConstants.ActionTrust.LOW);
      this.registerAction('resume', this.resumeAction_.bind(this), _actionConstants.ActionTrust.LOW);
      this.registerAction('togglePause', this.togglePauseAction_.bind(this), _actionConstants.ActionTrust.LOW);
      this.registerAction('seekTo', this.seekToAction_.bind(this), _actionConstants.ActionTrust.LOW);
      this.registerAction('reverse', this.reverseAction_.bind(this), _actionConstants.ActionTrust.LOW);
      this.registerAction('finish', this.finishAction_.bind(this), _actionConstants.ActionTrust.LOW);
      this.registerAction('cancel', this.cancelAction_.bind(this), _actionConstants.ActionTrust.LOW);
    }
    /** @override */

  }, {
    key: "detachedCallback",
    value: function detachedCallback() {
      var cleanups = this.cleanups_.slice(0);
      this.cleanups_.length = 0;
      cleanups.forEach(function (cleanup) {
        return cleanup();
      });
    }
    /**
     * Returns the animation spec.
     * @return {?JsonObject}
     */

  }, {
    key: "getAnimationSpec",
    value: function getAnimationSpec() {
      return (
        /** @type {?JsonObject} */
        this.configJson_
      );
    }
    /** @override */

  }, {
    key: "layoutCallback",
    value: function layoutCallback() {
      if (this.triggerOnVisibility_) {
        this.startAction_();
      }

      return (0, _resolvedPromise10.resolvedPromise)();
    }
    /** @override */

  }, {
    key: "pauseCallback",
    value: function pauseCallback() {
      this.setVisible_(false);
    }
    /**
     * @param {?../../../src/service/action-impl.ActionInvocation=} opt_invocation
     * @return {?Promise}
     * @private
     */

  }, {
    key: "startAction_",
    value: function startAction_(opt_invocation) {
      // The animation has been triggered, but there's no guarantee that it
      // will actually be running.
      this.triggered_ = true;

      if (this.visible_) {
        return this.startOrResume_(opt_invocation ? opt_invocation.args : null);
      }

      return (0, _resolvedPromise10.resolvedPromise)();
    }
    /**
     * @param {!../../../src/service/action-impl.ActionInvocation} invocation
     * @return {?Promise}
     * @private
     */

  }, {
    key: "restartAction_",
    value: function restartAction_(invocation) {
      this.cancel_();
      // The animation has been triggered, but there's no guarantee that it
      // will actually be running.
      this.triggered_ = true;

      if (this.visible_) {
        return this.startOrResume_(invocation.args);
      }

      return (0, _resolvedPromise10.resolvedPromise)();
    }
    /**
     * @return {?Promise}
     * @private
     */

  }, {
    key: "pauseAction_",
    value: function pauseAction_() {
      var _this3 = this;

      if (!this.triggered_) {
        return (0, _resolvedPromise10.resolvedPromise)();
      }

      return this.createRunnerIfNeeded_().then(function () {
        _this3.pause_();

        _this3.pausedByAction_ = true;
      });
    }
    /**
     * @return {?Promise}
     * @private
     */

  }, {
    key: "resumeAction_",
    value: function resumeAction_() {
      var _this4 = this;

      if (!this.triggered_) {
        return (0, _resolvedPromise10.resolvedPromise)();
      }

      return this.createRunnerIfNeeded_().then(function () {
        if (_this4.visible_) {
          _this4.runner_.resume();

          _this4.pausedByAction_ = false;
        }
      });
    }
    /**
     * @return {?Promise}
     * @private
     */

  }, {
    key: "togglePauseAction_",
    value: function togglePauseAction_() {
      var _this5 = this;

      if (!this.triggered_) {
        return (0, _resolvedPromise10.resolvedPromise)();
      }

      return this.createRunnerIfNeeded_().then(function () {
        if (_this5.visible_) {
          if (_this5.runner_.getPlayState() == _webAnimationTypes.WebAnimationPlayState.PAUSED) {
            return _this5.startOrResume_();
          } else {
            _this5.pause_();

            _this5.pausedByAction_ = true;
          }
        }
      });
    }
    /**
     * @param {!../../../src/service/action-impl.ActionInvocation} invocation
     * @return {?Promise}
     * @private
     */

  }, {
    key: "seekToAction_",
    value: function seekToAction_(invocation) {
      var _this6 = this;

      var positionObserverData = null;

      if (invocation.event) {
        var detail = (0, _eventHelper.getDetail)(
        /** @type {!Event} */
        invocation.event);

        if (detail) {
          positionObserverData = detail['positionObserverData'] || null;
        }
      }

      return this.createRunnerIfNeeded_(null, positionObserverData).then(function () {
        // The animation will be triggered (in paused state) and seek will happen
        // regardless of visibility
        _this6.triggered_ = true;

        _this6.pause_();

        _this6.pausedByAction_ = true;
        // time based seek
        var time = parseFloat(invocation.args && invocation.args['time']);

        if ((0, _types.isFiniteNumber)(time)) {
          _this6.runner_.seekTo(time);
        }

        // percent based seek
        var percent = parseFloat(invocation.args && invocation.args['percent']);

        if ((0, _types.isFiniteNumber)(percent)) {
          _this6.runner_.seekToPercent((0, _math.clamp)(percent, 0, 1));
        }
      });
    }
    /**
     * @return {?Promise}
     * @private
     */

  }, {
    key: "reverseAction_",
    value: function reverseAction_() {
      var _this7 = this;

      if (!this.triggered_) {
        return (0, _resolvedPromise10.resolvedPromise)();
      }

      return this.createRunnerIfNeeded_().then(function () {
        if (_this7.visible_) {
          _this7.runner_.reverse();
        }
      });
    }
    /**
     * @return {?Promise}
     * @private
     */

  }, {
    key: "finishAction_",
    value: function finishAction_() {
      this.finish_();
      return (0, _resolvedPromise10.resolvedPromise)();
    }
    /**
     * @return {?Promise}
     * @private
     */

  }, {
    key: "cancelAction_",
    value: function cancelAction_() {
      this.cancel_();
      return (0, _resolvedPromise10.resolvedPromise)();
    }
    /**
     * @param {boolean} visible
     * @private
     */

  }, {
    key: "setVisible_",
    value: function setVisible_(visible) {
      if (this.visible_ != visible) {
        this.visible_ = visible;

        if (this.triggered_) {
          if (this.visible_) {
            if (!this.pausedByAction_) {
              this.startOrResume_();
            }
          } else {
            this.pause_();
          }
        }
      }
    }
    /** @private */

  }, {
    key: "onResize_",
    value: function onResize_() {
      // Store the previous `triggered` and `pausedByAction` value since
      // `cancel` may reset it.
      var triggered = this.triggered_,
          pausedByAction = this.pausedByAction_;

      // Stop animation right away.
      if (this.runner_) {
        this.runner_.cancel();
        this.runner_ = null;
        this.runnerPromise_ = null;
      }

      // Restart the animation, but debounce to avoid re-starting it multiple
      // times per restart.
      this.triggered_ = triggered;
      this.pausedByAction_ = pausedByAction;

      if (this.triggered_ && this.visible_) {
        this.restartPass_.schedule();
      }
    }
    /**
     * @param {?JsonObject=} opt_args
     * @return {?Promise}
     * @private
     */

  }, {
    key: "startOrResume_",
    value: function startOrResume_(opt_args) {
      var _this8 = this;

      if (!this.triggered_ || !this.visible_) {
        return null;
      }

      this.pausedByAction_ = false;

      if (this.runner_) {
        this.runner_.resume();
        return null;
      }

      return this.createRunnerIfNeeded_(opt_args).then(function () {
        _this8.runner_.start();
      });
    }
    /**
     * Creates the runner but animations will not start.
     * @param {?JsonObject=} opt_args
     * @param {?JsonObject=} opt_positionObserverData
     * @return {!Promise}
     * @private
     */

  }, {
    key: "createRunnerIfNeeded_",
    value: function createRunnerIfNeeded_(opt_args, opt_positionObserverData) {
      var _this9 = this;

      if (!this.runnerPromise_) {
        this.runnerPromise_ = this.createRunner_(opt_args, opt_positionObserverData).then(function (runner) {
          _this9.runner_ = runner;

          _this9.runner_.onPlayStateChanged(_this9.playStateChanged_.bind(_this9));

          _this9.runner_.init();
        });
      }

      return this.runnerPromise_;
    }
    /** @private */

  }, {
    key: "finish_",
    value: function finish_() {
      this.triggered_ = false;
      this.pausedByAction_ = false;

      if (this.runner_) {
        this.runner_.finish();
        this.runner_ = null;
        this.runnerPromise_ = null;
      }
    }
    /** @private */

  }, {
    key: "cancel_",
    value: function cancel_() {
      this.triggered_ = false;
      this.pausedByAction_ = false;

      if (this.runner_) {
        this.runner_.cancel();
        this.runner_ = null;
        this.runnerPromise_ = null;
      }
    }
    /**
     * @param {?JsonObject=} opt_args
     * @param {?JsonObject=} opt_positionObserverData
     * @return {!Promise<!./runners/animation-runner.AnimationRunner>}
     * @private
     */

  }, {
    key: "createRunner_",
    value: function createRunner_(opt_args, opt_positionObserverData) {
      var _this10 = this;

      // Force cast to `WebAnimationDef`. It will be validated during preparation
      // phase.
      var configJson =
      /** @type {!./web-animation-types.WebAnimationDef} */
      this.configJson_;
      var args =
      /** @type {?./web-animation-types.WebAnimationDef} */
      opt_args || null;
      // Ensure polyfill is installed.
      var polyfillPromise = (0, _installPolyfill.installWebAnimationsIfNecessary)(this.win);
      var ampdoc = this.getAmpDoc();
      var readyPromise = this.embed_ ? this.embed_.whenReady() : ampdoc.whenReady();
      var hostWin = this.embed_ ? this.embed_.win : this.win;
      var baseUrl = this.embed_ ? this.embed_.getUrl() : ampdoc.getUrl();
      return Promise.all([polyfillPromise, readyPromise]).then(function () {
        var builder = new _webAnimations.Builder(hostWin, _this10.getRootNode_(), baseUrl, _this10.getVsync(), _services.Services.ownersForDoc(_this10.element.getAmpDoc()));
        return builder.createRunner(configJson, args, opt_positionObserverData);
      });
    }
    /**
     * @return {!Document|!ShadowRoot}
     * @private
     */

  }, {
    key: "getRootNode_",
    value: function getRootNode_() {
      return this.embed_ ? this.embed_.win.document : this.getAmpDoc().getRootNode();
    }
    /** @private */

  }, {
    key: "pause_",
    value: function pause_() {
      if (this.runner_) {
        this.runner_.pause();
      }
    }
    /**
     * @param {!WebAnimationPlayState} playState
     * @private
     */

  }, {
    key: "playStateChanged_",
    value: function playStateChanged_(playState) {
      if (playState == _webAnimationTypes.WebAnimationPlayState.FINISHED) {
        this.finish_();
      }
    }
  }]);

  return AmpAnimation;
}(AMP.BaseElement);

exports.AmpAnimation = AmpAnimation;
AMP.extension(TAG, '0.1', function (AMP) {
  AMP.registerElement(TAG, AmpAnimation);
  AMP.registerServiceForDoc('web-animation', _webAnimationService.WebAnimationService);
});

},{"../../../src/action-constants":15,"../../../src/event-helper":22,"../../../src/iframe-helper":24,"../../../src/json":26,"../../../src/log":28,"../../../src/pass":31,"../../../src/service":33,"../../../src/services":34,"../../../src/style":36,"../../../src/types":37,"../../../src/utils/math":44,"./../../../src/resolved-promise":32,"./install-polyfill":3,"./web-animation-service":11,"./web-animation-types":12,"./web-animations":13}],3:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.installWebAnimationsIfNecessary = installWebAnimationsIfNecessary;

var _promise = require("../../../src/utils/promise");

var _services = require("../../../src/services");

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var polyfillPromiseMap = new Map();

/**
 * @param {!Window} win
 * @return {Promise<void>}
 */
function installWebAnimationsIfNecessary(win) {
  if (polyfillPromiseMap.has(win)) {
    return polyfillPromiseMap.get(win).promise;
  }

  var polyfillPromise = new _promise.Deferred();
  polyfillPromiseMap.set(win, polyfillPromise);

  if (_services.Services.platformFor(win).isSafari()) {
    /*
      Force Web Animations polyfill on Safari.
      Native Web Animations on WebKit do not respect easing for individual
      keyframes and break overall timing. See https://go.amp.dev/issue/27762 and 
      https://bugs.webkit.org/show_bug.cgi?id=210526
      */
    // Using string access syntax to bypass typecheck.
    win.Element.prototype['animate'] = null;
  }

  if (!!win.Element.prototype['animate']) {
    // Native Support exists, there is no reason to load the polyfill.
    polyfillPromise.resolve();
    return polyfillPromise.promise;
  }

  _services.Services.extensionsFor(win).preloadExtension('amp-animation-polyfill').then(function () {
    return polyfillPromise.resolve();
  });

  return polyfillPromise.promise;
}

},{"../../../src/services":34,"../../../src/utils/promise":46}],4:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isVarCss = isVarCss;
exports.createBoxNode = createBoxNode;
exports.createBorderRadiusNode = createBorderRadiusNode;
exports.createPositionNode = createPositionNode;
exports.createInsetNode = createInsetNode;
exports.createCircleNode = createCircleNode;
exports.createEllipseNode = createEllipseNode;
exports.createPolygonNode = createPolygonNode;
exports.CssMinMaxNode = exports.CssCalcProductNode = exports.CssCalcSumNode = exports.CssCalcNode = exports.CssVarNode = exports.CssLengthFuncNode = exports.CssIndexNode = exports.CssRandNode = exports.CssNumConvertNode = exports.CssRectNode = exports.CssTranslateNode = exports.CssFuncNode = exports.CssTimeNode = exports.CssAngleNode = exports.CssLengthNode = exports.CssPercentNode = exports.CssNumberNode = exports.CssNumericNode = exports.CssUrlNode = exports.CssConcatNode = exports.CssPassthroughNode = exports.CssNode = exports.CssContext = void 0;

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FINAL_URL_RE = /^(data|https)\:/i;
var DEG_TO_RAD = 2 * Math.PI / 360;
var GRAD_TO_RAD = Math.PI / 200;
var VAR_CSS_RE = /\b(calc|min|max|clamp|var|url|rand|index|width|height|num|length|x|y)\(/i;
var NORM_CSS_RE = /\d(%|em|rem|vw|vh|vmin|vmax|s|deg|grad)/i;
var INFINITY_RE = /^(infinity|infinite)$/i;
var BOX_DIMENSIONS = ['h', 'w', 'h', 'w'];
var TUPLE_DIMENSIONS = ['w', 'h'];

/**
 * Returns `true` if the CSS expression contains variable components. The CSS
 * parsing and evaluation is heavy, but used relatively rarely. This method
 * can be used to avoid heavy parse/evaluate tasks.
 * @param {string} css
 * @param {boolean} normalize
 * @return {boolean}
 */
function isVarCss(css, normalize) {
  return VAR_CSS_RE.test(css) || normalize && NORM_CSS_RE.test(css);
}

/**
 * An interface that assists in CSS evaluation.
 * @interface
 */
var CssContext = /*#__PURE__*/function () {
  function CssContext() {
    _classCallCheck(this, CssContext);
  }

  _createClass(CssContext, [{
    key: "resolveUrl",

    /**
     * Returns a resolved URL. The result must be an allowed URL for execution,
     * with HTTPS restrictions.
     * @param {string} unusedUrl
     * @return {string}
     */
    value: function resolveUrl(unusedUrl) {}
    /**
     * Returns the value of a CSS variable or `null` if not available.
     * @param {string} unusedVarName
     * @return {?CssNode}
     */

  }, {
    key: "getVar",
    value: function getVar(unusedVarName) {}
    /**
     * Returns the current target's index in the context of other selected
     * targets.
     * @return {number}
     */

  }, {
    key: "getCurrentIndex",
    value: function getCurrentIndex() {}
    /**
     * Returns the number of selected targets.
     * @return {number}
     */

  }, {
    key: "getTargetLength",
    value: function getTargetLength() {}
    /**
     * Returns the current font size.
     * @return {number}
     */

  }, {
    key: "getCurrentFontSize",
    value: function getCurrentFontSize() {}
    /**
     * Returns the root font size.
     * @return {number}
     */

  }, {
    key: "getRootFontSize",
    value: function getRootFontSize() {}
    /**
     * Returns the viewport size.
     * @return {!{width: number, height: number}}
     */

  }, {
    key: "getViewportSize",
    value: function getViewportSize() {}
    /**
     * Returns the current element's rectangle.
     * @return {!../../../../src/layout-rect.LayoutRectDef}
     */

  }, {
    key: "getCurrentElementRect",
    value: function getCurrentElementRect() {}
    /**
     * Returns the specified element's rectangle.
     * @param {string} unusedSelector
     * @param {?string} unusedSelectionMethod
     * @return {!../../../../src/layout-rect.LayoutRectDef}
     */

  }, {
    key: "getElementRect",
    value: function getElementRect(unusedSelector, unusedSelectionMethod) {}
    /**
     * Returns the dimension: "w" for width or "h" for height.
     * @return {?string}
     */

  }, {
    key: "getDimension",
    value: function getDimension() {}
    /**
     * Pushes the dimension: "w" for width or "h" for height.
     * @param {?string} unusedDim
     * @param {function():T} unusedCallback
     * @return {T}
     * @template T
     */

  }, {
    key: "withDimension",
    value: function withDimension(unusedDim, unusedCallback) {}
  }]);

  return CssContext;
}();

exports.CssContext = CssContext;

/**
 * A base class for all CSS node components defined in the
 * `css-expr-impl.jison`.
 * @abstract
 */
var CssNode = /*#__PURE__*/function () {
  /**
   * Creates an instance of CssNode.
   */
  function CssNode() {
    _classCallCheck(this, CssNode);
  }

  /**
   * Returns a string CSS representation.
   * @return {string}
   * @abstract
   */
  _createClass(CssNode, [{
    key: "css",
    value: function css() {}
    /**
     * Resolves the value of all variable components. Only performs any work if
     * variable components exist. As an optimization, this node is returned
     * for a non-variable nodes (`isConst() == true`). Otherwise, `calc()` method
     * is used to calculate the new value.
     * @param {!CssContext} context
     * @param {boolean} normalize
     * @return {?CssNode}
     * @final
     */

  }, {
    key: "resolve",
    value: function resolve(context, normalize) {
      if (this.isConst(normalize)) {
        return this;
      }

      return this.calc(context, normalize);
    }
    /**
     * Whether the CSS node is a constant or includes variable components.
     * @param {boolean} unusedNormalize
     * @return {boolean}
     * @protected
     */

  }, {
    key: "isConst",
    value: function isConst(unusedNormalize) {
      return true;
    }
    /**
     * Calculates the value of all variable components.
     * @param {!CssContext} unusedContext
     * @param {boolean} unusedNormalize
     * @return {?CssNode}
     * @protected
     */

  }, {
    key: "calc",
    value: function calc(unusedContext, unusedNormalize) {
      return this;
    }
  }]);

  return CssNode;
}();

exports.CssNode = CssNode;

/**
 * A CSS expression that's simply passed through from the original expression.
 * Used for `url()`, colors, etc.
 */
var CssPassthroughNode = /*#__PURE__*/function (_CssNode) {
  _inherits(CssPassthroughNode, _CssNode);

  var _super = _createSuper(CssPassthroughNode);

  /** @param {string} css */
  function CssPassthroughNode(css) {
    var _this;

    _classCallCheck(this, CssPassthroughNode);

    _this = _super.call(this);

    /** @const @private {string} */
    _this.css_ = css;
    return _this;
  }

  /** @override */
  _createClass(CssPassthroughNode, [{
    key: "css",
    value: function css() {
      return this.css_;
    }
  }]);

  return CssPassthroughNode;
}(CssNode);

exports.CssPassthroughNode = CssPassthroughNode;

/**
 * A concatenation of CSS expressions: `translateX(...) rotate(...)`,
 * `1s normal`, etc.
 */
var CssConcatNode = /*#__PURE__*/function (_CssNode2) {
  _inherits(CssConcatNode, _CssNode2);

  var _super2 = _createSuper(CssConcatNode);

  /**
   * @param {(!Array<!CssNode>|!CssNode)=} opt_array
   * @param {?Array<string>=} opt_dimensions
   */
  function CssConcatNode(opt_array, opt_dimensions) {
    var _this2;

    _classCallCheck(this, CssConcatNode);

    _this2 = _super2.call(this);

    /** @private {!Array<!CssNode>} */
    _this2.array_ = opt_array instanceof CssConcatNode ? opt_array.array_ : Array.isArray(opt_array) ? opt_array : opt_array ? [opt_array] : [];

    /** @const @private {?Array<string>} */
    _this2.dimensions_ = opt_dimensions || null;
    return _this2;
  }

  /**
   * Concatenates two sets of expressions.
   * @param {!CssNode} nodeOrSet
   * @param {!CssNode} otherNodeOrSet
   * @return {!CssConcatNode}
   */
  _createClass(CssConcatNode, [{
    key: "css",

    /** @override */
    value: function css() {
      return this.array_.map(function (node) {
        return node.css();
      }).join(' ');
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst(normalize) {
      return this.array_.reduce(function (acc, node) {
        return acc && node.isConst(normalize);
      }, true);
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context, normalize) {
      var resolvedArray = resolveArray(context, normalize, this.array_, this.dimensions_);
      return resolvedArray ? new CssConcatNode(resolvedArray) : null;
    }
  }], [{
    key: "concat",
    value: function concat(nodeOrSet, otherNodeOrSet) {
      var set;

      if (nodeOrSet instanceof CssConcatNode) {
        set = nodeOrSet;
      } else {
        set = new CssConcatNode([nodeOrSet]);
      }

      if (otherNodeOrSet instanceof CssConcatNode) {
        set.array_ = set.array_.concat(otherNodeOrSet.array_);
      } else {
        set.array_.push(otherNodeOrSet);
      }

      return set;
    }
  }]);

  return CssConcatNode;
}(CssNode);

exports.CssConcatNode = CssConcatNode;

/**
 * Verifies that URL is an HTTPS URL.
 */
var CssUrlNode = /*#__PURE__*/function (_CssNode3) {
  _inherits(CssUrlNode, _CssNode3);

  var _super3 = _createSuper(CssUrlNode);

  /** @param {string} url */
  function CssUrlNode(url) {
    var _this3;

    _classCallCheck(this, CssUrlNode);

    _this3 = _super3.call(this);

    /** @const @private {string} */
    _this3.url_ = url;
    return _this3;
  }

  /** @override */
  _createClass(CssUrlNode, [{
    key: "css",
    value: function css() {
      if (!this.url_) {
        return '';
      }

      return "url(\"" + this.url_ + "\")";
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst() {
      return !this.url_ || FINAL_URL_RE.test(this.url_);
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context) {
      var url = context.resolveUrl(this.url_);
      // Return a passthrough CSS to avoid recursive `url()` evaluation.
      return new CssPassthroughNode("url(\"" + url + "\")");
    }
  }]);

  return CssUrlNode;
}(CssNode);

exports.CssUrlNode = CssUrlNode;

/**
 * @abstract
 */
var CssNumericNode = /*#__PURE__*/function (_CssNode4) {
  _inherits(CssNumericNode, _CssNode4);

  var _super4 = _createSuper(CssNumericNode);

  /**
   * @param {string} type
   * @param {number} num
   * @param {string} units
   */
  function CssNumericNode(type, num, units) {
    var _this4;

    _classCallCheck(this, CssNumericNode);

    _this4 = _super4.call(this);

    /** @const @private {string} */
    _this4.type_ = type;

    /** @const @private {number} */
    _this4.num_ = num;

    /** @const @private {string} */
    _this4.units_ = units.toLowerCase();
    return _this4;
  }

  /** @override */
  _createClass(CssNumericNode, [{
    key: "css",
    value: function css() {
      return "" + this.num_ + this.units_;
    }
    /**
     * @param {number} unusedNum
     * @return {!CssNumericNode}
     * @abstract
     */

  }, {
    key: "createSameUnits",
    value: function createSameUnits(unusedNum) {}
    /** @override */

  }, {
    key: "isConst",
    value: function isConst(normalize) {
      return normalize ? this.isNorm() : true;
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isNorm",
    value: function isNorm() {
      return true;
    }
    /**
     * @param {!CssContext} unusedContext
     * @return {!CssNumericNode}
     */

  }, {
    key: "norm",
    value: function norm(unusedContext) {
      return this;
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context, normalize) {
      return normalize ? this.norm(context) : this;
    }
    /**
     * @param {number} unusedPercent
     * @param {!CssContext} unusedContext
     * @return {!CssNumericNode}
     */

  }, {
    key: "calcPercent",
    value: function calcPercent(unusedPercent, unusedContext) {
      throw new Error('cannot calculate percent for ' + this.type_);
    }
  }]);

  return CssNumericNode;
}(CssNode);

exports.CssNumericNode = CssNumericNode;

/**
 * A CSS number: `100`, `1e2`, `1e-2`, `0.5`, etc.
 */
var CssNumberNode = /*#__PURE__*/function (_CssNumericNode) {
  _inherits(CssNumberNode, _CssNumericNode);

  var _super5 = _createSuper(CssNumberNode);

  /** @param {number} num */
  function CssNumberNode(num) {
    _classCallCheck(this, CssNumberNode);

    return _super5.call(this, 'NUM', num, '');
  }

  /** @override */
  _createClass(CssNumberNode, [{
    key: "createSameUnits",
    value: function createSameUnits(num) {
      return new CssNumberNode(num);
    }
    /**
     * Returns a numerical value of the node if possible. `Infinity` is one of
     * possible return values.
     * @param {!CssNode} node
     * @return {number|undefined}
     */

  }], [{
    key: "num",
    value: function num(node) {
      if (node instanceof CssNumberNode) {
        return node.num_;
      }

      var css = node.css();

      if (INFINITY_RE.test(css)) {
        return Infinity;
      }

      return undefined;
    }
  }]);

  return CssNumberNode;
}(CssNumericNode);

exports.CssNumberNode = CssNumberNode;

/**
 * A CSS percent value: `100%`, `0.5%`, etc.
 */
var CssPercentNode = /*#__PURE__*/function (_CssNumericNode2) {
  _inherits(CssPercentNode, _CssNumericNode2);

  var _super6 = _createSuper(CssPercentNode);

  /** @param {number} num */
  function CssPercentNode(num) {
    _classCallCheck(this, CssPercentNode);

    return _super6.call(this, 'PRC', num, '%');
  }

  /** @override */
  _createClass(CssPercentNode, [{
    key: "createSameUnits",
    value: function createSameUnits(num) {
      return new CssPercentNode(num);
    }
    /** @override */

  }, {
    key: "isNorm",
    value: function isNorm() {
      return false;
    }
    /** @override */

  }, {
    key: "norm",
    value: function norm(context) {
      if (context.getDimension()) {
        return new CssLengthNode(0, 'px').calcPercent(this.num_, context);
      }

      return this;
    }
  }]);

  return CssPercentNode;
}(CssNumericNode);

exports.CssPercentNode = CssPercentNode;

/**
 * A CSS length value: `100px`, `80vw`, etc.
 */
var CssLengthNode = /*#__PURE__*/function (_CssNumericNode3) {
  _inherits(CssLengthNode, _CssNumericNode3);

  var _super7 = _createSuper(CssLengthNode);

  /**
   * @param {number} num
   * @param {string} units
   */
  function CssLengthNode(num, units) {
    _classCallCheck(this, CssLengthNode);

    return _super7.call(this, 'LEN', num, units);
  }

  /** @override */
  _createClass(CssLengthNode, [{
    key: "createSameUnits",
    value: function createSameUnits(num) {
      return new CssLengthNode(num, this.units_);
    }
    /** @override */

  }, {
    key: "isNorm",
    value: function isNorm() {
      return this.units_ == 'px';
    }
    /** @override */

  }, {
    key: "norm",
    value: function norm(context) {
      if (this.isNorm()) {
        return this;
      }

      // Font-based: em/rem.
      if (this.units_ == 'em' || this.units_ == 'rem') {
        var fontSize = this.units_ == 'em' ? context.getCurrentFontSize() : context.getRootFontSize();
        return new CssLengthNode(this.num_ * fontSize, 'px');
      }

      // Viewport based: vw, vh, vmin, vmax.
      if (this.units_ == 'vw' || this.units_ == 'vh' || this.units_ == 'vmin' || this.units_ == 'vmax') {
        var vp = context.getViewportSize();
        var vw = vp.width * this.num_ / 100;
        var vh = vp.height * this.num_ / 100;
        var num = 0;

        if (this.units_ == 'vw') {
          num = vw;
        } else if (this.units_ == 'vh') {
          num = vh;
        } else if (this.units_ == 'vmin') {
          num = Math.min(vw, vh);
        } else if (this.units_ == 'vmax') {
          num = Math.max(vw, vh);
        }

        return new CssLengthNode(num, 'px');
      }

      // Can't convert cm/in/etc to px at this time.
      throw unknownUnits(this.units_);
    }
    /** @override */

  }, {
    key: "calcPercent",
    value: function calcPercent(percent, context) {
      var dim = context.getDimension();
      var size = context.getCurrentElementRect();
      var side = getRectField(dim, size);
      return new CssLengthNode(side * percent / 100, 'px');
    }
  }]);

  return CssLengthNode;
}(CssNumericNode);

exports.CssLengthNode = CssLengthNode;

/**
 * A CSS angle value: `45deg`, `0.5rad`, etc.
 */
var CssAngleNode = /*#__PURE__*/function (_CssNumericNode4) {
  _inherits(CssAngleNode, _CssNumericNode4);

  var _super8 = _createSuper(CssAngleNode);

  /**
   * @param {number} num
   * @param {string} units
   */
  function CssAngleNode(num, units) {
    _classCallCheck(this, CssAngleNode);

    return _super8.call(this, 'ANG', num, units);
  }

  /** @override */
  _createClass(CssAngleNode, [{
    key: "createSameUnits",
    value: function createSameUnits(num) {
      return new CssAngleNode(num, this.units_);
    }
    /** @override */

  }, {
    key: "isNorm",
    value: function isNorm() {
      return this.units_ == 'rad';
    }
    /** @override */

  }, {
    key: "norm",
    value: function norm() {
      if (this.isNorm()) {
        return this;
      }

      if (this.units_ == 'deg') {
        return new CssAngleNode(this.num_ * DEG_TO_RAD, 'rad');
      }

      if (this.units_ == 'grad') {
        return new CssAngleNode(this.num_ * GRAD_TO_RAD, 'rad');
      }

      throw unknownUnits(this.units_);
    }
  }]);

  return CssAngleNode;
}(CssNumericNode);

exports.CssAngleNode = CssAngleNode;

/**
 * A CSS time value: `1s`, `600ms`.
 */
var CssTimeNode = /*#__PURE__*/function (_CssNumericNode5) {
  _inherits(CssTimeNode, _CssNumericNode5);

  var _super9 = _createSuper(CssTimeNode);

  /**
   * @param {number} num
   * @param {string} units
   */
  function CssTimeNode(num, units) {
    _classCallCheck(this, CssTimeNode);

    return _super9.call(this, 'TME', num, units);
  }

  /** @override */
  _createClass(CssTimeNode, [{
    key: "createSameUnits",
    value: function createSameUnits(num) {
      return new CssTimeNode(num, this.units_);
    }
    /** @override */

  }, {
    key: "isNorm",
    value: function isNorm() {
      return this.units_ == 'ms';
    }
    /** @override */

  }, {
    key: "norm",
    value: function norm() {
      if (this.isNorm()) {
        return this;
      }

      return new CssTimeNode(this.millis_(), 'ms');
    }
    /**
     * @return {number}
     * @private
     */

  }, {
    key: "millis_",
    value: function millis_() {
      if (this.units_ == 'ms') {
        return this.num_;
      }

      if (this.units_ == 's') {
        return this.num_ * 1000;
      }

      throw unknownUnits(this.units_);
    }
    /**
     * @param {!CssNode} node
     * @return {number|undefined}
     */

  }], [{
    key: "millis",
    value: function millis(node) {
      if (node instanceof CssTimeNode) {
        return node.millis_();
      }

      if (node instanceof CssNumberNode) {
        return node.num_;
      }

      return undefined;
    }
  }]);

  return CssTimeNode;
}(CssNumericNode);

exports.CssTimeNode = CssTimeNode;

/**
 * A CSS generic function: `rgb(1, 1, 1)`, `translateX(300px)`, etc.
 */
var CssFuncNode = /*#__PURE__*/function (_CssNode5) {
  _inherits(CssFuncNode, _CssNode5);

  var _super10 = _createSuper(CssFuncNode);

  /**
   * @param {string} name
   * @param {!Array<!CssNode>} args
   * @param {?Array<string>=} opt_dimensions
   */
  function CssFuncNode(name, args, opt_dimensions) {
    var _this5;

    _classCallCheck(this, CssFuncNode);

    _this5 = _super10.call(this);

    /** @const @private {string} */
    _this5.name_ = name.toLowerCase();

    /** @const @private {!Array<!CssNode>} */
    _this5.args_ = args;

    /** @const @private {?Array<string>} */
    _this5.dimensions_ = opt_dimensions || null;
    return _this5;
  }

  /** @override */
  _createClass(CssFuncNode, [{
    key: "css",
    value: function css() {
      var args = this.args_.map(function (node) {
        return node.css();
      }).join(',');
      return this.name_ + "(" + args + ")";
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst(normalize) {
      return this.args_.reduce(function (acc, node) {
        return acc && node.isConst(normalize);
      }, true);
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context, normalize) {
      var resolvedArgs = resolveArray(context, normalize, this.args_, this.dimensions_);
      return resolvedArgs ? new CssFuncNode(this.name_, resolvedArgs) : null;
    }
  }]);

  return CssFuncNode;
}(CssNode);

exports.CssFuncNode = CssFuncNode;

/**
 * A space separated box declaration (https://developer.mozilla.org/en-US/docs/Web/CSS/margin).
 *
 * Typical forms are:
 * - `<top> <right> <bottom> <left>` (e.g. `10% 20em 30px var(--x)`)
 * - `<top> <horizontal> <bottom>` (e.g. `10% 20em 30vw`)
 * - `<vertical> <horizontal>` (e.g. `10% 20em`)
 * - `<all>` (e.g. `10%`)
 *
 * @param {!CssNode} value
 * @param {?Array<string>=} opt_dimensions
 * @return {!CssNode}
 */
function createBoxNode(value, opt_dimensions) {
  var dims = opt_dimensions || BOX_DIMENSIONS;
  var args = value instanceof CssConcatNode ? value.array_ : [value];

  if (args.length < 1 || args.length > 4) {
    throw new Error('box must have between 1 and 4 components');
  }

  if (dims.length > 0) {
    // We have to always turn all forms into the full form at least two
    // `<vertical> <horizontal>`, because we cannot otherwise apply
    // the correct dimensions to a single argument.
    return new CssConcatNode(args.length == 1 ? [args[0], args[0]] : args, dims);
  }

  return new CssConcatNode(args);
}

/**
 * A CSS `border-radius()` expression: `box` or `box1 / box2`.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/border-radius
 *
 * @param {!CssNode} box1
 * @param {!CssNode=} opt_box2
 * @return {!CssNode}
 */
function createBorderRadiusNode(box1, opt_box2) {
  var box1Node = createBoxNode(box1, []);

  if (opt_box2) {
    return new CssConcatNode([box1Node, new CssPassthroughNode('/'), createBoxNode(opt_box2, [])]);
  }

  return box1Node;
}

/**
 * A CSS `position` expression.
 *
 * See See https://developer.mozilla.org/en-US/docs/Web/CSS/position_value
 *
 * Variants:
 * - `10%` - X percentage.
 * - `10% 10%` - X and Y percentages.
 * - `left 10%` - X keyword and Y percentage.
 * - `left 10% top 20%` - X keyword and Y percentage.
 *
 * @param {!CssNode} value
 * @return {!CssNode}
 */
function createPositionNode(value) {
  var args = value instanceof CssConcatNode ? value.array_ : [value];

  if (args.length != 1 && args.length != 2 && args.length != 4) {
    throw new Error('position is either 1, 2, or 4 components');
  }

  var dims = null;

  if (args.length == 1) {
    dims = ['w'];
  } else if (args.length == 2) {
    dims = ['w', 'h'];
  } else {
    // [ left | center | right ] || [ top | center | bottom ]
    dims = ['', '', '', ''];

    for (var i = 0; i < args.length; i += 2) {
      var kw = args[i].css().toLowerCase();
      var dim = kw == 'left' || kw == 'right' ? 'w' : kw == 'top' || kw == 'bottom' ? 'h' : '';
      dims[i] = dims[i + 1] = dim;
    }
  }

  return new CssConcatNode(args, dims);
}

/**
 * A CSS `inset()` expression:
 * `inset( <length-percentage>{1,4} [ round <'border-radius'> ]? )`.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/clip-path#inset().
 *
 * @param {!CssNode} box
 * @param {!CssNode=} opt_round
 * @return {!CssNode}
 */
function createInsetNode(box, opt_round) {
  var boxNode = createBoxNode(box);

  if (opt_round) {
    return new CssFuncNode('inset', [new CssConcatNode([boxNode, new CssPassthroughNode('round'), opt_round])]);
  }

  return new CssFuncNode('inset', [boxNode]);
}

/**
 * A CSS `circle()` expression:
 * `<circle()> = circle( [ <shape-radius> ]? [ at <position> ]? )`.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/clip-path#circle()
 *
 * @param {?CssNode} radius
 * @param {!CssNode=} opt_position
 * @return {!CssNode}
 */
function createCircleNode(radius, opt_position) {
  return createEllipseNode(radius, opt_position, 'circle');
}

/**
 * A CSS `ellipse()` expression:
 * `<ellipse()> = ellipse( [ <shape-radius>{2} ]? [ at <position> ]? )`.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/clip-path#ellipse()
 *
 * @param {?CssNode} radii
 * @param {!CssNode=} opt_position
 * @param {string=} opt_name
 * @return {!CssNode}
 */
function createEllipseNode(radii, opt_position, opt_name) {
  var name = opt_name || 'ellipse';
  var position = opt_position ? createPositionNode(opt_position) : null;

  if (!radii && !position) {
    return new CssFuncNode(name, []);
  }

  if (radii && position) {
    return new CssFuncNode(name, [new CssConcatNode([radii, new CssPassthroughNode('at'), position])]);
  }

  if (position) {
    return new CssFuncNode(name, [new CssConcatNode([new CssPassthroughNode('at'), position])]);
  }

  return new CssFuncNode(name, [radii]);
}

/**
 * A CSS `polygon()` expression:
 * `<polygon()> = polygon( [ <length-percentage> <length-percentage> ]# )`.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/clip-path#polygon()
 *
 * @param {!Array<!CssNode>} tuples
 * @return {!CssNode}
 */
function createPolygonNode(tuples) {
  var tuplesWithDims = tuples.map(function (tuple) {
    return new CssConcatNode(tuple, TUPLE_DIMENSIONS);
  });
  return new CssFuncNode('polygon', tuplesWithDims);
}

/**
 * A CSS translate family of functions:
 * - `translate(x, y)`
 * - `translateX(x)`
 * - `translateY(y)`
 * - `translateZ(z)`
 * - `translate3d(x, y, z)`
 */
var CssTranslateNode = /*#__PURE__*/function (_CssFuncNode) {
  _inherits(CssTranslateNode, _CssFuncNode);

  var _super11 = _createSuper(CssTranslateNode);

  /**
   * @param {string} suffix
   * @param {!Array<!CssNode>} args
   */
  function CssTranslateNode(suffix, args) {
    var _this6;

    _classCallCheck(this, CssTranslateNode);

    _this6 = _super11.call(this, "translate" + suffix.toUpperCase(), args, suffix == '' ? ['w', 'h'] : suffix == 'x' ? ['w'] : suffix == 'y' ? ['h'] : suffix == 'z' ? ['z'] : suffix == '3d' ? ['w', 'h', 'z'] : null);

    /** @const @protected {string} */
    _this6.suffix_ = suffix;
    return _this6;
  }

  return CssTranslateNode;
}(CssFuncNode);

exports.CssTranslateNode = CssTranslateNode;

/**
 * AMP-specific `width()` and `height()` functions.
 */
var CssRectNode = /*#__PURE__*/function (_CssNode6) {
  _inherits(CssRectNode, _CssNode6);

  var _super12 = _createSuper(CssRectNode);

  /**
   * @param {string} field x, y, width or height
   * @param {?string=} opt_selector
   * @param {?string=} opt_selectionMethod Either `undefined` or "closest".
   */
  function CssRectNode(field, opt_selector, opt_selectionMethod) {
    var _this7;

    _classCallCheck(this, CssRectNode);

    _this7 = _super12.call(this);

    /** @const @private */
    _this7.field_ = field;

    /** @const @private */
    _this7.selector_ = opt_selector || null;

    /** @const @private */
    _this7.selectionMethod_ = opt_selectionMethod || null;
    return _this7;
  }

  /** @override */
  _createClass(CssRectNode, [{
    key: "css",
    value: function css() {
      throw noCss();
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst() {
      return false;
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context) {
      var rect = this.selector_ ? context.getElementRect(this.selector_, this.selectionMethod_) : context.getCurrentElementRect();
      return new CssLengthNode(getRectField(this.field_, rect), 'px');
    }
  }]);

  return CssRectNode;
}(CssNode);

exports.CssRectNode = CssRectNode;

/**
 * AMP-specific `num()` function. Format is `num(value)`. Returns a numeric
 * representation of the value. E.g. `11px` -> 11, `12em` -> 12, `10s` -> 10.
 */
var CssNumConvertNode = /*#__PURE__*/function (_CssNode7) {
  _inherits(CssNumConvertNode, _CssNode7);

  var _super13 = _createSuper(CssNumConvertNode);

  /**
   * @param {!CssNode} value
   */
  function CssNumConvertNode(value) {
    var _this8;

    _classCallCheck(this, CssNumConvertNode);

    _this8 = _super13.call(this);

    /** @const @private */
    _this8.value_ = value;
    return _this8;
  }

  /** @override */
  _createClass(CssNumConvertNode, [{
    key: "css",
    value: function css() {
      throw noCss();
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst() {
      return false;
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context, normalize) {
      var value = this.value_.resolve(context, normalize);

      if (value == null) {
        return null;
      }

      var num;

      if (value instanceof CssNumericNode) {
        num = value.num_;
      } else {
        num = parseFloat(value.css());
      }

      if (num == null || isNaN(num)) {
        return null;
      }

      return new CssNumberNode(num);
    }
  }]);

  return CssNumConvertNode;
}(CssNode);

exports.CssNumConvertNode = CssNumConvertNode;

/**
 * AMP-specific `rand()` function. Has two forms:
 * - `rand()` - returns a random number value between 0 and 1.
 * - `rand(left, right)` - returns a random value between `left` and
 *   `right`. The `left` and `right` are any number-based values in this
 *   case, such as a length (`10px`), a time (`1s`), an angle (`1rad`), etc.
 *   The returned value is the same type - a length, time angle, etc. Thus,
 *   `rand(1s, 5s)` may return a value of `rand(2.1s)`.
 */
var CssRandNode = /*#__PURE__*/function (_CssNode8) {
  _inherits(CssRandNode, _CssNode8);

  var _super14 = _createSuper(CssRandNode);

  /**
   * @param {?CssNode=} left
   * @param {?CssNode=} right
   */
  function CssRandNode(left, right) {
    var _this9;

    if (left === void 0) {
      left = null;
    }

    if (right === void 0) {
      right = null;
    }

    _classCallCheck(this, CssRandNode);

    _this9 = _super14.call(this);

    /** @const @private */
    _this9.left_ = left;

    /** @const @private */
    _this9.right_ = right;
    return _this9;
  }

  /** @override */
  _createClass(CssRandNode, [{
    key: "css",
    value: function css() {
      throw noCss();
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst() {
      return false;
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context, normalize) {
      // No arguments: return a random node between 0 and 1.
      if (this.left_ == null || this.right_ == null) {
        return new CssNumberNode(Math.random());
      }

      // Arguments: do a min/max random math.
      var left = this.left_.resolve(context, normalize);
      var right = this.right_.resolve(context, normalize);

      if (left == null || right == null) {
        return null;
      }

      if (!(left instanceof CssNumericNode) || !(right instanceof CssNumericNode)) {
        throw new Error('left and right must be both numerical');
      }

      if (left.type_ != right.type_) {
        throw new Error('left and right must be the same type');
      }

      // Units are the same, the math is simple: numerals are summed. Otherwise,
      // the units neeed to be normalized first.
      if (left.units_ != right.units_) {
        left = left.norm(context);
        right = right.norm(context);
      }

      var min = Math.min(left.num_, right.num_);
      var max = Math.max(left.num_, right.num_);
      var rand = Math.random();
      // Formula: rand(A, B) = A * (1 - R) + B * R
      var num = min * (1 - rand) + max * rand;
      return left.createSameUnits(num);
    }
  }]);

  return CssRandNode;
}(CssNode);

exports.CssRandNode = CssRandNode;

/**
 * AMP-specific `index()` function. Returns 0-based index of the current
 * target in a list of all selected targets.
 */
var CssIndexNode = /*#__PURE__*/function (_CssNode9) {
  _inherits(CssIndexNode, _CssNode9);

  var _super15 = _createSuper(CssIndexNode);

  /**
   * Creates an instance of CssIndexNode.
   */
  function CssIndexNode() {
    _classCallCheck(this, CssIndexNode);

    return _super15.call(this);
  }

  /** @override */
  _createClass(CssIndexNode, [{
    key: "css",
    value: function css() {
      throw noCss();
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst() {
      return false;
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context) {
      return new CssNumberNode(context.getCurrentIndex());
    }
  }]);

  return CssIndexNode;
}(CssNode);

exports.CssIndexNode = CssIndexNode;

/**
 * AMP-specific `length()` function. Returns number of targets selected.
 */
var CssLengthFuncNode = /*#__PURE__*/function (_CssNode10) {
  _inherits(CssLengthFuncNode, _CssNode10);

  var _super16 = _createSuper(CssLengthFuncNode);

  /**
   * Creates an instance of CssLengthFuncNode.
   */
  function CssLengthFuncNode() {
    _classCallCheck(this, CssLengthFuncNode);

    return _super16.call(this);
  }

  /** @override */
  _createClass(CssLengthFuncNode, [{
    key: "css",
    value: function css() {
      throw noCss();
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst() {
      return false;
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context) {
      return new CssNumberNode(context.getTargetLength());
    }
  }]);

  return CssLengthFuncNode;
}(CssNode);

exports.CssLengthFuncNode = CssLengthFuncNode;

/**
 * A CSS `var()` expression: `var(--name)`, `var(--name, 100px)`, etc.
 * See https://www.w3.org/TR/css-variables/.
 */
var CssVarNode = /*#__PURE__*/function (_CssNode11) {
  _inherits(CssVarNode, _CssNode11);

  var _super17 = _createSuper(CssVarNode);

  /**
   * @param {string} varName
   * @param {!CssNode=} opt_def
   */
  function CssVarNode(varName, opt_def) {
    var _this10;

    _classCallCheck(this, CssVarNode);

    _this10 = _super17.call(this);

    /** @const @private {string} */
    _this10.varName_ = varName;

    /** @const @private {?CssNode} */
    _this10.def_ = opt_def || null;
    return _this10;
  }

  /** @override */
  _createClass(CssVarNode, [{
    key: "css",
    value: function css() {
      return "var(" + this.varName_ + (this.def_ ? ',' + this.def_.css() : '') + ")";
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst() {
      return false;
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context, normalize) {
      var varNode = context.getVar(this.varName_);

      if (varNode) {
        return varNode.resolve(context, normalize);
      }

      if (this.def_) {
        return this.def_.resolve(context, normalize);
      }

      return null;
    }
  }]);

  return CssVarNode;
}(CssNode);

exports.CssVarNode = CssVarNode;

/**
 * A CSS `calc()` expression: `calc(100px)`, `calc(80vw - 30em)`, etc.
 * See https://drafts.csswg.org/css-values-3/#calc-notation.
 */
var CssCalcNode = /*#__PURE__*/function (_CssNode12) {
  _inherits(CssCalcNode, _CssNode12);

  var _super18 = _createSuper(CssCalcNode);

  /** @param {!CssNode} expr */
  function CssCalcNode(expr) {
    var _this11;

    _classCallCheck(this, CssCalcNode);

    _this11 = _super18.call(this);

    /** @const @private {!CssNode} */
    _this11.expr_ = expr;
    return _this11;
  }

  /** @override */
  _createClass(CssCalcNode, [{
    key: "css",
    value: function css() {
      return "calc(" + this.expr_.css() + ")";
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst() {
      return false;
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context, normalize) {
      return this.expr_.resolve(context, normalize);
    }
  }]);

  return CssCalcNode;
}(CssNode);

exports.CssCalcNode = CssCalcNode;

/**
 * A CSS `calc()` sum expression: `100px + 20em`, `80vw - 30em`, etc.
 */
var CssCalcSumNode = /*#__PURE__*/function (_CssNode13) {
  _inherits(CssCalcSumNode, _CssNode13);

  var _super19 = _createSuper(CssCalcSumNode);

  /**
   * @param {!CssNode} left
   * @param {!CssNode} right
   * @param {string} op Either "+" or "-".
   */
  function CssCalcSumNode(left, right, op) {
    var _this12;

    _classCallCheck(this, CssCalcSumNode);

    _this12 = _super19.call(this);

    /** @const @private {!CssNode} */
    _this12.left_ = left;

    /** @const @private {!CssNode} */
    _this12.right_ = right;

    /** @const @private {string} */
    _this12.op_ = op;
    return _this12;
  }

  /** @override */
  _createClass(CssCalcSumNode, [{
    key: "css",
    value: function css() {
      return this.left_.css() + " " + this.op_ + " " + this.right_.css();
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst() {
      return false;
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context, normalize) {
      /*
       * From spec:
       * At + or -, check that both sides have the same type, or that one side is
       * a <number> and the other is an <integer>. If both sides are the same
       * type, resolve to that type. If one side is a <number> and the other is
       * an <integer>, resolve to <number>.
       */
      var left = this.left_.resolve(context, normalize);
      var right = this.right_.resolve(context, normalize);

      if (left == null || right == null) {
        return null;
      }

      if (!(left instanceof CssNumericNode) || !(right instanceof CssNumericNode)) {
        throw new Error('left and right must be both numerical');
      }

      if (left.type_ != right.type_) {
        // Percent values are special: they need to be resolved in the context
        // of the other dimension.
        if (left instanceof CssPercentNode) {
          left = right.calcPercent(left.num_, context);
        } else if (right instanceof CssPercentNode) {
          right = left.calcPercent(right.num_, context);
        } else {
          throw new Error('left and right must be the same type');
        }
      }

      // Units are the same, the math is simple: numerals are summed. Otherwise,
      // the units neeed to be normalized first.
      if (left.units_ != right.units_) {
        left = left.norm(context);
        right = right.norm(context);
      }

      var sign = this.op_ == '+' ? 1 : -1;
      return left.createSameUnits(left.num_ + sign * right.num_);
    }
  }]);

  return CssCalcSumNode;
}(CssNode);

exports.CssCalcSumNode = CssCalcSumNode;

/**
 * A CSS `calc()` product expression: `100px * 2`, `80vw / 2`, etc.
 */
var CssCalcProductNode = /*#__PURE__*/function (_CssNode14) {
  _inherits(CssCalcProductNode, _CssNode14);

  var _super20 = _createSuper(CssCalcProductNode);

  /**
   * @param {!CssNode} left
   * @param {!CssNode} right
   * @param {string} op Either "*" or "/".
   */
  function CssCalcProductNode(left, right, op) {
    var _this13;

    _classCallCheck(this, CssCalcProductNode);

    _this13 = _super20.call(this);

    /** @const @private {!CssNode} */
    _this13.left_ = left;

    /** @const @private {!CssNode} */
    _this13.right_ = right;

    /** @const @private {string} */
    _this13.op_ = op;
    return _this13;
  }

  /** @override */
  _createClass(CssCalcProductNode, [{
    key: "css",
    value: function css() {
      return this.left_.css() + " " + this.op_ + " " + this.right_.css();
    }
    /** @override */

  }, {
    key: "isConst",
    value: function isConst() {
      return false;
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context, normalize) {
      var left = this.left_.resolve(context, normalize);
      var right = this.right_.resolve(context, normalize);

      if (left == null || right == null) {
        return null;
      }

      if (!(left instanceof CssNumericNode) || !(right instanceof CssNumericNode)) {
        throw new Error('left and right must be both numerical');
      }

      /*
       * From spec:
       * At *, check that at least one side is <number>. If both sides are
       * <integer>, resolve to <integer>. Otherwise, resolve to the type of the
       * other side.
       * At /, check that the right side is <number>. If the left side is
       * <integer>, resolve to <number>. Otherwise, resolve to the type of the
       * left side.
       */
      var base;
      var multi;

      if (this.op_ == '*') {
        if (left instanceof CssNumberNode) {
          multi = left.num_;
          base = right;
        } else {
          if (!(right instanceof CssNumberNode)) {
            throw new Error('one of sides in multiplication must be a number');
          }

          multi = right.num_;
          base = left;
        }
      } else {
        if (!(right instanceof CssNumberNode)) {
          throw new Error('denominator must be a number');
        }

        base = left;
        multi = 1 / right.num_;
      }

      var num = base.num_ * multi;

      if (!isFinite(num)) {
        return null;
      }

      return base.createSameUnits(num);
    }
  }]);

  return CssCalcProductNode;
}(CssNode);

exports.CssCalcProductNode = CssCalcProductNode;

/**
 * CSS `min()` and `max()`.
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/min
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/max
 */
var CssMinMaxNode = /*#__PURE__*/function (_CssFuncNode2) {
  _inherits(CssMinMaxNode, _CssFuncNode2);

  var _super21 = _createSuper(CssMinMaxNode);

  /**
   * @param {string} name
   * @param {!Array<!CssNode>} args
   */
  function CssMinMaxNode(name, args) {
    _classCallCheck(this, CssMinMaxNode);

    return _super21.call(this, name, args);
  }

  /** @override */
  _createClass(CssMinMaxNode, [{
    key: "isConst",
    value: function isConst() {
      return false;
    }
    /** @override */

  }, {
    key: "calc",
    value: function calc(context, normalize) {
      var resolvedArgs = resolveArray(context, normalize, this.args_, null);

      if (!resolvedArgs) {
        return null;
      }

      var firstNonPercent = null;
      var hasPercent = false;
      var hasDifferentUnits = false;
      resolvedArgs.forEach(function (arg) {
        if (!(arg instanceof CssNumericNode)) {
          throw new Error('arguments must be numerical');
        }

        if (arg instanceof CssPercentNode) {
          hasPercent = true;
        } else if (firstNonPercent) {
          if (arg.type_ != firstNonPercent.type_) {
            throw new Error('arguments must be the same type');
          }

          if (arg.units_ != firstNonPercent.units_) {
            hasDifferentUnits = true;
          }
        } else {
          firstNonPercent = arg;
        }
      });

      if (firstNonPercent && hasPercent) {
        hasDifferentUnits = true;
      }

      if (firstNonPercent) {
        // Recalculate percent values and normalize units.
        if (hasDifferentUnits) {
          firstNonPercent = firstNonPercent.norm(context);
        }

        resolvedArgs = resolvedArgs.map(function (arg) {
          if (arg == firstNonPercent) {
            return arg;
          }

          // Percent values.
          if (arg instanceof CssPercentNode) {
            return firstNonPercent.calcPercent(arg.num_, context);
          }

          // Units are the same, the math is simple: numerals are summed.
          // Otherwise, the units neeed to be normalized first.
          if (hasDifferentUnits) {
            return (
              /** @type {!CssNumericNode} */
              arg.norm(context)
            );
          }

          return arg;
        });
      }

      // Calculate.
      var nums = resolvedArgs.map(function (arg) {
        return arg.num_;
      });
      var value;

      if (this.name_ == 'min') {
        // min(...)
        value = Math.min.apply(null, nums);
      } else if (this.name_ == 'max') {
        // max(...)
        value = Math.max.apply(null, nums);
      } else {
        // clamp(min, preferred, max)
        var min = nums[0];
        var preferred = nums[1];
        var max = nums[2];
        value = Math.max(min, Math.min(max, preferred));
      }

      return resolvedArgs[0].createSameUnits(value);
    }
  }]);

  return CssMinMaxNode;
}(CssFuncNode);

exports.CssMinMaxNode = CssMinMaxNode;

/**
 * @param {string} units
 * @return {!Error}
 */
function unknownUnits(units) {
  return new Error('unknown units: ' + units);
}

/**
 * @return {!Error}
 */
function noCss() {
  return new Error('no css');
}

/**
 * @param {?string} field
 * @param {!../../../../src/layout-rect.LayoutRectDef} rect
 * @return {number}
 */
function getRectField(field, rect) {
  var _rect$field;

  if (field == 'w') {
    return rect.width;
  }

  if (field == 'h') {
    return rect.height;
  }

  return (_rect$field = rect[field]) != null ? _rect$field : 0;
}

/**
 * @param {!CssContext} context
 * @param {boolean} normalize
 * @param {!Array<!CssNode>} array
 * @param {?Array<string>} dimensions
 * @return {?Array<!CssNode>}
 */
function resolveArray(context, normalize, array, dimensions) {
  var resolvedArray = [];

  var _loop = function _loop(i) {
    var node = array[i];
    var resolved = void 0;

    if (dimensions && i < dimensions.length) {
      resolved = context.withDimension(dimensions[i], function () {
        return node.resolve(context, normalize);
      });
    } else {
      resolved = node.resolve(context, normalize);
    }

    if (resolved) {
      resolvedArray.push(resolved);
    } else {
      // One argument is null - the function's result is null.
      return {
        v: null
      };
    }
  };

  for (var i = 0; i < array.length; i++) {
    var _ret = _loop(i);

    if (typeof _ret === "object") return _ret.v;
  }

  return resolvedArray;
}

},{}],5:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.parseCss = parseCss;

var _cssExprImpl = require("../../../../build/parsers/css-expr-impl");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @param {string} cssString
 * @return {?./css-expr-ast.CssNode}
 */
function parseCss(cssString) {
  return _cssExprImpl.cssParser.parse(cssString);
}

},{"../../../../build/parsers/css-expr-impl":1}],6:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.extractKeyframes = extractKeyframes;

var _string = require("../../../../src/string");

var _types = require("../../../../src/types");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Finds and extracts keyframes definition for Web Animations from CSS styles.
 * @param {!Document|!ShadowRoot} rootNode
 * @param {string} name
 * @return {?../web-animation-types.WebKeyframesDef}
 */
function extractKeyframes(rootNode, name) {
  var styleSheets = rootNode.styleSheets;

  if (!styleSheets) {
    return null;
  }

  var win = (0, _types.toWin)((rootNode.ownerDocument || rootNode).defaultView);

  // Go from the last to first since the last rule wins in CSS.
  for (var i = styleSheets.length - 1; i >= 0; i--) {
    var keyframes = scanStyle(win,
    /** @type {!CSSStyleSheet} */
    styleSheets[i], name);

    if (keyframes) {
      return keyframes;
    }
  }

  return null;
}

/**
 * @param {!Window} win
 * @param {!CSSStyleSheet} styleSheet
 * @param {string} name
 * @return {?../web-animation-types.WebKeyframesDef}
 */
function scanStyle(win, styleSheet, name) {
  // No rules, e.g. a font.
  if (!styleSheet.cssRules) {
    return null;
  }

  var styleNode = styleSheet.ownerNode;

  if (!styleNode) {
    return null;
  }

  // Exlcude AMP's own styles.
  if (!styleNode.hasAttribute('amp-custom') && !styleNode.hasAttribute('amp-keyframes')) {
    return null;
  }

  return scanRules(win, styleSheet.cssRules, name);
}

/**
 * @param {!Window} win
 * @param {!CSSRuleList} rules
 * @param {string} name
 * @return {?../web-animation-types.WebKeyframesDef}
 */
function scanRules(win, rules, name) {
  // Go backwards since in CSS the last one wins.
  for (var i = rules.length - 1; i >= 0; i--) {
    var rule = rules[i];

    if (rule.type ==
    /* CSSKeyframesRule */
    7) {
      var keyframesRule =
      /** @type {!CSSKeyframesRule} */
      rule;

      if (rule.name == name && isEnabled(win, rule)) {
        return buildKeyframes(keyframesRule);
      }
    } else if (rule.type ==
    /* CSSMediaRule */
    4 || rule.type ==
    /* CSSSupportsRule */
    12) {
      // Go recursively inside. The media/supports match will be checked only
      // when the corresponding @keyframes have been found.
      var found = scanRules(win, rule.cssRules, name);

      if (found) {
        return found;
      }
    }
  }

  return null;
}

/**
 * @param {!Window} win
 * @param {!CSSRule} rule
 * @return {boolean}
 */
function isEnabled(win, rule) {
  // Try rule itself.
  if (rule.media && rule.media.mediaText) {
    var enabled = win.matchMedia(rule.media.mediaText).matches;

    if (!enabled) {
      return false;
    }
  }

  if (rule.type ==
  /* CSSSupportsRule */
  12) {
    if (!win.CSS || !win.CSS.supports || !win.CSS.supports(
    /** @type {!CSSSupportsRule} */
    rule.conditionText)) {
      return false;
    }
  }

  // Check the parents.
  if (rule.parentRule) {
    return isEnabled(win, rule.parentRule);
  }

  return true;
}

/**
 * @param {!CSSKeyframesRule} keyframesRule
 * @return {!../web-animation-types.WebKeyframesDef}
 */
function buildKeyframes(keyframesRule) {
  var array = [];

  for (var i = 0; i < keyframesRule.cssRules.length; i++) {
    var keyframeRule =
    /** @type {!CSSKeyframeRule} */
    keyframesRule.cssRules[i];
    var keyframe = {};
    keyframe['offset'] = keyframeRule.keyText == 'from' ? 0 : keyframeRule.keyText == 'to' ? 1 : parseFloat(keyframeRule.keyText) / 100;
    var style = keyframeRule.style;

    for (var j = 0; j < style.length; j++) {
      var styleName = style[j];
      var propName = styleName;

      if ((0, _string.endsWith)(styleName, 'animation-timing-function')) {
        propName = 'easing';
      }

      keyframe[propName] = style[styleName];
    }

    array.push(keyframe);
  }

  return array;
}

},{"../../../../src/string":35,"../../../../src/types":37}],7:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AnimationRunner = void 0;

var _webAnimationTypes = require("../web-animation-types");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 */
var AnimationRunner = /*#__PURE__*/function () {
  /**
   * @param {!Array<!../web-animation-types.InternalWebAnimationRequestDef>} requests
   */
  function AnimationRunner(requests) {
    _classCallCheck(this, AnimationRunner);

    /** @const @protected */
    this.requests_ = requests;
  }

  /**
   * @return {!WebAnimationPlayState}
   */
  _createClass(AnimationRunner, [{
    key: "getPlayState",
    value: function getPlayState() {}
    /**
     * @param {function(!WebAnimationPlayState)} unusedHandler
     * @return {!UnlistenDef}
     */

  }, {
    key: "onPlayStateChanged",
    value: function onPlayStateChanged(unusedHandler) {}
    /**
     * Initializes the players but does not change the state.
     */

  }, {
    key: "init",
    value: function init() {}
    /**
     * Initializes the players if not already initialized,
     * and starts playing the animations.
     */

  }, {
    key: "start",
    value: function start() {}
    /**
     */

  }, {
    key: "pause",
    value: function pause() {}
    /**
     */

  }, {
    key: "resume",
    value: function resume() {}
    /**
     */

  }, {
    key: "reverse",
    value: function reverse() {}
    /**
     * @param {time} unusedTime
     */

  }, {
    key: "seekTo",
    value: function seekTo(unusedTime) {}
    /**
     * Seeks to a relative position within the animation timeline given a
     * percentage (0 to 1 number).
     * @param {number} unusedPercent between 0 and 1
     */

  }, {
    key: "seekToPercent",
    value: function seekToPercent(unusedPercent) {}
    /**
     */

  }, {
    key: "finish",
    value: function finish() {}
    /**
     */

  }, {
    key: "cancel",
    value: function cancel() {}
  }]);

  return AnimationRunner;
}();

exports.AnimationRunner = AnimationRunner;

},{"../web-animation-types":12}],8:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.NativeWebAnimationRunner = void 0;

var _animationRunner = require("./animation-runner");

var _observable = require("../../../../src/observable");

var _webAnimationTypes = require("../web-animation-types");

var _style = require("../../../../src/style");

var _log = require("../../../../src/log");

var _utils = require("./utils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 */
var NativeWebAnimationRunner = /*#__PURE__*/function (_AnimationRunner) {
  _inherits(NativeWebAnimationRunner, _AnimationRunner);

  var _super = _createSuper(NativeWebAnimationRunner);

  /**
   * @param {!Array<!../web-animation-types.InternalWebAnimationRequestDef>} requests
   */
  function NativeWebAnimationRunner(requests) {
    var _this;

    _classCallCheck(this, NativeWebAnimationRunner);

    _this = _super.call(this, requests);

    /** @protected {?Array<!Animation>} */
    _this.players_ = null;

    /** @private {number} */
    _this.runningCount_ = 0;

    /** @private {!WebAnimationPlayState} */
    _this.playState_ = _webAnimationTypes.WebAnimationPlayState.IDLE;

    /** @private {!Observable} */
    _this.playStateChangedObservable_ = new _observable.Observable();
    return _this;
  }

  /**
   * @override
   * @return {!WebAnimationPlayState}
   */
  _createClass(NativeWebAnimationRunner, [{
    key: "getPlayState",
    value: function getPlayState() {
      return this.playState_;
    }
    /**
     * @override
     * @param {function(!WebAnimationPlayState)} handler
     * @return {!UnlistenDef}
     */

  }, {
    key: "onPlayStateChanged",
    value: function onPlayStateChanged(handler) {
      return this.playStateChangedObservable_.add(handler);
    }
    /**
     * @override
     * Initializes the players but does not change the state.
     */

  }, {
    key: "init",
    value: function init() {
      var _this2 = this;

      (0, _log.devAssert)(!this.players_);
      this.players_ = this.requests_.map(function (request) {
        // Apply vars.
        if (request.vars) {
          (0, _style.setStyles)(request.target, (0, _style.assertDoesNotContainDisplay)(request.vars));
        }

        var player = request.target.animate(
        /** @type {!Array<Object>} */
        request.keyframes,
        /** @type {KeyframeAnimationOptions} */
        request.timing);
        player.pause();
        return player;
      });
      this.runningCount_ = this.players_.length;
      this.players_.forEach(function (player) {
        player.onfinish = function () {
          _this2.runningCount_--;

          if (_this2.runningCount_ == 0) {
            _this2.setPlayState_(_webAnimationTypes.WebAnimationPlayState.FINISHED);
          }
        };
      });
    }
    /**
     * @override
     * Initializes the players if not already initialized,
     * and starts playing the animations.
     */

  }, {
    key: "start",
    value: function start() {
      if (!this.players_) {
        this.init();
      }

      this.resume();
    }
    /**
     * @override
     */

  }, {
    key: "pause",
    value: function pause() {
      (0, _log.devAssert)(this.players_);
      this.setPlayState_(_webAnimationTypes.WebAnimationPlayState.PAUSED);
      this.players_.forEach(function (player) {
        if (player.playState == _webAnimationTypes.WebAnimationPlayState.RUNNING) {
          player.pause();
        }
      });
    }
    /**
     * @override
     */

  }, {
    key: "resume",
    value: function resume() {
      var _this3 = this;

      (0, _log.devAssert)(this.players_);
      var oldRunnerPlayState = this.playState_;

      if (oldRunnerPlayState == _webAnimationTypes.WebAnimationPlayState.RUNNING) {
        return;
      }

      this.setPlayState_(_webAnimationTypes.WebAnimationPlayState.RUNNING);
      this.runningCount_ = 0;
      this.players_.forEach(function (player) {
        /**
         * TODO(gharbiw):
         * The playState on Safari and Edge sometimes gets stuck on
         * the PENDING state (particularly when the animation's visibility
         * gets toggled) so we add an exception to play even if the state
         * is PENDING. Need to investigate why this happens, fix it and
         * remove the exception below.
         */
        if (oldRunnerPlayState != _webAnimationTypes.WebAnimationPlayState.PAUSED || player.playState == _webAnimationTypes.WebAnimationPlayState.PAUSED || player.playState == _webAnimationTypes.WebAnimationPlayState.PENDING) {
          player.play();
          _this3.runningCount_++;
        }
      });
    }
    /**
     * @override
     */

  }, {
    key: "reverse",
    value: function reverse() {
      (0, _log.devAssert)(this.players_);
      // TODO(nainar) there is no reverse call on WorkletAnimation
      this.players_.forEach(function (player) {
        player.reverse();
      });
    }
    /**
     * @override
     * @param {time} time
     */

  }, {
    key: "seekTo",
    value: function seekTo(time) {
      (0, _log.devAssert)(this.players_);
      this.setPlayState_(_webAnimationTypes.WebAnimationPlayState.PAUSED);
      this.players_.forEach(function (player) {
        player.pause();
        player.currentTime = time;
      });
    }
    /**
     * @override
     * Seeks to a relative position within the animation timeline given a
     * percentage (0 to 1 number).
     * @param {number} percent between 0 and 1
     */

  }, {
    key: "seekToPercent",
    value: function seekToPercent(percent) {
      (0, _log.devAssert)(percent >= 0 && percent <= 1);
      var totalDuration = this.getTotalDuration_();
      var time = totalDuration * percent;
      this.seekTo(time);
    }
    /**
     * @override
     */

  }, {
    key: "finish",
    value: function finish() {
      if (!this.players_) {
        return;
      }

      var players = this.players_;
      this.players_ = null;
      this.setPlayState_(_webAnimationTypes.WebAnimationPlayState.FINISHED);
      players.forEach(function (player) {
        player.finish();
      });
    }
    /**
     * @override
     */

  }, {
    key: "cancel",
    value: function cancel() {
      if (!this.players_) {
        return;
      }

      this.setPlayState_(_webAnimationTypes.WebAnimationPlayState.IDLE);
      this.players_.forEach(function (player) {
        player.cancel();
      });
    }
    /**
     * @param {!WebAnimationPlayState} playState
     * @private
     */

  }, {
    key: "setPlayState_",
    value: function setPlayState_(playState) {
      if (this.playState_ != playState) {
        this.playState_ = playState;
        this.playStateChangedObservable_.fire(this.playState_);
      }
    }
    /**
     * @return {number} total duration in milliseconds.
     * @throws {Error} If timeline is infinite.
     */

  }, {
    key: "getTotalDuration_",
    value: function getTotalDuration_() {
      return (0, _utils.getTotalDuration)(this.requests_);
    }
  }]);

  return NativeWebAnimationRunner;
}(_animationRunner.AnimationRunner);

exports.NativeWebAnimationRunner = NativeWebAnimationRunner;

},{"../../../../src/log":28,"../../../../src/observable":30,"../../../../src/style":36,"../web-animation-types":12,"./animation-runner":7,"./utils":10}],9:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.ScrollTimelineWorkletRunner = void 0;

var _animationRunner = require("./animation-runner");

var _services = require("../../../../src/services");

var _style = require("../../../../src/style");

var _log = require("../../../../src/log");

var _utils = require("./utils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var moduleName = 'amp-animation-worklet';
var workletModulePromise;

/**
 */
var ScrollTimelineWorkletRunner = /*#__PURE__*/function (_AnimationRunner) {
  _inherits(ScrollTimelineWorkletRunner, _AnimationRunner);

  var _super = _createSuper(ScrollTimelineWorkletRunner);

  /**
   * @param {!Window} win
   * @param {!Array<!../web-animation-types.InternalWebAnimationRequestDef>} requests
   * @param {!JsonObject} viewportData
   */
  function ScrollTimelineWorkletRunner(win, requests, viewportData) {
    var _this;

    _classCallCheck(this, ScrollTimelineWorkletRunner);

    _this = _super.call(this, requests);

    /** @const @private */
    _this.win_ = win;

    /** @protected {?Array<!WorkletAnimation>} */
    _this.players_ = [];

    /** @private {number} */
    _this.startScrollOffset_ = viewportData['start-scroll-offset'];

    /** @private {number} */
    _this.endScrollOffset_ = viewportData['end-scroll-offset'];

    /** @private {number} */
    _this.initialInViewPercent_ = viewportData['initial-inview-percent'];
    return _this;
  }

  /**
   * @override
   * Initializes the players but does not change the state.
   * @suppress {missingProperties}
   */
  _createClass(ScrollTimelineWorkletRunner, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var documentElement = this.win_.document.documentElement;

      var viewportService = _services.Services.viewportForDoc(documentElement);

      var scrollSource = viewportService.getScrollingElement();
      var timeRange = (0, _utils.getTotalDuration)(this.requests_);
      var adjustedTimeRange = (1 - this.initialInViewPercent_) * timeRange;
      var initialElementOffset = this.initialInViewPercent_ * timeRange;
      this.requests_.map(function (request) {
        // Apply vars.
        if (request.vars) {
          (0, _style.setStyles)(request.target, (0, _style.assertDoesNotContainDisplay)(request.vars));
        }

        getOrAddWorkletModule(_this2.win_).then(function () {
          var scrollTimeline = new _this2.win_.ScrollTimeline({
            scrollSource: scrollSource,
            orientation: 'block',
            startScrollOffset: "" + (0, _style.px)(_this2.startScrollOffset_),
            endScrollOffset: "" + (0, _style.px)(_this2.endScrollOffset_),
            timeRange: adjustedTimeRange,
            fill: 'both'
          });
          var keyframeEffect = new KeyframeEffect(request.target, request.keyframes,
          /** @type {AnimationEffectTimingProperties} */
          request.timing);
          var player = new _this2.win_.WorkletAnimation("" + moduleName, [keyframeEffect], scrollTimeline, {
            'initial-element-offset': initialElementOffset
          });
          player.play();

          _this2.players_.push(player);
        }, function (e) {
          (0, _log.dev)().error('AMP-ANIMATION', e);
        });
      });
    }
    /**
     * @override
     * Initializes the players if not already initialized,
     * and starts playing the animations.
     */

  }, {
    key: "start",
    value: function start() {
      if (!this.players_) {
        this.init();
      }
    }
    /**
     * @override
     */

  }, {
    key: "cancel",
    value: function cancel() {
      if (!this.players_) {
        return;
      }

      this.players_.forEach(function (player) {
        player.cancel();
      });
    }
  }]);

  return ScrollTimelineWorkletRunner;
}(_animationRunner.AnimationRunner);

exports.ScrollTimelineWorkletRunner = ScrollTimelineWorkletRunner;

/**
 * @param {!Window} win
 * @private
 * @return {*} TODO(#23582): Specify return type
 */
function getOrAddWorkletModule(win) {
  if (workletModulePromise) {
    return workletModulePromise;
  }

  var blob = "registerAnimator('" + moduleName + "', class {\n    constructor(options = {\n      'current-element-offset': 0\n    }) {\n      console/*OK*/.info('Using animationWorklet ScrollTimeline');\n      this.initialElementOffset_ = options['initial-element-offset'];\n    }\n    animate(currentTime, effect) {\n      if (currentTime == NaN) {\n        return;\n      }\n      effect.localTime = currentTime + this.initialElementOffset_;\n    }\n  });\n  ";
  workletModulePromise = win.CSS.animationWorklet.addModule(URL.createObjectURL(new Blob([blob], {
    type: 'text/javascript'
  })));
  return workletModulePromise;
}

},{"../../../../src/log":28,"../../../../src/services":34,"../../../../src/style":36,"./animation-runner":7,"./utils":10}],10:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getTotalDuration = getTotalDuration;

var _log = require("../../../../src/log");

/**
 * Copyright 2019 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @param {!Array<!../web-animation-types.InternalWebAnimationRequestDef>} requests
 * @return {number} total duration in milliseconds.
 * @throws {Error} If timeline is infinite.
 */
function getTotalDuration(requests) {
  var maxTotalDuration = 0;

  for (var i = 0; i < requests.length; i++) {
    var timing = requests[i].timing;
    (0, _log.userAssert)(isFinite(timing.iterations), 'Animation has infinite ' + 'timeline, we can not seek to a relative position within an infinite ' + 'timeline. Use "time" for seekTo or remove infinite iterations');
    var iteration = timing.iterations - timing.iterationStart;
    var totalDuration = timing.duration * iteration + timing.delay + timing.endDelay;

    if (totalDuration > maxTotalDuration) {
      maxTotalDuration = totalDuration;
    }
  }

  return maxTotalDuration;
}

},{"../../../../src/log":28}],11:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.WebAnimationService = void 0;

var _webAnimations = require("./web-animations");

var _services = require("../../../src/services");

var _webAnimationTypes = require("./web-animation-types");

var _installPolyfill = require("./install-polyfill");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var WebAnimationService = /*#__PURE__*/function () {
  /**
   * @param {!../../../src/service/ampdoc-impl.AmpDoc} ampdoc
   */
  function WebAnimationService(ampdoc) {
    _classCallCheck(this, WebAnimationService);

    /** @private @const */
    this.ampdoc_ = ampdoc;

    /** @private @const */
    this.vsync_ = _services.Services.vsyncFor(ampdoc.win);

    /** @private @const */
    this.owners_ = _services.Services.ownersForDoc(ampdoc);
  }

  /**
   * @param {!WebAnimationBuilderOptionsDef} options
   * @return {!Promise<Builder>}
   */
  _createClass(WebAnimationService, [{
    key: "createBuilder",
    value: function createBuilder(options) {
      var _this = this;

      return (0, _installPolyfill.installWebAnimationsIfNecessary)(this.ampdoc_.win).then(function () {
        return new _webAnimations.Builder(_this.ampdoc_.win, _this.ampdoc_.getRootNode(), _this.ampdoc_.getUrl(), _this.vsync_, _this.owners_, options);
      });
    }
  }]);

  return WebAnimationService;
}();

exports.WebAnimationService = WebAnimationService;

},{"../../../src/services":34,"./install-polyfill":3,"./web-animation-types":12,"./web-animations":13}],12:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isAllowlistedProp = isAllowlistedProp;
exports.WebAnimationTimingFill = exports.WebAnimationTimingDirection = exports.WebAnimationPlayState = exports.WebAnimationBuilderOptionsDef = exports.WebAnimationSubtargetDef = exports.WebAnimationSelectorDef = exports.WebAnimationConditionalDef = exports.WebAnimationVarsDef = exports.WebAnimationTimingDef = exports.WebKeyframesDef = exports.WebKeyframeAnimationDef = exports.WebCompAnimationDef = exports.WebSwitchAnimationDef = exports.WebMultiAnimationDef = exports.WebAnimationDef = exports.InternalWebAnimationRequestDef = void 0;

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// WARNING
// WARNING
// WARNING
// WARNING
// File must be synced with amp.extens.js

/**
 * A struct for parameters for `Element.animate` call.
 * See https://developer.mozilla.org/en-US/docs/Web/API/Element/animate
 *
 * @typedef {{
 *   target: !Element,
 *   keyframes: !WebKeyframesDef,
 *   vars: ?Object<string, *>,
 *   timing: !WebAnimationTimingDef,
 * }}
 */
var InternalWebAnimationRequestDef;
exports.InternalWebAnimationRequestDef = InternalWebAnimationRequestDef;

/**
 * @typedef {
 *   !WebMultiAnimationDef|
 *   !WebSwitchAnimationDef|
 *   !WebCompAnimationDef|
 *   !WebKeyframeAnimationDef
 * }
 */
var WebAnimationDef;
exports.WebAnimationDef = WebAnimationDef;

/**
 * @mixes WebAnimationSelectorDef
 * @mixes WebAnimationTimingDef
 * @mixes WebAnimationVarsDef
 * @mixes WebAnimationConditionalDef
 * @typedef {{
 *   animations: !Array<!WebAnimationDef>,
 * }}
 */
var WebMultiAnimationDef;
exports.WebMultiAnimationDef = WebMultiAnimationDef;

/**
 * @mixes WebAnimationSelectorDef
 * @mixes WebAnimationTimingDef
 * @mixes WebAnimationVarsDef
 * @mixes WebAnimationConditionalDef
 * @typedef {{
 *   switch: !Array<!WebAnimationDef>,
 * }}
 */
var WebSwitchAnimationDef;
exports.WebSwitchAnimationDef = WebSwitchAnimationDef;

/**
 * @mixes WebAnimationSelectorDef
 * @mixes WebAnimationTimingDef
 * @mixes WebAnimationVarsDef
 * @mixes WebAnimationConditionalDef
 * @typedef {{
 *   animation: string,
 * }}
 */
var WebCompAnimationDef;
exports.WebCompAnimationDef = WebCompAnimationDef;

/**
 * @mixes WebAnimationSelectorDef
 * @mixes WebAnimationTimingDef
 * @mixes WebAnimationVarsDef
 * @mixes WebAnimationConditionalDef
 * @typedef {{
 *   keyframes: (string|!WebKeyframesDef),
 * }}
 */
var WebKeyframeAnimationDef;
exports.WebKeyframeAnimationDef = WebKeyframeAnimationDef;

/**
 * @typedef {!Object<string, *>|!Array<!Object<string, *>>}
 */
var WebKeyframesDef;
exports.WebKeyframesDef = WebKeyframesDef;

/**
 * See https://developer.mozilla.org/en-US/docs/Web/API/AnimationEffectTimingProperties
 *
 * @mixin
 * @typedef {{
 *   duration: (time|undefined),
 *   delay: (time|undefined),
 *   endDelay: (time|undefined),
 *   iterations: (number|string|undefined),
 *   iterationStart: (number|undefined),
 *   easing: (string|undefined),
 *   direction: (!WebAnimationTimingDirection|undefined),
 *   fill: (!WebAnimationTimingFill|undefined),
 * }}
 */
var WebAnimationTimingDef;
exports.WebAnimationTimingDef = WebAnimationTimingDef;

/**
 * Indicates an extension to a type that allows specifying vars. Vars are
 * specified as properties with the name in the format of `--varName`.
 *
 * @mixin
 * @typedef {Object}
 */
var WebAnimationVarsDef;
exports.WebAnimationVarsDef = WebAnimationVarsDef;

/**
 * Defines media parameters for an animation.
 *
 * @mixin
 * @typedef {{
 *   media: (string|undefined),
 *   supports: (string|undefined),
 * }}
 */
var WebAnimationConditionalDef;
exports.WebAnimationConditionalDef = WebAnimationConditionalDef;

/**
 * @typedef {{
 *   target: (!Element|undefined),
 *   selector: (string|undefined),
 *   subtargets: (!Array<!WebAnimationSubtargetDef>|undefined),
 * }}
 */
var WebAnimationSelectorDef;
exports.WebAnimationSelectorDef = WebAnimationSelectorDef;

/**
 * @mixes WebAnimationTimingDef
 * @mixes WebAnimationVarsDef
 * @typedef {{
 *   matcher: (function(!Element, number):boolean|undefined),
 *   index: (number|undefined),
 *   selector: (string|undefined),
 * }}
 */
var WebAnimationSubtargetDef;
exports.WebAnimationSubtargetDef = WebAnimationSubtargetDef;

/**
 * @typedef {{
 *   scope: (!Element|undefined),
 *   scaleByScope: (boolean|undefined),
 * }}
 *
 * - scope delimits selectors.
 * - scaleByScope determines that CSS resolution should treat the scope
 *   element as a virtual viewport, so that:
 *   1. vw/vh units are relative to the scope's size
 *   2. element's x() and y() coords are relative to the scope's top-left corner
 *   3. element's size and position (width()/height()/x()/y()) are inversely
 *      relative to the scope's transformed scale, e.g. if the scope is scaled
 *      to 90%, the element's dimensions will be returned as if it was unscaled
 *      to 100%.
 */
var WebAnimationBuilderOptionsDef;
exports.WebAnimationBuilderOptionsDef = WebAnimationBuilderOptionsDef;

/**
 * See https://developer.mozilla.org/en-US/docs/Web/API/Animation/playState
 * @enum {string}
 */
var WebAnimationPlayState = {
  IDLE: 'idle',
  PENDING: 'pending',
  RUNNING: 'running',
  PAUSED: 'paused',
  FINISHED: 'finished'
};
exports.WebAnimationPlayState = WebAnimationPlayState;

/**
 * See https://developer.mozilla.org/en-US/docs/Web/API/AnimationEffectTimingProperties/direction
 * @enum {string}
 */
var WebAnimationTimingDirection = {
  NORMAL: 'normal',
  REVERSE: 'reverse',
  ALTERNATE: 'alternate',
  ALTERNATE_REVERSE: 'alternate-reverse'
};
exports.WebAnimationTimingDirection = WebAnimationTimingDirection;

/**
 * See https://developer.mozilla.org/en-US/docs/Web/API/AnimationEffectTimingProperties/fill
 * @enum {string}
 */
var WebAnimationTimingFill = {
  NONE: 'none',
  FORWARDS: 'forwards',
  BACKWARDS: 'backwards',
  BOTH: 'both',
  AUTO: 'auto'
};
exports.WebAnimationTimingFill = WebAnimationTimingFill;

/** @const {!Object<string, boolean>} */
var ALLOWLISTED_PROPS = {
  'opacity': true,
  'transform': true,
  'transform-origin': true,
  'visibility': true,
  'offset-distance': true,
  'offsetDistance': true,
  'clip-path': true,
  'clipPath': true
};

/**
 * @param {string} prop
 * @return {boolean}
 */
function isAllowlistedProp(prop) {
  return ALLOWLISTED_PROPS[prop] || false;
}

},{}],13:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.MeasureScanner = exports.Builder = void 0;

var _cssExprAst = require("./parsers/css-expr-ast");

var _webAnimationTypes = require("./web-animation-types");

var _nativeWebAnimationRunner = require("./runners/native-web-animation-runner");

var _scrolltimelineWorkletRunner = require("./runners/scrolltimeline-worklet-runner");

var _url = require("../../../src/url");

var _dom = require("../../../src/dom");

var _style = require("../../../src/style");

var _string = require("../../../src/string");

var _log = require("../../../src/log");

var _css = require("../../../src/css");

var _keyframesExtractor = require("./parsers/keyframes-extractor");

var _mode = require("../../../src/mode");

var _types = require("../../../src/types");

var _experiments = require("../../../src/experiments");

var _iframeHelper = require("../../../src/iframe-helper");

var _layoutRect = require("../../../src/layout-rect");

var _object = require("../../../src/utils/object");

var _cssExpr = require("./parsers/css-expr");

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const {string} */
var TAG = 'amp-animation';
var TARGET_ANIM_ID = '__AMP_ANIM_ID';

/**
 * Auto-incrementing ID generator for internal animation uses.
 * See `TARGET_ANIM_ID`.
 * @type {number}
 */
var animIdCounter = 0;

/**
 * @const {!Object<string, boolean>}
 */
var SERVICE_PROPS = {
  'offset': true,
  'easing': true
};

/**
 * Clip-path is an only CSS property we allow for animation that may require
 * vendor prefix. And it's always "-webkit". Use a simple map to avoid
 * expensive lookup for all other properties.
 */
var ADD_PROPS = {
  'clip-path': '-webkit-clip-path',
  'clipPath': '-webkit-clip-path'
};

/**
 * The scanner for the `WebAnimationDef` format. It calls the appropriate
 * callbacks based on the discovered animation types.
 * @abstract
 */
var Scanner = /*#__PURE__*/function () {
  function Scanner() {
    _classCallCheck(this, Scanner);
  }

  _createClass(Scanner, [{
    key: "scan",

    /**
     * @param {!WebAnimationDef|!Array<!WebAnimationDef>} spec
     * @return {boolean}
     */
    value: function scan(spec) {
      var _this = this;

      if ((0, _types.isArray)(spec)) {
        // Returns `true` if any of the components scan successfully.
        return spec.reduce(function (acc, comp) {
          return _this.scan(comp) || acc;
        }, false);
      }

      // Check whether the animation is enabled.
      if (!this.isEnabled(
      /** @type {!WebAnimationDef} */
      spec)) {
        return false;
      }

      // WebAnimationDef: (!WebMultiAnimationDef|!WebSpecAnimationDef|
      //                   !WebCompAnimationDef|!WebKeyframeAnimationDef)
      if (spec.animations) {
        this.onMultiAnimation(
        /** @type {!WebMultiAnimationDef} */
        spec);
      } else if (spec.switch) {
        this.onSwitchAnimation(
        /** @type {!WebSwitchAnimationDef} */
        spec);
      } else if (spec.animation) {
        this.onCompAnimation(
        /** @type {!WebCompAnimationDef} */
        spec);
      } else if (spec.keyframes) {
        this.onKeyframeAnimation(
        /** @type {!WebKeyframeAnimationDef} */
        spec);
      } else {
        this.onUnknownAnimation(spec);
      }

      return true;
    }
    /**
     * Whether the animation spec is enabled.
     * @param {!WebAnimationDef} unusedSpec
     * @return {boolean}
     */

  }, {
    key: "isEnabled",
    value: function isEnabled(unusedSpec) {
      return true;
    }
    /**
     * @param {!WebMultiAnimationDef} unusedSpec
     * @abstract
     */

  }, {
    key: "onMultiAnimation",
    value: function onMultiAnimation(unusedSpec) {}
    /**
     * @param {!WebSwitchAnimationDef} unusedSpec
     * @abstract
     */

  }, {
    key: "onSwitchAnimation",
    value: function onSwitchAnimation(unusedSpec) {}
    /**
     * @param {!WebCompAnimationDef} unusedSpec
     * @abstract
     */

  }, {
    key: "onCompAnimation",
    value: function onCompAnimation(unusedSpec) {}
    /**
     * @param {!WebKeyframeAnimationDef} unusedSpec
     * @abstract
     */

  }, {
    key: "onKeyframeAnimation",
    value: function onKeyframeAnimation(unusedSpec) {}
    /** @param {!Object} unusedSpec */

  }, {
    key: "onUnknownAnimation",
    value: function onUnknownAnimation(unusedSpec) {
      throw (0, _log.dev)().createError('unknown animation type: must have "animations" or "keyframes" field');
    }
  }]);

  return Scanner;
}();

/**
 * Builds animation runners based on the provided spec.
 */
var Builder = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Document|!ShadowRoot} rootNode
   * @param {string} baseUrl
   * @param {!../../../src/service/vsync-impl.Vsync} vsync
   * @param {!../../../src/service/owners-interface.OwnersInterface} owners
   * @param {!./web-animation-types.WebAnimationBuilderOptionsDef=} options
   */
  function Builder(win, rootNode, baseUrl, vsync, owners, options) {
    if (options === void 0) {
      options = {};
    }

    _classCallCheck(this, Builder);

    /** @const @private */
    this.win_ = win;

    /** @const @private */
    this.css_ = new CssContextImpl(win, rootNode, baseUrl, options);

    /** @const @private */
    this.vsync_ = vsync;

    /** @const @private */
    this.owners_ = owners;

    /** @const @private {!Array<!Element>} */
    this.targets_ = [];

    /** @const @private {!Array<!Promise>} */
    this.loaders_ = [];
  }

  /**
   * Creates the animation runner for the provided spec. Waits for all
   * necessary resources to be loaded before the runner is resolved.
   * @param {!WebAnimationDef|!Array<!WebAnimationDef>} spec
   * @param {?WebAnimationDef=} opt_args
   * @param {?JsonObject=} opt_positionObserverData
   * @return {!Promise<!./runners/animation-runner.AnimationRunner>}
   */
  _createClass(Builder, [{
    key: "createRunner",
    value: function createRunner(spec, opt_args, opt_positionObserverData) {
      var _this2 = this;

      if (opt_positionObserverData === void 0) {
        opt_positionObserverData = null;
      }

      return this.resolveRequests([], spec, opt_args).then(function (requests) {
        if ((0, _mode.getMode)().localDev || (0, _mode.getMode)().development) {
          (0, _log.user)().fine(TAG, 'Animation: ', requests);
        }

        return Promise.all(_this2.loaders_).then(function () {
          return _this2.isAnimationWorkletSupported_() && opt_positionObserverData ? new _scrolltimelineWorkletRunner.ScrollTimelineWorkletRunner(_this2.win_, requests, opt_positionObserverData) : new _nativeWebAnimationRunner.NativeWebAnimationRunner(requests);
        });
      });
    }
    /**
     * @param {!Array<string>} path
     * @param {!WebAnimationDef|!Array<!WebAnimationDef>} spec
     * @param {?WebAnimationDef|undefined} args
     * @param {?Element} target
     * @param {?number} index
     * @param {?Object<string, *>} vars
     * @param {?WebAnimationTimingDef} timing
     * @return {!Promise<!Array<!InternalWebAnimationRequestDef>>}
     * @protected
     */

  }, {
    key: "resolveRequests",
    value: function resolveRequests(path, spec, args, target, index, vars, timing) {
      if (target === void 0) {
        target = null;
      }

      if (index === void 0) {
        index = null;
      }

      if (vars === void 0) {
        vars = null;
      }

      if (timing === void 0) {
        timing = null;
      }

      var scanner = this.createScanner_(path, target, index, vars, timing);
      return this.vsync_.measurePromise(function () {
        return scanner.resolveRequests(spec, args);
      });
    }
    /**
     * @param {!Element} target
     * @protected
     */

  }, {
    key: "requireLayout",
    value: function requireLayout(target) {
      if (!this.targets_.includes(target)) {
        this.targets_.push(target);
        this.loaders_.push(this.owners_.requireLayout(target));
      }
    }
    /**
     * @param {!Array<string>} path
     * @param {?Element} target
     * @param {?number} index
     * @param {?Object<string, *>} vars
     * @param {?WebAnimationTimingDef} timing
     * @private
     * @return {*} TODO(#23582): Specify return type
     */

  }, {
    key: "createScanner_",
    value: function createScanner_(path, target, index, vars, timing) {
      return new MeasureScanner(this, this.css_, path, target, index, vars, timing);
    }
    /**
     * @return {boolean} Whether animationWorklet can be used.
     * @private
     */

  }, {
    key: "isAnimationWorkletSupported_",
    value: function isAnimationWorkletSupported_() {
      return (0, _experiments.isExperimentOn)(this.win_, 'chrome-animation-worklet') && 'animationWorklet' in CSS && (0, _mode.getMode)(this.win_).runtime != 'inabox' && !(0, _iframeHelper.isInFie)(this.win_.document.documentElement);
    }
  }]);

  return Builder;
}();

exports.Builder = Builder;

/**
 * The scanner that evaluates all expressions and builds the final
 * `AnimationRunner` instance for the target animation. It must be
 * executed in the "measure" vsync phase.
 */
var MeasureScanner = /*#__PURE__*/function (_Scanner) {
  _inherits(MeasureScanner, _Scanner);

  var _super = _createSuper(MeasureScanner);

  /**
   * @param {!Builder} builder
   * @param {!CssContextImpl} css
   * @param {!Array<string>} path
   * @param {?Element} target
   * @param {?number} index
   * @param {?Object<string, *>} vars
   * @param {?WebAnimationTimingDef} timing
   */
  function MeasureScanner(builder, css, path, target, index, vars, timing) {
    var _this3;

    _classCallCheck(this, MeasureScanner);

    _this3 = _super.call(this);

    /** @const @private */
    _this3.builder_ = builder;

    /** @const @private */
    _this3.css_ = css;

    /** @const @private */
    _this3.path_ = path;

    /** @private {?Element} */
    _this3.target_ = target;

    /** @private {?number} */
    _this3.index_ = index;

    /** @private {!Object<string, *>} */
    _this3.vars_ = vars || (0, _object.map)();

    /** @private {!WebAnimationTimingDef} */
    _this3.timing_ = timing || {
      duration: 0,
      delay: 0,
      endDelay: 0,
      iterations: 1,
      iterationStart: 0,
      easing: 'linear',
      direction: _webAnimationTypes.WebAnimationTimingDirection.NORMAL,
      fill: _webAnimationTypes.WebAnimationTimingFill.NONE
    };

    /** @private {!Array<!InternalWebAnimationRequestDef>} */
    _this3.requests_ = [];

    /**
     * Dependencies required to resolve all animation requests. In case of
     * composition, all requests can only be resolved asynchronously. This
     * dependencies are used to block `resolveRequests` to collect all
     * dependenices.
     * @const @private {!Array<!Promise>}
     */
    _this3.deps_ = [];
    return _this3;
  }

  /**
   * This methods scans all animation declarations specified in `spec`
   * recursively to produce the animation requests. `opt_args` is an additional
   * spec that can be used to default timing and variables.
   * @param {!WebAnimationDef|!Array<!WebAnimationDef>} spec
   * @param {?WebAnimationDef=} opt_args
   * @return {!Promise<!Array<!InternalWebAnimationRequestDef>>}
   */
  _createClass(MeasureScanner, [{
    key: "resolveRequests",
    value: function resolveRequests(spec, opt_args) {
      var _this4 = this;

      if (opt_args) {
        this.with_(opt_args, function () {
          _this4.scan(spec);
        });
      } else {
        this.css_.withVars(this.vars_, function () {
          _this4.scan(spec);
        });
      }

      return Promise.all(this.deps_).then(function () {
        return _this4.requests_;
      });
    }
    /** @override */

  }, {
    key: "isEnabled",
    value: function isEnabled(spec) {
      if (spec.media && !this.css_.matchMedia(spec.media)) {
        return false;
      }

      if (spec.supports && !this.css_.supports(spec.supports)) {
        return false;
      }

      return true;
    }
    /** @override */

  }, {
    key: "onMultiAnimation",
    value: function onMultiAnimation(spec) {
      var _this5 = this;

      this.with_(spec, function () {
        return _this5.scan(spec.animations);
      });
    }
    /** @override */

  }, {
    key: "onSwitchAnimation",
    value: function onSwitchAnimation(spec) {
      var _this6 = this;

      // The first to match will be used; the rest will be ignored.
      this.with_(spec, function () {
        for (var i = 0; i < spec.switch.length; i++) {
          var candidate = spec.switch[i];

          if (_this6.scan(candidate)) {
            // First matching candidate is applied and the rest are ignored.
            break;
          }
        }
      });
    }
    /** @override */

  }, {
    key: "onCompAnimation",
    value: function onCompAnimation(spec) {
      var _this7 = this;

      (0, _log.userAssert)(this.path_.indexOf(spec.animation) == -1, "Recursive animations are not allowed: \"" + spec.animation + "\"");
      var newPath = this.path_.concat(spec.animation);
      var animationElement = (0, _log.user)().assertElement(this.css_.getElementById(spec.animation), "Animation not found: \"" + spec.animation + "\"");
      // Currently, only `<amp-animation>` supplies animations. In the future
      // this could become an interface.
      (0, _log.userAssert)(animationElement.tagName == 'AMP-ANIMATION', "Element is not an animation: \"" + spec.animation + "\"");
      var otherSpecPromise = animationElement.getImpl().then(function (impl) {
        return impl.getAnimationSpec();
      });
      this.with_(spec, function () {
        var target = _this7.target_,
            index = _this7.index_,
            vars = _this7.vars_,
            timing = _this7.timing_;
        var promise = otherSpecPromise.then(function (otherSpec) {
          if (!otherSpec) {
            return;
          }

          return _this7.builder_.resolveRequests(newPath, otherSpec,
          /* args */
          null, target, index, vars, timing);
        }).then(function (requests) {
          /** @type {!Array} */
          requests.forEach(function (request) {
            return _this7.requests_.push(request);
          });
        });

        _this7.deps_.push(promise);
      });
    }
    /** @override */

  }, {
    key: "onKeyframeAnimation",
    value: function onKeyframeAnimation(spec) {
      var _this8 = this;

      this.with_(spec, function () {
        var target = (0, _log.user)().assertElement(_this8.target_, 'No target specified');

        var keyframes = _this8.createKeyframes_(target, spec);

        _this8.requests_.push({
          target: target,
          keyframes: keyframes,
          vars: _this8.vars_,
          timing: _this8.timing_
        });
      });
    }
    /**
     * @param {!Element} target
     * @param {!WebKeyframeAnimationDef} spec
     * @return {!WebKeyframesDef}
     * @private
     */

  }, {
    key: "createKeyframes_",
    value: function createKeyframes_(target, spec) {
      var _this9 = this;

      var specKeyframes = spec.keyframes;

      if (typeof specKeyframes == 'string') {
        // Keyframes name to be extracted from `<style>`.
        var keyframes = (0, _keyframesExtractor.extractKeyframes)(this.css_.rootNode, specKeyframes);
        (0, _log.userAssert)(keyframes, "Keyframes not found in stylesheet: \"" + specKeyframes + "\"");
        specKeyframes = keyframes;
      }

      if ((0, _types.isObject)(specKeyframes)) {
        // Property -> keyframes form.
        // The object is cloned, while properties are verified to be
        // allowlisted. Additionally, the `offset:0` frames are inserted
        // to polyfill partial keyframes per spec.
        // See https://github.com/w3c/web-animations/issues/187
        var object =
        /** @type {!Object<string, *>} */
        specKeyframes;

        /** @type {!WebKeyframesDef} */
        var _keyframes = {};

        for (var prop in object) {
          this.validateProperty_(prop);
          var value = object[prop];
          var preparedValue = void 0;

          if (SERVICE_PROPS[prop]) {
            preparedValue = value;
          } else if (!(0, _types.isArray)(value) || value.length == 1) {
            // Missing "from" value. Measure and add.
            var fromValue = this.css_.measure(target, prop);
            var toValue = (0, _types.isArray)(value) ? value[0] : value;
            preparedValue = [fromValue, this.css_.resolveCss(toValue)];
          } else {
            preparedValue = value.map(function (v) {
              return _this9.css_.resolveCss(v);
            });
          }

          _keyframes[prop] = preparedValue;

          if (prop in ADD_PROPS) {
            _keyframes[ADD_PROPS[prop]] = preparedValue;
          }
        }

        return _keyframes;
      }

      if ((0, _types.isArray)(specKeyframes) && specKeyframes.length > 0) {
        // Keyframes -> property form.
        // The array is cloned, while properties are verified to be allowlisted.
        // Additionally, if the `offset:0` properties are inserted when absent
        // to polyfill partial keyframes per spec.
        // See https://github.com/w3c/web-animations/issues/187 and
        // https://github.com/web-animations/web-animations-js/issues/14
        var array =
        /** @type {!Array<!Object<string, *>>} */
        specKeyframes;

        /** @type {!WebKeyframesDef} */
        var _keyframes2 = [];
        var addStartFrame = array.length == 1 || array[0].offset > 0;
        var startFrame = addStartFrame ? (0, _object.map)() : this.css_.resolveCssMap(array[0]);

        _keyframes2.push(startFrame);

        var start = addStartFrame ? 0 : 1;

        for (var i = start; i < array.length; i++) {
          var frame = array[i];

          for (var _prop in frame) {
            if (SERVICE_PROPS[_prop]) {
              continue;
            }

            this.validateProperty_(_prop);

            if (!startFrame[_prop]) {
              // Missing "from" value. Measure and add to start frame.
              startFrame[_prop] = this.css_.measure(target, _prop);
            }
          }

          _keyframes2.push(this.css_.resolveCssMap(frame));
        }

        for (var _i = 0; _i < _keyframes2.length; _i++) {
          var _frame = _keyframes2[_i];

          for (var k in ADD_PROPS) {
            if (k in _frame) {
              _frame[ADD_PROPS[k]] = _frame[k];
            }
          }
        }

        return _keyframes2;
      }

      // TODO(dvoytenko): support CSS keyframes per https://github.com/w3c/web-animations/issues/189
      // Unknown form of keyframes spec.
      throw (0, _log.user)().createError('keyframes not found', specKeyframes);
    }
    /** @override */

  }, {
    key: "onUnknownAnimation",
    value: function onUnknownAnimation() {
      throw (0, _log.user)().createError('unknown animation type:' + ' must have "animation", "animations" or "keyframes" field');
    }
    /**
     * @param {string} prop
     * @private
     */

  }, {
    key: "validateProperty_",
    value: function validateProperty_(prop) {
      if (SERVICE_PROPS[prop]) {
        return;
      }

      (0, _log.userAssert)((0, _webAnimationTypes.isAllowlistedProp)(prop), 'Property is not allowlisted for animation: %s', prop);
    }
    /**
     * Resolves common parameters of an animation: target, timing and vars.
     * @param {!WebAnimationDef} spec
     * @param {function()} callback
     * @private
     */

  }, {
    key: "with_",
    value: function with_(spec, callback) {
      var _this10 = this;

      // Save context.
      var prevTarget = this.target_,
          prevIndex = this.index_,
          prevVars = this.vars_,
          prevTiming = this.timing_;
      // Push new context and perform calculations.
      var targets = spec.target || spec.selector ? this.resolveTargets_(spec) : [null];
      this.css_.setTargetLength(targets.length);
      targets.forEach(function (target, index) {
        _this10.target_ = target || prevTarget;
        _this10.index_ = target ? index : prevIndex;

        _this10.css_.withTarget(_this10.target_, _this10.index_, function () {
          var subtargetSpec = _this10.target_ ? _this10.matchSubtargets_(_this10.target_, _this10.index_ || 0, spec) : spec;
          _this10.vars_ = _this10.mergeVars_(subtargetSpec, prevVars);

          _this10.css_.withVars(_this10.vars_, function () {
            _this10.timing_ = _this10.mergeTiming_(subtargetSpec, prevTiming);
            callback();
          });
        });
      });
      // Restore context.
      this.target_ = prevTarget;
      this.index_ = prevIndex;
      this.vars_ = prevVars;
      this.timing_ = prevTiming;
    }
    /**
     * @param {!WebAnimationDef} spec
     * @return {!Array<!Element>}
     * @private
     */

  }, {
    key: "resolveTargets_",
    value: function resolveTargets_(spec) {
      var _this11 = this;

      var targets;

      if (spec.selector) {
        (0, _log.userAssert)(!spec.target, 'Both "selector" and "target" are not allowed');
        targets = this.css_.queryElements(spec.selector);

        if (targets.length == 0) {
          (0, _log.user)().warn(TAG, "Target not found: \"" + spec.selector + "\"");
        }
      } else if (spec.target) {
        if (typeof spec.target == 'string') {
          // TODO(dvoytenko, #9129): cleanup deprecated string targets.
          (0, _log.user)().error(TAG, 'string targets are deprecated');
        }

        var target = (0, _log.user)().assertElement(typeof spec.target == 'string' ? this.css_.getElementById(spec.target) : spec.target, "Target not found: \"" + spec.target + "\"");
        targets = [target];
      } else if (this.target_) {
        targets = [this.target_];
      }

      targets.forEach(function (target) {
        return _this11.builder_.requireLayout(target);
      });
      return targets;
    }
    /**
     * @param {!Element} target
     * @param {number} index
     * @param {!WebAnimationSelectorDef} spec
     * @return {!WebAnimationSelectorDef}
     */

  }, {
    key: "matchSubtargets_",
    value: function matchSubtargets_(target, index, spec) {
      var _this12 = this;

      if (!spec.subtargets || spec.subtargets.length == 0) {
        return spec;
      }

      var result = (0, _object.map)(spec);
      spec.subtargets.forEach(function (subtargetSpec) {
        var matcher = _this12.getMatcher_(subtargetSpec);

        if (matcher(target, index)) {
          Object.assign(result, subtargetSpec);
        }
      });
      return result;
    }
    /**
     * @param {!WebAnimationSubtargetDef} spec
     * @return {function(!Element, number):boolean}
     */

  }, {
    key: "getMatcher_",
    value: function getMatcher_(spec) {
      if (spec.matcher) {
        return spec.matcher;
      }

      (0, _log.userAssert)((spec.index !== undefined || spec.selector !== undefined) && (spec.index === undefined || spec.selector === undefined), 'Only one "index" or "selector" must be specified');
      var matcher;

      if (spec.index !== undefined) {
        // Match by index, e.g. `index: 0`.
        var specIndex = Number(spec.index);

        matcher = function matcher(target, index) {
          return index === specIndex;
        };
      } else {
        // Match by selector, e.g. `:nth-child(2n+1)`.
        var specSelector =
        /** @type {string} */
        spec.selector;

        matcher = function matcher(target) {
          try {
            return (0, _dom.matches)(target, specSelector);
          } catch (e) {
            throw (0, _log.user)().createError("Bad subtarget selector: \"" + specSelector + "\"", e);
          }
        };
      }

      return spec.matcher = matcher;
    }
    /**
     * Merges vars by defaulting values from the previous vars.
     * @param {!Object<string, *>} newVars
     * @param {!Object<string, *>} prevVars
     * @return {!Object<string, *>}
     * @private
     */

  }, {
    key: "mergeVars_",
    value: function mergeVars_(newVars, prevVars) {
      var _this13 = this;

      // First combine all vars (previous and new) in one map. The new vars take
      // precedence. This is done so that the new vars can be resolved from both
      // the previous and new vars.
      var result = (0, _object.map)(prevVars);

      for (var k in newVars) {
        if ((0, _string.startsWith)(k, '--')) {
          result[k] = newVars[k];
        }
      }

      this.css_.withVars(result, function () {
        for (var _k in newVars) {
          if ((0, _string.startsWith)(_k, '--')) {
            result[_k] = _this13.css_.resolveCss(newVars[_k]);
          }
        }
      });
      return result;
    }
    /**
     * Merges timing by defaulting values from the previous timing.
     * @param {!WebAnimationTimingDef} newTiming
     * @param {!WebAnimationTimingDef} prevTiming
     * @return {!WebAnimationTimingDef}
     * @private
     */

  }, {
    key: "mergeTiming_",
    value: function mergeTiming_(newTiming, prevTiming) {
      // CSS time values in milliseconds.
      var duration = this.css_.resolveMillis(newTiming.duration, prevTiming.duration);
      var delay = this.css_.resolveMillis(newTiming.delay, prevTiming.delay);
      var endDelay = this.css_.resolveMillis(newTiming.endDelay, prevTiming.endDelay);
      // Numeric.
      var iterations = this.css_.resolveNumber(newTiming.iterations, (0, _log.dev)().assertNumber(prevTiming.iterations));
      var iterationStart = this.css_.resolveNumber(newTiming.iterationStart, prevTiming.iterationStart);
      // Identifier CSS values.
      var easing = this.css_.resolveIdent(newTiming.easing, prevTiming.easing);
      var direction =
      /** @type {!WebAnimationTimingDirection} */
      this.css_.resolveIdent(newTiming.direction, prevTiming.direction);
      var fill =
      /** @type {!WebAnimationTimingFill} */
      this.css_.resolveIdent(newTiming.fill, prevTiming.fill);
      // Validate.
      this.validateTime_(duration, newTiming.duration, 'duration');
      this.validateTime_(delay, newTiming.delay, 'delay',
      /* negative */
      true);
      this.validateTime_(endDelay, newTiming.endDelay, 'endDelay');
      (0, _log.userAssert)(iterations != null && iterations >= 0, '"iterations" is invalid: %s', newTiming.iterations);
      (0, _log.userAssert)(iterationStart != null && iterationStart >= 0 && isFinite(iterationStart), '"iterationStart" is invalid: %s', newTiming.iterationStart);
      (0, _log.user)().assertEnumValue(_webAnimationTypes.WebAnimationTimingDirection,
      /** @type {string} */
      direction, 'direction');
      (0, _log.user)().assertEnumValue(_webAnimationTypes.WebAnimationTimingFill,
      /** @type {string} */
      fill, 'fill');
      return {
        duration: duration,
        delay: delay,
        endDelay: endDelay,
        iterations: iterations,
        iterationStart: iterationStart,
        easing: easing,
        direction: direction,
        fill: fill
      };
    }
    /**
     * @param {number|undefined} value
     * @param {*} newValue
     * @param {string} field
     * @param {boolean=} opt_allowNegative
     * @private
     */

  }, {
    key: "validateTime_",
    value: function validateTime_(value, newValue, field, opt_allowNegative) {
      // Ensure that positive or zero values are only allowed.
      (0, _log.userAssert)(value != null && (value >= 0 || value < 0 && opt_allowNegative), '"%s" is invalid: %s', field, newValue);

      // Make sure that the values are in milliseconds: show a warning if
      // time is fractional.
      if (newValue != null && Math.floor(value) != value && value < 1) {
        (0, _log.user)().warn(TAG, "\"" + field + "\" is fractional." + ' Note that all times are in milliseconds.');
      }
    }
  }]);

  return MeasureScanner;
}(Scanner);

exports.MeasureScanner = MeasureScanner;

/**
 * @implements {./parsers/css-expr-ast.CssContext}
 */
var CssContextImpl = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Document|!ShadowRoot} rootNode
   * @param {string} baseUrl
   * @param {!./web-animation-types.WebAnimationBuilderOptionsDef} options
   */
  function CssContextImpl(win, rootNode, baseUrl, options) {
    _classCallCheck(this, CssContextImpl);

    var _options$scope = options.scope,
        scope = _options$scope === void 0 ? null : _options$scope,
        _options$scaleByScope = options.scaleByScope,
        scaleByScope = _options$scaleByScope === void 0 ? false : _options$scaleByScope;

    /** @const @private */
    this.win_ = win;

    /** @const @private {!Document|!ShadowRoot} */
    this.rootNode_ = rootNode;

    /** @const @private {?Element} */
    this.scope_ = scope;

    /** @const @private {boolean} */
    this.scaleByScope_ = scaleByScope;

    /** @const @private */
    this.baseUrl_ = baseUrl;

    /** @private {!Object<string, !CSSStyleDeclaration>} */
    this.computedStyleCache_ = (0, _object.map)();

    /** @private {!Object<string, ?./parsers/css-expr-ast.CssNode>} */
    this.parsedCssCache_ = (0, _object.map)();

    /** @private {?number} */
    this.targetLength_ = null;

    /** @private {?Element} */
    this.currentTarget_ = null;

    /** @private {?number} */
    this.currentIndex_ = null;

    /** @private {?Object<string, *>} */
    this.vars_ = null;

    /** @private {!Array<string>} */
    this.varPath_ = [];

    /** @private {?string} */
    this.dim_ = null;

    /**
     * @private {?{
     *   size: {width: number, height: number},
     *   offset: {x: number, y: number},
     *   scaleFactorX: number,
     *   scaleFactorY: number,
     * }}
     */
    this.viewportParams_ = null;
  }

  /** @return {!Document|!ShadowRoot} */
  _createClass(CssContextImpl, [{
    key: "matchMedia",

    /**
     * @param {string} mediaQuery
     * @return {boolean}
     */
    value: function matchMedia(mediaQuery) {
      return this.win_.matchMedia(mediaQuery).matches;
    }
    /**
     * @param {string} query
     * @return {boolean}
     */

  }, {
    key: "supports",
    value: function supports(query) {
      if (this.win_.CSS && this.win_.CSS.supports) {
        return this.win_.CSS.supports(query);
      }

      return false;
    }
    /**
     * @param {string} id
     * @return {?Element}
     */

  }, {
    key: "getElementById",
    value: function getElementById(id) {
      return this.scopedQuerySelector_("#" + (0, _css.escapeCssSelectorIdent)(id));
    }
    /**
     * @param {string} selector
     * @return {!Array<!Element>}
     */

  }, {
    key: "queryElements",
    value: function queryElements(selector) {
      try {
        return (0, _types.toArray)(this.scopedQuerySelectorAll_(selector));
      } catch (e) {
        throw (0, _log.user)().createError("Bad query selector: \"" + selector + "\"", e);
      }
    }
    /**
     * @param {!Element} target
     * @param {string} prop
     * @return {string}
     */

  }, {
    key: "measure",
    value: function measure(target, prop) {
      // Get ID.
      var targetId = target[TARGET_ANIM_ID];

      if (!targetId) {
        targetId = String(++animIdCounter);
        target[TARGET_ANIM_ID] = targetId;
      }

      // Get and cache styles.
      var styles = this.computedStyleCache_[targetId];

      if (!styles) {
        styles = (0, _style.computedStyle)(this.win_, target);
        this.computedStyleCache_[targetId] =
        /** @type {!CSSStyleDeclaration} */
        styles;
      }

      // Resolve a var or a property.
      return (0, _string.startsWith)(prop, '--') ? styles.getPropertyValue(prop) : styles[(0, _style.getVendorJsPropertyName)(styles, (0, _string.dashToCamelCase)(prop))];
    }
    /**
     * @param {number} len
     * @protected
     */

  }, {
    key: "setTargetLength",
    value: function setTargetLength(len) {
      this.targetLength_ = len;
    }
    /**
     * @param {?Element} target
     * @param {?number} index
     * @param {function(?Element):T} callback
     * @return {T}
     * @template T
     * @protected
     */

  }, {
    key: "withTarget",
    value: function withTarget(target, index, callback) {
      var prev = this.currentTarget_,
          prevIndex = this.currentIndex_;
      this.currentTarget_ = target;
      this.currentIndex_ = index;
      var result = callback(target);
      this.currentTarget_ = prev;
      this.currentIndex_ = prevIndex;
      return result;
    }
    /**
     * @param {?Object<string, *>} vars
     * @param {function():T} callback
     * @return {T}
     * @template T
     * @protected
     */

  }, {
    key: "withVars",
    value: function withVars(vars, callback) {
      var prev = this.vars_;
      this.vars_ = vars;
      var result = callback();
      this.vars_ = prev;
      return result;
    }
    /**
     * @param {*} input
     * @return {string}
     * @protected
     */

  }, {
    key: "resolveCss",
    value: function resolveCss(input) {
      // Will always return a valid string, since the default value is `''`.
      return (0, _log.dev)().assertString(this.resolveCss_(input,
      /* def */
      '',
      /* normalize */
      true));
    }
    /**
     * @param {!Object<string, *>} input
     * @return {!Object<string, string|number>}
     */

  }, {
    key: "resolveCssMap",
    value: function resolveCssMap(input) {
      var result = (0, _object.map)();

      for (var k in input) {
        if (k == 'offset') {
          result[k] = input[k];
        } else {
          result[k] = this.resolveCss(input[k]);
        }
      }

      return result;
    }
    /**
     * @param {*} input
     * @param {string|undefined} def
     * @return {string|undefined}
     */

  }, {
    key: "resolveIdent",
    value: function resolveIdent(input, def) {
      return this.resolveCss_(input, def,
      /* normalize */
      false);
    }
    /**
     * @param {*} input
     * @param {number|undefined} def
     * @return {number|undefined}
     */

  }, {
    key: "resolveMillis",
    value: function resolveMillis(input, def) {
      if (input != null && input !== '') {
        if (typeof input == 'number') {
          return input;
        }

        var node = this.resolveAsNode_(input,
        /* normalize */
        false);

        if (node) {
          return _cssExprAst.CssTimeNode.millis(node);
        }
      }

      return def;
    }
    /**
     * @param {*} input
     * @param {number|undefined} def
     * @return {number|undefined}
     */

  }, {
    key: "resolveNumber",
    value: function resolveNumber(input, def) {
      if (input != null && input !== '') {
        if (typeof input == 'number') {
          return input;
        }

        var node = this.resolveAsNode_(input,
        /* normalize */
        false);

        if (node) {
          return _cssExprAst.CssNumberNode.num(node);
        }
      }

      return def;
    }
    /**
     * @param {*} input
     * @param {string|undefined} def
     * @param {boolean} normalize
     * @return {string|undefined}
     * @private
     */

  }, {
    key: "resolveCss_",
    value: function resolveCss_(input, def, normalize) {
      if (input == null || input === '') {
        return def;
      }

      var inputCss = String(input);

      if (typeof input == 'number') {
        return inputCss;
      }

      // Test first if CSS contains any variable components. Otherwise, there's
      // no need to spend cycles to parse/evaluate.
      if (!(0, _cssExprAst.isVarCss)(inputCss, normalize)) {
        return inputCss;
      }

      var result = this.resolveAsNode_(inputCss, normalize);
      return result != null ? result.css() : def;
    }
    /**
     * @param {*} input
     * @param {boolean} normalize
     * @return {?./parsers/css-expr-ast.CssNode}
     * @private
     */

  }, {
    key: "resolveAsNode_",
    value: function resolveAsNode_(input, normalize) {
      if (input == null || input === '') {
        return null;
      }

      if (typeof input == 'number') {
        return new _cssExprAst.CssNumberNode(input);
      }

      // Check if the expression has already been parsed. Notice that the parsed
      // value could be `null`.
      var css = String(input);
      var node = this.parsedCssCache_[css];

      if (node === undefined) {
        node = (0, _cssExpr.parseCss)(css);
        this.parsedCssCache_[css] = node;
      }

      if (!node) {
        return null;
      }

      return node.resolve(this, normalize);
    }
    /**
     * @return {!Element}
     * @private
     */

  }, {
    key: "requireTarget_",
    value: function requireTarget_() {
      return (0, _log.user)().assertElement(this.currentTarget_, 'Only allowed when target is specified');
    }
    /** @override */

  }, {
    key: "getVar",
    value: function getVar(varName) {
      (0, _log.userAssert)(this.varPath_.indexOf(varName) == -1, "Recursive variable: \"" + varName + "\"");
      this.varPath_.push(varName);
      var rawValue = this.vars_ && this.vars_[varName] != undefined ? this.vars_[varName] : this.currentTarget_ ? this.measure(this.currentTarget_, varName) : null;

      if (rawValue == null || rawValue === '') {
        (0, _log.user)().warn(TAG, "Variable not found: \"" + varName + "\"");
      }

      // No need to normalize vars - they will be normalized later.
      var result = this.resolveAsNode_(rawValue,
      /* normalize */
      false);
      this.varPath_.pop();
      return result;
    }
    /** @override */

  }, {
    key: "withDimension",
    value: function withDimension(dim, callback) {
      var savedDim = this.dim_;
      this.dim_ = dim;
      var result = callback();
      this.dim_ = savedDim;
      return result;
    }
    /** @override */

  }, {
    key: "getDimension",
    value: function getDimension() {
      return this.dim_;
    }
    /** @override */

  }, {
    key: "getViewportSize",
    value: function getViewportSize() {
      return this.getViewportParams_().size;
    }
    /** @private */

  }, {
    key: "getViewportParams_",
    value: function getViewportParams_() {
      if (!this.viewportParams_) {
        if (this.scope_ && this.scaleByScope_) {
          var rect = this.scope_.
          /*OK*/
          getBoundingClientRect();
          var _this$scope_ = this.scope_,
              offsetWidth = _this$scope_.offsetWidth,
              offsetHeight = _this$scope_.offsetHeight;
          this.viewportParams_ = {
            offset: {
              x: rect.x,
              y: rect.y
            },
            size: {
              width: offsetWidth,
              height: offsetHeight
            },
            scaleFactorX: offsetWidth / (rect.width || 1),
            scaleFactorY: offsetHeight / (rect.height || 1)
          };
        } else {
          var _this$win_ = this.win_,
              innerWidth = _this$win_.innerWidth,
              innerHeight = _this$win_.innerHeight;
          this.viewportParams_ = {
            offset: {
              x: 0,
              y: 0
            },
            size: {
              width: innerWidth,
              height: innerHeight
            },
            scaleFactorX: 1,
            scaleFactorY: 1
          };
        }
      }

      return this.viewportParams_;
    }
    /** @override */

  }, {
    key: "getCurrentIndex",
    value: function getCurrentIndex() {
      this.requireTarget_();
      return (0, _log.dev)().assertNumber(this.currentIndex_);
    }
    /** @override */

  }, {
    key: "getTargetLength",
    value: function getTargetLength() {
      this.requireTarget_();
      return (0, _log.dev)().assertNumber(this.targetLength_);
    }
    /** @override */

  }, {
    key: "getCurrentFontSize",
    value: function getCurrentFontSize() {
      return this.getElementFontSize_(this.requireTarget_());
    }
    /** @override */

  }, {
    key: "getRootFontSize",
    value: function getRootFontSize() {
      return this.getElementFontSize_(this.win_.document.documentElement);
    }
    /**
     * @param {!Element} target
     * @return {number}
     * @private
     */

  }, {
    key: "getElementFontSize_",
    value: function getElementFontSize_(target) {
      return parseFloat(this.measure(target, 'font-size'));
    }
    /** @override */

  }, {
    key: "getCurrentElementRect",
    value: function getCurrentElementRect() {
      return this.getElementRect_(this.requireTarget_());
    }
    /** @override */

  }, {
    key: "getElementRect",
    value: function getElementRect(selector, selectionMethod) {
      return this.getElementRect_(this.getElement_(selector, selectionMethod));
    }
    /**
     * @param {string} selector
     * @param {?string} selectionMethod
     * @return {!Element}
     * @private
     */

  }, {
    key: "getElement_",
    value: function getElement_(selector, selectionMethod) {
      (0, _log.devAssert)(selectionMethod == null || selectionMethod == 'closest', 'Unknown selection method: %s', selectionMethod);
      var element;

      try {
        if (selectionMethod == 'closest') {
          var maybeFoundInScope = (0, _dom.closestAncestorElementBySelector)(this.requireTarget_(), selector);

          if (maybeFoundInScope && (!this.scope_ || this.scope_.contains(maybeFoundInScope))) {
            element = maybeFoundInScope;
          }
        } else {
          element = this.scopedQuerySelector_(selector);
        }
      } catch (e) {
        throw (0, _log.user)().createError("Bad query selector: \"" + selector + "\"", e);
      }

      return (0, _log.user)().assertElement(element, "Element not found: " + selector);
    }
    /**
     * @param {!Element} target
     * @return {!../../../src/layout-rect.LayoutRectDef}
     * @private
     */

  }, {
    key: "getElementRect_",
    value: function getElementRect_(target) {
      var _this$getViewportPara = this.getViewportParams_(),
          offset = _this$getViewportPara.offset,
          scaleFactorX = _this$getViewportPara.scaleFactorX,
          scaleFactorY = _this$getViewportPara.scaleFactorY;

      var _target$getBoundingCl = target.
      /*OK*/
      getBoundingClientRect(),
          x = _target$getBoundingCl.x,
          y = _target$getBoundingCl.y,
          width = _target$getBoundingCl.width,
          height = _target$getBoundingCl.height;

      // This assumes default `transform-origin: center center`
      return (0, _layoutRect.layoutRectLtwh)((x - offset.x) * scaleFactorX, (y - offset.y) * scaleFactorY, width * scaleFactorX, height * scaleFactorY);
    }
    /** @override */

  }, {
    key: "resolveUrl",
    value: function resolveUrl(url) {
      var resolvedUrl = (0, _url.resolveRelativeUrl)(url, this.baseUrl_);
      return (0, _url.assertHttpsUrl)(resolvedUrl, this.currentTarget_ || '');
    }
    /**
     * @param {string} selector
     * @return {?Element}
     * @private
     */

  }, {
    key: "scopedQuerySelector_",
    value: function scopedQuerySelector_(selector) {
      if (this.scope_) {
        return (
          /*OK*/
          (0, _dom.scopedQuerySelector)(this.scope_, selector)
        );
      }

      return this.rootNode_.
      /*OK*/
      querySelector(selector);
    }
    /**
     * @param {string} selector
     * @return {!NodeList}
     * @private
     */

  }, {
    key: "scopedQuerySelectorAll_",
    value: function scopedQuerySelectorAll_(selector) {
      if (this.scope_) {
        return (
          /*OK*/
          (0, _dom.scopedQuerySelectorAll)(this.scope_, selector)
        );
      }

      return this.rootNode_.
      /*OK*/
      querySelectorAll(selector);
    }
  }, {
    key: "rootNode",
    get: function get() {
      return this.rootNode_;
    }
  }]);

  return CssContextImpl;
}();

},{"../../../src/css":18,"../../../src/dom":19,"../../../src/experiments":23,"../../../src/iframe-helper":24,"../../../src/layout-rect":27,"../../../src/log":28,"../../../src/mode":29,"../../../src/string":35,"../../../src/style":36,"../../../src/types":37,"../../../src/url":40,"../../../src/utils/object":45,"./parsers/css-expr":5,"./parsers/css-expr-ast":4,"./parsers/keyframes-extractor":6,"./runners/native-web-animation-runner":8,"./runners/scrolltimeline-worklet-runner":9,"./web-animation-types":12}],14:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.listen = listen;
exports.serializeMessage = serializeMessage;
exports.deserializeMessage = deserializeMessage;
exports.isAmpMessage = isAmpMessage;
exports.IframeTransportEvent = exports.MessageType = exports.CONSTANTS = void 0;

var _log = require("./log");

var _object = require("./utils/object");

var _eventHelperListen = require("./event-helper-listen");

var _json = require("./json");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @const */
var AMP_MESSAGE_PREFIX = 'amp-';
var CONSTANTS = {
  responseTypeSuffix: '-result',
  messageIdFieldName: 'messageId',
  payloadFieldName: 'payload',
  contentFieldName: 'content'
};
exports.CONSTANTS = CONSTANTS;

/** @enum {string} */
var MessageType = {
  // For amp-ad
  SEND_EMBED_STATE: 'send-embed-state',
  EMBED_STATE: 'embed-state',
  SEND_EMBED_CONTEXT: 'send-embed-context',
  EMBED_CONTEXT: 'embed-context',
  SEND_INTERSECTIONS: 'send-intersections',
  INTERSECTION: 'intersection',
  EMBED_SIZE: 'embed-size',
  EMBED_SIZE_CHANGED: 'embed-size-changed',
  EMBED_SIZE_DENIED: 'embed-size-denied',
  NO_CONTENT: 'no-content',
  GET_HTML: 'get-html',
  GET_CONSENT_STATE: 'get-consent-state',
  // For the frame to be placed in full overlay mode for lightboxes
  FULL_OVERLAY_FRAME: 'full-overlay-frame',
  FULL_OVERLAY_FRAME_RESPONSE: 'full-overlay-frame-response',
  CANCEL_FULL_OVERLAY_FRAME: 'cancel-full-overlay-frame',
  CANCEL_FULL_OVERLAY_FRAME_RESPONSE: 'cancel-full-overlay-frame-response',
  // For amp-inabox
  SEND_POSITIONS: 'send-positions',
  POSITION: 'position',
  // For amp-analytics' iframe-transport
  SEND_IFRAME_TRANSPORT_EVENTS: 'send-iframe-transport-events',
  IFRAME_TRANSPORT_EVENTS: 'iframe-transport-events',
  IFRAME_TRANSPORT_RESPONSE: 'iframe-transport-response',
  // For user-error-in-iframe
  USER_ERROR_IN_IFRAME: 'user-error-in-iframe'
};
exports.MessageType = MessageType;

/**
 * Listens for the specified event on the element.
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {function(!Event)} listener
 * @param {Object=} opt_evtListenerOpts
 * @return {!UnlistenDef}
 */
function listen(element, eventType, listener, opt_evtListenerOpts) {
  return (0, _eventHelperListen.internalListenImplementation)(element, eventType, listener, opt_evtListenerOpts);
}

/**
 * Serialize an AMP post message. Output looks like:
 * 'amp-011481323099490{"type":"position","sentinel":"12345","foo":"bar"}'
 * @param {string} type
 * @param {string} sentinel
 * @param {JsonObject=} data
 * @param {?string=} rtvVersion
 * @return {string}
 */
function serializeMessage(type, sentinel, data, rtvVersion) {
  if (data === void 0) {
    data = (0, _object.dict)();
  }

  if (rtvVersion === void 0) {
    rtvVersion = null;
  }

  // TODO: consider wrap the data in a "data" field. { type, sentinal, data }
  var message = data;
  message['type'] = type;
  message['sentinel'] = sentinel;
  return AMP_MESSAGE_PREFIX + (rtvVersion || '') + JSON.stringify(message);
}

/**
 * Deserialize an AMP post message.
 * Returns null if it's not valid AMP message format.
 *
 * @param {*} message
 * @return {?JsonObject|undefined}
 */
function deserializeMessage(message) {
  if (!isAmpMessage(message)) {
    return null;
  }

  var startPos = message.indexOf('{');
  (0, _log.devAssert)(startPos != -1, 'JSON missing in %s', message);

  try {
    return (0, _json.parseJson)(message.substr(startPos));
  } catch (e) {
    (0, _log.dev)().error('MESSAGING', 'Failed to parse message: ' + message, e);
    return null;
  }
}

/**
 *  Returns true if message looks like it is an AMP postMessage
 *  @param {*} message
 *  @return {boolean}
 */
function isAmpMessage(message) {
  return typeof message == 'string' && message.indexOf(AMP_MESSAGE_PREFIX) == 0 && message.indexOf('{') != -1;
}

/** @typedef {{creativeId: string, message: string}} */
var IframeTransportEvent;
exports.IframeTransportEvent = IframeTransportEvent;

},{"./event-helper-listen":21,"./json":26,"./log":28,"./utils/object":45}],15:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.actionTrustToString = actionTrustToString;
exports.ActionTrust = exports.DEFAULT_ACTION = exports.RAW_OBJECT_ARGS_KEY = void 0;

var _log = require("./log");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Key string in an action arguments map for an unparsed object literal string.
 *
 * E.g. for the action in <p on="tap:AMP.setState({foo: 'bar'})",
 * then `args[RAW_OBJECT_ARGS_KEY]` is the string "{foo: 'bar'}".
 *
 * The action service delegates parsing of object literals to the corresponding
 * extension (in the example above, amp-bind).
 *
 * @see ./service/action-impl.ActionInfoDef
 * @const {string}
 */
var RAW_OBJECT_ARGS_KEY = '__AMP_OBJECT_STRING__';
exports.RAW_OBJECT_ARGS_KEY = RAW_OBJECT_ARGS_KEY;

/**
 * Identifier for an element's default action.
 *
 * @const {string}
 */
var DEFAULT_ACTION = 'activate';
exports.DEFAULT_ACTION = DEFAULT_ACTION;

/**
 * Corresponds to degree of user intent, i.e. events triggered with strong
 * user intent have high trust.
 *
 * @enum {number}
 */
var ActionTrust = {
  /**
   * Events that are triggered without a user gesture, or triggered by a user
   * gesture with weak intent (e.g. scroll) are "low trust".
   *
   * Actions that have low impact on the page's visual state should require
   * "low trust" (e.g. pausing a video).
   */
  LOW: 1,

  /**
   * Events that are triggered nearly immediately (up to a few seconds) after
   * a user gesture with strong intent (e.g. tap or swipe) are "default trust".
   *
   * Actions that can modify the page's visual state (e.g. content jumping)
   * should require "default trust". This is the default required trust level
   * for actions.
   */
  DEFAULT: 2,

  /**
   * Events that are triggered immediately after a user gesture with
   * strong intent (e.g. tap or swipe) are "high trust".
   *
   * There are no actions yet that require high trust.
   */
  HIGH: 3
};
exports.ActionTrust = ActionTrust;

/**
 * @param {!ActionTrust} actionTrust
 * @return {string}
 */
function actionTrustToString(actionTrust) {
  switch (actionTrust) {
    case ActionTrust.LOW:
      return 'low';

    case ActionTrust.HIGH:
      return 'high';

    default:
      (0, _log.devAssert)(actionTrust === ActionTrust.DEFAULT);
      return 'default';
  }
}

},{"./log":28}],16:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.toggleAmpdocFieForTesting = toggleAmpdocFieForTesting;
exports.isInAmpdocFieExperiment = isInAmpdocFieExperiment;
exports.EXPERIMENT_INFO_LIST = void 0;

var _experiments = require("./experiments");

/**
 * Copyright 2019 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO(#22733): Remove this file once "ampdoc-fie" is cleaned up.
var EXPERIMENT_ID = 'ampdoc-fie';

/**
 * @const {{experiment: string, control: string, branch: string}}
 */
var EXPERIMENT = {
  branch: EXPERIMENT_ID,
  control: '21066823',
  experiment: '21066824'
};

/**
 * @const {!Array<!./experiments.ExperimentInfo>}
 */
var EXPERIMENT_INFO_LIST = [{
  experimentId: EXPERIMENT_ID,
  isTrafficEligible: function isTrafficEligible() {
    return true;
  },
  branches: [EXPERIMENT.control, EXPERIMENT.experiment]
}];
exports.EXPERIMENT_INFO_LIST = EXPERIMENT_INFO_LIST;

/**
 * @param {!Window} win
 * @param {boolean} on
 * @visibleForTesting
 */
function toggleAmpdocFieForTesting(win, on) {
  (0, _experiments.forceExperimentBranch)(win, EXPERIMENT_ID, on ? EXPERIMENT.experiment : null);
}

/**
 * @param {!Window} win
 * @return {boolean}
 */
function isInAmpdocFieExperiment(win) {
  if (!(0, _experiments.isExperimentOn)(win, 'ampdoc-fie')) {
    return false;
  }

  (0, _experiments.randomlySelectUnsetExperiments)(win, EXPERIMENT_INFO_LIST);
  return (0, _experiments.getExperimentBranch)(win, EXPERIMENT_ID) === EXPERIMENT.experiment;
}

},{"./experiments":23}],17:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.config = exports.urls = void 0;

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Allows for runtime configuration. Internally, the runtime should
 * use the src/config.js module for various constants. We can use the
 * AMP_CONFIG global to translate user-defined configurations to this
 * module.
 * @type {!Object<string, string>}
 */
var env = self.AMP_CONFIG || {};
var thirdPartyFrameRegex = (typeof env['thirdPartyFrameRegex'] == 'string' ? new RegExp(env['thirdPartyFrameRegex']) : env['thirdPartyFrameRegex']) || /^d-\d+\.ampproject\.net$/;
var cdnProxyRegex = (typeof env['cdnProxyRegex'] == 'string' ? new RegExp(env['cdnProxyRegex']) : env['cdnProxyRegex']) || /^https:\/\/([a-zA-Z0-9_-]+\.)?cdn\.ampproject\.org$/;

/**
 * Check for a custom URL definition in special <meta> tags. Note that this does
 * not allow for distinct custom URLs in AmpDocShadow instances. The shell is
 * allowed to define one set of custom URLs via AMP_CONFIG (recommended) or by
 * including <meta> tags in the shell <head>. Those custom URLs then apply to
 * all AMP documents loaded in the shell.
 * @param {string} name
 * @return {?string}
 * @private
 */
function getMetaUrl(name) {
  // Avoid exceptions in unit tests
  if (!self.document || !self.document.head) {
    return null;
  }

  // Disallow on proxy origins
  if (self.location && cdnProxyRegex.test(self.location.origin)) {
    return null;
  }

  var metaEl = self.document.head.
  /*OK*/
  querySelector("meta[name=\"" + name + "\"]");
  return metaEl && metaEl.getAttribute('content') || null;
}

/** @type {!Object<string, string|boolean|RegExp|Array<RegExp>>} */
var urls = {
  thirdParty: env['thirdPartyUrl'] || 'https://3p.ampproject.net',
  thirdPartyFrameHost: env['thirdPartyFrameHost'] || 'ampproject.net',
  thirdPartyFrameRegex: thirdPartyFrameRegex,
  cdn: env['cdnUrl'] || getMetaUrl('runtime-host') || 'https://cdn.ampproject.org',

  /* Note that cdnProxyRegex is only ever checked against origins
   * (proto://host[:port]) so does not need to consider path
   */
  cdnProxyRegex: cdnProxyRegex,
  localhostRegex: /^https?:\/\/localhost(:\d+)?$/,
  errorReporting: env['errorReportingUrl'] || 'https://us-central1-amp-error-reporting.cloudfunctions.net/r',
  betaErrorReporting: env['betaErrorReportingUrl'] || 'https://us-central1-amp-error-reporting.cloudfunctions.net/r-beta',
  localDev: env['localDev'] || false,

  /**
   * These domains are trusted with more sensitive viewer operations such as
   * propagating the referrer. If you believe your domain should be here,
   * file the issue on GitHub to discuss. The process will be similar
   * (but somewhat more stringent) to the one described in the [3p/README.md](
   * https://github.com/ampproject/amphtml/blob/master/3p/README.md)
   *
   * {!Array<!RegExp>}
   */
  trustedViewerHosts: [/(^|\.)google\.(com?|[a-z]{2}|com?\.[a-z]{2}|cat)$/, /(^|\.)gmail\.(com|dev)$/],
  // Optional fallback API if amp-geo is left unpatched
  geoApi: env['geoApiUrl'] || getMetaUrl('amp-geo-api')
};
exports.urls = urls;
var config = {
  urls: urls
};
exports.config = config;

},{}],18:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.assertIsName = assertIsName;
exports.setScopeSelectorSupportedForTesting = setScopeSelectorSupportedForTesting;
exports.isScopeSelectorSupported = isScopeSelectorSupported;
exports.prependSelectorsWith = prependSelectorsWith;
exports.escapeCssSelectorIdent = escapeCssSelectorIdent;
exports.escapeCssSelectorNth = escapeCssSelectorNth;

var _cssEscape = require("../third_party/css-escape/css-escape");

var _log = require("./log");

/**
 * Copyright 2019 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Asserts that name is just an alphanumeric word, and does not contain
 * advanced CSS selector features like attributes, psuedo-classes, class names,
 * nor ids.
 * @param {string} name
 */
function assertIsName(name) {
  (0, _log.devAssert)(/^[\w-]+$/.test(name));
}

/**
 * @type {boolean|undefined}
 */
var scopeSelectorSupported;

/**
 * @param {boolean|undefined} val
 * @visibleForTesting
 */
function setScopeSelectorSupportedForTesting(val) {
  scopeSelectorSupported = val;
}

/**
 * Test that the :scope selector is supported and behaves correctly.
 * @param {!Element} el
 * @return {boolean}
 */
function isScopeSelectorSupported(el) {
  if (scopeSelectorSupported !== undefined) {
    return scopeSelectorSupported;
  }

  return scopeSelectorSupported = testScopeSelector(el);
}

/**
 * Test that the :scope selector is supported and behaves correctly.
 * @param {!Element} el
 * @return {boolean}
 */
function testScopeSelector(el) {
  try {
    var doc = el.ownerDocument;
    var testElement = doc.createElement('div');
    var testChild = doc.createElement('div');
    testElement.appendChild(testChild);
    // NOTE(cvializ, #12383): Firefox's implementation is incomplete,
    // therefore we test actual functionality of`:scope` as well.
    return testElement.
    /*OK*/
    querySelector(':scope div') === testChild;
  } catch (e) {
    return false;
  }
}

/**
 * Prefixes a selector for ancestor selection. Splits in subselectors and
 * applies prefix to each.
 *
 * e.g.
 * ```
 *   prependSelectorsWith('div', '.i-amphtml-scoped');
 *   // => '.i-amphtml-scoped div'
 *   prependSelectorsWith('div, ul', ':scope');
 *   // => ':scope div, :scope ul'
 *   prependSelectorsWith('div, ul', 'article >');
 *   // => 'article > div, article > ul'
 * ```
 *
 * @param {string} selector
 * @param {string} distribute
 * @return {string}
 */
function prependSelectorsWith(selector, distribute) {
  return selector.replace(/^|,/g, "$&" + distribute + " ");
}

/**
 * Escapes an ident (ID or a class name) to be used as a CSS selector.
 *
 * See https://drafts.csswg.org/cssom/#serialize-an-identifier.
 *
 * @param {string} ident
 * @return {string}
 */
function escapeCssSelectorIdent(ident) {
  if (false) {
    return CSS.escape(ident);
  }

  return (0, _cssEscape.cssEscape)(ident);
}

/**
 * Escapes an ident in a way that can be used by :nth-child() psuedo-class.
 *
 * See https://github.com/w3c/csswg-drafts/issues/2306.
 *
 * @param {string|number} ident
 * @return {string}
 */
function escapeCssSelectorNth(ident) {
  var escaped = String(ident);
  // Ensure it doesn't close the nth-child psuedo class.
  (0, _log.devAssert)(escaped.indexOf(')') === -1);
  return escaped;
}

},{"../third_party/css-escape/css-escape":47,"./log":28}],19:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.waitForChild = waitForChild;
exports.waitForChildPromise = waitForChildPromise;
exports.waitForBodyOpen = waitForBodyOpen;
exports.waitForBodyOpenPromise = waitForBodyOpenPromise;
exports.removeElement = removeElement;
exports.removeChildren = removeChildren;
exports.copyChildren = copyChildren;
exports.insertAfterOrAtStart = insertAfterOrAtStart;
exports.insertAtStart = insertAtStart;
exports.addAttributesToElement = addAttributesToElement;
exports.createElementWithAttributes = createElementWithAttributes;
exports.isConnectedNode = isConnectedNode;
exports.rootNodeFor = rootNodeFor;
exports.isShadowRoot = isShadowRoot;
exports.closest = closest;
exports.closestNode = closestNode;
exports.closestAncestorElementBySelector = closestAncestorElementBySelector;
exports.ancestorElements = ancestorElements;
exports.ancestorElementsByTag = ancestorElementsByTag;
exports.childElement = childElement;
exports.childElements = childElements;
exports.lastChildElement = lastChildElement;
exports.childNodes = childNodes;
exports.childElementByAttr = childElementByAttr;
exports.lastChildElementByAttr = lastChildElementByAttr;
exports.childElementsByAttr = childElementsByAttr;
exports.childElementByTag = childElementByTag;
exports.childElementsByTag = childElementsByTag;
exports.matches = matches;
exports.elementByTag = elementByTag;
exports.scopedQuerySelector = scopedQuerySelector;
exports.scopedQuerySelectorAll = scopedQuerySelectorAll;
exports.getDataParamsFromAttributes = getDataParamsFromAttributes;
exports.hasNextNodeInDocumentOrder = hasNextNodeInDocumentOrder;
exports.templateContentClone = templateContentClone;
exports.iterateCursor = iterateCursor;
exports.openWindowDialog = openWindowDialog;
exports.isJsonScriptTag = isJsonScriptTag;
exports.isJsonLdScriptTag = isJsonLdScriptTag;
exports.isRTL = isRTL;
exports.escapeHtml = escapeHtml;
exports.tryFocus = tryFocus;
exports.isIframed = isIframed;
exports.isAmpElement = isAmpElement;
exports.whenUpgradedToCustomElement = whenUpgradedToCustomElement;
exports.fullscreenEnter = fullscreenEnter;
exports.fullscreenExit = fullscreenExit;
exports.isFullscreenElement = isFullscreenElement;
exports.isEnabled = isEnabled;
exports.domOrderComparator = domOrderComparator;
exports.toggleAttribute = toggleAttribute;
exports.getVerticalScrollbarWidth = getVerticalScrollbarWidth;
exports.UPGRADE_TO_CUSTOMELEMENT_RESOLVER = exports.UPGRADE_TO_CUSTOMELEMENT_PROMISE = void 0;

var _promise = require("./utils/promise");

var _css = require("./css");

var _log = require("./log");

var _object = require("./utils/object");

var _string = require("./string");

var _types = require("./types");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var HTML_ESCAPE_CHARS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
};
var HTML_ESCAPE_REGEX = /(&|<|>|"|'|`)/g;

/** @const {string} */
var UPGRADE_TO_CUSTOMELEMENT_PROMISE = '__AMP_UPG_PRM';
exports.UPGRADE_TO_CUSTOMELEMENT_PROMISE = UPGRADE_TO_CUSTOMELEMENT_PROMISE;

/** @const {string} */
var UPGRADE_TO_CUSTOMELEMENT_RESOLVER = '__AMP_UPG_RES';
exports.UPGRADE_TO_CUSTOMELEMENT_RESOLVER = UPGRADE_TO_CUSTOMELEMENT_RESOLVER;

/**
 * Waits until the child element is constructed. Once the child is found, the
 * callback is executed.
 * @param {!Element} parent
 * @param {function(!Element):boolean} checkFunc
 * @param {function()} callback
 */
function waitForChild(parent, checkFunc, callback) {
  if (checkFunc(parent)) {
    callback();
    return;
  }

  /** @const {!Window} */
  var win = (0, _types.toWin)(parent.ownerDocument.defaultView);

  if (win.MutationObserver) {
    /** @const {MutationObserver} */
    var observer = new win.MutationObserver(function () {
      if (checkFunc(parent)) {
        observer.disconnect();
        callback();
      }
    });
    observer.observe(parent, {
      childList: true
    });
  } else {
    /** @const {number} */
    var interval = win.setInterval(function () {
      if (checkFunc(parent)) {
        win.clearInterval(interval);
        callback();
      }
    },
    /* milliseconds */
    5);
  }
}

/**
 * Waits until the child element is constructed. Once the child is found, the
 * promise is resolved.
 * @param {!Element} parent
 * @param {function(!Element):boolean} checkFunc
 * @return {!Promise}
 */
function waitForChildPromise(parent, checkFunc) {
  return new Promise(function (resolve) {
    waitForChild(parent, checkFunc, resolve);
  });
}

/**
 * Waits for document's body to be available and ready.
 * @param {!Document} doc
 * @param {function()} callback
 */
function waitForBodyOpen(doc, callback) {
  waitForChild(doc.documentElement, function () {
    return !!doc.body;
  }, callback);
}

/**
 * Waits for document's body to be available.
 * @param {!Document} doc
 * @return {!Promise}
 */
function waitForBodyOpenPromise(doc) {
  return new Promise(function (resolve) {
    return waitForBodyOpen(doc, resolve);
  });
}

/**
 * Removes the element.
 * @param {!Element} element
 */
function removeElement(element) {
  if (element.parentElement) {
    element.parentElement.removeChild(element);
  }
}

/**
 * Removes all child nodes of the specified element.
 * @param {!Element|!DocumentFragment} parent
 */
function removeChildren(parent) {
  while (parent.firstChild) {
    parent.removeChild(parent.firstChild);
  }
}

/**
 * Copies all children nodes of element "from" to element "to". Child nodes
 * are deeply cloned. Notice, that this method should be used with care and
 * preferably on smaller subtrees.
 * @param {!Element} from
 * @param {!Element|!DocumentFragment} to
 */
function copyChildren(from, to) {
  var frag = to.ownerDocument.createDocumentFragment();

  for (var n = from.firstChild; n; n = n.nextSibling) {
    frag.appendChild(n.cloneNode(true));
  }

  to.appendChild(frag);
}

/**
 * Insert the element in the root after the element named after or
 * if that is null at the beginning.
 * @param {!Element|!ShadowRoot} root
 * @param {!Element} element
 * @param {?Node=} after
 */
function insertAfterOrAtStart(root, element, after) {
  if (after === void 0) {
    after = null;
  }

  if (!after) {
    insertAtStart(root, element);
    return;
  }

  var before = after.nextSibling;
  root.insertBefore(element, before);
}

/**
 * Insert the element in the root after the element named after or
 * if that is null at the beginning.
 * @param {!Element|!ShadowRoot} root
 * @param {!Element} element
 */
function insertAtStart(root, element) {
  root.insertBefore(element, root.firstChild);
}

/**
 * Add attributes to an element.
 * @param {!Element} element
 * @param {!JsonObject<string, string>} attributes
 * @return {!Element} created element
 */
function addAttributesToElement(element, attributes) {
  for (var attr in attributes) {
    element.setAttribute(attr, attributes[attr]);
  }

  return element;
}

/**
 * Create a new element on document with specified tagName and attributes.
 * @param {!Document} doc
 * @param {string} tagName
 * @param {!JsonObject<string, string>} attributes
 * @return {!Element} created element
 */
function createElementWithAttributes(doc, tagName, attributes) {
  var element = doc.createElement(tagName);
  return addAttributesToElement(element, attributes);
}

/**
 * Returns true if node is connected (attached).
 * @param {!Node} node
 * @return {boolean}
 * @see https://dom.spec.whatwg.org/#connected
 */
function isConnectedNode(node) {
  var connected = node.isConnected;

  if (connected !== undefined) {
    return connected;
  }

  // "An element is connected if its shadow-including root is a document."
  var n = node;

  do {
    n = rootNodeFor(n);

    if (n.host) {
      n = n.host;
    } else {
      break;
    }
  } while (true);

  return n.nodeType === Node.DOCUMENT_NODE;
}

/**
 * Returns the root for a given node. Does not cross shadow DOM boundary.
 * @param {!Node} node
 * @return {!Node}
 */
function rootNodeFor(node) {
  if (Node.prototype.getRootNode) {
    // Type checker says `getRootNode` may return null.
    return node.getRootNode() || node;
  }

  var n;

  // Check isShadowRoot() is only needed for the polyfill case.
  for (n = node; !!n.parentNode && !isShadowRoot(n); n = n.parentNode) {}

  return n;
}

/**
 * Determines if value is actually a `ShadowRoot` node.
 * @param {*} value
 * @return {boolean}
 */
function isShadowRoot(value) {
  // TODO(#22733): remove in preference to dom's `rootNodeFor`.
  if (!value) {
    return false;
  }

  // Node.nodeType == DOCUMENT_FRAGMENT to speed up the tests. Unfortunately,
  // nodeType of DOCUMENT_FRAGMENT is used currently for ShadowRoot nodes.
  if (value.tagName == 'I-AMPHTML-SHADOW-ROOT') {
    return true;
  }

  return value.nodeType ==
  /* DOCUMENT_FRAGMENT */
  11 && Object.prototype.toString.call(value) === '[object ShadowRoot]';
}

/**
 * Finds the closest element that satisfies the callback from this element
 * up the DOM subtree.
 * @param {!Element} element
 * @param {function(!Element):boolean} callback
 * @param {Element=} opt_stopAt optional elemnt to stop the search at.
 * @return {?Element}
 */
function closest(element, callback, opt_stopAt) {
  for (var el = element; el && el !== opt_stopAt; el = el.parentElement) {
    if (callback(el)) {
      return el;
    }
  }

  return null;
}

/**
 * Finds the closest node that satisfies the callback from this node
 * up the DOM subtree.
 * @param {!Node} node
 * @param {function(!Node):boolean} callback
 * @return {?Node}
 */
function closestNode(node, callback) {
  for (var n = node; n; n = n.parentNode) {
    if (callback(n)) {
      return n;
    }
  }

  return null;
}

/**
 * Finds the closest ancestor element with the specified selector from this
 * element.
 * @param {!Element} element
 * @param {string} selector
 * @return {?Element} closest ancestor if found.
 */
function closestAncestorElementBySelector(element, selector) {
  if (element.closest) {
    return element.closest(selector);
  }

  return closest(element, function (el) {
    return matches(el, selector);
  });
}

/**
 * Finds all ancestor elements that satisfy predicate.
 * @param {!Element} child
 * @param {function(!Element):boolean} predicate
 * @return {!Array<!Element>}
 */
function ancestorElements(child, predicate) {
  var ancestors = [];

  for (var ancestor = child.parentElement; ancestor; ancestor = ancestor.parentElement) {
    if (predicate(ancestor)) {
      ancestors.push(ancestor);
    }
  }

  return ancestors;
}

/**
 * Finds all ancestor elements that has the specified tag name.
 * @param {!Element} child
 * @param {string} tagName
 * @return {!Array<!Element>}
 */
function ancestorElementsByTag(child, tagName) {
  (0, _css.assertIsName)(tagName);
  tagName = tagName.toUpperCase();
  return ancestorElements(child, function (el) {
    return el.tagName == tagName;
  });
}

/**
 * Finds the first child element that satisfies the callback.
 * @param {!Element} parent
 * @param {function(!Element):boolean} callback
 * @return {?Element}
 */
function childElement(parent, callback) {
  for (var child = parent.firstElementChild; child; child = child.nextElementSibling) {
    if (callback(child)) {
      return child;
    }
  }

  return null;
}

/**
 * Finds all child elements that satisfy the callback.
 * @param {!Element} parent
 * @param {function(!Element):boolean} callback
 * @return {!Array<!Element>}
 */
function childElements(parent, callback) {
  var children = [];

  for (var child = parent.firstElementChild; child; child = child.nextElementSibling) {
    if (callback(child)) {
      children.push(child);
    }
  }

  return children;
}

/**
 * Finds the last child element that satisfies the callback.
 * @param {!Element} parent
 * @param {function(!Element):boolean} callback
 * @return {?Element}
 */
function lastChildElement(parent, callback) {
  for (var child = parent.lastElementChild; child; child = child.previousElementSibling) {
    if (callback(child)) {
      return child;
    }
  }

  return null;
}

/**
 * Finds all child nodes that satisfy the callback.
 * These nodes can include Text, Comment and other child nodes.
 * @param {!Node} parent
 * @param {function(!Node):boolean} callback
 * @return {!Array<!Node>}
 */
function childNodes(parent, callback) {
  var nodes = [];

  for (var child = parent.firstChild; child; child = child.nextSibling) {
    if (callback(child)) {
      nodes.push(child);
    }
  }

  return nodes;
}

/**
 * Finds the first child element that has the specified attribute.
 * @param {!Element} parent
 * @param {string} attr
 * @return {?Element}
 */
function childElementByAttr(parent, attr) {
  (0, _css.assertIsName)(attr);
  return (
    /*OK*/
    scopedQuerySelector(parent, "> [" + attr + "]")
  );
}

/**
 * Finds the last child element that has the specified attribute.
 * @param {!Element} parent
 * @param {string} attr
 * @return {?Element}
 */
function lastChildElementByAttr(parent, attr) {
  (0, _css.assertIsName)(attr);
  return lastChildElement(parent, function (el) {
    return el.hasAttribute(attr);
  });
}

/**
 * Finds all child elements that has the specified attribute.
 * @param {!Element} parent
 * @param {string} attr
 * @return {!NodeList<!Element>}
 */
function childElementsByAttr(parent, attr) {
  (0, _css.assertIsName)(attr);
  return (
    /*OK*/
    scopedQuerySelectorAll(parent, "> [" + attr + "]")
  );
}

/**
 * Finds the first child element that has the specified tag name.
 * @param {!Element} parent
 * @param {string} tagName
 * @return {?Element}
 */
function childElementByTag(parent, tagName) {
  (0, _css.assertIsName)(tagName);
  return (
    /*OK*/
    scopedQuerySelector(parent, "> " + tagName)
  );
}

/**
 * Finds all child elements with the specified tag name.
 * @param {!Element} parent
 * @param {string} tagName
 * @return {!NodeList<!Element>}
 */
function childElementsByTag(parent, tagName) {
  (0, _css.assertIsName)(tagName);
  return (
    /*OK*/
    scopedQuerySelectorAll(parent, "> " + tagName)
  );
}

/**
 * Checks if the given element matches the selector
 * @param  {!Element} el The element to verify
 * @param  {string} selector The selector to check against
 * @return {boolean} True if the element matched the selector. False otherwise.
 */
function matches(el, selector) {
  var matcher = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector || el.oMatchesSelector;

  if (matcher) {
    return matcher.call(el, selector);
  }

  return false;
}

/**
 * Finds the first descendant element with the specified name.
 * @param {!Element|!Document|!ShadowRoot} element
 * @param {string} tagName
 * @return {?Element}
 */
function elementByTag(element, tagName) {
  (0, _css.assertIsName)(tagName);
  return element.
  /*OK*/
  querySelector(tagName);
}

/**
 * Finds all elements that matche `selector`, scoped inside `root`
 * for user-agents that do not support native scoping.
 *
 * This method isn't required for modern builds, can be removed.
 *
 * @param {!Element} root
 * @param {string} selector
 * @return {!NodeList<!Element>}
 */
function scopedQuerySelectionFallback(root, selector) {
  var unique = 'i-amphtml-scoped';
  root.classList.add(unique);
  var scopedSelector = (0, _css.prependSelectorsWith)(selector, "." + unique);
  var elements = root.
  /*OK*/
  querySelectorAll(scopedSelector);
  root.classList.remove(unique);
  return elements;
}

/**
 * Finds the first element that matches `selector`, scoped inside `root`.
 * Note: in IE, this causes a quick mutation of the element's class list.
 * @param {!Element} root
 * @param {string} selector
 * @return {?Element}
 */
function scopedQuerySelector(root, selector) {
  if ((0, _css.isScopeSelectorSupported)(root)) {
    return root.
    /*OK*/
    querySelector((0, _css.prependSelectorsWith)(selector, ':scope'));
  }

  // Only IE.
  var fallbackResult = scopedQuerySelectionFallback(root, selector);
  return fallbackResult[0] === undefined ? null : fallbackResult[0];
}

/**
 * Finds every element that matches `selector`, scoped inside `root`.
 * Note: in IE, this causes a quick mutation of the element's class list.
 * @param {!Element} root
 * @param {string} selector
 * @return {!NodeList<!Element>}
 */
function scopedQuerySelectorAll(root, selector) {
  if ((0, _css.isScopeSelectorSupported)(root)) {
    return root.
    /*OK*/
    querySelectorAll((0, _css.prependSelectorsWith)(selector, ':scope'));
  }

  // Only IE.
  return scopedQuerySelectionFallback(root, selector);
}

/**
 * Returns element data-param- attributes as url parameters key-value pairs.
 * e.g. data-param-some-attr=value -> {someAttr: value}.
 * @param {!Element} element
 * @param {function(string):string=} opt_computeParamNameFunc to compute the
 *    parameter name, get passed the camel-case parameter name.
 * @param {!RegExp=} opt_paramPattern Regex pattern to match data attributes.
 * @return {!JsonObject}
 */
function getDataParamsFromAttributes(element, opt_computeParamNameFunc, opt_paramPattern) {
  var computeParamNameFunc = opt_computeParamNameFunc || function (key) {
    return key;
  };

  var dataset = element.dataset;
  var params = (0, _object.dict)();
  var paramPattern = opt_paramPattern ? opt_paramPattern : /^param(.+)/;

  for (var key in dataset) {
    var _matches = key.match(paramPattern);

    if (_matches) {
      var param = _matches[1][0].toLowerCase() + _matches[1].substr(1);

      params[computeParamNameFunc(param)] = dataset[key];
    }
  }

  return params;
}

/**
 * Whether the element have a next node in the document order.
 * This means either:
 *  a. The element itself has a nextSibling.
 *  b. Any of the element ancestors has a nextSibling.
 * @param {!Element} element
 * @param {?Node} opt_stopNode
 * @return {boolean}
 */
function hasNextNodeInDocumentOrder(element, opt_stopNode) {
  var currentElement = element;

  do {
    if (currentElement.nextSibling) {
      return true;
    }
  } while ((currentElement = currentElement.parentNode) && currentElement != opt_stopNode);

  return false;
}

/**
 * Returns a clone of the content of a template element.
 *
 * Polyfill to replace .content access for browsers that do not support
 * HTMLTemplateElements natively.
 *
 * @param {!HTMLTemplateElement|!Element} template
 * @return {!DocumentFragment}
 */
function templateContentClone(template) {
  if ('content' in template) {
    return template.content.cloneNode(true);
  } else {
    var content = template.ownerDocument.createDocumentFragment();
    copyChildren(template, content);
    return content;
  }
}

/**
 * Iterate over an array-like.
 * Test cases: https://jsbench.github.io/#f638cacc866a1b2d6e517e6cfa900d6b
 * @param {!IArrayLike<T>} iterable
 * @param {function(T, number)} cb
 * @template T
 */
function iterateCursor(iterable, cb) {
  var length = iterable.length;

  for (var i = 0; i < length; i++) {
    cb(iterable[i], i);
  }
}

/**
 * This method wraps around window's open method. It first tries to execute
 * `open` call with the provided target and if it fails, it retries the call
 * with the `_top` target. This is necessary given that in some embedding
 * scenarios, such as iOS' WKWebView, navigation to `_blank` and other targets
 * is blocked by default.
 *
 * @param {!Window} win
 * @param {string} url
 * @param {string} target
 * @param {string=} opt_features
 * @return {?Window}
 */
function openWindowDialog(win, url, target, opt_features) {
  // Try first with the specified target. If we're inside the WKWebView or
  // a similar environments, this method is expected to fail by default for
  // all targets except `_top`.
  var res;

  try {
    res = win.open(url, target, opt_features);
  } catch (e) {
    (0, _log.dev)().error('DOM', 'Failed to open url on target: ', target, e);
  }

  // Then try with `_top` target.
  if (!res && target != '_top' && !(0, _string.includes)(opt_features || '', 'noopener')) {
    res = win.open(url, '_top');
  }

  return res;
}

/**
 * Whether the element is a script tag with application/json type.
 * @param {!Element} element
 * @return {boolean}
 */
function isJsonScriptTag(element) {
  return element.tagName == 'SCRIPT' && element.hasAttribute('type') && element.getAttribute('type').toUpperCase() == 'APPLICATION/JSON';
}

/**
 * Whether the element is a script tag with application/json type.
 * @param {!Element} element
 * @return {boolean}
 */
function isJsonLdScriptTag(element) {
  return element.tagName == 'SCRIPT' && element.getAttribute('type').toUpperCase() == 'APPLICATION/LD+JSON';
}

/**
 * Whether the page's direction is right to left or not.
 * @param {!Document} doc
 * @return {boolean}
 */
function isRTL(doc) {
  var dir = doc.body.getAttribute('dir') || doc.documentElement.getAttribute('dir') || 'ltr';
  return dir == 'rtl';
}

/**
 * Escapes `<`, `>` and other HTML charcaters with their escaped forms.
 * @param {string} text
 * @return {string}
 */
function escapeHtml(text) {
  if (!text) {
    return text;
  }

  return text.replace(HTML_ESCAPE_REGEX, escapeHtmlChar);
}

/**
 * @param {string} c
 * @return {string}
 */
function escapeHtmlChar(c) {
  return HTML_ESCAPE_CHARS[c];
}

/**
 * Tries to focus on the given element; fails silently if browser throws an
 * exception.
 * @param {!Element} element
 */
function tryFocus(element) {
  try {
    element.
    /*OK*/
    focus();
  } catch (e) {// IE <= 7 may throw exceptions when focusing on hidden items.
  }
}

/**
 * Whether the given window is in an iframe or not.
 * @param {!Window} win
 * @return {boolean}
 */
function isIframed(win) {
  return win.parent && win.parent != win;
}

/**
 * Determines if this element is an AMP element
 * @param {!Element} element
 * @return {boolean}
 */
function isAmpElement(element) {
  var tag = element.tagName;
  // Use prefix to recognize AMP element. This is necessary because stub
  // may not be attached yet.
  return (0, _string.startsWith)(tag, 'AMP-') && // Some "amp-*" elements are not really AMP elements. :smh:
  !(tag == 'AMP-STICKY-AD-TOP-PADDING' || tag == 'AMP-BODY');
}

/**
 * Return a promise that resolve when an AMP element upgrade from HTMLElement
 * to CustomElement
 * @param {!Element} element
 * @return {!Promise<!Element>}
 */
function whenUpgradedToCustomElement(element) {
  (0, _log.devAssert)(isAmpElement(element), 'element is not AmpElement');

  if (element.createdCallback) {
    // Element already is CustomElement;
    return Promise.resolve(element);
  }

  // If Element is still HTMLElement, wait for it to upgrade to customElement
  // Note: use pure string to avoid obfuscation between versions.
  if (!element[UPGRADE_TO_CUSTOMELEMENT_PROMISE]) {
    var deferred = new _promise.Deferred();
    element[UPGRADE_TO_CUSTOMELEMENT_PROMISE] = deferred.promise;
    element[UPGRADE_TO_CUSTOMELEMENT_RESOLVER] = deferred.resolve;
  }

  return element[UPGRADE_TO_CUSTOMELEMENT_PROMISE];
}

/**
 * Replacement for `Element.requestFullscreen()` method.
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullscreen
 * @param {!Element} element
 */
function fullscreenEnter(element) {
  var requestFs = element.requestFullscreen || element.requestFullScreen || element.webkitRequestFullscreen || element.webkitEnterFullscreen || element.msRequestFullscreen || element.mozRequestFullScreen;

  if (requestFs) {
    requestFs.call(element);
  }
}

/**
 * Replacement for `Document.exitFullscreen()` method.
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/exitFullscreen
 * @param {!Element} element
 */
function fullscreenExit(element) {
  var elementBoundExit = element.cancelFullScreen || element.exitFullscreen || element.webkitExitFullscreen || element.webkitCancelFullScreen || element.mozCancelFullScreen || element.msExitFullscreen;

  if (elementBoundExit) {
    elementBoundExit.call(element);
    return;
  }

  var ownerDocument = element.ownerDocument;

  if (!ownerDocument) {
    return;
  }

  var docBoundExit = ownerDocument.cancelFullScreen || ownerDocument.exitFullscreen || ownerDocument.webkitExitFullscreen || ownerDocument.webkitCancelFullScreen || ownerDocument.mozCancelFullScreen || ownerDocument.msExitFullscreen;

  if (docBoundExit) {
    docBoundExit.call(ownerDocument);
  }
}

/**
 * Replacement for `Document.fullscreenElement`.
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/fullscreenElement
 * @param {!Element} element
 * @return {boolean}
 */
function isFullscreenElement(element) {
  var webkitDisplayingFullscreen = element.webkitDisplayingFullscreen;

  if (webkitDisplayingFullscreen !== undefined) {
    return webkitDisplayingFullscreen;
  }

  var ownerDocument = element.ownerDocument;

  if (!ownerDocument) {
    return false;
  }

  var fullscreenElement = ownerDocument.fullscreenElement || ownerDocument.webkitFullscreenElement || ownerDocument.mozFullScreenElement || ownerDocument.webkitCurrentFullScreenElement;
  return fullscreenElement == element;
}

/**
 * Returns true if node is not disabled.
 *
 * IE8 can return false positives, see {@link matches}.
 * @param {!Element} element
 * @return {boolean}
 * @see https://www.w3.org/TR/html5/forms.html#concept-fe-disabled
 */
function isEnabled(element) {
  return !(element.disabled || matches(element, ':disabled'));
}

/**
 * A sorting comparator that sorts elements in DOM tree order.
 * A first sibling is sorted to be before its nextSibling.
 * A parent node is sorted to be before a child.
 * See https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
 *
 * @param {!Element} element1
 * @param {!Element} element2
 * @return {number}
 */
function domOrderComparator(element1, element2) {
  if (element1 === element2) {
    return 0;
  }

  var pos = element1.compareDocumentPosition(element2);
  var precedingOrContains = Node.DOCUMENT_POSITION_PRECEDING | Node.DOCUMENT_POSITION_CONTAINS;

  // if fe2 is preceding or contains fe1 then, fe1 is after fe2
  if (pos & precedingOrContains) {
    return 1;
  }

  // if fe2 is following or contained by fe1, then fe1 is before fe2
  return -1;
}

/**
 * Like `Element.prototype.toggleAttribute`. This either toggles an attribute
 * on by adding an attribute with an empty value, or toggles it off by removing
 * the attribute. This does not mutate the element if the new state matches
 * the existing state.
 * @param {!Element} element An element to toggle the attribute for.
 * @param {string} name The name of the attribute.
 * @param {boolean=} forced Whether the attribute should be forced on/off. If
 *    not specified, it will be toggled from the current state.
 * @return {boolean} Whether or not the element now has the attribute.
 */
function toggleAttribute(element, name, forced) {
  var hasAttribute = element.hasAttribute(name);
  var enabled = forced !== undefined ? forced : !hasAttribute;

  if (enabled !== hasAttribute) {
    if (enabled) {
      element.setAttribute(name, '');
    } else {
      element.removeAttribute(name);
    }
  }

  return enabled;
}

/**
 * @param {!Window} win
 * @return {number} The width of the vertical scrollbar, in pixels.
 */
function getVerticalScrollbarWidth(win) {
  var documentElement = win.document.documentElement;
  var windowWidth = win.
  /*OK*/
  innerWidth;
  var documentWidth = documentElement.
  /*OK*/
  clientWidth;
  return windowWidth - documentWidth;
}

},{"./css":18,"./log":28,"./string":35,"./types":37,"./utils/object":45,"./utils/promise":46}],20:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getElementService = getElementService;
exports.getElementServiceIfAvailable = getElementServiceIfAvailable;
exports.getElementServiceForDoc = getElementServiceForDoc;
exports.getElementServiceIfAvailableForDoc = getElementServiceIfAvailableForDoc;
exports.getElementServiceIfAvailableForDocInEmbedScope = getElementServiceIfAvailableForDocInEmbedScope;
exports.extensionScriptsInNode = extensionScriptsInNode;
exports.isExtensionScriptInNode = isExtensionScriptInNode;

var _resolvedPromise2 = require("./resolved-promise");

var dom = _interopRequireWildcard(require("./dom"));

var _service = require("./service");

var _types = require("./types");

var _log = require("./log");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a promise for a service for the given id and window. Also expects an
 * element that has the actual implementation. The promise resolves when the
 * implementation loaded. Users should typically wrap this as a special purpose
 * function (e.g. Services.viewportForDoc(...)) for type safety and because the
 * factory should not be passed around.
 * @param {!Window} win
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an element,
 *     not the extension.
 * @return {!Promise<*>}
 */
function getElementService(win, id, extension, opt_element) {
  return getElementServiceIfAvailable(win, id, extension, opt_element).then(function (service) {
    return assertService(service, id, extension);
  });
}

/**
 * Same as getElementService but produces null if the given element is not
 * actually available on the current page.
 * @param {!Window} win
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an
 *     element, not the extension.
 * @return {!Promise<?Object>}
 */
function getElementServiceIfAvailable(win, id, extension, opt_element) {
  var s = (0, _service.getServicePromiseOrNull)(win, id);

  if (s) {
    return (
      /** @type {!Promise<?Object>} */
      s
    );
  }

  return getElementServicePromiseOrNull(win, id, extension, opt_element);
}

/**
 * @param {!Window} win
 * @param {string} elementName Name of an extended custom element.
 * @return {boolean} Whether this element is scheduled to be loaded.
 */
function isElementScheduled(win, elementName) {
  // Set in custom-element.js
  if (!win.__AMP_EXTENDED_ELEMENTS) {
    return false;
  }

  return !!win.__AMP_EXTENDED_ELEMENTS[elementName];
}

/**
 * Returns a promise for a service for the given id and window. Also expects an
 * element that has the actual implementation. The promise resolves when the
 * implementation loaded. Users should typically wrap this as a special purpose
 * function (e.g. Services.viewportForDoc(...)) for type safety and because the
 * factory should not be passed around.
 * @param {!Element|!ShadowRoot} element
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an element,
 *     not the extension.
 * @return {!Promise<*>}
 */
function getElementServiceForDoc(element, id, extension, opt_element) {
  return getElementServiceIfAvailableForDoc(element, id, extension, opt_element).then(function (service) {
    return assertService(service, id, extension);
  });
}

/**
 * Same as getElementService but produces null if the given element is not
 * actually available on the current page.
 * @param {!Element|!ShadowRoot} element
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an
 *     element, not the extension.
 * @return {!Promise<?Object>}
 */
function getElementServiceIfAvailableForDoc(element, id, extension, opt_element) {
  var s = (0, _service.getServicePromiseOrNullForDoc)(element, id);

  if (s) {
    return (
      /** @type {!Promise<?Object>} */
      s
    );
  }

  var ampdoc = (0, _service.getAmpdoc)(element);
  return ampdoc.waitForBodyOpen().then(function () {
    return waitForExtensionIfPresent(ampdoc.win, extension, ampdoc.win.document.head);
  }).then(function () {
    // If this service is provided by an element, then we can't depend on
    // the service (they may not use the element).
    if (opt_element) {
      return (0, _service.getServicePromiseOrNullForDoc)(element, id);
    } else if (isElementScheduled(ampdoc.win, extension)) {
      return (0, _service.getServicePromiseForDoc)(element, id);
    }

    return null;
  });
}

/**
 * Returns a promise for service for the given id in the embed scope of
 * a given element, if it exists. Falls back to ampdoc scope if the element
 * is not embedded.
 *
 * @param {!Element|!ShadowRoot} element
 * @param {string} id of the service.
 * @param {string} extension Name of the custom element that provides
 *     the implementation of this service.
 * @return {!Promise<?Object>}
 */
function getElementServiceIfAvailableForDocInEmbedScope(element, id, extension) {
  var s = (0, _service.getExistingServiceForDocInEmbedScope)(element, id);

  if (s) {
    return (
      /** @type {!Promise<?Object>} */
      Promise.resolve(s)
    );
  }

  var win = (0, _types.toWin)(element.ownerDocument.defaultView);
  var topWin = (0, _service.getTopWindow)(win);

  // In embeds, doc services are stored on the embed window.
  if (win !== topWin) {
    return getElementServicePromiseOrNull(win, id, extension);
  } else {
    // Only fallback to element's ampdoc (top-level) if not embedded.
    return getElementServiceIfAvailableForDoc(element, id, extension);
  }
}

/**
 * Throws user error if `service` is null.
 * @param {Object} service
 * @param {string} id
 * @param {string} extension
 * @return {!Object}
 * @private
 * @closurePrimitive {asserts.matchesReturn}
 */
function assertService(service, id, extension) {
  return (
    /** @type {!Object} */
    (0, _log.userAssert)(service, 'Service %s was requested to be provided through %s, ' + 'but %s is not loaded in the current page. To fix this ' + 'problem load the JavaScript file for %s in this page.', id, extension, extension, extension)
  );
}

/**
 * Get list of all the extension JS files.
 * @param {HTMLHeadElement|Element|ShadowRoot} head
 * @return {!Array<string>}
 */
function extensionScriptsInNode(head) {
  // ampdoc.getHeadNode() can return null.
  if (!head) {
    return [];
  }

  var scripts = {};
  // Note: Some extensions don't have [custom-element] or [custom-template]
  // e.g. amp-viewer-integration.
  var list = head.querySelectorAll('script[custom-element],script[custom-template]');

  for (var i = 0; i < list.length; i++) {
    var script = list[i];
    var name = script.getAttribute('custom-element') || script.getAttribute('custom-template');
    scripts[name] = true;
  }

  return Object.keys(scripts);
}

/**
 * Waits for body to be present then verifies that an extension script is
 * present in head for installation.
 * @param {!./service/ampdoc-impl.AmpDoc} ampdoc
 * @param {string} extensionId
 * @return {!Promise<boolean>}
 */
function isExtensionScriptInNode(ampdoc, extensionId) {
  return ampdoc.waitForBodyOpen().then(function () {
    return extensionScriptInNode(ampdoc.getHeadNode(), extensionId);
  });
}

/**
 * Verifies that an extension script is present in head for
 * installation.
 * @param {HTMLHeadElement|Element|ShadowRoot} head
 * @param {string} extensionId
 * @return {boolean}
 * @private
 */
function extensionScriptInNode(head, extensionId) {
  return extensionScriptsInNode(head).includes(extensionId);
}

/**
 * Waits for an extension if its script is present
 * @param {!Window} win
 * @param {string} extension
 * @param {HTMLHeadElement|Element|ShadowRoot} head
 * @return {!Promise}
 * @private
 */
function waitForExtensionIfPresent(win, extension, head) {
  /**
   * If there is an extension script wait for it to load before trying
   * to get the service. Prevents a race condition when everything but
   * the extensions is in cache. If there is no script then it's either
   * not present, or the service was defined by a test. In those cases
   * we don't wait around for an extension that does not exist.
   */
  // TODO(jpettitt) investigate registerExtension to short circuit
  // the dom call in extensionScriptsInNode()
  if (!extensionScriptInNode(head, extension)) {
    return (0, _resolvedPromise2.resolvedPromise)();
  }

  var extensions = (0, _service.getService)(win, 'extensions');
  return (
    /** @type {!Promise<?Object>} */
    extensions.waitForExtension(win, extension)
  );
}

/**
 * Returns the promise for service with `id` on the given window if available.
 * Otherwise, resolves with null (service was not registered).
 * @param {!Window} win
 * @param {string} id
 * @param {string} extension
 * @param {boolean=} opt_element
 * @return {!Promise<Object>}
 * @private
 */
function getElementServicePromiseOrNull(win, id, extension, opt_element) {
  return dom.waitForBodyOpenPromise(win.document).then(function () {
    return waitForExtensionIfPresent(win, extension, win.document.head);
  }).then(function () {
    // If this service is provided by an element, then we can't depend on
    // the service (they may not use the element).
    if (opt_element) {
      return (0, _service.getServicePromiseOrNull)(win, id);
    } else if (isElementScheduled(win, extension)) {
      return (0, _service.getServicePromise)(win, id);
    }

    return null;
  });
}

},{"./dom":19,"./log":28,"./resolved-promise":32,"./service":33,"./types":37}],21:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.internalListenImplementation = internalListenImplementation;
exports.detectEvtListenerOptsSupport = detectEvtListenerOptsSupport;
exports.resetEvtListenerOptsSupportForTesting = resetEvtListenerOptsSupportForTesting;
exports.supportsPassiveEventListener = supportsPassiveEventListener;
exports.resetPassiveSupportedForTesting = resetPassiveSupportedForTesting;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Whether addEventListener supports options or only takes capture as a boolean
 * @type {boolean|undefined}
 * @visibleForTesting
 */
var optsSupported;

/**
 * Whether addEventListener supports options or only takes passive as a boolean
 * @type {boolean|undefined}
 */
var passiveSupported;

/**
 * Listens for the specified event on the element.
 *
 * Do not use this directly. This method is implemented as a shared
 * dependency. Use `listen()` in either `event-helper` or `3p-frame-messaging`,
 * depending on your use case.
 *
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {function(!Event)} listener
 * @param {Object=} opt_evtListenerOpts
 * @return {!UnlistenDef}
 */
function internalListenImplementation(element, eventType, listener, opt_evtListenerOpts) {
  var localElement = element;
  var localListener = listener;

  /**
   * @type {?Function}
   */
  var wrapped;

  wrapped = function wrapped(event) {
    try {
      return localListener(event);
    } catch (e) {
      // __AMP_REPORT_ERROR is installed globally per window in the entry point.
      self.__AMP_REPORT_ERROR(e);

      throw e;
    }
  };

  var optsSupported = detectEvtListenerOptsSupport();
  var capture = false;

  if (opt_evtListenerOpts) {
    capture = opt_evtListenerOpts.capture;
  }

  localElement.addEventListener(eventType, wrapped, optsSupported ? opt_evtListenerOpts : capture);
  return function () {
    if (localElement) {
      localElement.removeEventListener(eventType, wrapped, optsSupported ? opt_evtListenerOpts : capture);
    }

    // Ensure these are GC'd
    localListener = null;
    localElement = null;
    wrapped = null;
  };
}

/**
 * Tests whether the browser supports options as an argument of addEventListener
 * or not.
 *
 * @return {boolean}
 */
function detectEvtListenerOptsSupport() {
  // Only run the test once
  if (optsSupported !== undefined) {
    return optsSupported;
  }

  optsSupported = false;

  try {
    // Test whether browser supports EventListenerOptions or not
    var options = {
      get capture() {
        optsSupported = true;
      }

    };
    self.addEventListener('test-options', null, options);
    self.removeEventListener('test-options', null, options);
  } catch (err) {// EventListenerOptions are not supported
  }

  return optsSupported;
}

/**
 * Resets the test for whether addEventListener supports options or not.
 */
function resetEvtListenerOptsSupportForTesting() {
  optsSupported = undefined;
}

/**
 * Return boolean. if listener option is supported, return `true`.
 * if not supported, return `false`
 * @param {!Window} win
 * @return {boolean}
 */
function supportsPassiveEventListener(win) {
  if (passiveSupported !== undefined) {
    return passiveSupported;
  }

  passiveSupported = false;

  try {
    var options = {
      get passive() {
        // This function will be called when the browser
        // attempts to access the passive property.
        passiveSupported = true;
        return false;
      }

    };
    win.addEventListener('test-options', null, options);
    win.removeEventListener('test-options', null, options);
  } catch (err) {// EventListenerOptions are not supported
  }

  return passiveSupported;
}

/**
 * Resets the test for whether addEventListener supports passive options or not.
 */
function resetPassiveSupportedForTesting() {
  passiveSupported = undefined;
}

},{}],22:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.createCustomEvent = createCustomEvent;
exports.listen = listen;
exports.getData = getData;
exports.getDetail = getDetail;
exports.listenOnce = listenOnce;
exports.listenOncePromise = listenOncePromise;
exports.isLoaded = isLoaded;
exports.loadPromise = loadPromise;
exports.isLoadErrorMessage = isLoadErrorMessage;
exports.MEDIA_LOAD_FAILURE_SRC_PROPERTY = void 0;

var _eventHelperListen = require("./event-helper-listen");

var _dom = require("./dom");

var _log = require("./log");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @const {string}  */
var LOAD_FAILURE_PREFIX = 'Failed to load:';

/** @const {string} */
var MEDIA_LOAD_FAILURE_SRC_PROPERTY = '__AMP_MEDIA_LOAD_FAILURE_SRC';
exports.MEDIA_LOAD_FAILURE_SRC_PROPERTY = MEDIA_LOAD_FAILURE_SRC_PROPERTY;

/**
 * Returns a CustomEvent with a given type and detail; supports fallback for IE.
 * @param {!Window} win
 * @param {string} type
 * @param {!JsonObject|string|undefined|null} detail
 * @param {EventInit=} opt_eventInit
 * @return {!Event}
 */
function createCustomEvent(win, type, detail, opt_eventInit) {
  var eventInit =
  /** @type {!CustomEventInit} */
  {
    detail: detail
  };
  Object.assign(eventInit, opt_eventInit);

  // win.CustomEvent is a function on Edge, Chrome, FF, Safari but
  // is an object on IE 11.
  if (typeof win.CustomEvent == 'function') {
    return new win.CustomEvent(type, eventInit);
  } else {
    // Deprecated fallback for IE.
    var e = win.document.createEvent('CustomEvent');
    e.initCustomEvent(type, !!eventInit.bubbles, !!eventInit.cancelable, detail);
    return e;
  }
}

/**
 * Listens for the specified event on the element.
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {function(!Event)} listener
 * @param {Object=} opt_evtListenerOpts
 * @return {!UnlistenDef}
 */
function listen(element, eventType, listener, opt_evtListenerOpts) {
  return (0, _eventHelperListen.internalListenImplementation)(element, eventType, listener, opt_evtListenerOpts);
}

/**
 * Returns the data property of an event with the correct type.
 * @param {!Event|{data: !JsonObject}} event
 * @return {?JsonObject|string|undefined}
 */
function getData(event) {
  return (
    /** @type {?JsonObject|string|undefined} */
    event.data
  );
}

/**
 * Returns the detail property of an event with the correct type.
 * @param {!Event|{detail: !JsonObject}} event
 * @return {?JsonObject|string|undefined}
 */
function getDetail(event) {
  return (
    /** @type {?JsonObject|string|undefined} */
    event.detail
  );
}

/**
 * Listens for the specified event on the element and removes the listener
 * as soon as event has been received.
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {function(!Event)} listener
 * @param {Object=} opt_evtListenerOpts
 * @return {!UnlistenDef}
 */
function listenOnce(element, eventType, listener, opt_evtListenerOpts) {
  var localListener = listener;
  var unlisten = (0, _eventHelperListen.internalListenImplementation)(element, eventType, function (event) {
    try {
      localListener(event);
    } finally {
      // Ensure listener is GC'd
      localListener = null;
      unlisten();
    }
  }, opt_evtListenerOpts);
  return unlisten;
}

/**
 * Returns  a promise that will resolve as soon as the specified event has
 * fired on the element.
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {Object=} opt_evtListenerOpts
 * @param {function(!UnlistenDef)=} opt_cancel An optional function that, when
 *     provided, will be called with the unlistener. This gives the caller
 *     access to the unlistener, so it may be called manually when necessary.
 * @return {!Promise<!Event>}
 */
function listenOncePromise(element, eventType, opt_evtListenerOpts, opt_cancel) {
  var unlisten;
  var eventPromise = new Promise(function (resolve) {
    unlisten = listenOnce(element, eventType, resolve, opt_evtListenerOpts);
  });
  eventPromise.then(unlisten, unlisten);

  if (opt_cancel) {
    opt_cancel(unlisten);
  }

  return eventPromise;
}

/**
 * Whether the specified element/window has been loaded already.
 * @param {!Element|!Window} eleOrWindow
 * @return {boolean}
 */
function isLoaded(eleOrWindow) {
  return !!(eleOrWindow.complete || eleOrWindow.readyState == 'complete' || isHTMLMediaElement(eleOrWindow) && eleOrWindow.readyState > 0 || // If the passed in thing is a Window, infer loaded state from
  //
  eleOrWindow.document && eleOrWindow.document.readyState == 'complete');
}

/**
 * Returns a promise that will resolve or fail based on the eleOrWindow's 'load'
 * and 'error' events. Optionally this method takes a timeout, which will reject
 * the promise if the resource has not loaded by then.
 * @param {T} eleOrWindow Supports both Elements and as a special case Windows.
 * @return {!Promise<T>}
 * @template T
 */
function loadPromise(eleOrWindow) {
  var unlistenLoad;
  var unlistenError;

  if (isLoaded(eleOrWindow)) {
    return Promise.resolve(eleOrWindow);
  }

  var isMediaElement = isHTMLMediaElement(eleOrWindow);

  if (isMediaElement && eleOrWindow[MEDIA_LOAD_FAILURE_SRC_PROPERTY] === eleOrWindow.currentSrc) {
    return Promise.reject(eleOrWindow);
  }

  var loadingPromise = new Promise(function (resolve, reject) {
    // Listen once since IE 5/6/7 fire the onload event continuously for
    // animated GIFs.
    if (isMediaElement) {
      // The following event can be triggered by the media or one of its
      // sources. Using capture is required as the media events do not bubble.
      unlistenLoad = listenOnce(eleOrWindow, 'loadedmetadata', resolve, {
        capture: true
      });
    } else {
      unlistenLoad = listenOnce(eleOrWindow, 'load', resolve);
    }

    // Don't unlisten on error for Windows.
    if (!eleOrWindow.tagName) {
      return;
    }

    var errorTarget = eleOrWindow;

    // If the media element has no `src`, it will try to load the sources in
    // document order. If the last source errors, then the media element
    // loading errored.
    if (isMediaElement && !eleOrWindow.hasAttribute('src')) {
      errorTarget = (0, _dom.lastChildElement)(eleOrWindow, function (child) {
        return child.tagName === 'SOURCE';
      });

      if (!errorTarget) {
        return reject(new Error('Media has no source.'));
      }
    }

    unlistenError = listenOnce(errorTarget, 'error', reject);
  });
  return loadingPromise.then(function () {
    if (unlistenError) {
      unlistenError();
    }

    return eleOrWindow;
  }, function () {
    if (unlistenLoad) {
      unlistenLoad();
    }

    failedToLoad(eleOrWindow);
  });
}

/**
 * Emit error on load failure.
 * @param {!Element|!Window} eleOrWindow Supports both Elements and as a special
 *     case Windows.
 */
function failedToLoad(eleOrWindow) {
  // Mark the element as errored since some elements - like HTMLMediaElement
  // using HTMLSourceElement - do not provide any synchronous way to verify if
  // they already errored, even though the error event was already dispatched.
  if (isHTMLMediaElement(eleOrWindow)) {
    eleOrWindow[MEDIA_LOAD_FAILURE_SRC_PROPERTY] = eleOrWindow.currentSrc || true;
  }

  // Report failed loads as user errors so that they automatically go
  // into the "document error" bucket.
  var target = eleOrWindow;

  if (target && target.src) {
    target = target.src;
  }

  throw (0, _log.user)().createError(LOAD_FAILURE_PREFIX, target);
}

/**
 * Returns true if the parameter is a HTMLMediaElement.
 * @param {!Element|!Window} eleOrWindow
 * @return {boolean}
 */
function isHTMLMediaElement(eleOrWindow) {
  return eleOrWindow.tagName === 'AUDIO' || eleOrWindow.tagName === 'VIDEO';
}

/**
 * Returns true if this error message is was created for a load error.
 * @param {string} message An error message
 * @return {boolean}
 */
function isLoadErrorMessage(message) {
  return message.indexOf(LOAD_FAILURE_PREFIX) != -1;
}

},{"./dom":19,"./event-helper-listen":21,"./log":28}],23:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isCanary = isCanary;
exports.getBinaryType = getBinaryType;
exports.isExperimentOn = isExperimentOn;
exports.toggleExperiment = toggleExperiment;
exports.experimentToggles = experimentToggles;
exports.experimentTogglesOrNull = experimentTogglesOrNull;
exports.getExperimentTogglesForTesting = getExperimentTogglesForTesting;
exports.resetExperimentTogglesForTesting = resetExperimentTogglesForTesting;
exports.randomlySelectUnsetExperiments = randomlySelectUnsetExperiments;
exports.getExperimentBranch = getExperimentBranch;
exports.getActiveExperimentBranches = getActiveExperimentBranches;
exports.forceExperimentBranch = forceExperimentBranch;
exports.RANDOM_NUMBER_GENERATORS = exports.ExperimentInfo = void 0;

var _log = require("./log");

var _mode = require("./mode");

var _service = require("./service");

var _object = require("./utils/object");

var _url = require("./url");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @const {string} */
var TAG = 'EXPERIMENTS';

/** @const {string} */
var LOCAL_STORAGE_KEY = 'amp-experiment-toggles';

/** @const {string} */
var TOGGLES_WINDOW_PROPERTY = '__AMP__EXPERIMENT_TOGGLES';

/**
 * @typedef {{
 *   experimentId: string,
 *   isTrafficEligible: function(!Window):boolean,
 *   branches: !Array<string>
 * }}
 */
var ExperimentInfo;
exports.ExperimentInfo = ExperimentInfo;

/**
 * Whether we are in canary.
 * @param {!Window} win
 * @return {boolean}
 */
function isCanary(win) {
  return !!(win.AMP_CONFIG && win.AMP_CONFIG.canary);
}

/**
 * Returns binary type, e.g., canary, production, control, or rc.
 * @param {!Window} win
 * @return {string}
 */
function getBinaryType(win) {
  return win.AMP_CONFIG && win.AMP_CONFIG.type ? win.AMP_CONFIG.type : 'unknown';
}

/**
 * Whether the specified experiment is on or off.
 * @param {!Window} win
 * @param {string} experimentId
 * @return {boolean}
 */
function isExperimentOn(win, experimentId) {
  var toggles = experimentToggles(win);
  return !!toggles[experimentId];
}

/**
 * Toggles the experiment on or off. Returns the actual value of the experiment
 * after toggling is done.
 * @param {!Window} win
 * @param {string} experimentId
 * @param {boolean=} opt_on
 * @param {boolean=} opt_transientExperiment  Whether to toggle the
 *     experiment state "transiently" (i.e., for this page load only) or
 *     durably (by saving the experiment IDs after toggling).
 *     Default: false (save durably).
 * @return {boolean} New state for experimentId.
 */
function toggleExperiment(win, experimentId, opt_on, opt_transientExperiment) {
  var currentlyOn = isExperimentOn(win,
  /*OK*/
  experimentId);
  var on = !!(opt_on !== undefined ? opt_on : !currentlyOn);

  if (on != currentlyOn) {
    var toggles = experimentToggles(win);
    toggles[experimentId] = on;

    if (!opt_transientExperiment) {
      var storedToggles = getExperimentToggles(win);
      storedToggles[experimentId] = on;
      saveExperimentToggles(win, storedToggles);

      // Avoid affecting tests that spy/stub warn().
      if (!(0, _mode.getMode)().test) {
        (0, _log.user)().warn(TAG, '"%s" experiment %s for the domain "%s". See: https://amp.dev/documentation/guides-and-tutorials/learn/experimental', experimentId, on ? 'enabled' : 'disabled', win.location.hostname);
      }
    }
  }

  return on;
}

/**
 * Calculate whether the experiment is on or off based off of its default value,
 * stored overriden value, or the global config frequency given.
 * @param {!Window} win
 * @return {!Object<string, boolean>}
 */
function experimentToggles(win) {
  if (win[TOGGLES_WINDOW_PROPERTY]) {
    return win[TOGGLES_WINDOW_PROPERTY];
  }

  win[TOGGLES_WINDOW_PROPERTY] = Object.create(null);
  var toggles = win[TOGGLES_WINDOW_PROPERTY];

  // Read the default config of this build.
  if (win.AMP_CONFIG) {
    for (var experimentId in win.AMP_CONFIG) {
      var frequency = win.AMP_CONFIG[experimentId];

      if (typeof frequency === 'number' && frequency >= 0 && frequency <= 1) {
        toggles[experimentId] = Math.random() < frequency;
      }
    }
  }

  // Read document level override from meta tag.
  if (win.AMP_CONFIG && Array.isArray(win.AMP_CONFIG['allow-doc-opt-in']) && win.AMP_CONFIG['allow-doc-opt-in'].length > 0) {
    var allowed = win.AMP_CONFIG['allow-doc-opt-in'];
    var meta = win.document.head.querySelector('meta[name="amp-experiments-opt-in"]');

    if (meta) {
      var optedInExperiments = meta.getAttribute('content').split(',');

      for (var i = 0; i < optedInExperiments.length; i++) {
        if (allowed.indexOf(optedInExperiments[i]) != -1) {
          toggles[optedInExperiments[i]] = true;
        }
      }
    }
  }

  Object.assign(toggles, getExperimentToggles(win));

  if (win.AMP_CONFIG && Array.isArray(win.AMP_CONFIG['allow-url-opt-in']) && win.AMP_CONFIG['allow-url-opt-in'].length > 0) {
    var _allowed = win.AMP_CONFIG['allow-url-opt-in'];
    var hash = win.location.originalHash || win.location.hash;
    var params = (0, _url.parseQueryString)(hash);

    for (var _i = 0; _i < _allowed.length; _i++) {
      var param = params["e-" + _allowed[_i]];

      if (param == '1') {
        toggles[_allowed[_i]] = true;
      }

      if (param == '0') {
        toggles[_allowed[_i]] = false;
      }
    }
  }

  return toggles;
}

/**
 * Returns the cached experiments toggles, or null if they have not been
 * computed yet.
 * @param {!Window} win
 * @return {Object<string, boolean>}
 */
function experimentTogglesOrNull(win) {
  return win[TOGGLES_WINDOW_PROPERTY] || null;
}

/**
 * Returns a set of experiment IDs currently on.
 * @param {!Window} win
 * @return {!Object<string, boolean>}
 */
function getExperimentToggles(win) {
  var experimentsString = '';

  try {
    if ('localStorage' in win) {
      experimentsString = win.localStorage.getItem(LOCAL_STORAGE_KEY);
    }
  } catch (e) {
    (0, _log.dev)().warn(TAG, 'Failed to retrieve experiments from localStorage.');
  }

  var tokens = experimentsString ? experimentsString.split(/\s*,\s*/g) : [];
  var toggles = Object.create(null);

  for (var i = 0; i < tokens.length; i++) {
    if (tokens[i].length == 0) {
      continue;
    }

    if (tokens[i][0] == '-') {
      toggles[tokens[i].substr(1)] = false;
    } else {
      toggles[tokens[i]] = true;
    }
  }

  return toggles;
}

/**
 * Saves a set of experiment IDs currently on.
 * @param {!Window} win
 * @param {!Object<string, boolean>} toggles
 */
function saveExperimentToggles(win, toggles) {
  var experimentIds = [];

  for (var experiment in toggles) {
    experimentIds.push((toggles[experiment] === false ? '-' : '') + experiment);
  }

  try {
    if ('localStorage' in win) {
      win.localStorage.setItem(LOCAL_STORAGE_KEY, experimentIds.join(','));
    }
  } catch (e) {
    (0, _log.user)().error(TAG, 'Failed to save experiments to localStorage.');
  }
}

/**
 * See getExperimentToggles().
 * @param {!Window} win
 * @return {!Object<string, boolean>}
 * @visibleForTesting
 */
function getExperimentTogglesForTesting(win) {
  return getExperimentToggles(win);
}

/**
 * Resets the experimentsToggle cache for testing purposes.
 * @param {!Window} win
 * @visibleForTesting
 */
function resetExperimentTogglesForTesting(win) {
  saveExperimentToggles(win, {});
  win[TOGGLES_WINDOW_PROPERTY] = null;
}

/**
 * In some browser implementations of Math.random(), sequential calls of
 * Math.random() are correlated and can cause a bias.  In particular,
 * if the previous random() call was < 0.001 (as it will be if we select
 * into an experiment), the next value could be less than 0.5 more than
 * 50.7% of the time.  This provides an implementation that roots down into
 * the crypto API, when available, to produce less biased samples.
 *
 * @return {number} Pseudo-random floating-point value on the range [0, 1).
 */
function slowButAccuratePrng() {
  // TODO(tdrl): Implement.
  return Math.random();
}

/**
 * Container for alternate random number generator implementations.  This
 * allows us to set an "accurate" PRNG for branch selection, but to mock it
 * out easily in tests.
 *
 * @visibleForTesting
 * @const {!{accuratePrng: function():number}}
 */
var RANDOM_NUMBER_GENERATORS = {
  accuratePrng: slowButAccuratePrng
};
exports.RANDOM_NUMBER_GENERATORS = RANDOM_NUMBER_GENERATORS;

/**
 * Selects, uniformly at random, a single item from the array.
 * @param {!Array<string>} arr Object to select from.
 * @return {?string} Single item from arr or null if arr was empty.
 */
function selectRandomItem(arr) {
  var rn = RANDOM_NUMBER_GENERATORS.accuratePrng();
  return (0, _log.dev)().assertString(arr[Math.floor(rn * arr.length)]) || null;
}

/**
 * Selects which page-level experiment branches are enabled. If a given
 * experiment name is already set (including to the null / no branches selected
 * state), this won't alter its state.
 *
 * Check whether a given experiment is set using isExperimentOn(win,
 * experimentName) and, if it is on, look for which branch is selected in
 * win.__AMP_EXPERIMENT_BRANCHES[experimentName].
 *
 * @param {!Window} win Window context on which to save experiment
 *     selection state.
 * @param {!Array<!ExperimentInfo>} experiments  Set of experiments to
 *     configure for this page load.
 * @return {!Object<string, string>} Map of experiment names to selected
 *     branches.
 */
function randomlySelectUnsetExperiments(win, experiments) {
  win.__AMP_EXPERIMENT_BRANCHES = win.__AMP_EXPERIMENT_BRANCHES || {};
  var selectedExperiments = {};

  for (var i = 0; i < experiments.length; i++) {
    var experiment = experiments[i];
    var experimentName = experiment.experimentId;

    if ((0, _object.hasOwn)(win.__AMP_EXPERIMENT_BRANCHES, experimentName)) {
      selectedExperiments[experimentName] = win.__AMP_EXPERIMENT_BRANCHES[experimentName];
      continue;
    }

    if (!experiment.isTrafficEligible || !experiment.isTrafficEligible(win)) {
      win.__AMP_EXPERIMENT_BRANCHES[experimentName] = null;
      continue;
    }

    // If we're in the experiment, but we haven't already forced a specific
    // experiment branch (e.g., via a test setup), then randomize the branch
    // choice.
    if (!win.__AMP_EXPERIMENT_BRANCHES[experimentName] && isExperimentOn(win,
    /*OK*/
    experimentName)) {
      win.__AMP_EXPERIMENT_BRANCHES[experimentName] = selectRandomItem(experiment.branches);
      selectedExperiments[experimentName] = win.__AMP_EXPERIMENT_BRANCHES[experimentName];
    }
  }

  return selectedExperiments;
}

/**
 * Returns the experiment branch enabled for the given experiment ID.
 * For example, 'control' or 'experiment'.
 *
 * @param {!Window} win Window context to check for experiment state.
 * @param {string} experimentName Name of the experiment to check.
 * @return {?string} Active experiment branch ID for experimentName (possibly
 *     null if experimentName has been tested but no branch was enabled).
 */
function getExperimentBranch(win, experimentName) {
  return win.__AMP_EXPERIMENT_BRANCHES ? win.__AMP_EXPERIMENT_BRANCHES[experimentName] : null;
}

/**
 * Returns an object containing all active experiment branches on the
 * top Window.
 *
 * @param {!Window} win Window context to check for experiment state.
 * @return {!Object} contains all experiment branches and their ids.
 */
function getActiveExperimentBranches(win) {
  var topWin = (0, _service.getTopWindow)(win);

  if (!topWin.__AMP_EXPERIMENT_BRANCHES) {
    topWin.__AMP_EXPERIMENT_BRANCHES = {};
  }

  return _extends({}, topWin.__AMP_EXPERIMENT_BRANCHES);
}

/**
 * Force enable (or disable) a specific branch of a given experiment name.
 * Disables the experiment name altogether if branchId is falseish.
 *
 * @param {!Window} win Window context to check for experiment state.
 * @param {string} experimentName Name of the experiment to check.
 * @param {?string} branchId ID of branch to force or null to disable
 *     altogether.
 * @visibleForTesting
 */
function forceExperimentBranch(win, experimentName, branchId) {
  win.__AMP_EXPERIMENT_BRANCHES = win.__AMP_EXPERIMENT_BRANCHES || {};
  toggleExperiment(win, experimentName, !!branchId, true);
  win.__AMP_EXPERIMENT_BRANCHES[experimentName] = branchId;
}

},{"./log":28,"./mode":29,"./service":33,"./url":40,"./utils/object":45}],24:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.listenFor = listenFor;
exports.listenForOncePromise = listenForOncePromise;
exports.postMessage = postMessage;
exports.postMessageToWindows = postMessageToWindows;
exports.parseIfNeeded = parseIfNeeded;
exports.looksLikeTrackingIframe = looksLikeTrackingIframe;
exports.isAdLike = isAdLike;
exports.disableScrollingOnIframe = disableScrollingOnIframe;
exports.canInspectWindow = canInspectWindow;
exports.getFriendlyIframeEmbedOptional = getFriendlyIframeEmbedOptional;
exports.isInFie = isInFie;
exports.makePausable = makePausable;
exports.isPausable = isPausable;
exports.setPaused = setPaused;
exports.FIE_EMBED_PROP = exports.SubscriptionApi = void 0;

var _dom = require("./dom");

var _pFrameMessaging = require("./3p-frame-messaging");

var _log = require("./log");

var _object = require("./utils/object");

var _eventHelper = require("./event-helper");

var _url = require("./url");

var _array = require("./utils/array");

var _style = require("./style");

var _json = require("./json");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sentinel used to force unlistening after a iframe is detached.
 * @type {string}
 */
var UNLISTEN_SENTINEL = 'unlisten';

/**
 * The iframe feature policy that forces the iframe to pause when it's not
 * display.
 * See https://github.com/dtapuska/iframe-freeze.
 */
var EXECUTION_WHILE_NOT_RENDERED = 'execution-while-not-rendered';

/**
 * @typedef {{
 *   frame: !Element,
 *   events: !Object<string, !Array<function(!JsonObject)>>
 * }}
 */
var WindowEventsDef;

/**
 * Returns a mapping from a URL's origin to an array of windows and their
 * listenFor listeners.
 * @param {?Window} parentWin the window that created the iframe
 * @param {boolean=} opt_create create the mapping if it does not exist
 * @return {?Object<string, !Array<!WindowEventsDef>>}
 */
function getListenFors(parentWin, opt_create) {
  var listeningFors = parentWin.listeningFors;

  if (!listeningFors && opt_create) {
    listeningFors = parentWin.listeningFors = Object.create(null);
  }

  return listeningFors || null;
}

/**
 * Returns an array of WindowEventsDef that have had any listenFor listeners
 * registered for this sentinel.
 * @param {?Window} parentWin the window that created the iframe
 * @param {string} sentinel the sentinel of the message
 * @param {boolean=} opt_create create the array if it does not exist
 * @return {?Array<!WindowEventsDef>}
 */
function getListenForSentinel(parentWin, sentinel, opt_create) {
  var listeningFors = getListenFors(parentWin, opt_create);

  if (!listeningFors) {
    return listeningFors;
  }

  var listenSentinel = listeningFors[sentinel];

  if (!listenSentinel && opt_create) {
    listenSentinel = listeningFors[sentinel] = [];
  }

  return listenSentinel || null;
}

/**
 * Returns an mapping of event names to listenFor listeners.
 * @param {?Window} parentWin the window that created the iframe
 * @param {!Element} iframe the iframe element who's context will trigger the
 *     event
 * @param {boolean=} opt_is3P set to true if the iframe is 3p.
 * @return {?Object<string, !Array<function(!JsonObject, !Window, string, !MessageEvent)>>}
 */
function getOrCreateListenForEvents(parentWin, iframe, opt_is3P) {
  var sentinel = getSentinel_(iframe, opt_is3P);
  var listenSentinel = getListenForSentinel(parentWin, sentinel, true);
  var windowEvents;

  for (var i = 0; i < listenSentinel.length; i++) {
    var we = listenSentinel[i];

    if (we.frame === iframe) {
      windowEvents = we;
      break;
    }
  }

  if (!windowEvents) {
    windowEvents = {
      frame: iframe,
      events: Object.create(null)
    };
    listenSentinel.push(windowEvents);
  }

  return windowEvents.events;
}

/**
 * Returns an mapping of event names to listenFor listeners.
 * @param {?Window} parentWin the window that created the iframe
 * @param {string} sentinel the sentinel of the message
 * @param {string} origin the source window's origin
 * @param {?Window} triggerWin the window that triggered the event
 * @return {?Object<string, !Array<function(!JsonObject, !Window, string, !MessageEvent)>>}
 */
function getListenForEvents(parentWin, sentinel, origin, triggerWin) {
  var listenSentinel = getListenForSentinel(parentWin, sentinel);

  if (!listenSentinel) {
    return listenSentinel;
  }

  // Find the entry for the frame.
  // TODO(@nekodo): Add a WeakMap<Window, WindowEventsDef> cache to
  //     speed up this process.
  var windowEvents;

  for (var i = 0; i < listenSentinel.length; i++) {
    var we = listenSentinel[i];
    var contentWindow = we.frame.contentWindow;

    if (!contentWindow) {
      setTimeout(dropListenSentinel, 0, listenSentinel);
    } else if (triggerWin == contentWindow || isDescendantWindow(contentWindow, triggerWin)) {
      // 3p code path, we may accept messages from nested frames.
      windowEvents = we;
      break;
    }
  }

  return windowEvents ? windowEvents.events : null;
}

/**
 * Checks whether one window is a descendant of another by climbing
 * the parent chain.
 * @param {?Window} ancestor potential ancestor window
 * @param {?Window} descendant potential descendant window
 * @return {boolean}
 */
function isDescendantWindow(ancestor, descendant) {
  for (var win = descendant; win && win != win.parent; win = win.parent) {
    if (win == ancestor) {
      return true;
    }
  }

  return false;
}

/**
 * Removes any listenFors registed on listenSentinel that do not have
 * a contentWindow (the frame was removed from the DOM tree).
 * @param {!Array<!WindowEventsDef>} listenSentinel
 */
function dropListenSentinel(listenSentinel) {
  var noopData = (0, _object.dict)({
    'sentinel': UNLISTEN_SENTINEL
  });

  for (var i = listenSentinel.length - 1; i >= 0; i--) {
    var windowEvents = listenSentinel[i];

    if (!windowEvents.frame.contentWindow) {
      listenSentinel.splice(i, 1);
      var events = windowEvents.events;

      for (var name in events) {
        // Splice here, so that each unlisten does not shift the array
        events[name].splice(0, Infinity).forEach(function (event) {
          event(noopData);
        });
      }
    }
  }
}

/**
 * Registers the global listenFor event listener if it has yet to be.
 * @param {?Window} parentWin
 */
function registerGlobalListenerIfNeeded(parentWin) {
  if (parentWin.listeningFors) {
    return;
  }

  var listenForListener = function listenForListener(event) {
    if (!(0, _eventHelper.getData)(event)) {
      return;
    }

    var data = parseIfNeeded((0, _eventHelper.getData)(event));

    if (!data || !data['sentinel']) {
      return;
    }

    var listenForEvents = getListenForEvents(parentWin, data['sentinel'], event.origin, event.source);

    if (!listenForEvents) {
      return;
    }

    var listeners = listenForEvents[data['type']];

    if (!listeners) {
      return;
    }

    // We slice to avoid issues with adding another listener or unlistening
    // during iteration. We could move to a Doubly Linked List with
    // backtracking, but that's overly complicated.
    listeners = listeners.slice();

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener(data, event.source, event.origin, event);
    }
  };

  parentWin.addEventListener('message', listenForListener);
}

/**
 * Allows listening for message from the iframe. Returns an unlisten
 * function to remove the listener.
 *
 * @param {?Element} iframe
 * @param {string} typeOfMessage
 * @param {?function(!JsonObject, !Window, string, !MessageEvent)} callback Called when a
 *     message of this type arrives for this iframe.
 * @param {boolean=} opt_is3P set to true if the iframe is 3p.
 * @param {boolean=} opt_includingNestedWindows set to true if messages from
 *     nested frames should also be accepted.
 * @param {boolean=} opt_allowOpaqueOrigin set to true if messages from
       opaque origins (origin == null) are allowed.
 * @return {!UnlistenDef}
 */
function listenFor(iframe, typeOfMessage, callback, opt_is3P, opt_includingNestedWindows, opt_allowOpaqueOrigin) {
  (0, _log.devAssert)(iframe.src, 'only iframes with src supported');
  (0, _log.devAssert)(!iframe.parentNode, 'cannot register events on an attached ' + 'iframe. It will cause hair-pulling bugs like #2942');
  (0, _log.devAssert)(callback);
  var parentWin = iframe.ownerDocument.defaultView;
  registerGlobalListenerIfNeeded(parentWin);
  var listenForEvents = getOrCreateListenForEvents(parentWin, iframe, opt_is3P);
  var iframeOrigin = (0, _url.parseUrlDeprecated)(iframe.src).origin;
  var events = listenForEvents[typeOfMessage] || (listenForEvents[typeOfMessage] = []);
  var unlisten;

  var listener = function listener(data, source, origin, event) {
    var sentinel = data['sentinel'];

    // Exclude messages that don't satisfy amp sentinel rules.
    if (sentinel == 'amp') {
      // For `amp` sentinel, nested windows are not allowed
      if (source != iframe.contentWindow) {
        return;
      }

      // For `amp` sentinel origin must match unless opaque origin is allowed
      var isOpaqueAndAllowed = origin == 'null' && opt_allowOpaqueOrigin;

      if (iframeOrigin != origin && !isOpaqueAndAllowed) {
        return;
      }
    }

    // Exclude nested frames if necessary.
    // Note that the source was already verified to be either the contentWindow
    // of the iframe itself or a descendant window within it.
    if (!opt_includingNestedWindows && source != iframe.contentWindow) {
      return;
    }

    if (data.sentinel == UNLISTEN_SENTINEL) {
      unlisten();
      return;
    }

    callback(data, source, origin, event);
  };

  events.push(listener);
  return unlisten = function unlisten() {
    if (listener) {
      var index = events.indexOf(listener);

      if (index > -1) {
        events.splice(index, 1);
      }

      // Make sure references to the unlisten function do not keep
      // alive too much.
      listener = null;
      events = null;
      callback = null;
    }
  };
}

/**
 * Returns a promise that resolves when one of given messages has been observed
 * for the first time. And remove listener for all other messages.
 * @param {!Element} iframe
 * @param {string|!Array<string>} typeOfMessages
 * @param {boolean=} opt_is3P
 * @return {!Promise<!{data: !JsonObject, source: !Window, origin: string, event: !MessageEvent}>}
 */
function listenForOncePromise(iframe, typeOfMessages, opt_is3P) {
  var unlistenList = [];

  if (typeof typeOfMessages == 'string') {
    typeOfMessages = [typeOfMessages];
  }

  return new Promise(function (resolve) {
    for (var i = 0; i < typeOfMessages.length; i++) {
      var message = typeOfMessages[i];
      var unlisten = listenFor(iframe, message, function (data, source, origin, event) {
        for (var _i = 0; _i < unlistenList.length; _i++) {
          unlistenList[_i]();
        }

        resolve({
          data: data,
          source: source,
          origin: origin,
          event: event
        });
      }, opt_is3P);
      unlistenList.push(unlisten);
    }
  });
}

/**
 * Posts a message to the iframe.
 * @param {!Element} iframe The iframe.
 * @param {string} type Type of the message.
 * @param {!JsonObject} object Message payload.
 * @param {string} targetOrigin origin of the target.
 * @param {boolean=} opt_is3P set to true if the iframe is 3p.
 */
function postMessage(iframe, type, object, targetOrigin, opt_is3P) {
  postMessageToWindows(iframe, [{
    win: iframe.contentWindow,
    origin: targetOrigin
  }], type, object, opt_is3P);
}

/**
 * Posts an identical message to multiple target windows with the same
 * sentinel.
 * The message is serialized only once.
 * @param {!Element} iframe The iframe.
 * @param {!Array<{win: !Window, origin: string}>} targets to send the message
 *     to, pairs of window and its origin.
 * @param {string} type Type of the message.
 * @param {!JsonObject} object Message payload.
 * @param {boolean=} opt_is3P set to true if the iframe is 3p.
 */
function postMessageToWindows(iframe, targets, type, object, opt_is3P) {
  if (!iframe.contentWindow) {
    return;
  }

  object['type'] = type;
  object['sentinel'] = getSentinel_(iframe, opt_is3P);
  var payload = object;

  if (opt_is3P) {
    // Serialize ourselves because that is much faster in Chrome.
    payload = 'amp-' + JSON.stringify(object);
  }

  for (var i = 0; i < targets.length; i++) {
    var target = targets[i];
    target.win.
    /*OK*/
    postMessage(payload, target.origin);
  }
}

/**
 * Gets the sentinel string.
 * @param {!Element} iframe The iframe.
 * @param {boolean=} opt_is3P set to true if the iframe is 3p.
 * @return {string} Sentinel string.
 * @private
 */
function getSentinel_(iframe, opt_is3P) {
  return opt_is3P ? iframe.getAttribute('data-amp-3p-sentinel') : 'amp';
}

/**
 * JSON parses event.data if it needs to be
 * @param {*} data
 * @return {?JsonObject} object message
 * @private
 * @visibleForTesting
 */
function parseIfNeeded(data) {
  if (typeof data == 'string') {
    if (data.charAt(0) == '{') {
      data = (0, _json.tryParseJson)(data, function (e) {
        (0, _log.dev)().warn('IFRAME-HELPER', 'Postmessage could not be parsed. ' + 'Is it in a valid JSON format?', e);
      }) || null;
    } else if ((0, _pFrameMessaging.isAmpMessage)(data)) {
      data = (0, _pFrameMessaging.deserializeMessage)(data);
    } else {
      data = null;
    }
  }

  return (
    /** @type {?JsonObject} */
    data
  );
}

/**
 * Manages a postMessage API for an iframe with a subscription message and
 * a way to broadcast messages to all subscribed windows, which
 * in turn must all be descendants of the contentWindow of the iframe.
 */
var SubscriptionApi = /*#__PURE__*/function () {
  /**
   * @param {!Element} iframe The iframe.
   * @param {string} type Type of the subscription message.
   * @param {boolean} is3p set to true if the iframe is 3p.
   * @param {function(!JsonObject, !Window, string)} requestCallback Callback
   *     invoked whenever a new window subscribes.
   */
  function SubscriptionApi(iframe, type, is3p, requestCallback) {
    var _this = this;

    _classCallCheck(this, SubscriptionApi);

    /** @private @const {!Element} */
    this.iframe_ = iframe;

    /** @private @const {boolean} */
    this.is3p_ = is3p;

    /** @private @const {!Array<{win: !Window, origin: string}>} */
    this.clientWindows_ = [];

    /** @private @const {!UnlistenDef} */
    this.unlisten_ = listenFor(this.iframe_, type, function (data, source, origin) {
      // This message might be from any window within the iframe, we need
      // to keep track of which windows want to be sent updates.
      if (!_this.clientWindows_.some(function (entry) {
        return entry.win == source;
      })) {
        _this.clientWindows_.push({
          win: source,
          origin: origin
        });
      }

      requestCallback(data, source, origin);
    }, this.is3p_, // For 3P frames we also allow nested frames within them to subscribe..
    this.is3p_
    /* opt_includingNestedWindows */
    );
  }

  /**
   * Sends a message to all subscribed windows.
   * @param {string} type Type of the message.
   * @param {!JsonObject} data Message payload.
   */
  _createClass(SubscriptionApi, [{
    key: "send",
    value: function send(type, data) {
      // Remove clients that have been removed from the DOM.
      (0, _array.remove)(this.clientWindows_, function (client) {
        return !client.win.parent;
      });
      postMessageToWindows(this.iframe_, this.clientWindows_, type, data, this.is3p_);
    }
    /**
     * Destroys iframe.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.unlisten_();
      this.clientWindows_.length = 0;
    }
  }]);

  return SubscriptionApi;
}();

exports.SubscriptionApi = SubscriptionApi;

/**
 * @param {!Element} element
 * @return {boolean}
 */
function looksLikeTrackingIframe(element) {
  var box = element.getLayoutBox();

  // This heuristic is subject to change.
  if (box.width > 10 || box.height > 10) {
    return false;
  }

  // Iframe is not tracking iframe if open with user interaction
  return !(0, _dom.closestAncestorElementBySelector)(element, '.i-amphtml-overlay');
}

// Most common ad sizes
// Array of [width, height] pairs.
var adSizes = [[300, 250], [320, 50], [300, 50], [320, 100]];

/**
 * Guess whether this element might be an ad.
 * @param {!Element} element An amp-iframe element.
 * @return {boolean}
 * @visibleForTesting
 */
function isAdLike(element) {
  var box = element.getLayoutBox();
  var height = box.height,
      width = box.width;

  for (var i = 0; i < adSizes.length; i++) {
    var refWidth = adSizes[i][0];
    var refHeight = adSizes[i][1];

    if (refHeight > height) {
      continue;
    }

    if (refWidth > width) {
      continue;
    }

    // Fuzzy matching to account for padding.
    if (height - refHeight <= 20 && width - refWidth <= 20) {
      return true;
    }
  }

  return false;
}

/**
 * @param {!Element} iframe
 * @return {!Element}
 */
function disableScrollingOnIframe(iframe) {
  (0, _dom.addAttributesToElement)(iframe, (0, _object.dict)({
    'scrolling': 'no'
  }));
  // This shouldn't work, but it does on Firefox.
  // https://stackoverflow.com/a/15494969
  (0, _style.setStyle)(iframe, 'overflow', 'hidden');
  return iframe;
}

/**
 * Returns true if win's properties can be accessed and win is defined.
 * This functioned is used to determine if a window is cross-domained
 * from the perspective of the current window.
 * @param {!Window} win
 * @return {boolean}
 */
function canInspectWindow(win) {
  // TODO: this is not reliable.  The compiler assumes that property reads are
  // side-effect free.  The recommended fix is to use goog.reflect.sinkValue
  // but since we're not using the closure library I'm not sure how to do this.
  // See https://github.com/google/closure-compiler/issues/3156
  try {
    // win['test'] could be truthy but not true the compiler shouldn't be able
    // to optimize this check away.
    return !!win.location.href && (win['test'] || true);
  } catch (unusedErr) {
    // eslint-disable-line no-unused-vars
    return false;
  }
}

/** @const {string} */
var FIE_EMBED_PROP = '__AMP_EMBED__';
exports.FIE_EMBED_PROP = FIE_EMBED_PROP;

/**
 * Returns the embed created using `installFriendlyIframeEmbed` or `null`.
 * Caution: This will only return the FIE after the iframe has 'loaded'. If you
 * are checking before this signal you may be in a race condition that returns
 * null.
 * @param {!HTMLIFrameElement} iframe
 * @return {?./friendly-iframe-embed.FriendlyIframeEmbed}
 */
function getFriendlyIframeEmbedOptional(iframe) {
  return (
    /** @type {?./friendly-iframe-embed.FriendlyIframeEmbed} */
    iframe[FIE_EMBED_PROP]
  );
}

/**
 * @param {!Element} element
 * @return {boolean}
 */
function isInFie(element) {
  return element.classList.contains('i-amphtml-fie') || !!(0, _dom.closestAncestorElementBySelector)(element, '.i-amphtml-fie');
}

/**
 * @param {!HTMLIFrameElement} iframe
 */
function makePausable(iframe) {
  var oldAllow = (iframe.getAttribute('allow') || '').trim();
  iframe.setAttribute('allow', EXECUTION_WHILE_NOT_RENDERED + " 'none';" + oldAllow);
}

/**
 * @param {!HTMLIFrameElement} iframe
 * @return {boolean}
 */
function isPausable(iframe) {
  return !!iframe.featurePolicy && iframe.featurePolicy.features().indexOf(EXECUTION_WHILE_NOT_RENDERED) != -1 && !iframe.featurePolicy.allowsFeature(EXECUTION_WHILE_NOT_RENDERED);
}

/**
 * @param {!HTMLIFrameElement} iframe
 * @param {boolean} paused
 */
function setPaused(iframe, paused) {
  (0, _style.toggle)(iframe, !paused);
}

},{"./3p-frame-messaging":14,"./dom":19,"./event-helper":22,"./json":26,"./log":28,"./style":36,"./url":40,"./utils/array":41,"./utils/object":45}],25:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.internalRuntimeVersion = internalRuntimeVersion;

/**
 * Copyright 2019 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns the internal AMP runtime version. Note that this is not the RTV,
 * which is a prefix and the runtime version.
 *
 * The call sites for this function are replaced with a compile time constant
 * string.
 *
 * @return {string}
 */
function internalRuntimeVersion() {
  return '$internalRuntimeVersion$';
}

},{}],26:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.recreateNonProtoObject = recreateNonProtoObject;
exports.getValueForExpr = getValueForExpr;
exports.parseJson = parseJson;
exports.tryParseJson = tryParseJson;
exports.getChildJsonConfig = getChildJsonConfig;
exports.deepEquals = deepEquals;
exports.jsonConfiguration = jsonConfiguration;
exports.jsonLiteral = jsonLiteral;
exports.includeJsonLiteral = includeJsonLiteral;

var _dom = require("./dom");

var _types = require("./types");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview This module declares JSON types as defined in the
 * {@link http://json.org/}.
 */
// NOTE Type are changed to {*} because of
// https://github.com/google/closure-compiler/issues/1999

/**
 * JSON scalar. It's either string, number or boolean.
 * @typedef {*} should be string|number|boolean|null
 */
var JSONScalarDef;

/**
 * JSON object. It's a map with string keys and JSON values.
 * @typedef {*} should be !Object<string, ?JSONValueDef>
 */
var JSONObjectDef;

/**
 * JSON array. It's an array with JSON values.
 * @typedef {*} should be !Array<?JSONValueDef>
 */
var JSONArrayDef;

/**
 * JSON value. It's either a scalar, an object or an array.
 * @typedef {*} should be !JSONScalarDef|!JSONObjectDef|!JSONArrayDef
 */
var JSONValueDef;

/**
 * Recreates objects with prototype-less copies.
 * @param {!JsonObject} obj
 * @return {!JsonObject}
 */
function recreateNonProtoObject(obj) {
  var copy = Object.create(null);

  for (var k in obj) {
    if (!hasOwnProperty(obj, k)) {
      continue;
    }

    var v = obj[k];
    copy[k] = (0, _types.isObject)(v) ? recreateNonProtoObject(v) : v;
  }

  return (
    /** @type {!JsonObject} */
    copy
  );
}

/**
 * Returns a value from an object for a field-based expression. The expression
 * is a simple nested dot-notation of fields, such as `field1.field2`. If any
 * field in a chain does not exist or is not an object or array, the returned
 * value will be `undefined`.
 *
 * @param {!JsonObject} obj
 * @param {string} expr
 * @return {*}
 */
function getValueForExpr(obj, expr) {
  // The `.` indicates "the object itself".
  if (expr == '.') {
    return obj;
  }

  // Otherwise, navigate via properties.
  var parts = expr.split('.');
  var value = obj;

  for (var i = 0; i < parts.length; i++) {
    var part = parts[i];

    if (part && value && value[part] !== undefined && hasOwnProperty(value, part)) {
      value = value[part];
      continue;
    }

    value = undefined;
    break;
  }

  return value;
}

/**
 * Simple wrapper around JSON.parse that casts the return value
 * to JsonObject.
 * Create a new wrapper if an array return value is desired.
 * @param {*} json JSON string to parse
 * @return {?JsonObject} May be extend to parse arrays.
 */
function parseJson(json) {
  return (
    /** @type {?JsonObject} */
    JSON.parse(
    /** @type {string} */
    json)
  );
}

/**
 * Parses the given `json` string without throwing an exception if not valid.
 * Returns `undefined` if parsing fails.
 * Returns the `Object` corresponding to the JSON string when parsing succeeds.
 * @param {*} json JSON string to parse
 * @param {function(!Error)=} opt_onFailed Optional function that will be called
 *     with the error if parsing fails.
 * @return {?JsonObject} May be extend to parse arrays.
 */
function tryParseJson(json, opt_onFailed) {
  try {
    return parseJson(json);
  } catch (e) {
    if (opt_onFailed) {
      opt_onFailed(e);
    }

    return null;
  }
}

/**
 * Helper method to get the json config from an element <script> tag
 * @param {!Element} element
 * @return {?JsonObject}
 * @throws {!Error} If element does not have exactly one <script> child
 * with type="application/json", or if the <script> contents are not valid JSON.
 */
function getChildJsonConfig(element) {
  var scripts = (0, _dom.childElementsByTag)(element, 'script');
  var n = scripts.length;

  if (n !== 1) {
    throw new Error("Found " + scripts.length + " <script> children. Expected 1.");
  }

  var script = scripts[0];

  if (!(0, _dom.isJsonScriptTag)(script)) {
    throw new Error('<script> child must have type="application/json"');
  }

  try {
    return parseJson(script.textContent);
  } catch (unusedError) {
    throw new Error('Failed to parse <script> contents. Is it valid JSON?');
  }
}

/**
 * Deeply checks strict equality of items in nested arrays and objects.
 *
 * @param {JSONValueDef} a
 * @param {JSONValueDef} b
 * @param {number} depth The maximum depth. Must be finite.
 * @return {boolean}
 * @throws {Error} If depth argument is not finite.
 */
function deepEquals(a, b, depth) {
  if (depth === void 0) {
    depth = 5;
  }

  if (!isFinite(depth) || depth < 0) {
    throw new Error('Invalid depth: ' + depth);
  }

  if (a === b) {
    return true;
  }

  /** @type {!Array<{a: JSONValueDef, b: JSONValueDef, depth: number}>} */
  var queue = [{
    a: a,
    b: b,
    depth: depth
  }];

  while (queue.length > 0) {
    var _queue$shift = queue.shift(),
        _a = _queue$shift.a,
        _b = _queue$shift.b,
        _depth = _queue$shift.depth;

    // Only check deep equality if depth > 0.
    if (_depth > 0) {
      if (typeof _a !== typeof _b) {
        return false;
      } else if (Array.isArray(_a) && Array.isArray(_b)) {
        if (_a.length !== _b.length) {
          return false;
        }

        for (var i = 0; i < _a.length; i++) {
          queue.push({
            a: _a[i],
            b: _b[i],
            depth: _depth - 1
          });
        }

        continue;
      } else if (_a && _b && typeof _a === 'object' && typeof _b === 'object') {
        var keysA = Object.keys(
        /** @type {!Object} */
        _a);
        var keysB = Object.keys(
        /** @type {!Object} */
        _b);

        if (keysA.length !== keysB.length) {
          return false;
        }

        for (var _i = 0; _i < keysA.length; _i++) {
          var k = keysA[_i];
          queue.push({
            a: _a[k],
            b: _b[k],
            depth: _depth - 1
          });
        }

        continue;
      }
    }

    // If we get here, then depth == 0 or (a, b) are primitives.
    if (_a !== _b) {
      return false;
    }
  }

  return true;
}

/**
 * @param {*} obj
 * @param {string} key
 * @return {boolean}
 */
function hasOwnProperty(obj, key) {
  if (obj == null || typeof obj != 'object') {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(
  /** @type {!Object} */
  obj, key);
}

/**
 * This helper function handles configurations specified in a JSON format.
 *
 * It allows the configuration is to be written in plain JS (which has better
 * dev ergonomics like comments and trailing commas), and allows the
 * configuration to be transformed into an efficient JSON-parsed representation
 * in the dist build. See https://v8.dev/blog/cost-of-javascript-2019#json
 *
 * @param {!Object} obj
 * @return {!JsonObject}
 */
function jsonConfiguration(obj) {
  return (
    /** @type {!JsonObject} */
    obj
  );
}

/**
 * This converts an Object into a suitable type to be used in `includeJsonLiteral`.
 * This doesn't actually do any conversion, it only changes the closure type.
 *
 * @param {!Object|!Array|string|number|boolean|null} value
 * @return {!InternalJsonLiteralTypeDef}
 */
function jsonLiteral(value) {
  return (
    /** @type {!InternalJsonLiteralTypeDef} */
    value
  );
}

/**
 * Allows inclusion of a variable (that's wrapped in a jsonLiteral
 * call) to be included inside a jsonConfiguration.
 *
 * @param {!InternalJsonLiteralTypeDef} value
 * @return {*}
 */
function includeJsonLiteral(value) {
  return value;
}

},{"./dom":19,"./types":37}],27:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.layoutRectLtwh = layoutRectLtwh;
exports.layoutRectFromDomRect = layoutRectFromDomRect;
exports.rectsOverlap = rectsOverlap;
exports.rectIntersection = rectIntersection;
exports.layoutRectsRelativePos = layoutRectsRelativePos;
exports.layoutPositionRelativeToScrolledViewport = layoutPositionRelativeToScrolledViewport;
exports.expandLayoutRect = expandLayoutRect;
exports.moveLayoutRect = moveLayoutRect;
exports.areMarginsChanged = areMarginsChanged;
exports.layoutRectSizeEquals = layoutRectSizeEquals;
exports.layoutRectEquals = layoutRectEquals;
exports.cloneLayoutMarginsChangeDef = cloneLayoutMarginsChangeDef;
exports.RelativePositions = exports.LayoutMarginsChangeDef = exports.LayoutMarginsDef = exports.LayoutRectDef = void 0;

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The structure that combines position and size for an element. The exact
 * interpretation of position and size depends on the use case.
 *
 * @typedef {{
 *   top: number,
 *   bottom: number,
 *   left: number,
 *   right: number,
 *   width: number,
 *   height: number,
 *   x: number,
 *   y: number
 * }}
 */
var LayoutRectDef;
exports.LayoutRectDef = LayoutRectDef;

/**
 * The structure that represents the margins of an Element.
 *
 * @typedef {{
 *   top: number,
 *   right: number,
 *   bottom: number,
 *   left: number
 * }}
 */
var LayoutMarginsDef;
exports.LayoutMarginsDef = LayoutMarginsDef;

/**
 * The structure that represents a requested change to the margins of an
 * Element. Any new values specified will replace existing ones (rather than
 * being additive).
 *
 * @typedef {{
 *   top: (number|undefined),
 *   right: (number|undefined),
 *   bottom: (number|undefined),
 *   left: (number|undefined)
 * }}
 */
var LayoutMarginsChangeDef;
exports.LayoutMarginsChangeDef = LayoutMarginsChangeDef;

/**
 * RelativePositions
 *
 * Describes the relative position of an element to another (whether the
 * first is inside the second, on top of the second or on the bottom
 * @enum {string}
 */
var RelativePositions = {
  INSIDE: 'inside',
  TOP: 'top',
  BOTTOM: 'bottom'
};
exports.RelativePositions = RelativePositions;

/**
 * Creates a layout rect based on the left, top, width and height parameters
 * in that order.
 * @param {number} left
 * @param {number} top
 * @param {number} width
 * @param {number} height
 * @return {!LayoutRectDef}
 */
function layoutRectLtwh(left, top, width, height) {
  return {
    left: left,
    top: top,
    width: width,
    height: height,
    bottom: top + height,
    right: left + width,
    x: left,
    y: top
  };
}

/**
 * Creates a layout rect based on the DOMRect, e.g. obtained from calling
 * getBoundingClientRect.
 * @param {!ClientRect} rect
 * @return {!LayoutRectDef}
 */
function layoutRectFromDomRect(rect) {
  return layoutRectLtwh(Number(rect.left), Number(rect.top), Number(rect.width), Number(rect.height));
}

/**
 * Returns true if the specified two rects overlap by a single pixel.
 * @param {!LayoutRectDef|!ClientRect} r1
 * @param {!LayoutRectDef|!ClientRect} r2
 * @return {boolean}
 */
function rectsOverlap(r1, r2) {
  return r1.top <= r2.bottom && r2.top <= r1.bottom && r1.left <= r2.right && r2.left <= r1.right;
}

/**
 * Returns the intersection between a, b or null if there is none.
 * @param {...?LayoutRectDef|undefined} var_args
 * @return {?LayoutRectDef}
 */
function rectIntersection(var_args) {
  var x0 = -Infinity;
  var x1 = Infinity;
  var y0 = -Infinity;
  var y1 = Infinity;

  for (var i = 0; i < arguments.length; i++) {
    var current = arguments[i];

    if (!current) {
      continue;
    }

    x0 = Math.max(x0, current.left);
    x1 = Math.min(x1, current.left + current.width);
    y0 = Math.max(y0, current.top);
    y1 = Math.min(y1, current.top + current.height);

    if (x1 < x0 || y1 < y0) {
      return null;
    }
  }

  if (x1 == Infinity) {
    return null;
  }

  return layoutRectLtwh(x0, y0, x1 - x0, y1 - y0);
}

/**
 * Returns the position of r2 relative to r1
 * @param {!LayoutRectDef} r1
 * @param {!LayoutRectDef} r2
 * @return {RelativePositions}
 */
function layoutRectsRelativePos(r1, r2) {
  if (r1.top < r2.top) {
    return RelativePositions.TOP;
  } else if (r1.bottom > r2.bottom) {
    return RelativePositions.BOTTOM;
  } else {
    return RelativePositions.INSIDE;
  }
}

/**
 * Determines if any portion of a layoutBox would be onscreen in the given
 * viewport, when scrolled to the specified position.
 * @param {!LayoutRectDef} layoutBox
 * @param {!./service/viewport/viewport-interface.ViewportInterface} viewport
 * @param {number} scrollPos
 * @return {RelativePositions}
 */
function layoutPositionRelativeToScrolledViewport(layoutBox, viewport, scrollPos) {
  var scrollLayoutBox = layoutRectFromDomRect(
  /** @type {!ClientRect} */
  {
    top: scrollPos,
    bottom: scrollPos + viewport.getHeight(),
    left: 0,
    right: viewport.getWidth()
  });

  if (rectsOverlap(layoutBox, scrollLayoutBox)) {
    return RelativePositions.INSIDE;
  } else {
    return layoutRectsRelativePos(layoutBox, scrollLayoutBox);
  }
}

/**
 * Expand the layout rect using multiples of width and height.
 * @param {!LayoutRectDef} rect Original rect.
 * @param {number} dw Expansion in width, specified as a multiple of width.
 * @param {number} dh Expansion in height, specified as a multiple of height.
 * @return {!LayoutRectDef}
 */
function expandLayoutRect(rect, dw, dh) {
  return layoutRectLtwh(rect.left - rect.width * dw, rect.top - rect.height * dh, rect.width * (1 + dw * 2), rect.height * (1 + dh * 2));
}

/**
 * Moves the layout rect using dx and dy.
 * @param {!LayoutRectDef} rect Original rect.
 * @param {number} dx Move horizontally with this value.
 * @param {number} dy Move vertically with this value.
 * @return {!LayoutRectDef}
 */
function moveLayoutRect(rect, dx, dy) {
  if (dx == 0 && dy == 0 || rect.width == 0 && rect.height == 0) {
    return rect;
  }

  return layoutRectLtwh(rect.left + dx, rect.top + dy, rect.width, rect.height);
}

/**
 * @param {!LayoutMarginsDef} margins
 * @param {!LayoutMarginsChangeDef} change
 * @return {boolean}
 */
function areMarginsChanged(margins, change) {
  return change.top !== undefined && change.top != margins.top || change.right !== undefined && change.right != margins.right || change.bottom !== undefined && change.bottom != margins.bottom || change.left !== undefined && change.left != margins.left;
}

/**
 * @param {!LayoutRectDef} from
 * @param {!LayoutRectDef} to
 * @return {boolean}
 */
function layoutRectSizeEquals(from, to) {
  return from.width == to.width && from.height === to.height;
}

/**
 * @param {?LayoutRectDef} r1
 * @param {?LayoutRectDef} r2
 * @return {boolean}
 */
function layoutRectEquals(r1, r2) {
  if (!r1 || !r2) {
    return false;
  }

  return r1.left == r2.left && r1.top == r2.top && r1.width == r2.width && r1.height == r2.height;
}

/**
 * @param {LayoutMarginsChangeDef|undefined} marginsChange
 * @return {LayoutMarginsChangeDef|undefined}
 */
function cloneLayoutMarginsChangeDef(marginsChange) {
  if (!marginsChange) {
    return marginsChange;
  }

  return {
    top: marginsChange.top,
    bottom: marginsChange.bottom,
    left: marginsChange.left,
    right: marginsChange.right
  };
}

},{}],28:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isUserErrorMessage = isUserErrorMessage;
exports.stripUserError = stripUserError;
exports.isUserErrorEmbed = isUserErrorEmbed;
exports.setReportError = setReportError;
exports.overrideLogLevel = overrideLogLevel;
exports.duplicateErrorIfNecessary = duplicateErrorIfNecessary;
exports.createErrorVargs = createErrorVargs;
exports.rethrowAsync = rethrowAsync;
exports.initLogConstructor = initLogConstructor;
exports.resetLogConstructorForTesting = resetLogConstructorForTesting;
exports.user = user;
exports.dev = dev;
exports.isFromEmbed = isFromEmbed;
exports.devAssert = devAssert;
exports.userAssert = userAssert;
exports.Log = exports.LogLevel = exports.USER_ERROR_EMBED_SENTINEL = exports.USER_ERROR_SENTINEL = void 0;

var _mode = require("./mode");

var _internalVersion = require("./internal-version");

var _types = require("./types");

var _function = require("./utils/function");

var _config = require("./config");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var noop = function noop() {};

/**
 * Triple zero width space.
 *
 * This is added to user error messages, so that we can later identify
 * them, when the only thing that we have is the message. This is the
 * case in many browsers when the global exception handler is invoked.
 *
 * @const {string}
 */
var USER_ERROR_SENTINEL = "\u200B\u200B\u200B";
exports.USER_ERROR_SENTINEL = USER_ERROR_SENTINEL;

/**
 * Four zero width space.
 *
 * @const {string}
 */
var USER_ERROR_EMBED_SENTINEL = "\u200B\u200B\u200B\u200B";
exports.USER_ERROR_EMBED_SENTINEL = USER_ERROR_EMBED_SENTINEL;

/**
 * @param {string} message
 * @return {boolean} Whether this message was a user error.
 */
function isUserErrorMessage(message) {
  return message.indexOf(USER_ERROR_SENTINEL) >= 0;
}

/**
 * @param {string} message
 * @return {string} The new message without USER_ERROR_SENTINEL
 */
function stripUserError(message) {
  return message.replace(USER_ERROR_SENTINEL, '');
}

/**
 * @param {string} message
 * @return {boolean} Whether this message was a a user error from an iframe embed.
 */
function isUserErrorEmbed(message) {
  return message.indexOf(USER_ERROR_EMBED_SENTINEL) >= 0;
}

/**
 * @enum {number}
 */
var LogLevel = {
  OFF: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  FINE: 4
};
exports.LogLevel = LogLevel;

/**
 * Sets reportError function. Called from error.js to break cyclic
 * dependency.
 * @param {function(*, !Element=)|undefined} fn
 */
function setReportError(fn) {
  self.__AMP_REPORT_ERROR = fn;
}

/**
 * @type {!LogLevel|undefined}
 * @private
 */
var levelOverride_ = undefined;

/**
 * @param {!LogLevel} level
 */
function overrideLogLevel(level) {
  levelOverride_ = level;
}

/**
 * Prefixes `internalRuntimeVersion` with the `01` channel signifier (for prod.) for
 * extracted message URLs.
 * (Specific channel is irrelevant: message tables are invariant on internal version.)
 * @return {string}
 */
var messageUrlRtv = function messageUrlRtv() {
  return "01" + (0, _internalVersion.internalRuntimeVersion)();
};

/**
 * Gets a URL to display a message on amp.dev.
 * @param {string} id
 * @param {!Array} interpolatedParts
 * @return {string}
 */
var externalMessageUrl = function externalMessageUrl(id, interpolatedParts) {
  return interpolatedParts.reduce(function (prefix, arg) {
    return prefix + "&s[]=" + messageArgToEncodedComponent(arg);
  }, "https://log.amp.dev/?v=" + messageUrlRtv() + "&id=" + encodeURIComponent(id));
};

/**
 * URL to simple log messages table JSON file, which contains an Object<string, string>
 * which maps message id to full message template.
 * @return {string}
 */
var externalMessagesSimpleTableUrl = function externalMessagesSimpleTableUrl() {
  return _config.urls.cdn + "/rtv/" + messageUrlRtv() + "/log-messages.simple.json";
};

/**
 * @param {*} arg
 * @return {string}
 */
var messageArgToEncodedComponent = function messageArgToEncodedComponent(arg) {
  return encodeURIComponent(String(elementStringOrPassthru(arg)));
};

/**
 * Logging class. Use of sentinel string instead of a boolean to check user/dev
 * errors because errors could be rethrown by some native code as a new error,
 * and only a message would survive. Also, some browser don’t support a 5th
 * error object argument in window.onerror. List of supporting browser can be
 * found here:
 * https://blog.sentry.io/2016/01/04/client-javascript-reporting-window-onerror.html
 * @final
 * @private Visible for testing only.
 */
var Log = /*#__PURE__*/function () {
  /**
   * opt_suffix will be appended to error message to identify the type of the
   * error message. We can't rely on the error object to pass along the type
   * because some browsers do not have this param in its window.onerror API.
   * See:
   * https://blog.sentry.io/2016/01/04/client-javascript-reporting-window-onerror.html
   *
   * @param {!Window} win
   * @param {function(number, boolean):!LogLevel} levelFunc
   * @param {string=} opt_suffix
   */
  function Log(win, levelFunc, opt_suffix) {
    var _this = this;

    if (opt_suffix === void 0) {
      opt_suffix = '';
    }

    _classCallCheck(this, Log);

    /**
     * In tests we use the main test window instead of the iframe where
     * the tests runs because only the former is relayed to the console.
     * @const {!Window}
     */
    this.win = (0, _mode.getMode)().test && win.__AMP_TEST_IFRAME ? win.parent : win;

    /** @private @const {function(number, boolean):!LogLevel} */
    this.levelFunc_ = levelFunc;

    /** @private @const {!LogLevel} */
    this.level_ = this.defaultLevel_();

    /** @private @const {string} */
    this.suffix_ = opt_suffix;

    /** @private {?JsonObject} */
    this.messages_ = null;
    this.fetchExternalMessagesOnce_ = (0, _function.once)(function () {
      win.fetch(externalMessagesSimpleTableUrl()).then(function (response) {
        return response.json();
      }, noop).then(function (opt_messages) {
        if (opt_messages) {
          _this.messages_ =
          /** @type {!JsonObject} */
          opt_messages;
        }
      });
    });
  }

  /**
   * @return {!LogLevel}
   * @private
   */
  _createClass(Log, [{
    key: "getLevel_",
    value: function getLevel_() {
      return levelOverride_ !== undefined ? levelOverride_ : this.level_;
    }
    /**
     * @return {!LogLevel}
     * @private
     */

  }, {
    key: "defaultLevel_",
    value: function defaultLevel_() {
      // No console - can't enable logging.
      if (!this.win.console || !this.win.console.log) {
        return LogLevel.OFF;
      }

      // Logging has been explicitly disabled.
      if ((0, _mode.getMode)().log == '0') {
        return LogLevel.OFF;
      }

      // Logging is enabled for tests directly.
      if ((0, _mode.getMode)().test && this.win.ENABLE_LOG) {
        return LogLevel.FINE;
      }

      // LocalDev by default allows INFO level, unless overriden by `#log`.
      if ((0, _mode.getMode)().localDev && !(0, _mode.getMode)().log) {
        return LogLevel.INFO;
      }

      return this.defaultLevelWithFunc_();
    }
    /**
     * @return {!LogLevel}
     * @private
     */

  }, {
    key: "defaultLevelWithFunc_",
    value: function defaultLevelWithFunc_() {
      // Delegate to the specific resolver.
      return this.levelFunc_(parseInt((0, _mode.getMode)().log, 10), (0, _mode.getMode)().development);
    }
    /**
     * @param {string} tag
     * @param {string} level
     * @param {!Array} messages
     */

  }, {
    key: "msg_",
    value: function msg_(tag, level, messages) {
      if (this.getLevel_() != LogLevel.OFF) {
        var fn = this.win.console.log;

        if (level == 'ERROR') {
          fn = this.win.console.error || fn;
        } else if (level == 'INFO') {
          fn = this.win.console.info || fn;
        } else if (level == 'WARN') {
          fn = this.win.console.warn || fn;
        }

        var args = this.maybeExpandMessageArgs_(messages);
        // Prefix console message with "[tag]".
        var prefix = "[" + tag + "]";

        if (typeof args[0] === 'string') {
          // Prepend string to avoid breaking string substitutions e.g. %s.
          args[0] = prefix + ' ' + args[0];
        } else {
          args.unshift(prefix);
        }

        fn.apply(this.win.console, args);
      }
    }
    /**
     * Whether the logging is enabled.
     * @return {boolean}
     */

  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.getLevel_() != LogLevel.OFF;
    }
    /**
     * Reports a fine-grained message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "fine",
    value: function fine(tag, var_args) {
      if (this.getLevel_() >= LogLevel.FINE) {
        this.msg_(tag, 'FINE', Array.prototype.slice.call(arguments, 1));
      }
    }
    /**
     * Reports a informational message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "info",
    value: function info(tag, var_args) {
      if (this.getLevel_() >= LogLevel.INFO) {
        this.msg_(tag, 'INFO', Array.prototype.slice.call(arguments, 1));
      }
    }
    /**
     * Reports a warning message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "warn",
    value: function warn(tag, var_args) {
      if (this.getLevel_() >= LogLevel.WARN) {
        this.msg_(tag, 'WARN', Array.prototype.slice.call(arguments, 1));
      }
    }
    /**
     * Reports an error message. If the logging is disabled, the error is rethrown
     * asynchronously.
     * @param {string} tag
     * @param {...*} var_args
     * @return {!Error|undefined}
     * @private
     */

  }, {
    key: "error_",
    value: function error_(tag, var_args) {
      if (this.getLevel_() >= LogLevel.ERROR) {
        this.msg_(tag, 'ERROR', Array.prototype.slice.call(arguments, 1));
      } else {
        var error = createErrorVargs.apply(null, Array.prototype.slice.call(arguments, 1));
        this.prepareError_(error);
        return error;
      }
    }
    /**
     * Reports an error message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "error",
    value: function error(tag, var_args) {
      var error = this.error_.apply(this, arguments);

      if (error) {
        error.name = tag || error.name;

        // __AMP_REPORT_ERROR is installed globally per window in the entry point.
        self.__AMP_REPORT_ERROR(error);
      }
    }
    /**
     * Reports an error message and marks with an expected property. If the
     * logging is disabled, the error is rethrown asynchronously.
     * @param {string} unusedTag
     * @param {...*} var_args
     */

  }, {
    key: "expectedError",
    value: function expectedError(unusedTag, var_args) {
      var error = this.error_.apply(this, arguments);

      if (error) {
        error.expected = true;

        // __AMP_REPORT_ERROR is installed globally per window in the entry point.
        self.__AMP_REPORT_ERROR(error);
      }
    }
    /**
     * Creates an error object.
     * @param {...*} var_args
     * @return {!Error}
     */

  }, {
    key: "createError",
    value: function createError(var_args) {
      var error = createErrorVargs.apply(null, arguments);
      this.prepareError_(error);
      return error;
    }
    /**
     * Creates an error object with its expected property set to true.
     * @param {...*} var_args
     * @return {!Error}
     */

  }, {
    key: "createExpectedError",
    value: function createExpectedError(var_args) {
      var error = createErrorVargs.apply(null, arguments);
      this.prepareError_(error);
      error.expected = true;
      return error;
    }
    /**
     * Throws an error if the first argument isn't trueish.
     *
     * Supports argument substitution into the message via %s placeholders.
     *
     * Throws an error object that has two extra properties:
     * - associatedElement: This is the first element provided in the var args.
     *   It can be used for improved display of error messages.
     * - messageArray: The elements of the substituted message as non-stringified
     *   elements in an array. When e.g. passed to console.error this yields
     *   native displays of things like HTML elements.
     *
     * @param {T} shouldBeTrueish The value to assert. The assert fails if it does
     *     not evaluate to true.
     * @param {!Array|string=} opt_message The assertion message
     * @param {...*} var_args Arguments substituted into %s in the message.
     * @return {T} The value of shouldBeTrueish.
     * @throws {!Error} When `value` is falsey.
     * @template T
     * @closurePrimitive {asserts.truthy}
     */

  }, {
    key: "assert",
    value: function assert(shouldBeTrueish, opt_message, var_args) {
      var firstElement;

      if ((0, _types.isArray)(opt_message)) {
        return this.assert.apply(this, [shouldBeTrueish].concat(this.expandMessageArgs_(
        /** @type {!Array} */
        opt_message)));
      }

      if (!shouldBeTrueish) {
        var message = opt_message || 'Assertion failed';
        var splitMessage = message.split('%s');
        var first = splitMessage.shift();
        var formatted = first;
        var messageArray = [];
        var i = 2;
        pushIfNonEmpty(messageArray, first);

        while (splitMessage.length > 0) {
          var nextConstant = splitMessage.shift();
          var val = arguments[i++];

          if (val && val.tagName) {
            firstElement = val;
          }

          messageArray.push(val);
          pushIfNonEmpty(messageArray, nextConstant.trim());
          formatted += stringOrElementString(val) + nextConstant;
        }

        var e = new Error(formatted);
        e.fromAssert = true;
        e.associatedElement = firstElement;
        e.messageArray = messageArray;
        this.prepareError_(e);

        // __AMP_REPORT_ERROR is installed globally per window in the entry point.
        self.__AMP_REPORT_ERROR(e);

        throw e;
      }

      return shouldBeTrueish;
    }
    /**
     * Throws an error if the first argument isn't an Element
     *
     * Otherwise see `assert` for usage
     *
     * @param {*} shouldBeElement
     * @param {!Array|string=} opt_message The assertion message
     * @return {!Element} The value of shouldBeTrueish.
     * @template T
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertElement",
    value: function assertElement(shouldBeElement, opt_message) {
      var shouldBeTrueish = shouldBeElement && shouldBeElement.nodeType == 1;
      this.assertType_(shouldBeElement, shouldBeTrueish, 'Element expected', opt_message);
      return (
        /** @type {!Element} */
        shouldBeElement
      );
    }
    /**
     * Throws an error if the first argument isn't a string. The string can
     * be empty.
     *
     * For more details see `assert`.
     *
     * @param {*} shouldBeString
     * @param {!Array|string=} opt_message The assertion message
     * @return {string} The string value. Can be an empty string.
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertString",
    value: function assertString(shouldBeString, opt_message) {
      this.assertType_(shouldBeString, typeof shouldBeString == 'string', 'String expected', opt_message);
      return (
        /** @type {string} */
        shouldBeString
      );
    }
    /**
     * Throws an error if the first argument isn't a number. The allowed values
     * include `0` and `NaN`.
     *
     * For more details see `assert`.
     *
     * @param {*} shouldBeNumber
     * @param {!Array|string=} opt_message The assertion message
     * @return {number} The number value. The allowed values include `0`
     *   and `NaN`.
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertNumber",
    value: function assertNumber(shouldBeNumber, opt_message) {
      this.assertType_(shouldBeNumber, typeof shouldBeNumber == 'number', 'Number expected', opt_message);
      return (
        /** @type {number} */
        shouldBeNumber
      );
    }
    /**
     * Throws an error if the first argument is not an array.
     * The array can be empty.
     *
     * @param {*} shouldBeArray
     * @param {!Array|string=} opt_message The assertion message
     * @return {!Array} The array value
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertArray",
    value: function assertArray(shouldBeArray, opt_message) {
      this.assertType_(shouldBeArray, (0, _types.isArray)(shouldBeArray), 'Array expected', opt_message);
      return (
        /** @type {!Array} */
        shouldBeArray
      );
    }
    /**
     * Throws an error if the first argument isn't a boolean.
     *
     * For more details see `assert`.
     *
     * @param {*} shouldBeBoolean
     * @param {!Array|string=} opt_message The assertion message
     * @return {boolean} The boolean value.
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertBoolean",
    value: function assertBoolean(shouldBeBoolean, opt_message) {
      this.assertType_(shouldBeBoolean, !!shouldBeBoolean === shouldBeBoolean, 'Boolean expected', opt_message);
      return (
        /** @type {boolean} */
        shouldBeBoolean
      );
    }
    /**
     * Asserts and returns the enum value. If the enum doesn't contain such a
     * value, the error is thrown.
     *
     * @param {!Object<T>} enumObj
     * @param {string} s
     * @param {string=} opt_enumName
     * @return {T}
     * @template T
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertEnumValue",
    value: function assertEnumValue(enumObj, s, opt_enumName) {
      if ((0, _types.isEnumValue)(enumObj, s)) {
        return s;
      }

      this.assert(false, 'Unknown %s value: "%s"', opt_enumName || 'enum', s);
    }
    /**
     * @param {!Error} error
     * @private
     */

  }, {
    key: "prepareError_",
    value: function prepareError_(error) {
      error = duplicateErrorIfNecessary(error);

      if (this.suffix_) {
        if (!error.message) {
          error.message = this.suffix_;
        } else if (error.message.indexOf(this.suffix_) == -1) {
          error.message += this.suffix_;
        }
      } else if (isUserErrorMessage(error.message)) {
        error.message = error.message.replace(USER_ERROR_SENTINEL, '');
      }
    }
    /**
     * @param {!Array} args
     * @return {!Array}
     * @private
     */

  }, {
    key: "maybeExpandMessageArgs_",
    value: function maybeExpandMessageArgs_(args) {
      if ((0, _types.isArray)(args[0])) {
        return this.expandMessageArgs_(
        /** @type {!Array} */
        args[0]);
      }

      return args;
    }
    /**
     * Either redirects a pair of (errorId, ...args) to a URL where the full
     * message is displayed, or displays it from a fetched table.
     *
     * This method is used by the output of the `transform-log-methods` babel
     * plugin. It should not be used directly. Use the (*error|assert*|info|warn)
     * methods instead.
     *
     * @param {!Array} parts
     * @return {!Array}
     * @private
     */

  }, {
    key: "expandMessageArgs_",
    value: function expandMessageArgs_(parts) {
      // First value should exist.
      var id = parts.shift();

      // Best effort fetch of message template table.
      // Since this is async, the first few logs might be indirected to a URL even
      // if in development mode. Message table is ~small so this should be a short
      // gap.
      if ((0, _mode.getMode)(this.win).development) {
        this.fetchExternalMessagesOnce_();
      }

      if (this.messages_ && id in this.messages_) {
        return [this.messages_[id]].concat(parts);
      }

      return ["More info at " + externalMessageUrl(id, parts)];
    }
    /**
     * Asserts types, backbone of `assertNumber`, `assertString`, etc.
     *
     * It understands array-based "id"-contracted messages.
     *
     * Otherwise creates a sprintf syntax string containing the optional message or the
     * default. An interpolation token is added at the end to include the `subject`.
     * @param {*} subject
     * @param {*} assertion
     * @param {string} defaultMessage
     * @param {!Array|string=} opt_message
     * @private
     */

  }, {
    key: "assertType_",
    value: function assertType_(subject, assertion, defaultMessage, opt_message) {
      if ((0, _types.isArray)(opt_message)) {
        this.assert(assertion, opt_message.concat(subject));
      } else {
        this.assert(assertion, (opt_message || defaultMessage) + ": %s", subject);
      }
    }
  }]);

  return Log;
}();

exports.Log = Log;

/**
 * @param {string|!Element} val
 * @return {string}
 */
var stringOrElementString = function stringOrElementString(val) {
  return (
    /** @type {string} */
    elementStringOrPassthru(val)
  );
};

/**
 * @param {*} val
 * @return {*}
 */
function elementStringOrPassthru(val) {
  // Do check equivalent to `val instanceof Element` without cross-window bug
  if (val && val.nodeType == 1) {
    return val.tagName.toLowerCase() + (val.id ? '#' + val.id : '');
  }

  return val;
}

/**
 * @param {!Array} array
 * @param {*} val
 */
function pushIfNonEmpty(array, val) {
  if (val != '') {
    array.push(val);
  }
}

/**
 * Some exceptions (DOMException, namely) have read-only message.
 * @param {!Error} error
 * @return {!Error};
 */
function duplicateErrorIfNecessary(error) {
  var messageProperty = Object.getOwnPropertyDescriptor(error, 'message');

  if (messageProperty && messageProperty.writable) {
    return error;
  }

  var message = error.message,
      stack = error.stack;
  var e = new Error(message);

  // Copy all the extraneous things we attach.
  for (var prop in error) {
    e[prop] = error[prop];
  }

  // Ensure these are copied.
  e.stack = stack;
  return e;
}

/**
 * @param {...*} var_args
 * @return {!Error}
 * @visibleForTesting
 */
function createErrorVargs(var_args) {
  var error = null;
  var message = '';

  for (var i = 0; i < arguments.length; i++) {
    var arg = arguments[i];

    if (arg instanceof Error && !error) {
      error = duplicateErrorIfNecessary(arg);
    } else {
      if (message) {
        message += ' ';
      }

      message += arg;
    }
  }

  if (!error) {
    error = new Error(message);
  } else if (message) {
    error.message = message + ': ' + error.message;
  }

  return error;
}

/**
 * Rethrows the error without terminating the current context. This preserves
 * whether the original error designation is a user error or a dev error.
 * @param {...*} var_args
 */
function rethrowAsync(var_args) {
  var error = createErrorVargs.apply(null, arguments);
  setTimeout(function () {
    // reportError is installed globally per window in the entry point.
    self.__AMP_REPORT_ERROR(error);

    throw error;
  });
}

/**
 * Cache for logs. We do not use a Service since the service module depends
 * on Log and closure literally can't even.
 * @type {{user: ?Log, dev: ?Log, userForEmbed: ?Log}}
 */
self.__AMP_LOG = self.__AMP_LOG || {
  user: null,
  dev: null,
  userForEmbed: null
};
var logs = self.__AMP_LOG;

/**
 * Eventually holds a constructor for Log objects. Lazily initialized, so we
 * can avoid ever referencing the real constructor except in JS binaries
 * that actually want to include the implementation.
 * @type {?typeof Log}
 */
var logConstructor = null;

/**
 * Initializes log constructor.
 */
function initLogConstructor() {
  logConstructor = Log;
  // Initialize instances for use. If a binary (an extension for example) that
  // does not call `initLogConstructor` invokes `dev()` or `user()` earlier than
  // the binary that does call `initLogConstructor` (amp.js), the extension will
  // throw an error as that extension will never be able to initialize the log
  // instances and we also don't want it to call `initLogConstructor` either
  // (since that will cause the Log implementation to be bundled into that
  // binary). So we must initialize the instances eagerly so that they are ready
  // for use (stored globally) after the main binary calls `initLogConstructor`.
  dev();
  user();
}

/**
 * Resets log constructor for testing.
 */
function resetLogConstructorForTesting() {
  logConstructor = null;
}

/**
 * Publisher level log.
 *
 * Enabled in the following conditions:
 *  1. Not disabled using `#log=0`.
 *  2. Development mode is enabled via `#development=1` or logging is explicitly
 *     enabled via `#log=D` where D >= 1.
 *  3. AMP.setLogLevel(D) is called, where D >= 1.
 *
 * @param {!Element=} opt_element
 * @return {!Log}
 */
function user(opt_element) {
  if (!logs.user) {
    logs.user = getUserLogger(USER_ERROR_SENTINEL);
  }

  if (!isFromEmbed(logs.user.win, opt_element)) {
    return logs.user;
  } else {
    if (logs.userForEmbed) {
      return logs.userForEmbed;
    }

    return logs.userForEmbed = getUserLogger(USER_ERROR_EMBED_SENTINEL);
  }
}

/**
 * Getter for user logger
 * @param {string=} suffix
 * @return {!Log}
 */
function getUserLogger(suffix) {
  if (!logConstructor) {
    throw new Error('failed to call initLogConstructor');
  }

  return new logConstructor(self, function (logNum, development) {
    if (development || logNum >= 1) {
      return LogLevel.FINE;
    }

    return LogLevel.WARN;
  }, suffix);
}

/**
 * AMP development log. Calls to `devLog().assert` and `dev.fine` are stripped
 * in the PROD binary. However, `devLog().assert` result is preserved in either
 * case.
 *
 * Enabled in the following conditions:
 *  1. Not disabled using `#log=0`.
 *  2. Logging is explicitly enabled via `#log=D`, where D >= 2.
 *  3. AMP.setLogLevel(D) is called, where D >= 2.
 *
 * @return {!Log}
 */
function dev() {
  if (logs.dev) {
    return logs.dev;
  }

  if (!logConstructor) {
    throw new Error('failed to call initLogConstructor');
  }

  return logs.dev = new logConstructor(self, function (logNum) {
    if (logNum >= 3) {
      return LogLevel.FINE;
    }

    if (logNum >= 2) {
      return LogLevel.INFO;
    }

    return LogLevel.OFF;
  });
}

/**
 * @param {!Window} win
 * @param {!Element=} opt_element
 * @return {boolean} isEmbed
 */
function isFromEmbed(win, opt_element) {
  if (!opt_element) {
    return false;
  }

  return opt_element.ownerDocument.defaultView != win;
}

/**
 * Throws an error if the first argument isn't trueish.
 *
 * Supports argument substitution into the message via %s placeholders.
 *
 * Throws an error object that has two extra properties:
 * - associatedElement: This is the first element provided in the var args.
 *   It can be used for improved display of error messages.
 * - messageArray: The elements of the substituted message as non-stringified
 *   elements in an array. When e.g. passed to console.error this yields
 *   native displays of things like HTML elements.
 *
 * @param {T} shouldBeTrueish The value to assert. The assert fails if it does
 *     not evaluate to true.
 * @param {!Array|string=} opt_message The assertion message
 * @param {*=} opt_1 Optional argument (Var arg as individual params for better
 * @param {*=} opt_2 Optional argument inlining)
 * @param {*=} opt_3 Optional argument
 * @param {*=} opt_4 Optional argument
 * @param {*=} opt_5 Optional argument
 * @param {*=} opt_6 Optional argument
 * @param {*=} opt_7 Optional argument
 * @param {*=} opt_8 Optional argument
 * @param {*=} opt_9 Optional argument
 * @return {T} The value of shouldBeTrueish.
 * @throws {!Error} When `shouldBeTrueish` is falsey.
 * @template T
 * @closurePrimitive {asserts.truthy}
 */
function devAssert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9) {
  if ((0, _mode.getMode)().minified) {
    return shouldBeTrueish;
  }

  return dev().
  /*Orig call*/
  assert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9);
}

/**
 * Throws an error if the first argument isn't trueish.
 *
 * Supports argument substitution into the message via %s placeholders.
 *
 * Throws an error object that has two extra properties:
 * - associatedElement: This is the first element provided in the var args.
 *   It can be used for improved display of error messages.
 * - messageArray: The elements of the substituted message as non-stringified
 *   elements in an array. When e.g. passed to console.error this yields
 *   native displays of things like HTML elements.
 *
 * @param {T} shouldBeTrueish The value to assert. The assert fails if it does
 *     not evaluate to true.
 * @param {!Array|string=} opt_message The assertion message
 * @param {*=} opt_1 Optional argument (Var arg as individual params for better
 * @param {*=} opt_2 Optional argument inlining)
 * @param {*=} opt_3 Optional argument
 * @param {*=} opt_4 Optional argument
 * @param {*=} opt_5 Optional argument
 * @param {*=} opt_6 Optional argument
 * @param {*=} opt_7 Optional argument
 * @param {*=} opt_8 Optional argument
 * @param {*=} opt_9 Optional argument
 * @return {T} The value of shouldBeTrueish.
 * @throws {!Error} When `shouldBeTrueish` is falsey.
 * @template T
 * @closurePrimitive {asserts.truthy}
 */
function userAssert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9) {
  return user().
  /*Orig call*/
  assert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9);
}

},{"./config":17,"./internal-version":25,"./mode":29,"./types":37,"./utils/function":42}],29:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getMode = getMode;
exports.getRtvVersionForTesting = getRtvVersionForTesting;
exports.resetRtvVersionForTesting = resetRtvVersionForTesting;
exports.ModeDef = void 0;

var _internalVersion = require("./internal-version");

var _urlParseQueryString = require("./url-parse-query-string");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @typedef {{
 *   localDev: boolean,
 *   development: boolean,
 *   minified: boolean,
 *   lite: boolean,
 *   test: boolean,
 *   log: (string|undefined),
 *   version: string,
 *   rtvVersion: string,
 *   runtime: (null|string|undefined),
 *   a4aId: (null|string|undefined),
 *   esm: (boolean|undefined)
 * }}
 */
var ModeDef;
exports.ModeDef = ModeDef;

/**
 * `rtvVersion` is the prefixed version we serve off of the cdn.
 * The prefix denotes canary(00) or prod(01) or an experiment version ( > 01).
 * @type {string}
 */
var rtvVersion = '';

/**
 * Provides info about the current app.
 * @param {?Window=} opt_win
 * @return {!ModeDef}
 */
function getMode(opt_win) {
  var win = opt_win || self;

  if (win.__AMP_MODE) {
    return win.__AMP_MODE;
  }

  return win.__AMP_MODE = getMode_(win);
}

/**
 * Provides info about the current app.
 * @param {!Window} win
 * @return {!ModeDef}
 */
function getMode_(win) {
  // TODO(erwinmombay): simplify the logic here
  var AMP_CONFIG = self.AMP_CONFIG || {};
  // Magic constants that are replaced by closure compiler.
  // IS_MINIFIED is always replaced with true when closure compiler is used
  // while IS_DEV is only replaced when `gulp dist` is called without the
  // --fortesting flag.
  var IS_DEV = true;
  var IS_MINIFIED = false;
  var runningTests = IS_DEV && !!(AMP_CONFIG.test || win.__AMP_TEST || win.__karma__);
  var isLocalDev = IS_DEV && (!!AMP_CONFIG.localDev || runningTests);
  var hashQuery = (0, _urlParseQueryString.parseQueryString_)( // location.originalHash is set by the viewer when it removes the fragment
  // from the URL.
  win.location.originalHash || win.location.hash);
  var searchQuery = (0, _urlParseQueryString.parseQueryString_)(win.location.search);

  if (!rtvVersion) {
    rtvVersion = getRtvVersion(win);
  }

  // The `minified`, `test` and `localDev` properties are replaced
  // as boolean literals when we run `gulp dist` without the `--fortesting`
  // flags. This improved DCE on the production file we deploy as the code
  // paths for localhost/testing/development are eliminated.
  return {
    localDev: isLocalDev,
    // Triggers validation or enable pub level logging. Validation can be
    // bypassed via #validate=0.
    // Note that AMP_DEV_MODE flag is used for testing purposes.
    // Use Array.indexOf instead of Array.includes because of #24219
    development: !!(['1', 'actions', 'amp', 'amp4ads', 'amp4email'].indexOf(hashQuery['development']) >= 0 || win.AMP_DEV_MODE),
    examiner: hashQuery['development'] == '2',
    esm: false,
    // amp-geo override
    geoOverride: hashQuery['amp-geo'],
    minified: IS_MINIFIED,
    // Whether document is in an amp-lite viewer. It signal that the user
    // would prefer to use less bandwidth.
    lite: searchQuery['amp_lite'] != undefined,
    test: runningTests,
    log: hashQuery['log'],
    version: (0, _internalVersion.internalRuntimeVersion)(),
    rtvVersion: rtvVersion
  };
}

/**
 * Retrieve the `rtvVersion` which will have a numeric prefix
 * denoting canary/prod/experiment (unless `isLocalDev` is true).
 *
 * @param {!Window} win
 * @return {string}
 */
function getRtvVersion(win) {
  if (win.AMP_CONFIG && win.AMP_CONFIG.v) {
    return win.AMP_CONFIG.v;
  }

  // Currently `internalRuntimeVersion` and thus `mode.version` contain only
  // major version. The full version however must also carry the minor version.
  // We will default to production default `01` minor version for now.
  // TODO(erwinmombay): decide whether internalRuntimeVersion should contain
  // minor version.
  return "01" + (0, _internalVersion.internalRuntimeVersion)();
}

/**
 * @param {!Window} win
 * @return {string}
 * @visibleForTesting
 */
function getRtvVersionForTesting(win) {
  return getRtvVersion(win);
}

/** @visibleForTesting */
function resetRtvVersionForTesting() {
  rtvVersion = '';
}

},{"./internal-version":25,"./url-parse-query-string":38}],30:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Observable = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * This class helps to manage observers. Observers can be added, removed or
 * fired through and instance of this class.
 * @template TYPE
 */
var Observable = /*#__PURE__*/function () {
  /**
   * Creates an instance of Observable.
   */
  function Observable() {
    _classCallCheck(this, Observable);

    /** @type {?Array<function(TYPE)>} */
    this.handlers_ = null;
  }

  /**
   * Adds the observer to this instance.
   * @param {function(TYPE)} handler Observer's handler.
   * @return {!UnlistenDef}
   */
  _createClass(Observable, [{
    key: "add",
    value: function add(handler) {
      var _this = this;

      if (!this.handlers_) {
        this.handlers_ = [];
      }

      this.handlers_.push(handler);
      return function () {
        _this.remove(handler);
      };
    }
    /**
     * Removes the observer from this instance.
     * @param {function(TYPE)} handler Observer's instance.
     */

  }, {
    key: "remove",
    value: function remove(handler) {
      if (!this.handlers_) {
        return;
      }

      var index = this.handlers_.indexOf(handler);

      if (index > -1) {
        this.handlers_.splice(index, 1);
      }
    }
    /**
     * Removes all observers.
     */

  }, {
    key: "removeAll",
    value: function removeAll() {
      if (!this.handlers_) {
        return;
      }

      this.handlers_.length = 0;
    }
    /**
     * Fires an event. All observers are called.
     * @param {TYPE=} opt_event
     */

  }, {
    key: "fire",
    value: function fire(opt_event) {
      if (!this.handlers_) {
        return;
      }

      var handlers = this.handlers_;

      for (var i = 0; i < handlers.length; i++) {
        var handler = handlers[i];
        handler(opt_event);
      }
    }
    /**
     * Returns number of handlers. Mostly needed for tests.
     * @return {number}
     */

  }, {
    key: "getHandlerCount",
    value: function getHandlerCount() {
      if (!this.handlers_) {
        return 0;
      }

      return this.handlers_.length;
    }
  }]);

  return Observable;
}();

exports.Observable = Observable;

},{}],31:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Pass = void 0;

var _services = require("./services");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Pass class helps to manage single-pass process. A pass is scheduled using
 * delay method. Only one pass can be pending at a time. If no pass is pending
 * the process is considered to be "idle".
 */
var Pass = /*#__PURE__*/function () {
  /**
   * Creates a new Pass instance.
   * @param {!Window} win
   * @param {function()} handler Handler to be executed when pass is triggered.
   * @param {number=} opt_defaultDelay Default delay to be used when schedule
   *   is called without one.
   */
  function Pass(win, handler, opt_defaultDelay) {
    var _this = this;

    _classCallCheck(this, Pass);

    this.timer_ = _services.Services.timerFor(win);

    /** @private @const {function()} */
    this.handler_ = handler;

    /** @private @const {number} */
    this.defaultDelay_ = opt_defaultDelay || 0;

    /** @private {number|string} */
    this.scheduled_ = -1;

    /** @private {number} */
    this.nextTime_ = 0;

    /** @private {boolean} */
    this.running_ = false;

    /**
     * @private
     * @const {function()}
     */
    this.boundPass_ = function () {
      _this.pass_();
    };
  }

  /**
   * Whether or not a pass is currently pending.
   * @return {boolean}
   */
  _createClass(Pass, [{
    key: "isPending",
    value: function isPending() {
      return this.scheduled_ != -1;
    }
    /**
     * Tries to schedule a new pass optionally with specified delay. If the new
     * requested pass is requested before the pending pass, the pending pass is
     * canceled. If the new pass is requested after the pending pass, the newly
     * requested pass is ignored.
     *
     * Returns {@code true} if the pass has been scheduled and {@code false} if
     * ignored.
     *
     * @param {number=} opt_delay Delay to schedule the pass. If not specified
     *   the default delay is used, falling back to 0.
     * @return {boolean}
     */

  }, {
    key: "schedule",
    value: function schedule(opt_delay) {
      var delay = opt_delay || this.defaultDelay_;

      if (this.running_ && delay < 10) {
        // If we get called recursively, wait at least 10ms for the next
        // execution.
        delay = 10;
      }

      var nextTime = Date.now() + delay;

      // Schedule anew if nothing is scheduled currently or if the new time is
      // sooner then previously requested.
      if (!this.isPending() || nextTime - this.nextTime_ < -10) {
        this.cancel();
        this.nextTime_ = nextTime;
        this.scheduled_ = this.timer_.delay(this.boundPass_, delay);
        return true;
      }

      return false;
    }
    /**
     *
     */

  }, {
    key: "pass_",
    value: function pass_() {
      this.scheduled_ = -1;
      this.nextTime_ = 0;
      this.running_ = true;
      this.handler_();
      this.running_ = false;
    }
    /**
     * Cancels the pending pass if any.
     */

  }, {
    key: "cancel",
    value: function cancel() {
      if (this.isPending()) {
        this.timer_.cancel(this.scheduled_);
        this.scheduled_ = -1;
      }
    }
  }]);

  return Pass;
}();

exports.Pass = Pass;

},{"./services":34}],32:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.resolvedPromise = resolvedPromise;

/**
 * Copyright 2020 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var resolved;

/**
 * Returns a cached resolved promise.
 * Use this instead of directly calling Promise.resolve().
 * @return {!Promise<undefined>}
 */
function resolvedPromise() {
  if (resolved) {
    return resolved;
  }

  // It's important that we call with `undefined` here, to prevent a transform
  // recursion. If we didn't pass an arg, then the transformer would replace
  // this callsite with a call to `resolvedPromise()`.
  resolved = Promise.resolve(undefined);
  return resolved;
}

},{}],33:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getExistingServiceForDocInEmbedScope = getExistingServiceForDocInEmbedScope;
exports.installServiceInEmbedScope = installServiceInEmbedScope;
exports.registerServiceBuilder = registerServiceBuilder;
exports.registerServiceBuilderForDoc = registerServiceBuilderForDoc;
exports.rejectServicePromiseForDoc = rejectServicePromiseForDoc;
exports.getService = getService;
exports.getServicePromise = getServicePromise;
exports.getExistingServiceOrNull = getExistingServiceOrNull;
exports.getServicePromiseOrNull = getServicePromiseOrNull;
exports.getServiceForDoc = getServiceForDoc;
exports.getServicePromiseForDoc = getServicePromiseForDoc;
exports.getServicePromiseOrNullForDoc = getServicePromiseOrNullForDoc;
exports.setParentWindow = setParentWindow;
exports.getParentWindow = getParentWindow;
exports.getTopWindow = getTopWindow;
exports.getParentWindowFrameElement = getParentWindowFrameElement;
exports.getAmpdoc = getAmpdoc;
exports.isDisposable = isDisposable;
exports.assertDisposable = assertDisposable;
exports.disposeServicesForDoc = disposeServicesForDoc;
exports.disposeServicesForEmbed = disposeServicesForEmbed;
exports.installServiceInEmbedIfEmbeddable = installServiceInEmbedIfEmbeddable;
exports.adoptServiceForEmbedDoc = adoptServiceForEmbedDoc;
exports.resetServiceForTesting = resetServiceForTesting;
exports.EmbeddableService = exports.Disposable = void 0;

var _promise = require("./utils/promise");

var _log = require("./log");

var _ampdocFie = require("./ampdoc-fie");

var _types = require("./types");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Holds info about a service.
 * - obj: Actual service implementation when available.
 * - promise: Promise for the obj.
 * - resolve: Function to resolve the promise with the object.
 * - context: Argument for ctor, either a window or an ampdoc.
 * - ctor: Function that constructs and returns the service.
 * @typedef {{
 *   obj: (?Object),
 *   promise: (?Promise),
 *   resolve: (?function(!Object)),
 *   reject: (?function((*))),
 *   context: (?Window|?./service/ampdoc-impl.AmpDoc),
 *   ctor: (?function(new:Object, !Window)|
 *          ?function(new:Object, !./service/ampdoc-impl.AmpDoc)),
 * }}
 */
var ServiceHolderDef;

/**
 * This interface provides a `dispose` method that will be called by
 * runtime when a service needs to be disposed of.
 * @interface
 */
var Disposable = /*#__PURE__*/function () {
  function Disposable() {
    _classCallCheck(this, Disposable);
  }

  _createClass(Disposable, [{
    key: "dispose",

    /**
     * Instructs the service to release any resources it might be holding. Can
     * be called only once in the lifecycle of a service.
     */
    value: function dispose() {}
  }]);

  return Disposable;
}();

exports.Disposable = Disposable;

/**
 * Services must implement this interface to be embeddable in FIEs.
 * @interface
 */
var EmbeddableService = /*#__PURE__*/function () {
  function EmbeddableService() {
    _classCallCheck(this, EmbeddableService);
  }

  _createClass(EmbeddableService, null, [{
    key: "installInEmbedWindow",

    /**
     * Installs a new instance of the service in the given FIE window.
     * @param {!Window} unusedEmbedWin
     * @param {!./service/ampdoc-impl.AmpDoc} unusedAmpDoc
     */
    value: function installInEmbedWindow(unusedEmbedWin, unusedAmpDoc) {}
  }]);

  return EmbeddableService;
}();

exports.EmbeddableService = EmbeddableService;

/**
 * Returns a service with the given id. Assumes that it has been constructed
 * already.
 *
 * @param {!Element|!ShadowRoot} element
 * @param {string} id
 * @return {?Object}
 */
function getExistingServiceForDocInEmbedScope(element, id) {
  // TODO(#22733): completely remove this method once ampdoc-fie launches.
  var document = element.ownerDocument;
  var win = (0, _types.toWin)(document.defaultView);
  var topWin = getTopWindow(win);
  // First, try to resolve via local embed window (if applicable).
  var isEmbed = win != topWin;
  var ampdocFieExperimentOn = (0, _ampdocFie.isInAmpdocFieExperiment)(topWin);

  if (isEmbed && !ampdocFieExperimentOn) {
    if (isServiceRegistered(win, id)) {
      return getServiceInternal(win, id);
    }

    // Fallback from FIE to parent is intentionally unsupported for safety.
    return null;
  } else {
    // Resolve via the element's ampdoc.
    return getServiceForDocOrNullInternal(element, id);
  }
}

/**
 * Installs a service override on amp-doc level.
 * @param {!Window} embedWin
 * @param {string} id
 * @param {!Object} service The service.
 */
function installServiceInEmbedScope(embedWin, id, service) {
  var topWin = getTopWindow(embedWin);
  (0, _log.devAssert)(embedWin != topWin, 'Service override can only be installed in embed window: %s', id);
  (0, _log.devAssert)(!isServiceRegistered(embedWin, id), 'Service override has already been installed: %s', id);
  var ampdocFieExperimentOn = (0, _ampdocFie.isInAmpdocFieExperiment)(topWin);

  if (ampdocFieExperimentOn) {
    var ampdoc = getAmpdoc(embedWin.document);
    registerServiceInternal(getAmpdocServiceHolder(ampdoc), ampdoc, id, function () {
      return service;
    },
    /* override */
    true);
  } else {
    registerServiceInternal(embedWin, embedWin, id, function () {
      return service;
    });
    getServiceInternal(embedWin, id);
  }
}

/**
 * Registers a service given a class to be used as implementation.
 * @param {!Window} win
 * @param {string} id of the service.
 * @param {function(new:Object, !Window)} constructor
 * @param {boolean=} opt_instantiate Whether to immediately create the service
 */
function registerServiceBuilder(win, id, constructor, opt_instantiate) {
  win = getTopWindow(win);
  registerServiceInternal(win, win, id, constructor);

  if (opt_instantiate) {
    getServiceInternal(win, id);
  }
}

/**
 * Returns a service and registers it given a class to be used as
 * implementation.
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @param {string} id of the service.
 * @param {function(new:Object, !./service/ampdoc-impl.AmpDoc)} constructor
 * @param {boolean=} opt_instantiate Whether to immediately create the service
 */
function registerServiceBuilderForDoc(nodeOrDoc, id, constructor, opt_instantiate) {
  var ampdoc = getAmpdoc(nodeOrDoc);
  var holder = getAmpdocServiceHolder(ampdoc);
  registerServiceInternal(holder, ampdoc, id, constructor);

  if (opt_instantiate) {
    getServiceInternal(holder, id);
  }
}

/**
 * Reject a service promise.
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @param {string} id
 * @param {*} error
 */
function rejectServicePromiseForDoc(nodeOrDoc, id, error) {
  var ampdoc = getAmpdoc(nodeOrDoc);
  var holder = getAmpdocServiceHolder(ampdoc);
  rejectServicePromiseInternal(holder, id, error);
}

/**
 * Returns a service for the given id and window (a per-window singleton). Users
 * should typically wrap this as a special purpose function (e.g.
 * `Services.vsyncFor(win)`) for type safety and because the factory should not
 * be passed around.
 * @param {!Window} win
 * @param {string} id of the service.
 * @template T
 * @return {T}
 */
function getService(win, id) {
  win = getTopWindow(win);
  return getServiceInternal(win, id);
}

/**
 * Returns a promise for a service for the given id and window. Also expects an
 * element that has the actual implementation. The promise resolves when the
 * implementation loaded. Users should typically wrap this as a special purpose
 * function (e.g. `Services.vsyncFor(win)`) for type safety and because the
 * factory should not be passed around.
 * @param {!Window} win
 * @param {string} id of the service.
 * @return {!Promise<!Object>}
 */
function getServicePromise(win, id) {
  return getServicePromiseInternal(win, id);
}

/**
 * Returns a service or null with the given id.
 * @param {!Window} win
 * @param {string} id
 * @return {?Object} The service.
 */
function getExistingServiceOrNull(win, id) {
  win = getTopWindow(win);

  if (isServiceRegistered(win, id)) {
    return getServiceInternal(win, id);
  } else {
    return null;
  }
}

/**
 * Like getServicePromise but returns null if the service was never registered.
 * @param {!Window} win
 * @param {string} id
 * @return {?Promise<!Object>}
 */
function getServicePromiseOrNull(win, id) {
  return getServicePromiseOrNullInternal(win, id);
}

/**
 * Returns a service for the given id and ampdoc (a per-ampdoc singleton).
 * Expects service `id` to be registered.
 * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
 * @param {string} id
 * @return {T}
 * @template T
 */
function getServiceForDoc(elementOrAmpDoc, id) {
  var ampdoc = getAmpdoc(elementOrAmpDoc);
  var holder = getAmpdocServiceHolder(ampdoc);
  return getServiceInternal(holder, id);
}

/**
 * Returns a service for the given id and ampdoc (a per-ampdoc singleton).
 * If service `id` is not registered, returns null.
 * @param {!Element|!ShadowRoot} element
 * @param {string} id
 * @return {?Object}
 */
function getServiceForDocOrNullInternal(element, id) {
  var ampdoc = getAmpdoc(element);
  var holder = getAmpdocServiceHolder(ampdoc);

  if (isServiceRegistered(holder, id)) {
    return getServiceInternal(holder, id);
  } else {
    return null;
  }
}

/**
 * Returns a promise for a service for the given id and ampdoc. Also expects
 * a service that has the actual implementation. The promise resolves when
 * the implementation loaded.
 * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
 * @param {string} id
 * @return {!Promise<!Object>}
 */
function getServicePromiseForDoc(elementOrAmpDoc, id) {
  return getServicePromiseInternal(getAmpdocServiceHolder(elementOrAmpDoc), id);
}

/**
 * Like getServicePromiseForDoc but returns null if the service was never
 * registered for this ampdoc.
 * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
 * @param {string} id
 * @return {?Promise<!Object>}
 */
function getServicePromiseOrNullForDoc(elementOrAmpDoc, id) {
  return getServicePromiseOrNullInternal(getAmpdocServiceHolder(elementOrAmpDoc), id);
}

/**
 * Set the parent and top windows on a child window (friendly iframe).
 * @param {!Window} win
 * @param {!Window} parentWin
 */
function setParentWindow(win, parentWin) {
  win.__AMP_PARENT = parentWin;
  win.__AMP_TOP = getTopWindow(parentWin);
}

/**
 * Returns the parent window for a child window (friendly iframe).
 * @param {!Window} win
 * @return {!Window}
 */
function getParentWindow(win) {
  return win.__AMP_PARENT || win;
}

/**
 * Returns the top window where AMP Runtime is installed for a child window
 * (friendly iframe).
 * @param {!Window} win
 * @return {!Window}
 */
function getTopWindow(win) {
  return win.__AMP_TOP || (win.__AMP_TOP = win);
}

/**
 * Returns the parent "friendly" iframe if the node belongs to a child window.
 * @param {!Node} node
 * @param {!Window=} opt_topWin
 * @return {?HTMLIFrameElement}
 */
function getParentWindowFrameElement(node, opt_topWin) {
  var childWin = (node.ownerDocument || node).defaultView;
  var topWin = opt_topWin || getTopWindow(childWin);

  if (childWin && childWin != topWin && getTopWindow(childWin) == topWin) {
    try {
      return (
        /** @type {?HTMLIFrameElement} */
        childWin.frameElement
      );
    } catch (e) {// Ignore the error.
    }
  }

  return null;
}

/**
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @return {!./service/ampdoc-impl.AmpDoc}
 */
function getAmpdoc(nodeOrDoc) {
  if (nodeOrDoc.nodeType) {
    var win = (0, _types.toWin)(
    /** @type {!Document} */
    (nodeOrDoc.ownerDocument || nodeOrDoc).defaultView);
    return getAmpdocService(win).getAmpDoc(
    /** @type {!Node} */
    nodeOrDoc);
  }

  return (
    /** @type {!./service/ampdoc-impl.AmpDoc} */
    nodeOrDoc
  );
}

/**
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @return {!./service/ampdoc-impl.AmpDoc|!Window}
 */
function getAmpdocServiceHolder(nodeOrDoc) {
  var ampdoc = getAmpdoc(nodeOrDoc);
  return ampdoc.isSingleDoc() ? ampdoc.win : ampdoc;
}

/**
 * This is essentially a duplicate of `ampdoc.js`, but necessary to avoid
 * circular dependencies.
 * @param {!Window} win
 * @return {!./service/ampdoc-impl.AmpDocService}
 */
function getAmpdocService(win) {
  return (
    /** @type {!./service/ampdoc-impl.AmpDocService} */
    getService(win, 'ampdoc')
  );
}

/**
 * Get service `id` from `holder`. Assumes the service
 * has already been registered.
 * @param {!Object} holder Object holding the service instance.
 * @param {string} id of the service.
 * @return {Object}
 * @template T
 */
function getServiceInternal(holder, id) {
  (0, _log.devAssert)(isServiceRegistered(holder, id), "Expected service " + id + " to be registered");
  var services = getServices(holder);
  var s = services[id];

  if (!s.obj) {
    (0, _log.devAssert)(s.ctor, "Service " + id + " registered without ctor nor impl.");
    (0, _log.devAssert)(s.context, "Service " + id + " registered without context.");
    s.obj = new s.ctor(s.context);
    (0, _log.devAssert)(s.obj, "Service " + id + " constructed to null.");
    s.ctor = null;
    s.context = null;

    // The service may have been requested already, in which case we have a
    // pending promise we need to fulfill.
    if (s.resolve) {
      s.resolve(s.obj);
    }
  }

  return s.obj;
}

/**
 * @param {!Object} holder Object holding the service instance.
 * @param {!Window|!./service/ampdoc-impl.AmpDoc} context Win or AmpDoc.
 * @param {string} id of the service.
 * @param {?function(new:Object, !Window)|?function(new:Object, !./service/ampdoc-impl.AmpDoc)} ctor Constructor function to new the service. Called with context.
 * @param {boolean=} opt_override
 */
function registerServiceInternal(holder, context, id, ctor, opt_override) {
  var services = getServices(holder);
  var s = services[id];

  if (!s) {
    s = services[id] = {
      obj: null,
      promise: null,
      resolve: null,
      reject: null,
      context: null,
      ctor: null
    };
  }

  if (!opt_override && (s.ctor || s.obj)) {
    // Service already registered.
    return;
  }

  s.ctor = ctor;
  s.context = context;

  // The service may have been requested already, in which case there is a
  // pending promise that needs to fulfilled.
  if (s.resolve) {
    // getServiceInternal will resolve the promise.
    getServiceInternal(holder, id);
  }
}

/**
 * @param {!Object} holder
 * @param {string} id of the service.
 * @return {!Promise<!Object>}
 */
function getServicePromiseInternal(holder, id) {
  var cached = getServicePromiseOrNullInternal(holder, id);

  if (cached) {
    return cached;
  }

  // Service is not registered.
  // TODO(@cramforce): Add a check that if the element is eventually registered
  // that the service is actually provided and this promise resolves.
  var services = getServices(holder);
  services[id] = emptyServiceHolderWithPromise();
  return (
    /** @type {!Promise<!Object>} */
    services[id].promise
  );
}

/**
 * @param {!Object} holder
 * @param {string} id of the service.
 * @param {*} error
 */
function rejectServicePromiseInternal(holder, id, error) {
  var services = getServices(holder);
  var s = services[id];

  if (s) {
    if (s.reject) {
      s.reject(error);
    }

    return;
  }

  services[id] = emptyServiceHolderWithPromise();
  services[id].reject(error);
}

/**
 * Returns a promise for service `id` if the service has been registered
 * on `holder`.
 * @param {!Object} holder
 * @param {string} id of the service.
 * @return {?Promise<!Object>}
 */
function getServicePromiseOrNullInternal(holder, id) {
  var services = getServices(holder);
  var s = services[id];

  if (s) {
    if (s.promise) {
      return s.promise;
    } else {
      // Instantiate service if not already instantiated.
      getServiceInternal(holder, id);
      return s.promise = Promise.resolve(
      /** @type {!Object} */
      s.obj);
    }
  }

  return null;
}

/**
 * Returns the object that holds the services registered in a holder.
 * @param {!Object} holder
 * @return {!Object<string,!ServiceHolderDef>}
 */
function getServices(holder) {
  var services = holder.__AMP_SERVICES;

  if (!services) {
    services = holder.__AMP_SERVICES = {};
  }

  return services;
}

/**
 * Whether the specified service implements `Disposable` interface.
 * @param {!Object} service
 * @return {boolean}
 */
function isDisposable(service) {
  return typeof service.dispose == 'function';
}

/**
 * Asserts that the specified service implements `Disposable` interface and
 * typecasts the instance to `Disposable`.
 * @param {!Object} service
 * @return {!Disposable}
 */
function assertDisposable(service) {
  (0, _log.devAssert)(isDisposable(service), 'required to implement Disposable');
  return (
    /** @type {!Disposable} */
    service
  );
}

/**
 * Disposes all disposable (implements `Disposable` interface) services in
 * ampdoc scope.
 * @param {!./service/ampdoc-impl.AmpDoc} ampdoc
 */
function disposeServicesForDoc(ampdoc) {
  disposeServicesInternal(ampdoc);
}

/**
 * Disposes all disposable (implements `Disposable` interface) services in
 * embed scope.
 * @param {!Window} embedWin
 */
function disposeServicesForEmbed(embedWin) {
  disposeServicesInternal(embedWin);
}

/**
 * @param {!Object} holder Object holding the service instances.
 */
function disposeServicesInternal(holder) {
  // TODO(dvoytenko): Consider marking holder as destroyed for later-arriving
  // service to be canceled automatically.
  var services = getServices(holder);

  var _loop = function _loop(id) {
    if (!Object.prototype.hasOwnProperty.call(services, id)) {
      return "continue";
    }

    var serviceHolder = services[id];

    if (serviceHolder.obj) {
      disposeServiceInternal(id, serviceHolder.obj);
    } else if (serviceHolder.promise) {
      serviceHolder.promise.then(function (instance) {
        return disposeServiceInternal(id, instance);
      });
    }
  };

  for (var id in services) {
    var _ret = _loop(id);

    if (_ret === "continue") continue;
  }
}

/**
 * @param {string} id
 * @param {!Object} service
 */
function disposeServiceInternal(id, service) {
  if (!isDisposable(service)) {
    return;
  }

  try {
    assertDisposable(service).dispose();
  } catch (e) {
    // Ensure that a failure to dispose a service does not disrupt other
    // services.
    (0, _log.dev)().error('SERVICE', 'failed to dispose service', id, e);
  }
}

/**
 * Adopts an embeddable (implements `EmbeddableService` interface) service
 * in embed scope.
 * @param {!Window} embedWin
 * @param {function(new:Object, !./service/ampdoc-impl.AmpDoc)} serviceClass
 * @suppress {missingProperties}
 * @return {boolean}
 */
function installServiceInEmbedIfEmbeddable(embedWin, serviceClass) {
  var isEmbeddableService = typeof serviceClass.installInEmbedWindow === 'function';

  if (!isEmbeddableService) {
    return false;
  }

  var frameElement = (0, _log.dev)().assertElement(embedWin.frameElement, 'frameElement not found for embed');
  var ampdoc = getAmpdoc(frameElement);
  serviceClass.installInEmbedWindow(embedWin, ampdoc);
  return true;
}

/**
 * @param {!./service/ampdoc-impl.AmpDoc} ampdoc
 * @param {string} id
 */
function adoptServiceForEmbedDoc(ampdoc, id) {
  var service = getServiceInternal(getAmpdocServiceHolder((0, _log.devAssert)(ampdoc.getParent())), id);
  registerServiceInternal(getAmpdocServiceHolder(ampdoc), ampdoc, id, function () {
    return service;
  });
}

/**
 * Resets a single service, so it gets recreated on next getService invocation.
 * @param {!Object} holder
 * @param {string} id of the service.
 */
function resetServiceForTesting(holder, id) {
  if (holder.__AMP_SERVICES) {
    holder.__AMP_SERVICES[id] = null;
  }
}

/**
 * @param {!Object} holder Object holding the service instance.
 * @param {string} id of the service.
 * @return {boolean}
 */
function isServiceRegistered(holder, id) {
  var service = holder.__AMP_SERVICES && holder.__AMP_SERVICES[id];
  // All registered services must have an implementation or a constructor.
  return !!(service && (service.ctor || service.obj));
}

/** @return {!ServiceHolderDef} */
function emptyServiceHolderWithPromise() {
  var deferred = new _promise.Deferred();
  var promise = deferred.promise,
      resolve = deferred.resolve,
      reject = deferred.reject;
  promise.catch(function () {});
  // avoid uncaught exception when service gets rejected
  return {
    obj: null,
    promise: promise,
    resolve: resolve,
    reject: reject,
    context: null,
    ctor: null
  };
}

},{"./ampdoc-fie":16,"./log":28,"./types":37,"./utils/promise":46}],34:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Services = exports.SubscriptionService = void 0;

var _service = require("./service");

var _elementService = require("./element-service");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @typedef {!../extensions/amp-subscriptions/0.1/amp-subscriptions.SubscriptionService} */
var SubscriptionService;
exports.SubscriptionService = SubscriptionService;

var Services = /*#__PURE__*/function () {
  function Services() {
    _classCallCheck(this, Services);
  }

  _createClass(Services, null, [{
    key: "accessServiceForDoc",

    /**
     * Hint: Add extensions folder path to compile.js with
     * warnings cannot find modules.
     */

    /**
     * Returns a promise for the Access service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-access/0.1/amp-access.AccessService>}
     */
    value: function accessServiceForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-access/0.1/amp-access.AccessService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'access', 'amp-access')
      );
    }
    /**
     * Returns a promise for the Access service or a promise for null if the
     * service is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-access/0.1/amp-access.AccessService>}
     */

  }, {
    key: "accessServiceForDocOrNull",
    value: function accessServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-access/0.1/amp-access.AccessService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'access', 'amp-access')
      );
    }
    /**
     * Returns a promise for the Subscriptions service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!SubscriptionService>}
     */

  }, {
    key: "subscriptionsServiceForDoc",
    value: function subscriptionsServiceForDoc(element) {
      return (
        /** @type {!Promise<!SubscriptionService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'subscriptions', 'amp-subscriptions')
      );
    }
    /**
     * Returns a promise for the Subscriptions service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?SubscriptionService>}
     */

  }, {
    key: "subscriptionsServiceForDocOrNull",
    value: function subscriptionsServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?SubscriptionService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'subscriptions', 'amp-subscriptions')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/action-impl.ActionService}
     */

  }, {
    key: "actionServiceForDoc",
    value: function actionServiceForDoc(element) {
      return (
        /** @type {!./service/action-impl.ActionService} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'action')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/standard-actions-impl.StandardActions}
     */

  }, {
    key: "standardActionsForDoc",
    value: function standardActionsForDoc(element) {
      return (
        /** @type {!./service/standard-actions-impl.StandardActions} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'standard-actions')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-analytics/0.1/activity-impl.Activity>}
     */

  }, {
    key: "activityForDoc",
    value: function activityForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-analytics/0.1/activity-impl.Activity>} */
        (0, _elementService.getElementServiceForDoc)(element, 'activity', 'amp-analytics')
      );
    }
    /**
     * Returns the global instance of the `AmpDocService` service that can be
     * used to resolve an ampdoc for any node: either in the single-doc or
     * shadow-doc environment.
     * @param {!Window} window
     * @return {!./service/ampdoc-impl.AmpDocService}
     */

  }, {
    key: "ampdocServiceFor",
    value: function ampdocServiceFor(window) {
      return (
        /** @type {!./service/ampdoc-impl.AmpDocService} */
        (0, _service.getService)(window, 'ampdoc')
      );
    }
    /**
     * Returns the AmpDoc for the specified context node.
     * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrAmpDoc
     * @return {!./service/ampdoc-impl.AmpDoc}
     */

  }, {
    key: "ampdoc",
    value: function ampdoc(nodeOrAmpDoc) {
      return (0, _service.getAmpdoc)(nodeOrAmpDoc);
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @param {boolean=} loadAnalytics
     * @return {!Promise<!../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>}
     */

  }, {
    key: "analyticsForDoc",
    value: function analyticsForDoc(element, loadAnalytics) {
      if (loadAnalytics === void 0) {
        loadAnalytics = false;
      }

      if (loadAnalytics) {
        // Get Extensions service and force load analytics extension.
        var ampdoc = (0, _service.getAmpdoc)(element);
        Services.extensionsFor(ampdoc.win).
        /*OK*/
        installExtensionForDoc(ampdoc, 'amp-analytics');
      }

      return (
        /** @type {!Promise<!../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'amp-analytics-instrumentation', 'amp-analytics')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>}
     */

  }, {
    key: "analyticsForDocOrNull",
    value: function analyticsForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'amp-analytics-instrumentation', 'amp-analytics')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/batched-xhr-impl.BatchedXhr}
     */

  }, {
    key: "batchedXhrFor",
    value: function batchedXhrFor(window) {
      return (
        /** @type {!./service/batched-xhr-impl.BatchedXhr} */
        (0, _service.getService)(window, 'batched-xhr')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-bind/0.1/bind-impl.Bind>}
     */

  }, {
    key: "bindForDocOrNull",
    value: function bindForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-bind/0.1/bind-impl.Bind>} */
        (0, _elementService.getElementServiceIfAvailableForDocInEmbedScope)(element, 'bind', 'amp-bind')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-script/0.1/amp-script.AmpScriptService>}
     */

  }, {
    key: "scriptForDocOrNull",
    value: function scriptForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-script/0.1/amp-script.AmpScriptService>} */
        (0, _elementService.getElementServiceIfAvailableForDocInEmbedScope)(element, 'amp-script', 'amp-script')
      );
    }
    /**
     * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/cid-impl.CidDef>}
     */

  }, {
    key: "cidForDoc",
    value: function cidForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/cid-impl.CidDef>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'cid')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/navigation.Navigation}
     */

  }, {
    key: "navigationForDoc",
    value: function navigationForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/navigation.Navigation} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'navigation')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-loader/0.1/amp-loader.LoaderService>}
     */

  }, {
    key: "loaderServiceForDoc",
    value: function loaderServiceForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-loader/0.1/amp-loader.LoaderService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'loader', 'amp-loader')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-standalone/0.1/amp-standalone.StandaloneService>}
     */

  }, {
    key: "standaloneServiceForDoc",
    value: function standaloneServiceForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-standalone/0.1/amp-standalone.StandaloneService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'standalone', 'amp-standalone')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/crypto-impl.Crypto}
     */

  }, {
    key: "cryptoFor",
    value: function cryptoFor(window) {
      return (
        /** @type {!./service/crypto-impl.Crypto} */
        (0, _service.getService)(window, 'crypto')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/document-info-impl.DocumentInfoDef} Info about the doc
     */

  }, {
    key: "documentInfoForDoc",
    value: function documentInfoForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/document-info-impl.DocInfo} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'documentInfo').get()
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/extensions-impl.Extensions}
     */

  }, {
    key: "extensionsFor",
    value: function extensionsFor(window) {
      return (
        /** @type {!./service/extensions-impl.Extensions} */
        (0, _service.getService)(window, 'extensions')
      );
    }
    /**
     * Returns a service to register callbacks we wish to execute when an
     * amp-form is submitted.
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<../extensions/amp-form/0.1/form-submit-service.FormSubmitService>}
     */

  }, {
    key: "formSubmitForDoc",
    value: function formSubmitForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<../extensions/amp-form/0.1/form-submit-service.FormSubmitService>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'form-submit-service')
      );
    }
    /**
     * Returns service to listen for `hidden` attribute mutations.
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/hidden-observer-impl.HiddenObserver}
     */

  }, {
    key: "hiddenObserverForDoc",
    value: function hiddenObserverForDoc(element) {
      return (
        /** @type {!./service/hidden-observer-impl.HiddenObserver} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'hidden-observer')
      );
    }
    /**
     * Returns service implemented in service/history-impl.
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/history-impl.History}
     */

  }, {
    key: "historyForDoc",
    value: function historyForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/history-impl.History} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'history')
      );
    }
    /**
     * @param {!Window} win
     * @return {!./input.Input}
     */

  }, {
    key: "inputFor",
    value: function inputFor(win) {
      return (0, _service.getService)(win, 'input');
    }
    /**s
     * Returns a promise for the Inputmask service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-inputmask/0.1/amp-inputmask.AmpInputmaskService>}
     */

  }, {
    key: "inputmaskServiceForDocOrNull",
    value: function inputmaskServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-inputmask/0.1/amp-inputmask.AmpInputmaskService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'inputmask', 'amp-inputmask')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!../extensions/amp-next-page/1.0/service.NextPageService}
     */

  }, {
    key: "nextPageServiceForDoc",
    value: function nextPageServiceForDoc(elementOrAmpDoc) {
      return (
        /** @type {!../extensions/amp-next-page/1.0/service.NextPageService} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'next-page')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/mutator-interface.MutatorInterface}
     */

  }, {
    key: "mutatorForDoc",
    value: function mutatorForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/mutator-interface.MutatorInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'mutator')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/owners-interface.OwnersInterface}
     */

  }, {
    key: "ownersForDoc",
    value: function ownersForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/owners-interface.OwnersInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'owners')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/performance-impl.Performance}
     */

  }, {
    key: "performanceFor",
    value: function performanceFor(window) {
      return (
        /** @type {!./service/performance-impl.Performance}*/
        (0, _service.getService)(window, 'performance')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/performance-impl.Performance}
     */

  }, {
    key: "performanceForOrNull",
    value: function performanceForOrNull(window) {
      return (
        /** @type {!./service/performance-impl.Performance}*/
        (0, _service.getExistingServiceOrNull)(window, 'performance')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/platform-impl.Platform}
     */

  }, {
    key: "platformFor",
    value: function platformFor(window) {
      return (
        /** @type {!./service/platform-impl.Platform} */
        (0, _service.getService)(window, 'platform')
      );
    }
    /**
     * Not installed by default; must be installed in extension code before use.
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/position-observer/position-observer-impl.PositionObserver}
     * @throws If the service is not installed.
     */

  }, {
    key: "positionObserverForDoc",
    value: function positionObserverForDoc(element) {
      return (
        /** @type {!./service/position-observer/position-observer-impl.PositionObserver} */
        (0, _service.getServiceForDoc)(element, 'position-observer')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./preconnect.PreconnectService}
     */

  }, {
    key: "preconnectFor",
    value: function preconnectFor(window) {
      return (0, _service.getService)(window, 'preconnect');
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/resources-interface.ResourcesInterface}
     */

  }, {
    key: "resourcesForDoc",
    value: function resourcesForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/resources-interface.ResourcesInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'resources')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/resources-interface.ResourcesInterface>}
     */

  }, {
    key: "resourcesPromiseForDoc",
    value: function resourcesPromiseForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/resources-interface.ResourcesInterface>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'resources')
      );
    }
    /**
     * @param {!Window} win
     * @return {?Promise<?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService>}
     */

  }, {
    key: "storyVariableServiceForOrNull",
    value: function storyVariableServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-variable', 'amp-story')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService}
     */

  }, {
    key: "storyVariableService",
    value: function storyVariableService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-variable')
      );
    }
    /**
     * Version of the story store service depends on which version of amp-story
     * the publisher is loading. They all have the same implementation.
     * @param {!Window} win
     * @return {?Promise<?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService>}
     */

  }, {
    key: "storyStoreServiceForOrNull",
    value: function storyStoreServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-store', 'amp-story')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService}
     */

  }, {
    key: "storyStoreService",
    value: function storyStoreService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-store')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/amp-story-media-query-service.AmpStoryMediaQueryService}
     */

  }, {
    key: "storyMediaQueryService",
    value: function storyMediaQueryService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/amp-story-media-query-service.AmpStoryMediaQueryService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-media-query')
      );
    }
    /**
     * Get promise with story request service
     * @param {!Window} win
     * @return {?Promise<?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService>}
     */

  }, {
    key: "storyRequestServiceForOrNull",
    value: function storyRequestServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-request', 'amp-story')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService}
     */

  }, {
    key: "storyRequestService",
    value: function storyRequestService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-request')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/media-performance-metrics-service.MediaPerformanceMetricsService}
     */

  }, {
    key: "mediaPerformanceMetricsService",
    value: function mediaPerformanceMetricsService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/media-performance-metrics-service.MediaPerformanceMetricsService} */
        (0, _service.getExistingServiceOrNull)(win, 'media-performance-metrics')
      );
    }
    /**
     * @param {!Element} el
     * @return {!Promise<./service/localization.LocalizationService>}
     */

  }, {
    key: "localizationServiceForOrNull",
    value: function localizationServiceForOrNull(el) {
      return (
        /** @type {!Promise<?./service/localization.LocalizationService>} */
        (0, _service.getServicePromiseForDoc)(el, 'localization')
      );
    }
    /**
     * @param {!Element} element
     * @return {?./service/localization.LocalizationService}
     */

  }, {
    key: "localizationForDoc",
    value: function localizationForDoc(element) {
      return (
        /** @type {?./service/localization.LocalizationService} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'localization')
      );
    }
    /**
     * TODO(#14357): Remove this when amp-story:0.1 is deprecated.
     * @param {!Window} win
     * @return {!Promise<?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService>}
     */

  }, {
    key: "storyAnalyticsServiceForOrNull",
    value: function storyAnalyticsServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-analytics', 'amp-story', true)
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService}
     */

  }, {
    key: "storyAnalyticsService",
    value: function storyAnalyticsService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-analytics')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-animation/0.1/web-animation-service.WebAnimationService>}
     */

  }, {
    key: "webAnimationServiceFor",
    value: function webAnimationServiceFor(element) {
      return (
        /** @type {!Promise<!../extensions/amp-animation/0.1/web-animation-service.WebAnimationService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'web-animation', 'amp-animation')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/storage-impl.Storage>}
     */

  }, {
    key: "storageForDoc",
    value: function storageForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/storage-impl.Storage>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'storage')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/template-impl.Templates}
     */

  }, {
    key: "templatesFor",
    value: function templatesFor(window) {
      return (
        /** @type {!./service/template-impl.Templates} */
        (0, _service.getService)(window, 'templates')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/timer-impl.Timer}
     */

  }, {
    key: "timerFor",
    value: function timerFor(window) {
      // TODO(alabiaga): This will always return the top window's Timer service.
      return (
        /** @type {!./service/timer-impl.Timer} */
        (0, _service.getService)(window, 'timer')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/url-replacements-impl.UrlReplacements}
     */

  }, {
    key: "urlReplacementsForDoc",
    value: function urlReplacementsForDoc(element) {
      return (
        /** @type {!./service/url-replacements-impl.UrlReplacements} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'url-replace')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-user-notification/0.1/amp-user-notification.UserNotificationManager>}
     */

  }, {
    key: "userNotificationManagerForDoc",
    value: function userNotificationManagerForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-user-notification/0.1/amp-user-notification.UserNotificationManager>} */
        (0, _elementService.getElementServiceForDoc)(element, 'userNotificationManager', 'amp-user-notification')
      );
    }
    /**
     * Returns a promise for the consentPolicy Service or a promise for null if
     * the service is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-consent/0.1/consent-policy-manager.ConsentPolicyManager>}
     */

  }, {
    key: "consentPolicyServiceForDocOrNull",
    value: function consentPolicyServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-consent/0.1/consent-policy-manager.ConsentPolicyManager>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'consentPolicyManager', 'amp-consent')
      );
    }
    /**
     * Returns a promise for the geo service or a promise for null if
     * the service is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-geo/0.1/amp-geo.GeoDef>}
     */

  }, {
    key: "geoForDocOrNull",
    value: function geoForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-geo/0.1/amp-geo.GeoDef>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'geo', 'amp-geo', true)
      );
    }
    /**
     * Unlike most service getters, passing `Node` is necessary for some FIE-scope
     * services since sometimes we only have the FIE Document for context.
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/url-impl.Url}
     */

  }, {
    key: "urlForDoc",
    value: function urlForDoc(element) {
      return (
        /** @type {!./service/url-impl.Url} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'url')
      );
    }
    /**
     * Returns a promise for the experiment variants or a promise for null if it
     * is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-experiment/0.1/variant.Variants>}
     */

  }, {
    key: "variantsForDocOrNull",
    value: function variantsForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-experiment/0.1/variant.Variants>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'variant', 'amp-experiment', true)
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/video-manager-impl.VideoManager}
     */

  }, {
    key: "videoManagerForDoc",
    value: function videoManagerForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/video-manager-impl.VideoManager} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'video-manager')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-viewer-assistance/0.1/amp-viewer-assistance.AmpViewerAssistance>}
     */

  }, {
    key: "viewerAssistanceForDocOrNull",
    value: function viewerAssistanceForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-viewer-assistance/0.1/amp-viewer-assistance.AmpViewerAssistance>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'amp-viewer-assistance', 'amp-viewer-assistance')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/viewer-interface.ViewerInterface}
     */

  }, {
    key: "viewerForDoc",
    value: function viewerForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/viewer-interface.ViewerInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'viewer')
      );
    }
    /**
     * Returns promise for the viewer. This is an unusual case and necessary only
     * for services that need reference to the viewer before it has been
     * initialized. Most of the code, however, just should use `viewerForDoc`.
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/viewer-interface.ViewerInterface>}
     */

  }, {
    key: "viewerPromiseForDoc",
    value: function viewerPromiseForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/viewer-interface.ViewerInterface>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'viewer')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/vsync-impl.Vsync}
     */

  }, {
    key: "vsyncFor",
    value: function vsyncFor(window) {
      return (
        /** @type {!./service/vsync-impl.Vsync} */
        (0, _service.getService)(window, 'vsync')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/viewport/viewport-interface.ViewportInterface}
     */

  }, {
    key: "viewportForDoc",
    value: function viewportForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/viewport/viewport-interface.ViewportInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'viewport')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/xhr-impl.Xhr}
     */

  }, {
    key: "xhrFor",
    value: function xhrFor(window) {
      return (
        /** @type {!./service/xhr-impl.Xhr} */
        (0, _service.getService)(window, 'xhr')
      );
    }
  }]);

  return Services;
}();

exports.Services = Services;

},{"./element-service":20,"./service":33}],35:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.dashToCamelCase = dashToCamelCase;
exports.camelCaseToDash = camelCaseToDash;
exports.dashToUnderline = dashToUnderline;
exports.endsWith = endsWith;
exports.startsWith = startsWith;
exports.includes = includes;
exports.expandTemplate = expandTemplate;
exports.stringHash32 = stringHash32;
exports.trimEnd = trimEnd;
exports.trimStart = trimStart;
exports.asyncStringReplace = asyncStringReplace;
exports.padStart = padStart;

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @param {string} _match
 * @param {string} character
 * @return {string}
 */
function toUpperCase(_match, character) {
  return character.toUpperCase();
}

/**
 * @param {string} match
 * @return {string}
 */
function prependDashAndToLowerCase(match) {
  return '-' + match.toLowerCase();
}

/**
 * @param {string} name Attribute name containing dashes.
 * @return {string} Dashes removed and successive character sent to upper case.
 * visibleForTesting
 */
function dashToCamelCase(name) {
  return name.replace(/-([a-z])/g, toUpperCase);
}

/**
 * Converts a string that is in camelCase to one that is in dash-case.
 *
 * @param {string} string The string to convert.
 * @return {string} The string in dash-case.
 */
function camelCaseToDash(string) {
  return string.replace(/(?!^)[A-Z]/g, prependDashAndToLowerCase);
}

/**
 * @param {string} name Attribute name with dashes
 * @return {string} Dashes replaced by underlines.
 */
function dashToUnderline(name) {
  return name.replace('-', '_');
}

/**
 * Polyfill for String.prototype.endsWith.
 * @param {string} string
 * @param {string} suffix
 * @return {boolean}
 */
function endsWith(string, suffix) {
  var index = string.length - suffix.length;
  return index >= 0 && string.indexOf(suffix, index) == index;
}

/**
 * Polyfill for String.prototype.startsWith.
 * @param {string} string
 * @param {string} prefix
 * @return {boolean}
 */
function startsWith(string, prefix) {
  if (prefix.length > string.length) {
    return false;
  }

  return string.lastIndexOf(prefix, 0) == 0;
}

/**
 * Polyfill for String.prototype.includes.
 * @param {string} string
 * @param {string} substring
 * @param {number=} start
 * @return {boolean}
 */
function includes(string, substring, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + substring.length > string.length) {
    return false;
  }

  return string.indexOf(substring, start) !== -1;
}

/**
 * Expands placeholders in a given template string with values.
 *
 * Placeholders use ${key-name} syntax and are replaced with the value
 * returned from the given getter function.
 *
 * @param {string} template The template string to expand.
 * @param {function(string):*} getter Function used to retrieve a value for a
 *   placeholder. Returns values will be coerced into strings.
 * @param {number=} opt_maxIterations Number of times to expand the template.
 *   Defaults to 1, but should be set to a larger value your placeholder tokens
 *   can be expanded to other placeholder tokens. Take caution with large values
 *   as recursively expanding a string can be exponentially expensive.
 * @return {string}
 */
function expandTemplate(template, getter, opt_maxIterations) {
  var maxIterations = opt_maxIterations || 1;

  var _loop = function _loop(i) {
    var matches = 0;
    template = template.replace(/\${([^}]*)}/g, function (_a, b) {
      matches++;
      return getter(b);
    });

    if (!matches) {
      return "break";
    }
  };

  for (var i = 0; i < maxIterations; i++) {
    var _ret = _loop(i);

    if (_ret === "break") break;
  }

  return template;
}

/**
 * Hash function djb2a
 * This is intended to be a simple, fast hashing function using minimal code.
 * It does *not* have good cryptographic properties.
 * @param {string} str
 * @return {string} 32-bit unsigned hash of the string
 */
function stringHash32(str) {
  var length = str.length;
  var hash = 5381;

  for (var i = 0; i < length; i++) {
    hash = hash * 33 ^ str.charCodeAt(i);
  }

  // Convert from 32-bit signed to unsigned.
  return String(hash >>> 0);
}

/**
 * Trims a string on the end, removing whitespace characters.
 * @param {string} str  A string to trim.
 * @return {string} The string, with trailing whitespace removed.
 */
function trimEnd(str) {
  // TODO(sparhami) Does this get inlined for an ES2019 build?
  if (str.trimEnd) {
    return str.trimEnd();
  }

  return ('_' + str).trim().slice(1);
}

/**
 * Trims any leading whitespace from a string.
 * @param {string} str  A string to trim.
 * @return {string} The string, with leading whitespace removed.
 */
function trimStart(str) {
  if (str.trimStart) {
    return str.trimStart();
  }

  return (str + '_').trim().slice(0, -1);
}

/**
 * Wrapper around String.replace that handles asynchronous resolution.
 * @param {string} str
 * @param {RegExp} regex
 * @param {Function|string} replacer
 * @return {!Promise<string>}
 */
function asyncStringReplace(str, regex, replacer) {
  if (typeof replacer === 'string') {
    return Promise.resolve(str.replace(regex, replacer));
  }

  var stringBuilder = [];
  var lastIndex = 0;
  str.replace(regex, function (match) {
    // String.prototype.replace will pass 3 to n number of arguments to the
    // callback function based on how many capture groups the regex may or may
    // not contain. We know that the match will always be first, and the
    // index will always be second to last.
    var matchIndex = arguments[arguments.length - 2];
    stringBuilder.push(str.slice(lastIndex, matchIndex));
    lastIndex = matchIndex + match.length;
    // Store the promise in it's eventual string position.
    var replacementPromise = replacer.apply(null, arguments);
    stringBuilder.push(replacementPromise);
  });
  stringBuilder.push(str.slice(lastIndex));
  return Promise.all(stringBuilder).then(function (resolved) {
    return resolved.join('');
  });
}

/**
 * Pads the beginning of a string with a substring to a target length.
 * @param {string} s
 * @param {number} targetLength
 * @param {string} padString
 * @return {*} TODO(#23582): Specify return type
 */
function padStart(s, targetLength, padString) {
  if (s.length >= targetLength) {
    return s;
  }

  targetLength = targetLength - s.length;
  var padding = padString;

  while (targetLength > padding.length) {
    padding += padString;
  }

  return padding.slice(0, targetLength) + s;
}

},{}],36:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.camelCaseToTitleCase = camelCaseToTitleCase;
exports.getVendorJsPropertyName = getVendorJsPropertyName;
exports.setImportantStyles = setImportantStyles;
exports.setStyle = setStyle;
exports.getStyle = getStyle;
exports.setStyles = setStyles;
exports.assertNotDisplay = assertNotDisplay;
exports.assertDoesNotContainDisplay = assertDoesNotContainDisplay;
exports.setInitialDisplay = setInitialDisplay;
exports.toggle = toggle;
exports.px = px;
exports.deg = deg;
exports.translateX = translateX;
exports.translate = translate;
exports.scale = scale;
exports.rotate = rotate;
exports.removeAlphaFromColor = removeAlphaFromColor;
exports.computedStyle = computedStyle;
exports.resetStyles = resetStyles;
exports.propagateObjectFitStyles = propagateObjectFitStyles;

var _log = require("./log");

var _object = require("./utils/object.js");

var _string = require("./string");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Note: loaded by 3p system. Cannot rely on babel polyfills.

/** @type {Object<string, string>} */
var propertyNameCache;

/** @const {!Array<string>} */
var vendorPrefixes = ['Webkit', 'webkit', 'Moz', 'moz', 'ms', 'O', 'o'];

/**
 * @export
 * @param {string} camelCase camel cased string
 * @return {string} title cased string
 */
function camelCaseToTitleCase(camelCase) {
  return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
}

/**
  Checks the style if a prefixed version of a property exists and returns
 * it or returns an empty string.
 * @private
 * @param {!Object} style
 * @param {string} titleCase the title case version of a css property name
 * @return {string} the prefixed property name or null.
 */
function getVendorJsPropertyName_(style, titleCase) {
  for (var i = 0; i < vendorPrefixes.length; i++) {
    var propertyName = vendorPrefixes[i] + titleCase;

    if (style[propertyName] !== undefined) {
      return propertyName;
    }
  }

  return '';
}

/**
 * Returns the possibly prefixed JavaScript property name of a style property
 * (ex. WebkitTransitionDuration) given a camelCase'd version of the property
 * (ex. transitionDuration).
 * @export
 * @param {!Object} style
 * @param {string} camelCase the camel cased version of a css property name
 * @param {boolean=} opt_bypassCache bypass the memoized cache of property
 *   mapping
 * @return {string}
 */
function getVendorJsPropertyName(style, camelCase, opt_bypassCache) {
  if (isVar(camelCase)) {
    // CSS vars are returned as is.
    return camelCase;
  }

  if (!propertyNameCache) {
    propertyNameCache = (0, _object.map)();
  }

  var propertyName = propertyNameCache[camelCase];

  if (!propertyName || opt_bypassCache) {
    propertyName = camelCase;

    if (style[camelCase] === undefined) {
      var titleCase = camelCaseToTitleCase(camelCase);
      var prefixedPropertyName = getVendorJsPropertyName_(style, titleCase);

      if (style[prefixedPropertyName] !== undefined) {
        propertyName = prefixedPropertyName;
      }
    }

    if (!opt_bypassCache) {
      propertyNameCache[camelCase] = propertyName;
    }
  }

  return propertyName;
}

/**
 * Sets the CSS styles of the specified element with !important. The styles
 * are specified as a map from CSS property names to their values.
 * @param {!Element} element
 * @param {!Object<string, *>} styles
 */
function setImportantStyles(element, styles) {
  var style = element.style;

  for (var k in styles) {
    style.setProperty(getVendorJsPropertyName(style, k), styles[k].toString(), 'important');
  }
}

/**
 * Sets the CSS style of the specified element with optional units, e.g. "px".
 * @param {?Element} element
 * @param {string} property
 * @param {*} value
 * @param {string=} opt_units
 * @param {boolean=} opt_bypassCache
 */
function setStyle(element, property, value, opt_units, opt_bypassCache) {
  var propertyName = getVendorJsPropertyName(element.style, property, opt_bypassCache);

  if (!propertyName) {
    return;
  }

  var styleValue =
  /** @type {string} */
  opt_units ? value + opt_units : value;

  if (isVar(propertyName)) {
    element.style.setProperty(propertyName, styleValue);
  } else {
    element.style[propertyName] = styleValue;
  }
}

/**
 * Returns the value of the CSS style of the specified element.
 * @param {!Element} element
 * @param {string} property
 * @param {boolean=} opt_bypassCache
 * @return {*}
 */
function getStyle(element, property, opt_bypassCache) {
  var propertyName = getVendorJsPropertyName(element.style, property, opt_bypassCache);

  if (!propertyName) {
    return undefined;
  }

  if (isVar(propertyName)) {
    return element.style.getPropertyValue(propertyName);
  }

  return element.style[propertyName];
}

/**
 * Sets the CSS styles of the specified element. The styles
 * a specified as a map from CSS property names to their values.
 * @param {!Element} element
 * @param {!Object<string, *>} styles
 */
function setStyles(element, styles) {
  for (var k in styles) {
    setStyle(element, k, styles[k]);
  }
}

/**
 * Asserts that the style is not the `display` style.
 * This is the only possible way to pass a dynamic style to setStyle.
 *
 * If you wish to set `display`, use the `toggle` helper instead. This is so
 * changes to display can trigger necessary updates. See #17475.
 *
 * @param {string} style
 * @return {string}
 */
function assertNotDisplay(style) {
  if (style === 'display') {
    (0, _log.dev)().error('STYLE', '`display` style detected. You must use toggle instead.');
  }

  return style;
}

/**
 * Asserts that the styles does not contain the `display` style.
 * This is the only possible way to pass a dynamic styles object to setStyles
 * and setImportantStyles.
 *
 * If you wish to set `display`, use the `toggle` helper instead. This is so
 * changes to display can trigger necessary updates. See #17475.
 *
 * @param {!Object<string, *>} styles
 * @return {!Object<string, *>}
 */
function assertDoesNotContainDisplay(styles) {
  if ('display' in styles) {
    (0, _log.dev)().error('STYLE', '`display` style detected in styles. You must use toggle instead.');
  }

  return styles;
}

/**
 * Sets the initial display style of an element. This is a last resort. If you
 * can set the initial display using CSS, YOU MUST.
 * DO NOT USE THIS TO ARBITRARILY SET THE DISPLAY STYLE AFTER INITIAL SETUP.
 *
 * @param {!Element} el
 * @param {string} value
 */
function setInitialDisplay(el, value) {
  var style = el.style;
  (0, _log.devAssert)(value !== '' && value !== 'none', 'Initial display value must not be "none". Use toggle instead.');
  (0, _log.devAssert)(!style['display'], 'setInitialDisplay MUST NOT be used for ' + 'resetting the display style. If you are looking for display:none ' + 'toggling, use toggle instead.');
  style['display'] = value;
}

/**
 * Shows or hides the specified element.
 * @param {!Element} element
 * @param {boolean=} opt_display
 */
function toggle(element, opt_display) {
  if (opt_display === undefined) {
    opt_display = element.hasAttribute('hidden');
  }

  if (opt_display) {
    element.removeAttribute('hidden');
  } else {
    element.setAttribute('hidden', '');
  }
}

/**
 * Returns a pixel value.
 * @param {number} value
 * @return {string}
 */
function px(value) {
  return value + "px";
}

/**
 * Returns a degree value.
 * @param {number} value
 * @return {string}
 */
function deg(value) {
  return value + "deg";
}

/**
 * Returns a "translateX" for CSS "transform" property.
 * @param {number|string} value
 * @return {string}
 */
function translateX(value) {
  if (typeof value == 'string') {
    return "translateX(" + value + ")";
  }

  return "translateX(" + px(value) + ")";
}

/**
 * Returns a "translateX" for CSS "transform" property.
 * @param {number|string} x
 * @param {(number|string)=} opt_y
 * @return {string}
 */
function translate(x, opt_y) {
  if (typeof x == 'number') {
    x = px(x);
  }

  if (opt_y === undefined) {
    return "translate(" + x + ")";
  }

  if (typeof opt_y == 'number') {
    opt_y = px(opt_y);
  }

  return "translate(" + x + ", " + opt_y + ")";
}

/**
 * Returns a "scale" for CSS "transform" property.
 * @param {number|string} value
 * @return {string}
 */
function scale(value) {
  return "scale(" + value + ")";
}

/**
 * Returns a "rotate" for CSS "transform" property.
 * @param {number|string} value
 * @return {string}
 */
function rotate(value) {
  if (typeof value == 'number') {
    value = deg(value);
  }

  return "rotate(" + value + ")";
}

/**
 * Remove alpha value from a rgba color value.
 * Return the new color property with alpha equals if has the alpha value.
 * Caller needs to make sure the input color value is a valid rgba/rgb value
 * @param {string} rgbaColor
 * @return {string}
 */
function removeAlphaFromColor(rgbaColor) {
  return rgbaColor.replace(/\(([^,]+),([^,]+),([^,)]+),[^)]+\)/g, '($1,$2,$3, 1)');
}

/**
 * Gets the computed style of the element. The helper is necessary to enforce
 * the possible `null` value returned by a buggy Firefox.
 *
 * @param {!Window} win
 * @param {!Element} el
 * @return {!Object<string, string>}
 */
function computedStyle(win, el) {
  var style =
  /** @type {?CSSStyleDeclaration} */
  win.getComputedStyle(el);
  return (
    /** @type {!Object<string, string>} */
    style || (0, _object.map)()
  );
}

/**
 * Resets styles that were set dynamically (i.e. inline)
 * @param {!Element} element
 * @param {!Array<string>} properties
 */
function resetStyles(element, properties) {
  for (var i = 0; i < properties.length; i++) {
    setStyle(element, properties[i], null);
  }
}

/**
 * Propagates the object-fit/position element attributes as styles.
 * @param {!Element} fromEl ie: amp-img
 * @param {!Element} toEl ie: the img within amp-img
 */
function propagateObjectFitStyles(fromEl, toEl) {
  if (fromEl.hasAttribute('object-fit')) {
    setStyle(toEl, 'object-fit', fromEl.getAttribute('object-fit'));
  }

  if (fromEl.hasAttribute('object-position')) {
    setStyle(toEl, 'object-position', fromEl.getAttribute('object-position'));
  }
}

/**
 * @param {string} property
 * @return {boolean}
 */
function isVar(property) {
  return (0, _string.startsWith)(property, '--');
}

},{"./log":28,"./string":35,"./utils/object.js":45}],37:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isArray = isArray;
exports.toArray = toArray;
exports.isObject = isObject;
exports.isFiniteNumber = isFiniteNumber;
exports.isEnumValue = isEnumValue;
exports.toWin = toWin;

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @const */
var toString_ = Object.prototype.toString;

/**
 * Returns the ECMA [[Class]] of a value
 * @param {*} value
 * @return {string}
 */
function toString(value) {
  return toString_.call(value);
}

/**
 * Determines if value is actually an Array.
 * @param {*} value
 * @return {boolean}
 */
function isArray(value) {
  return Array.isArray(value);
}

/**
 * Converts an array-like object to an array.
 * @param {?IArrayLike<T>|string} arrayLike
 * @return {!Array<T>}
 * @template T
 */
function toArray(arrayLike) {
  return arrayLike ? Array.prototype.slice.call(arrayLike) : [];
}

/**
 * Determines if value is actually an Object.
 * @param {*} value
 * @return {boolean}
 */
function isObject(value) {
  return toString(value) === '[object Object]';
}

/**
 * Determines if value is of number type and finite.
 * NaN and Infinity are not considered a finite number.
 * String numbers are not considered numbers.
 * @param {*} value
 * @return {boolean}
 */
function isFiniteNumber(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Checks whether `s` is a valid value of `enumObj`.
 *
 * @param {!Object<T>} enumObj
 * @param {T} s
 * @return {boolean}
 * @template T
 */
function isEnumValue(enumObj, s) {
  for (var k in enumObj) {
    if (enumObj[k] === s) {
      return true;
    }
  }

  return false;
}

/**
 * Externs declare that access `defaultView` from `document` or
 * `ownerDocument` is of type `(Window|null)` but most of our parameter types
 * assume that it is never null. This is OK in practice as we ever only get
 * null on disconnected documents or old IE.
 * This helper function casts it into just a simple Window return type.
 *
 * @param {!Window|null} winOrNull
 * @return {!Window}
 */
function toWin(winOrNull) {
  return (
    /** @type {!Window} */
    winOrNull
  );
}

},{}],38:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.parseQueryString_ = parseQueryString_;

var _urlTryDecodeUriComponent = require("./url-try-decode-uri-component");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var regex = /(?:^[#?]?|&)([^=&]+)(?:=([^&]*))?/g;

/**
 * Parses the query string of an URL. This method returns a simple key/value
 * map. If there are duplicate keys the latest value is returned.
 *
 * DO NOT import the function from this file. Instead, import parseQueryString
 * from `src/url.js`.
 *
 * @param {string} queryString
 * @return {!JsonObject}
 */
function parseQueryString_(queryString) {
  var params =
  /** @type {!JsonObject} */
  Object.create(null);

  if (!queryString) {
    return params;
  }

  var match;

  while (match = regex.exec(queryString)) {
    var name = (0, _urlTryDecodeUriComponent.tryDecodeUriComponent_)(match[1], match[1]);
    var value = match[2] ? (0, _urlTryDecodeUriComponent.tryDecodeUriComponent_)(match[2].replace(/\+/g, ' '), match[2]) : '';
    params[name] = value;
  }

  return params;
}

},{"./url-try-decode-uri-component":39}],39:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.tryDecodeUriComponent_ = tryDecodeUriComponent_;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Tries to decode a URI component, falling back to opt_fallback (or an empty
 * string)
 *
 * DO NOT import the function from this file. Instead, import
 * tryDecodeUriComponent from `src/url.js`.
 *
 * @param {string} component
 * @param {string=} fallback
 * @return {string}
 */
function tryDecodeUriComponent_(component, fallback) {
  if (fallback === void 0) {
    fallback = '';
  }

  try {
    return decodeURIComponent(component);
  } catch (e) {
    return fallback;
  }
}

},{}],40:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getWinOrigin = getWinOrigin;
exports.parseUrlDeprecated = parseUrlDeprecated;
exports.parseUrlWithA = parseUrlWithA;
exports.appendEncodedParamStringToUrl = appendEncodedParamStringToUrl;
exports.addParamToUrl = addParamToUrl;
exports.addParamsToUrl = addParamsToUrl;
exports.addMissingParamsToUrl = addMissingParamsToUrl;
exports.serializeQueryString = serializeQueryString;
exports.isSecureUrlDeprecated = isSecureUrlDeprecated;
exports.assertHttpsUrl = assertHttpsUrl;
exports.assertAbsoluteHttpOrHttpsUrl = assertAbsoluteHttpOrHttpsUrl;
exports.parseQueryString = parseQueryString;
exports.removeFragment = removeFragment;
exports.getFragment = getFragment;
exports.isProxyOrigin = isProxyOrigin;
exports.getProxyServingType = getProxyServingType;
exports.isLocalhostOrigin = isLocalhostOrigin;
exports.isProtocolValid = isProtocolValid;
exports.removeAmpJsParamsFromUrl = removeAmpJsParamsFromUrl;
exports.removeSearch = removeSearch;
exports.removeParamsFromSearch = removeParamsFromSearch;
exports.getSourceUrl = getSourceUrl;
exports.getSourceOrigin = getSourceOrigin;
exports.resolveRelativeUrl = resolveRelativeUrl;
exports.resolveRelativeUrlFallback_ = resolveRelativeUrlFallback_;
exports.getCorsUrl = getCorsUrl;
exports.checkCorsUrl = checkCorsUrl;
exports.tryDecodeUriComponent = tryDecodeUriComponent;
exports.appendPathToUrl = appendPathToUrl;
exports.SOURCE_ORIGIN_PARAM = void 0;

var _lruCache = require("./utils/lru-cache");

var _object = require("./utils/object");

var _string = require("./string");

var _mode = require("./mode");

var _types = require("./types");

var _urlParseQueryString = require("./url-parse-query-string");

var _urlTryDecodeUriComponent = require("./url-try-decode-uri-component");

var _config = require("./config");

var _log = require("./log");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @type {!JsonObject}
 */
var SERVING_TYPE_PREFIX = (0, _object.dict)({
  // No viewer
  'c': true,
  // In viewer
  'v': true,
  // Ad landing page
  'a': true,
  // Ad
  'ad': true,
  // Actions viewer
  'action': true
});

/**
 * Cached a-tag to avoid memory allocation during URL parsing.
 * @type {HTMLAnchorElement}
 */
var a;

/**
 * We cached all parsed URLs. As of now there are no use cases
 * of AMP docs that would ever parse an actual large number of URLs,
 * but we often parse the same one over and over again.
 * @type {LruCache}
 */
var cache;

/** @private @const Matches amp_js_* parameters in query string. */
var AMP_JS_PARAMS_REGEX = /[?&]amp_js[^&]*/;

/** @private @const Matches amp_gsa parameters in query string. */
var AMP_GSA_PARAMS_REGEX = /[?&]amp_gsa[^&]*/;

/** @private @const Matches amp_r parameters in query string. */
var AMP_R_PARAMS_REGEX = /[?&]amp_r[^&]*/;

/** @private @const Matches amp_kit parameters in query string. */
var AMP_KIT_PARAMS_REGEX = /[?&]amp_kit[^&]*/;

/** @private @const Matches usqp parameters from goog experiment in query string. */
var GOOGLE_EXPERIMENT_PARAMS_REGEX = /[?&]usqp[^&]*/;
var INVALID_PROTOCOLS = [
/*eslint no-script-url: 0*/
'javascript:',
/*eslint no-script-url: 0*/
'data:',
/*eslint no-script-url: 0*/
'vbscript:'];

/** @const {string} */
var SOURCE_ORIGIN_PARAM = '__amp_source_origin';
exports.SOURCE_ORIGIN_PARAM = SOURCE_ORIGIN_PARAM;

/**
 * Returns the correct origin for a given window.
 * @param {!Window} win
 * @return {string} origin
 */
function getWinOrigin(win) {
  return win.origin || parseUrlDeprecated(win.location.href).origin;
}

/**
 * Returns a Location-like object for the given URL. If it is relative,
 * the URL gets resolved.
 * Consider the returned object immutable. This is enforced during
 * testing by freezing the object.
 * @param {string} url
 * @param {boolean=} opt_nocache
 * @return {!Location}
 */
function parseUrlDeprecated(url, opt_nocache) {
  if (!a) {
    a =
    /** @type {!HTMLAnchorElement} */
    self.document.createElement('a');
    cache = self.__AMP_URL_CACHE || (self.__AMP_URL_CACHE = new _lruCache.LruCache(100));
  }

  return parseUrlWithA(a, url, opt_nocache ? null : cache);
}

/**
 * Returns a Location-like object for the given URL. If it is relative,
 * the URL gets resolved.
 * Consider the returned object immutable. This is enforced during
 * testing by freezing the object.
 * @param {!HTMLAnchorElement} a
 * @param {string} url
 * @param {LruCache=} opt_cache
 * @return {!Location}
 * @restricted
 */
function parseUrlWithA(a, url, opt_cache) {
  if (opt_cache && opt_cache.has(url)) {
    return opt_cache.get(url);
  }

  a.href = url;

  // IE11 doesn't provide full URL components when parsing relative URLs.
  // Assigning to itself again does the trick #3449.
  if (!a.protocol) {
    a.href = a.href;
  }

  var info =
  /** @type {!Location} */
  {
    href: a.href,
    protocol: a.protocol,
    host: a.host,
    hostname: a.hostname,
    port: a.port == '0' ? '' : a.port,
    pathname: a.pathname,
    search: a.search,
    hash: a.hash,
    origin: null // Set below.

  };

  // Some IE11 specific polyfills.
  // 1) IE11 strips out the leading '/' in the pathname.
  if (info.pathname[0] !== '/') {
    info.pathname = '/' + info.pathname;
  }

  // 2) For URLs with implicit ports, IE11 parses to default ports while
  // other browsers leave the port field empty.
  if (info.protocol == 'http:' && info.port == 80 || info.protocol == 'https:' && info.port == 443) {
    info.port = '';
    info.host = info.hostname;
  }

  // For data URI a.origin is equal to the string 'null' which is not useful.
  // We instead return the actual origin which is the full URL.
  var origin;

  if (a.origin && a.origin != 'null') {
    origin = a.origin;
  } else if (info.protocol == 'data:' || !info.host) {
    origin = info.href;
  } else {
    origin = info.protocol + '//' + info.host;
  }

  info.origin = origin;
  // Freeze during testing to avoid accidental mutation.
  var frozen = (0, _mode.getMode)().test && Object.freeze ? Object.freeze(info) : info;

  if (opt_cache) {
    opt_cache.put(url, frozen);
  }

  return frozen;
}

/**
 * Appends the string just before the fragment part (or optionally
 * to the front of the query string) of the URL.
 * @param {string} url
 * @param {string} paramString
 * @param {boolean=} opt_addToFront
 * @return {string}
 */
function appendEncodedParamStringToUrl(url, paramString, opt_addToFront) {
  if (!paramString) {
    return url;
  }

  var mainAndFragment = url.split('#', 2);
  var mainAndQuery = mainAndFragment[0].split('?', 2);
  var newUrl = mainAndQuery[0] + (mainAndQuery[1] ? opt_addToFront ? "?" + paramString + "&" + mainAndQuery[1] : "?" + mainAndQuery[1] + "&" + paramString : "?" + paramString);
  newUrl += mainAndFragment[1] ? "#" + mainAndFragment[1] : '';
  return newUrl;
}

/**
 * Appends a query string field and value to a url. `key` and `value`
 * will be ran through `encodeURIComponent` before appending.
 * @param {string} url
 * @param {string} key
 * @param {string} value
 * @param {boolean=} opt_addToFront
 * @return {string}
 */
function addParamToUrl(url, key, value, opt_addToFront) {
  var field = encodeURIComponent(key) + "=" + encodeURIComponent(value);
  return appendEncodedParamStringToUrl(url, field, opt_addToFront);
}

/**
 * Appends query string fields and values to a url. The `params` objects'
 * `key`s and `value`s will be transformed into query string keys/values.
 * @param {string} url
 * @param {!JsonObject<string, string|!Array<string>>} params
 * @return {string}
 */
function addParamsToUrl(url, params) {
  return appendEncodedParamStringToUrl(url, serializeQueryString(params));
}

/**
 * Append query string fields and values to a url, only if the key does not
 * exist in current query string.
 * @param {string} url
 * @param {!JsonObject<string, string|!Array<string>>} params
 * @return {string}
 */
function addMissingParamsToUrl(url, params) {
  var location = parseUrlDeprecated(url);
  var existingParams = parseQueryString(location.search);
  var paramsToAdd = (0, _object.dict)({});
  var keys = Object.keys(params);

  for (var i = 0; i < keys.length; i++) {
    if (!(0, _object.hasOwn)(existingParams, keys[i])) {
      paramsToAdd[keys[i]] = params[keys[i]];
    }
  }

  return addParamsToUrl(url, paramsToAdd);
}

/**
 * Serializes the passed parameter map into a query string with both keys
 * and values encoded.
 * @param {!JsonObject<string, string|!Array<string>>} params
 * @return {string}
 */
function serializeQueryString(params) {
  var s = [];

  for (var k in params) {
    var v = params[k];

    if (v == null) {
      continue;
    } else if ((0, _types.isArray)(v)) {
      for (var i = 0; i < v.length; i++) {
        var sv =
        /** @type {string} */
        v[i];
        s.push(encodeURIComponent(k) + "=" + encodeURIComponent(sv));
      }
    } else {
      var _sv =
      /** @type {string} */
      v;
      s.push(encodeURIComponent(k) + "=" + encodeURIComponent(_sv));
    }
  }

  return s.join('&');
}

/**
 * Returns `true` if the URL is secure: either HTTPS or localhost (for testing).
 * @param {string|!Location} url
 * @return {boolean}
 */
function isSecureUrlDeprecated(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return url.protocol == 'https:' || url.hostname == 'localhost' || url.hostname == '127.0.0.1' || (0, _string.endsWith)(url.hostname, '.localhost');
}

/**
 * Asserts that a given url is HTTPS or protocol relative. It's a user-level
 * assert.
 *
 * Provides an exception for localhost.
 *
 * @param {?string|undefined} urlString
 * @param {!Element|string} elementContext Element where the url was found.
 * @param {string=} sourceName Used for error messages.
 * @return {string}
 */
function assertHttpsUrl(urlString, elementContext, sourceName) {
  if (sourceName === void 0) {
    sourceName = 'source';
  }

  (0, _log.userAssert)(urlString != null, '%s %s must be available', elementContext, sourceName);
  // (erwinm, #4560): type cast necessary until #4560 is fixed.
  var theUrlString =
  /** @type {string} */
  urlString;
  (0, _log.userAssert)(isSecureUrlDeprecated(theUrlString) || /^(\/\/)/.test(theUrlString), '%s %s must start with ' + '"https://" or "//" or be relative and served from ' + 'either https or from localhost. Invalid value: %s', elementContext, sourceName, theUrlString);
  return theUrlString;
}

/**
 * Asserts that a given url is an absolute HTTP or HTTPS URL.
 * @param {string} urlString
 * @return {string}
 */
function assertAbsoluteHttpOrHttpsUrl(urlString) {
  (0, _log.userAssert)(/^https?\:/i.test(urlString), 'URL must start with "http://" or "https://". Invalid value: %s', urlString);
  return parseUrlDeprecated(urlString).href;
}

/**
 * Parses the query string of an URL. This method returns a simple key/value
 * map. If there are duplicate keys the latest value is returned.
 *
 * This function is implemented in a separate file to avoid a circular
 * dependency.
 *
 * @param {string} queryString
 * @return {!JsonObject}
 */
function parseQueryString(queryString) {
  return (0, _urlParseQueryString.parseQueryString_)(queryString);
}

/**
 * Returns the URL without fragment. If URL doesn't contain fragment, the same
 * string is returned.
 * @param {string} url
 * @return {string}
 */
function removeFragment(url) {
  var index = url.indexOf('#');

  if (index == -1) {
    return url;
  }

  return url.substring(0, index);
}

/**
 * Returns the fragment from the URL. If the URL doesn't contain fragment,
 * the empty string is returned.
 * @param {string} url
 * @return {string}
 */
function getFragment(url) {
  var index = url.indexOf('#');

  if (index == -1) {
    return '';
  }

  return url.substring(index);
}

/**
 * Returns whether the URL has the origin of a proxy.
 * @param {string|!Location} url URL of an AMP document.
 * @return {boolean}
 */
function isProxyOrigin(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return _config.urls.cdnProxyRegex.test(url.origin);
}

/**
 * For proxy-origin URLs, returns the serving type. Otherwise, returns null.
 * E.g., 'https://amp-com.cdn.ampproject.org/a/s/amp.com/amp_document.html'
 * returns 'a'.
 * @param {string|!Location} url URL of an AMP document.
 * @return {?string}
 */
function getProxyServingType(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  if (!isProxyOrigin(url)) {
    return null;
  }

  var path = url.pathname.split('/', 2);
  return path[1];
}

/**
 * Returns whether the URL origin is localhost.
 * @param {string|!Location} url URL of an AMP document.
 * @return {boolean}
 */
function isLocalhostOrigin(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return _config.urls.localhostRegex.test(url.origin);
}

/**
 * Returns whether the URL has valid protocol.
 * Deep link protocol is valid, but not javascript etc.
 * @param {string|!Location} url
 * @return {boolean}
 */
function isProtocolValid(url) {
  if (!url) {
    return true;
  }

  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return !INVALID_PROTOCOLS.includes(url.protocol);
}

/**
 * Returns a URL without AMP JS parameters.
 * @param {string} url
 * @return {string}
 */
function removeAmpJsParamsFromUrl(url) {
  var parsed = parseUrlDeprecated(url);
  var search = removeAmpJsParamsFromSearch(parsed.search);
  return parsed.origin + parsed.pathname + search + parsed.hash;
}

/**
 * Returns a URL without a query string.
 * @param {string} url
 * @return {string}
 */
function removeSearch(url) {
  var index = url.indexOf('?');

  if (index == -1) {
    return url;
  }

  var fragment = getFragment(url);
  return url.substring(0, index) + fragment;
}

/**
 * Removes parameters that start with amp js parameter pattern and returns the
 * new search string.
 * @param {string} urlSearch
 * @return {string}
 */
function removeAmpJsParamsFromSearch(urlSearch) {
  if (!urlSearch || urlSearch == '?') {
    return '';
  }

  var search = urlSearch.replace(AMP_JS_PARAMS_REGEX, '').replace(AMP_GSA_PARAMS_REGEX, '').replace(AMP_R_PARAMS_REGEX, '').replace(AMP_KIT_PARAMS_REGEX, '').replace(GOOGLE_EXPERIMENT_PARAMS_REGEX, '').replace(/^[?&]/, '');
  // Removes first ? or &.
  return search ? '?' + search : '';
}

/**
 * Removes parameters with param name and returns the new search string.
 * @param {string} urlSearch
 * @param {string} paramName
 * @return {string}
 */
function removeParamsFromSearch(urlSearch, paramName) {
  // TODO: reuse the function in removeAmpJsParamsFromSearch. Accept paramNames
  // as an array.
  if (!urlSearch || urlSearch == '?') {
    return '';
  }

  var paramRegex = new RegExp("[?&]" + paramName + "=[^&]*", 'g');
  var search = urlSearch.replace(paramRegex, '').replace(/^[?&]/, '');
  return search ? '?' + search : '';
}

/**
 * Returns the source URL of an AMP document for documents served
 * on a proxy origin or directly.
 * @param {string|!Location} url URL of an AMP document.
 * @return {string}
 */
function getSourceUrl(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  // Not a proxy URL - return the URL itself.
  if (!isProxyOrigin(url)) {
    return url.href;
  }

  // A proxy URL.
  // Example path that is being matched here.
  // https://cdn.ampproject.org/c/s/www.origin.com/foo/
  // The /s/ is optional and signals a secure origin.
  var path = url.pathname.split('/');
  var prefix = path[1];
  (0, _log.userAssert)(SERVING_TYPE_PREFIX[prefix], 'Unknown path prefix in url %s', url.href);
  var domainOrHttpsSignal = path[2];
  var origin = domainOrHttpsSignal == 's' ? 'https://' + decodeURIComponent(path[3]) : 'http://' + decodeURIComponent(domainOrHttpsSignal);
  // Sanity test that what we found looks like a domain.
  (0, _log.userAssert)(origin.indexOf('.') > 0, 'Expected a . in origin %s', origin);
  path.splice(1, domainOrHttpsSignal == 's' ? 3 : 2);
  return origin + path.join('/') + removeAmpJsParamsFromSearch(url.search) + (url.hash || '');
}

/**
 * Returns the source origin of an AMP document for documents served
 * on a proxy origin or directly.
 * @param {string|!Location} url URL of an AMP document.
 * @return {string} The source origin of the URL.
 */
function getSourceOrigin(url) {
  return parseUrlDeprecated(getSourceUrl(url)).origin;
}

/**
 * Returns absolute URL resolved based on the relative URL and the base.
 * @param {string} relativeUrlString
 * @param {string|!Location} baseUrl
 * @return {string}
 */
function resolveRelativeUrl(relativeUrlString, baseUrl) {
  if (typeof baseUrl == 'string') {
    baseUrl = parseUrlDeprecated(baseUrl);
  }

  if (typeof URL == 'function') {
    return new URL(relativeUrlString, baseUrl.href).toString();
  }

  return resolveRelativeUrlFallback_(relativeUrlString, baseUrl);
}

/**
 * Fallback for URL resolver when URL class is not available.
 * @param {string} relativeUrlString
 * @param {string|!Location} baseUrl
 * @return {string}
 * @private Visible for testing.
 */
function resolveRelativeUrlFallback_(relativeUrlString, baseUrl) {
  if (typeof baseUrl == 'string') {
    baseUrl = parseUrlDeprecated(baseUrl);
  }

  relativeUrlString = relativeUrlString.replace(/\\/g, '/');
  var relativeUrl = parseUrlDeprecated(relativeUrlString);

  // Absolute URL.
  if ((0, _string.startsWith)(relativeUrlString.toLowerCase(), relativeUrl.protocol)) {
    return relativeUrl.href;
  }

  // Protocol-relative URL.
  if ((0, _string.startsWith)(relativeUrlString, '//')) {
    return baseUrl.protocol + relativeUrlString;
  }

  // Absolute path.
  if ((0, _string.startsWith)(relativeUrlString, '/')) {
    return baseUrl.origin + relativeUrlString;
  }

  // Relative path.
  return baseUrl.origin + baseUrl.pathname.replace(/\/[^/]*$/, '/') + relativeUrlString;
}

/**
 * Add "__amp_source_origin" query parameter to the URL.
 * @param {!Window} win
 * @param {string} url
 * @return {string}
 */
function getCorsUrl(win, url) {
  checkCorsUrl(url);
  var sourceOrigin = getSourceOrigin(win.location.href);
  return addParamToUrl(url, SOURCE_ORIGIN_PARAM, sourceOrigin);
}

/**
 * Checks if the url has __amp_source_origin and throws if it does.
 * @param {string} url
 */
function checkCorsUrl(url) {
  var parsedUrl = parseUrlDeprecated(url);
  var query = parseQueryString(parsedUrl.search);
  (0, _log.userAssert)(!(SOURCE_ORIGIN_PARAM in query), 'Source origin is not allowed in %s', url);
}

/**
 * Tries to decode a URI component, falling back to opt_fallback (or an empty
 * string)
 *
 * @param {string} component
 * @param {string=} opt_fallback
 * @return {string}
 */
function tryDecodeUriComponent(component, opt_fallback) {
  return (0, _urlTryDecodeUriComponent.tryDecodeUriComponent_)(component, opt_fallback);
}

/**
 * Adds the path to the given url.
 *
 * @param {!Location} url
 * @param {string} path
 * @return {string}
 */
function appendPathToUrl(url, path) {
  var pathname = url.pathname.replace(/\/?$/, '/') + path.replace(/^\//, '');
  return url.origin + pathname + url.search + url.hash;
}

},{"./config":17,"./log":28,"./mode":29,"./string":35,"./types":37,"./url-parse-query-string":38,"./url-try-decode-uri-component":39,"./utils/lru-cache":43,"./utils/object":45}],41:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.areEqualOrdered = areEqualOrdered;
exports.remove = remove;
exports.findIndex = findIndex;
exports.fromIterator = fromIterator;
exports.pushIfNotExist = pushIfNotExist;
exports.removeItem = removeItem;
exports.lastItem = lastItem;

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Compares if two arrays contains exactly same elements of same number
 * of same order. Note that it does NOT handle NaN case as expected.
 *
 * @param {!Array<T>} arr1
 * @param {!Array<T>} arr2
 * @return {boolean}
 * @template T
 */
function areEqualOrdered(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}

/**
 * Removes elements that shouldRemove returns true for from the array.
 *
 * @param {!Array<T>} array
 * @param {function(T, number, !Array<T>):boolean} shouldRemove
 * @return {!Array<T>}
 * @template T
 */
function remove(array, shouldRemove) {
  var removed = [];
  var index = 0;

  for (var i = 0; i < array.length; i++) {
    var item = array[i];

    if (shouldRemove(item, i, array)) {
      removed.push(item);
    } else {
      if (index < i) {
        array[index] = item;
      }

      index++;
    }
  }

  if (index < array.length) {
    array.length = index;
  }

  return removed;
}

/**
 * Returns the index of the first element matching the predicate.
 * Like Array#findIndex.
 *
 * @param {!Array<T>} array
 * @param {function(T, number, !Array<T>):boolean} predicate
 * @return {number}
 * @template T
 */
function findIndex(array, predicate) {
  for (var i = 0; i < array.length; i++) {
    if (predicate(array[i], i, array)) {
      return i;
    }
  }

  return -1;
}

/**
 * Converts the given iterator to an array.
 *
 * @param {!Iterator<T>} iterator
 * @return {Array<T>}
 * @template T
 */
function fromIterator(iterator) {
  var array = [];

  for (var e = iterator.next(); !e.done; e = iterator.next()) {
    array.push(e.value);
  }

  return array;
}

/**
 * Adds item to array if it is not already present.
 *
 * @param {Array<T>} array
 * @param {T} item
 * @return {boolean}
 * @template T
 */
function pushIfNotExist(array, item) {
  if (array.indexOf(item) < 0) {
    array.push(item);
    return true;
  }

  return false;
}

/**
 * Removes the first matching item in the array. Returns `true` if the array
 * has changed.
 *
 * @param {!Array<T>} array
 * @param {T} item
 * @return {boolean}
 * @template T
 */
function removeItem(array, item) {
  var index = array.indexOf(item);

  if (index == -1) {
    return false;
  }

  array.splice(index, 1);
  return true;
}

/**
 * Returns the last item in an array.
 *
 * @param {Array<T>} array
 * @template T
 * @return {?T}
 */
function lastItem(array) {
  return array[array.length - 1];
}

},{}],42:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.once = once;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO(rsimha, #15334): Enable this rule.

/* eslint jsdoc/check-types: 0 */

/**
 * Creates a function that is evaluated only once and returns the cached result
 * subsequently.
 *
 * Please note that `once` only takes the function definition into account,
 * so it will return the same cached value even when the arguments are
 * different.
 *
 * @param {function(...):T} fn
 * @return {function(...):T}
 * @template T
 */
function once(fn) {
  var evaluated = false;
  var retValue = null;
  var callback = fn;
  return function () {
    if (!evaluated) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      retValue = callback.apply(self, args);
      evaluated = true;
      callback = null;
    }

    return retValue;
  };
}

},{}],43:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.LruCache = void 0;

var _log = require("../log");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const {string} */
var TAG = 'lru-cache';

/**
 * @template T
 */
var LruCache = /*#__PURE__*/function () {
  /**
   * @param {number} capacity
   */
  function LruCache(capacity) {
    _classCallCheck(this, LruCache);

    /** @private @const {number} */
    this.capacity_ = capacity;

    /** @private {number} */
    this.size_ = 0;

    /**
     * An incrementing counter to define the last access.
     * @private {number}
     */
    this.access_ = 0;

    /** @private {!Object<(number|string), {payload: T, access: number}>} */
    this.cache_ = Object.create(null);
  }

  /**
   * Returns whether key is cached.
   *
   * @param {number|string} key
   * @return {boolean}
   */
  _createClass(LruCache, [{
    key: "has",
    value: function has(key) {
      return !!this.cache_[key];
    }
    /**
     * @param {number|string} key
     * @return {T} The cached payload.
     */

  }, {
    key: "get",
    value: function get(key) {
      var cacheable = this.cache_[key];

      if (cacheable) {
        cacheable.access = ++this.access_;
        return cacheable.payload;
      }

      return undefined;
    }
    /**
     * @param {number|string} key
     * @param {T} payload The payload to cache.
     */

  }, {
    key: "put",
    value: function put(key, payload) {
      if (!this.has(key)) {
        this.size_++;
      }

      this.cache_[key] = {
        payload: payload,
        access: this.access_
      };
      this.evict_();
    }
    /**
     * Evicts the oldest cache entry, if we've exceeded capacity.
     */

  }, {
    key: "evict_",
    value: function evict_() {
      if (this.size_ <= this.capacity_) {
        return;
      }

      (0, _log.dev)().warn(TAG, 'Trimming LRU cache');
      var cache = this.cache_;
      var oldest = this.access_ + 1;
      var oldestKey;

      for (var key in cache) {
        var access = cache[key].access;

        if (access < oldest) {
          oldest = access;
          oldestKey = key;
        }
      }

      if (oldestKey !== undefined) {
        delete cache[oldestKey];
        this.size_--;
      }
    }
  }]);

  return LruCache;
}();

exports.LruCache = LruCache;

},{"../log":28}],44:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.mapRange = mapRange;
exports.mod = mod;
exports.clamp = clamp;
exports.boundValue = boundValue;
exports.magnitude = magnitude;
exports.distance = distance;
exports.polarToCartesian = polarToCartesian;
exports.sum = sum;

var _log = require("../log");

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Maps a value in a first range to its equivalent in a second range
 * Ex.: 5 in the range [0,10] gives 60 in the range[40,80]
 *
 * NOTE: lower/upper bounds on the source range are detected automatically,
 * however the bounds on the target range are not altered (thus the target
 * range could be decreasing).
 * Ex1: 8 in the range [0, 10] gives 2 in the range [10, 0]
 * Ex2: also, 8 in the range [10, 0] gives 2 in the range [10, 0]
 *
 * NOTE: Input value is enforced to be bounded inside the source range
 * Ex1: -2 in the range [0, 10] is interpreted as 0 and thus gives 40 in [40,80]
 * Ex2: 19 in the range [0, 5] is interpreted as 5 and thus gives 80 in [40,80]
 *
 * @param {number} val the value in the source range
 * @param {number} min1 the lower bound of the source range
 * @param {number} max1 the upper bound of the source range
 * @param {number} min2 the lower bound of the target range
 * @param {number} max2 the upper bound of the target range
 * @return {number} the equivalent value in the target range
 */
function mapRange(val, min1, max1, min2, max2) {
  var max1Bound = max1;
  var min1Bound = min1;

  if (min1 > max1) {
    max1Bound = min1;
    min1Bound = max1;
  }

  if (val < min1Bound) {
    val = min1Bound;
  } else if (val > max1Bound) {
    val = max1Bound;
  }

  return (val - min1) * (max2 - min2) / (max1 - min1) + min2;
}

/**
 * Computes the modulus of values `a` and `b`.
 *
 * This is needed because the % operator in JavaScript doesn't implement
 * modulus behavior as can be seen by the spec here:
 * http://www.ecma-international.org/ecma-262/5.1/#sec-11.5.3.
 * It instead is used to obtain the remainder of a division.
 * This function uses the remainder (%) operator to determine the modulus.
 * Derived from here:
 * https://stackoverflow.com/questions/25726760/javascript-modular-arithmetic/47354356#47354356
 *
 * @param {number} a
 * @param {number} b
 * @return {number} returns the modulus of the two numbers.
 * @example
 *
 * _.min(10, 5);
 * // => 0
 *
 * _.mod(-1, 5);
 * // => 4
 */
function mod(a, b) {
  return a > 0 && b > 0 ? a % b : (a % b + b) % b;
}

/**
 * Restricts a number to be in the given min/max range. The minimum value must
 * be less than or equal to the maximum value.
 *
 * Examples:
 * clamp(0.5, 0, 1) -> 0.5
 * clamp(1.5, 0, 1) -> 1
 * clamp(-0.5, 0, 1) -> 0
 *
 * @param {number} val the value to clamp.
 * @param {number} min the lower bound.
 * @param {number} max the upper bound.
 * @return {number} the clamped value.
 */
function clamp(val, min, max) {
  (0, _log.devAssert)(min <= max, 'Minimum value is greater than the maximum.');
  return Math.min(Math.max(val, min), max);
}

/**
 * Returns value bound to min and max values +/- extent. The lower bound must
 * be less than or equal to the upper bound.
 * @param {number} val the value to bound.
 * @param {number} min the lower bound.
 * @param {number} max the upper bound
 * @param {number} extent the allowed extent beyond the bounds.
 * @return {number} the bounded value.
 */
function boundValue(val, min, max, extent) {
  (0, _log.devAssert)(min <= max, 'Lower bound is greater than the upper bound.');
  return clamp(val, min - extent, max + extent);
}

/**
 * Returns the length of a vector given in X- and Y-coordinates.
 * @param {number} deltaX distance in the X direction.
 * @param {number} deltaY distance in the Y direction.
 * @return {number} the magnitude of the vector.
 */
function magnitude(deltaX, deltaY) {
  return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
}

/**
 * Returns the distance between two points.
 * @param {number} x1 X-coordinate of the first point.
 * @param {number} y1 Y-coordinate of the first point.
 * @param {number} x2 X-coordinate of the second point.
 * @param {number} y2 Y-coordinate of the second point.
 * @return {number} the distance between the two points.
 */
function distance(x1, y1, x2, y2) {
  return magnitude(x2 - x1, y2 - y1);
}

/**
 * @param {number} centerX
 * @param {number} centerY
 * @param {number} radius
 * @param {number} angleInDegrees
 * @return {{
 *  x: number,
 *  y: number,
 * }}
 */
function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
}

/**
 * Sums up the values of the given array and returns the result
 * @param {Array<number>} values
 * @return {number}
 */
function sum(values) {
  return values.reduce(function (a, b) {
    return a + b;
  });
}

},{"../log":28}],45:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.map = map;
exports.dict = dict;
exports.hasOwn = hasOwn;
exports.ownProperty = ownProperty;
exports.deepMerge = deepMerge;
exports.omit = omit;
exports.objectsEqualShallow = objectsEqualShallow;

var _types = require("../types");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @const */
var hasOwn_ = Object.prototype.hasOwnProperty;

/**
 * Returns a map-like object.
 * If opt_initial is provided, copies its own properties into the
 * newly created object.
 * @param {T=} opt_initial This should typically be an object literal.
 * @return {T}
 * @template T
 */
function map(opt_initial) {
  var obj = Object.create(null);

  if (opt_initial) {
    Object.assign(obj, opt_initial);
  }

  return obj;
}

/**
 * Return an empty JsonObject or makes the passed in object literal
 * an JsonObject.
 * The JsonObject type is just a simple object that is at-dict.
 * See
 * https://github.com/google/closure-compiler/wiki/@struct-and-@dict-Annotations
 * for what a dict is type-wise.
 * The linter enforces that the argument is, in fact, at-dict like.
 * @param {!Object=} opt_initial
 * @return {!JsonObject}
 */
function dict(opt_initial) {
  // We do not copy. The linter enforces that the passed in object is a literal
  // and thus the caller cannot have a reference to it.
  return (
    /** @type {!JsonObject} */
    opt_initial || {}
  );
}

/**
 * Checks if the given key is a property in the map.
 *
 * @param {T}  obj a map like property.
 * @param {string}  key
 * @return {boolean}
 * @template T
 */
function hasOwn(obj, key) {
  return hasOwn_.call(obj, key);
}

/**
 * Returns obj[key] iff key is obj's own property (is not inherited).
 * Otherwise, returns undefined.
 *
 * @param {Object} obj
 * @param {string} key
 * @return {*}
 */
function ownProperty(obj, key) {
  if (hasOwn(obj, key)) {
    return obj[key];
  } else {
    return undefined;
  }
}

/**
 * Deep merges source into target.
 *
 * @param {!Object} target
 * @param {!Object} source
 * @param {number} depth The maximum merge depth. If exceeded, Object.assign
 *                       will be used instead.
 * @return {!Object}
 * @throws {Error} If source contains a circular reference.
 * Note: Only nested objects are deep-merged, primitives and arrays are not.
 */
function deepMerge(target, source, depth) {
  if (depth === void 0) {
    depth = 10;
  }

  // Keep track of seen objects to detect recursive references.
  var seen = [];

  /** @type {!Array<{t: !Object, s: !Object, d: number}>} */
  var queue = [];
  queue.push({
    t: target,
    s: source,
    d: 0
  });

  var _loop = function _loop() {
    var _queue$shift = queue.shift(),
        t = _queue$shift.t,
        s = _queue$shift.s,
        d = _queue$shift.d;

    if (seen.includes(s)) {
      throw new Error('Source object has a circular reference.');
    }

    seen.push(s);

    if (t === s) {
      return "continue";
    }

    if (d > depth) {
      Object.assign(t, s);
      return "continue";
    }

    Object.keys(s).forEach(function (key) {
      var newValue = s[key];

      // Perform a deep merge IFF both target and source have the same key
      // whose corresponding values are objects.
      if (hasOwn(t, key)) {
        var oldValue = t[key];

        if ((0, _types.isObject)(newValue) && (0, _types.isObject)(oldValue)) {
          queue.push({
            t: oldValue,
            s: newValue,
            d: d + 1
          });
          return;
        }
      }

      t[key] = newValue;
    });
  };

  // BFS to ensure objects don't have recursive references at shallower depths.
  while (queue.length > 0) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  return target;
}

/**
 * @param {!Object} o An object to remove properties from
 * @param {!Array<string>} props A list of properties to remove from the Object
 * @return {!Object} An object with the given properties removed
 */
function omit(o, props) {
  return Object.keys(o).reduce(function (acc, key) {
    if (!props.includes(key)) {
      acc[key] = o[key];
    }

    return acc;
  }, {});
}

/**
 * @param {!Object|null|undefined} o1
 * @param {!Object|null|undefined} o2
 * @return {boolean}
 */
function objectsEqualShallow(o1, o2) {
  if (o1 == null || o2 == null) {
    // Null is only equal to null, and undefined to undefined.
    return o1 === o2;
  }

  for (var k in o1) {
    if (o1[k] !== o2[k]) {
      return false;
    }
  }

  for (var _k in o2) {
    if (o2[_k] !== o1[_k]) {
      return false;
    }
  }

  return true;
}

},{"../types":37}],46:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.tryResolve = tryResolve;
exports.some = some;
exports.LastAddedResolver = exports.Deferred = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a Deferred struct, which holds a pending promise and its associated
 * resolve and reject functions.
 *
 * This is preferred instead of creating a Promise instance to extract the
 * resolve/reject functions yourself:
 *
 * ```
 * // Avoid doing
 * let resolve;
 * const promise = new Promise(res => {
 *   resolve = res;
 * });
 *
 * // Good
 * const deferred = new Deferred();
 * const { promise, resolve } = deferred;
 * ```
 *
 * @template T
 */
var Deferred =
/**
 * Creates an instance of Deferred.
 */
function Deferred() {
  _classCallCheck(this, Deferred);

  var resolve, reject;

  /**
   * @const {!Promise<T>}
   */
  this.promise = new
  /*OK*/
  Promise(function (res, rej) {
    resolve = res;
    reject = rej;
  });

  /**
   * @const {function(T=)}
   */
  this.resolve = resolve;

  /**
   * @const {function(*=)}
   */
  this.reject = reject;
};

exports.Deferred = Deferred;

/**
 * Creates a promise resolved to the return value of fn.
 * If fn sync throws, it will cause the promise to reject.
 *
 * @param {function():T} fn
 * @return {!Promise<T>}
 * @template T
 */
function tryResolve(fn) {
  return new Promise(function (resolve) {
    resolve(fn());
  });
}

/**
 * Returns a promise which resolves if a threshold amount of the given promises
 * resolve, and rejects otherwise.
 * @param {!Array<!Promise>} promises The array of promises to test.
 * @param {number} count The number of promises that must resolve for the
 *     returned promise to resolve.
 * @return {!Promise} A promise that resolves if any of the given promises
 *     resolve, and which rejects otherwise.
 */
function some(promises, count) {
  if (count === void 0) {
    count = 1;
  }

  return new Promise(function (resolve, reject) {
    count = Math.max(count, 0);
    var extra = promises.length - count;

    if (extra < 0) {
      reject(new Error('not enough promises to resolve'));
    }

    if (promises.length == 0) {
      resolve([]);
    }

    var values = [];
    var reasons = [];

    var onFulfilled = function onFulfilled(value) {
      if (values.length < count) {
        values.push(value);
      }

      if (values.length == count) {
        resolve(values);
      }
    };

    var onRejected = function onRejected(reason) {
      if (reasons.length <= extra) {
        reasons.push(reason);
      }

      if (reasons.length > extra) {
        reject(reasons);
      }
    };

    for (var i = 0; i < promises.length; i++) {
      Promise.resolve(promises[i]).then(onFulfilled, onRejected);
    }
  });
}

/**
 * Resolves with the result of the last promise added.
 * @implements {IThenable}
 */
var LastAddedResolver = /*#__PURE__*/function () {
  /**
   * @param {!Array<!Promise>=} opt_promises
   */
  function LastAddedResolver(opt_promises) {
    _classCallCheck(this, LastAddedResolver);

    var resolve_, reject_;

    /** @private @const {!Promise} */
    this.promise_ = new Promise(function (resolve, reject) {
      resolve_ = resolve;
      reject_ = reject;
    });

    /** @private */
    this.resolve_ = resolve_;

    /** @private */
    this.reject_ = reject_;

    /** @private */
    this.count_ = 0;

    if (opt_promises) {
      for (var i = 0; i < opt_promises.length; i++) {
        this.add(opt_promises[i]);
      }
    }
  }

  /**
   * Add a promise to possibly be resolved.
   * @param {!Promise} promise
   * @return {!Promise}
   */
  _createClass(LastAddedResolver, [{
    key: "add",
    value: function add(promise) {
      var _this = this;

      var countAtAdd = ++this.count_;
      Promise.resolve(promise).then(function (result) {
        if (_this.count_ === countAtAdd) {
          _this.resolve_(result);
        }
      }, function (error) {
        // Don't follow behavior of Promise.all and Promise.race error so that
        // this will only reject when most recently added promise fails.
        if (_this.count_ === countAtAdd) {
          _this.reject_(error);
        }
      });
      return this.promise_;
    }
    /** @override */

  }, {
    key: "then",
    value: function then(opt_resolve, opt_reject) {
      return this.promise_.then(opt_resolve, opt_reject);
    }
  }]);

  return LastAddedResolver;
}();

exports.LastAddedResolver = LastAddedResolver;

},{}],47:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.cssEscape = cssEscape;

/*! https://mths.be/cssescape v1.5.1 by @mathias | MIT license */

/**
 * This regex consists of 4 matching capture groups and one (non-matching) fallback:
 *
 * - (\0), catch the null terminator character so it may be replaced by UTF
 *   Replacement Char
 * - ^(-)$, catch a solitary dash char, so that it may be backslash escaped.
 *   This is a separate capture group so that the legal-chars (group 4) doesn't
 *   capture it first, since that group doesn't need to escape its dash.
 * - ([\x01-\x1f\x7f]|^-?[0-9]), catch a UTF control char, or any leading
 *   number (with an optional leading dash). The control or the number (but not
 *   the leading dash) must be hex-escaped,.
 * - ([\x80-\uffff0-9a-zA-Z_-]+), catch legal-chars, with the exception of a
 *   solitary dash, which will already have matched in group 1.
 * - [^], finally, a catch-all that allows us to backslash escape the char.
 *
 * Together, this matches everything necessary for CSS.escape.
 */
var regex = /(\0)|^(-)$|([\x01-\x1f\x7f]|^-?[0-9])|([\x80-\uffff0-9a-zA-Z_-]+)|[^]/g;

function escaper(match, nil, dash, hexEscape, chars) {
  // Chars is the legal-chars (group 4) capture
  if (chars) {
    return chars;
  }

  // Nil is the null terminator (group 1) capture
  if (nil) {
    return "\uFFFD";
  }

  // Both UTF control chars, and leading numbers (with optional leading dash)
  // (group 3) must be backslash escaped with a trailing space.  Funnily, the
  // leading dash must not be escaped, but the number. :shrug:
  if (hexEscape) {
    return match.slice(0, -1) + '\\' + match.slice(-1).charCodeAt(0).toString(16) + ' ';
  }

  // Finally, the solitary dash and the catch-all chars require backslash
  // escaping.
  return '\\' + match;
}

/**
 * https://drafts.csswg.org/cssom/#serialize-an-identifier
 * @param {string} value
 * @return {string}
 */
function cssEscape(value) {
  return String(value).replace(regex, escaper);
}

},{}]},{},[2])

